function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
!function(t, e) {
    "object" == (typeof exports === "undefined" ? "undefined" : _type_of(exports)) && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).jsts = e();
}(this, function() {
    "use strict";
    function t(t, e) {
        if (!_instanceof(t, e)) throw new TypeError("Cannot call a class as a function");
    }
    function e(t, e) {
        for(var n = 0; n < e.length; n++){
            var i = e[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
        }
    }
    function n(t, n, i) {
        return n && e(t.prototype, n), i && e(t, i), t;
    }
    function i(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
            constructor: {
                value: t,
                writable: !0,
                configurable: !0
            }
        }), e && s(t, e);
    }
    function r(t) {
        return r = Object.setPrototypeOf ? Object.getPrototypeOf : function r(t) {
            return t.__proto__ || Object.getPrototypeOf(t);
        }, r(t);
    }
    function s(t, e) {
        return s = Object.setPrototypeOf || function(t, e) {
            return t.__proto__ = e, t;
        }, s(t, e);
    }
    function a() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function o(t, e, n) {
        return o = a() ? Reflect.construct : function o(t, e, n) {
            var i = [
                null
            ];
            i.push.apply(i, e);
            var r = new (Function.bind.apply(t, i));
            return n && s(r, n.prototype), r;
        }, o.apply(null, arguments);
    }
    function u(t) {
        var e = "function" == typeof Map ? new Map : void 0;
        return u = function u(t) {
            if (null === t || (n = t, -1 === Function.toString.call(n).indexOf("[native code]"))) return t;
            var n;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
                if (e.has(t)) return e.get(t);
                e.set(t, i);
            }
            function i() {
                return o(t, arguments, r(this).constructor);
            }
            return i.prototype = Object.create(t.prototype, {
                constructor: {
                    value: i,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), s(i, t);
        }, u(t);
    }
    function l(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
    }
    function h(t, e) {
        if (e && ("object" == (typeof e === "undefined" ? "undefined" : _type_of(e)) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return l(t);
    }
    function c(t) {
        var e = a();
        return function() {
            var n, i = r(t);
            if (e) {
                var s = r(this).constructor;
                n = Reflect.construct(i, arguments, s);
            } else n = i.apply(this, arguments);
            return h(this, n);
        };
    }
    function f(t, e, n) {
        return f = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function f(t, e, n) {
            var i = function(t, e) {
                for(; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = r(t)););
                return t;
            }(t, e);
            if (i) {
                var s = Object.getOwnPropertyDescriptor(i, e);
                return s.get ? s.get.call(n) : s.value;
            }
        }, f(t, e, n || t);
    }
    function v(t) {
        return function(t) {
            if (Array.isArray(t)) return y(t);
        }(t) || function(t) {
            if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
        }(t) || g(t) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function g(t, e) {
        if (t) {
            if ("string" == typeof t) return y(t, e);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? y(t, e) : void 0;
        }
    }
    function y(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for(var n = 0, i = new Array(e); n < e; n++)i[n] = t[n];
        return i;
    }
    function d(t, e) {
        var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
        if (!n) {
            if (Array.isArray(t) || (n = g(t)) || e && t && "number" == typeof t.length) {
                n && (t = n);
                var i = 0, r = function r() {};
                return {
                    s: r,
                    n: function n() {
                        return i >= t.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: t[i++]
                        };
                    },
                    e: function e(t) {
                        throw t;
                    },
                    f: r
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var s, a = !0, o = !1;
        return {
            s: function s() {
                n = n.call(t);
            },
            n: function n1() {
                var _$t = n.next();
                return a = _$t.done, _$t;
            },
            e: function e(t) {
                o = !0, s = t;
            },
            f: function f() {
                try {
                    a || null == n.return || n.return();
                } finally{
                    if (o) throw s;
                }
            }
        };
    }
    var _ = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getEndCapStyle",
                value: function value() {
                    return this._endCapStyle;
                }
            },
            {
                key: "isSingleSided",
                value: function value() {
                    return this._isSingleSided;
                }
            },
            {
                key: "setQuadrantSegments",
                value: function value(t) {
                    this._quadrantSegments = t, 0 === this._quadrantSegments && (this._joinStyle = e.JOIN_BEVEL), this._quadrantSegments < 0 && (this._joinStyle = e.JOIN_MITRE, this._mitreLimit = Math.abs(this._quadrantSegments)), t <= 0 && (this._quadrantSegments = 1), this._joinStyle !== e.JOIN_ROUND && (this._quadrantSegments = e.DEFAULT_QUADRANT_SEGMENTS);
                }
            },
            {
                key: "getJoinStyle",
                value: function value() {
                    return this._joinStyle;
                }
            },
            {
                key: "setJoinStyle",
                value: function value(t) {
                    this._joinStyle = t;
                }
            },
            {
                key: "setSimplifyFactor",
                value: function value(t) {
                    this._simplifyFactor = t < 0 ? 0 : t;
                }
            },
            {
                key: "getSimplifyFactor",
                value: function value() {
                    return this._simplifyFactor;
                }
            },
            {
                key: "getQuadrantSegments",
                value: function value() {
                    return this._quadrantSegments;
                }
            },
            {
                key: "setEndCapStyle",
                value: function value(t) {
                    this._endCapStyle = t;
                }
            },
            {
                key: "getMitreLimit",
                value: function value() {
                    return this._mitreLimit;
                }
            },
            {
                key: "setMitreLimit",
                value: function value(t) {
                    this._mitreLimit = t;
                }
            },
            {
                key: "setSingleSided",
                value: function value(t) {
                    this._isSingleSided = t;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._quadrantSegments = e.DEFAULT_QUADRANT_SEGMENTS, this._endCapStyle = e.CAP_ROUND, this._joinStyle = e.JOIN_ROUND, this._mitreLimit = e.DEFAULT_MITRE_LIMIT, this._isSingleSided = !1, this._simplifyFactor = e.DEFAULT_SIMPLIFY_FACTOR, 0 === arguments.length) ;
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        this.setQuadrantSegments(t);
                    } else if (2 === arguments.length) {
                        var _$n = arguments[0], i = arguments[1];
                        this.setQuadrantSegments(_$n), this.setEndCapStyle(i);
                    } else if (4 === arguments.length) {
                        var r = arguments[0], s = arguments[1], a = arguments[2], o = arguments[3];
                        this.setQuadrantSegments(r), this.setEndCapStyle(s), this.setJoinStyle(a), this.setMitreLimit(o);
                    }
                }
            },
            {
                key: "bufferDistanceError",
                value: function value(t) {
                    var _$e = Math.PI / 2 / t;
                    return 1 - Math.cos(_$e / 2);
                }
            }
        ]), e;
    }();
    _.CAP_ROUND = 1, _.CAP_FLAT = 2, _.CAP_SQUARE = 3, _.JOIN_ROUND = 1, _.JOIN_MITRE = 2, _.JOIN_BEVEL = 3, _.DEFAULT_QUADRANT_SEGMENTS = 8, _.DEFAULT_MITRE_LIMIT = 5, _.DEFAULT_SIMPLIFY_FACTOR = .01;
    var p = function(e) {
        i(s, e);
        var r = c(s);
        function s(e) {
            var _$n;
            return t(this, s), (_$n = r.call(this, e)).name = Object.keys({
                Exception: s
            })[0], _$n;
        }
        return n(s, [
            {
                key: "toString",
                value: function value() {
                    return this.message;
                }
            }
        ]), s;
    }(u(Error)), m = function(e) {
        i(r, e);
        var n = c(r);
        function r(e) {
            var _$i;
            return t(this, r), (_$i = n.call(this, e)).name = Object.keys({
                IllegalArgumentException: r
            })[0], _$i;
        }
        return r;
    }(p), k = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "filter",
                value: function value(t) {}
            }
        ]), e;
    }();
    function x() {}
    function I() {}
    function E() {}
    var N, T, S, L, C, R, w, O, b = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "equalsWithTolerance",
                value: function value(t, e, n) {
                    return Math.abs(t - e) <= n;
                }
            }
        ]), e;
    }(), M = function() {
        function e(n, i) {
            t(this, e), this.low = i || 0, this.high = n || 0;
        }
        return n(e, null, [
            {
                key: "toBinaryString",
                value: function value(t) {
                    var _$e, _$n = "";
                    for(_$e = 2147483648; _$e > 0; _$e >>>= 1)_$n += (t.high & _$e) === _$e ? "1" : "0";
                    for(_$e = 2147483648; _$e > 0; _$e >>>= 1)_$n += (t.low & _$e) === _$e ? "1" : "0";
                    return _$n;
                }
            }
        ]), e;
    }();
    function A() {}
    function P() {}
    A.NaN = NaN, A.isNaN = function(t) {
        return Number.isNaN(t);
    }, A.isInfinite = function(t) {
        return !Number.isFinite(t);
    }, A.MAX_VALUE = Number.MAX_VALUE, A.POSITIVE_INFINITY = Number.POSITIVE_INFINITY, A.NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY, "function" == typeof Float64Array && "function" == typeof Int32Array ? (R = 2146435072, w = new Float64Array(1), O = new Int32Array(w.buffer), A.doubleToLongBits = function(t) {
        w[0] = t;
        var e = 0 | O[0], n = 0 | O[1];
        return (n & R) === R && 0 != (1048575 & n) && 0 !== e && (e = 0, n = 2146959360), new M(n, e);
    }, A.longBitsToDouble = function(t) {
        return O[0] = t.low, O[1] = t.high, w[0];
    }) : (N = 1023, T = Math.log2, S = Math.floor, L = Math.pow, C = function() {
        for(var t = 53; t > 0; t--){
            var e = L(2, t) - 1;
            if (S(T(e)) + 1 === t) return e;
        }
        return 0;
    }(), A.doubleToLongBits = function(t) {
        var e, n, i, r, s, a, o, _$u, l;
        if (t < 0 || 1 / t === Number.NEGATIVE_INFINITY ? (a = 1 << 31, t = -t) : a = 0, 0 === t) return new M(_$u = a, l = 0);
        if (t === 1 / 0) return new M(_$u = 2146435072 | a, l = 0);
        if (t != t) return new M(_$u = 2146959360, l = 0);
        if (r = 0, l = 0, (e = S(t)) > 1) if (e <= C) (r = S(T(e))) <= 20 ? (l = 0, _$u = e << 20 - r & 1048575) : (l = e % (n = L(2, i = r - 20)) << 32 - i, _$u = e / n & 1048575);
        else for(i = e, l = 0; 0 !== (i = S(n = i / 2));)r++, l >>>= 1, l |= (1 & _$u) << 31, _$u >>>= 1, n !== i && (_$u |= 524288);
        if (o = r + N, s = 0 === e, e = t - e, r < 52 && 0 !== e) for(i = 0;;){
            if ((n = 2 * e) >= 1 ? (e = n - 1, s ? (o--, s = !1) : (i <<= 1, i |= 1, r++)) : (e = n, s ? 0 == --o && (r++, s = !1) : (i <<= 1, r++)), 20 === r) _$u |= i, i = 0;
            else if (52 === r) {
                l |= i;
                break;
            }
            if (1 === n) {
                r < 20 ? _$u |= i << 20 - r : r < 52 && (l |= i << 52 - r);
                break;
            }
        }
        return _$u |= o << 20, new M(_$u |= a, l);
    }, A.longBitsToDouble = function(t) {
        var e, n, i, r, s = t.high, a = t.low, o = s & 1 << 31 ? -1 : 1;
        for(i = ((2146435072 & s) >> 20) - N, r = 0, n = 1 << 19, e = 1; e <= 20; e++)s & n && (r += L(2, -e)), n >>>= 1;
        for(n = 1 << 31, e = 21; e <= 52; e++)a & n && (r += L(2, -e)), n >>>= 1;
        if (-1023 === i) {
            if (0 === r) return 0 * o;
            i = -1022;
        } else {
            if (1024 === i) return 0 === r ? o / 0 : NaN;
            r += 1;
        }
        return o * r * L(2, i);
    });
    var D = function(e) {
        i(r, e);
        var n = c(r);
        function r(e) {
            var _$i;
            return t(this, r), (_$i = n.call(this, e)).name = Object.keys({
                RuntimeException: r
            })[0], _$i;
        }
        return r;
    }(p), F = function(e) {
        i(s, e);
        var r = c(s);
        function s() {
            var _$e;
            return t(this, s), _$e = r.call(this), s.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(s, null, [
            {
                key: "constructor_",
                value: function value() {
                    if (0 === arguments.length) D.constructor_.call(this);
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        D.constructor_.call(this, t);
                    }
                }
            }
        ]), s;
    }(D), G = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "shouldNeverReachHere",
                value: function value() {
                    if (0 === arguments.length) e.shouldNeverReachHere(null);
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        throw new F("Should never reach here" + (null !== t ? ": " + t : ""));
                    }
                }
            },
            {
                key: "isTrue",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        e.isTrue(t, null);
                    } else if (2 === arguments.length) {
                        var _$n = arguments[0], i = arguments[1];
                        if (!_$n) throw null === i ? new F : new F(i);
                    }
                }
            },
            {
                key: "equals",
                value: function value() {
                    if (2 === arguments.length) {
                        var t = arguments[0], _$n = arguments[1];
                        e.equals(t, _$n, null);
                    } else if (3 === arguments.length) {
                        var i = arguments[0], r = arguments[1], s = arguments[2];
                        if (!r.equals(i)) throw new F("Expected " + i + " but encountered " + r + (null !== s ? ": " + s : ""));
                    }
                }
            }
        ]), e;
    }(), q = new ArrayBuffer(8), Y = new Float64Array(q), z = new Int32Array(q), X = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getM",
                value: function value() {
                    return A.NaN;
                }
            },
            {
                key: "setOrdinate",
                value: function value(t, n) {
                    switch(t){
                        case e.X:
                            this.x = n;
                            break;
                        case e.Y:
                            this.y = n;
                            break;
                        case e.Z:
                            this.setZ(n);
                            break;
                        default:
                            throw new m("Invalid ordinate index: " + t);
                    }
                }
            },
            {
                key: "equals2D",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        return this.x === t.x && this.y === t.y;
                    }
                    if (2 === arguments.length) {
                        var _$e = arguments[0], _$n = arguments[1];
                        return !!b.equalsWithTolerance(this.x, _$e.x, _$n) && !!b.equalsWithTolerance(this.y, _$e.y, _$n);
                    }
                }
            },
            {
                key: "setM",
                value: function value(t) {
                    throw new m("Invalid ordinate index: " + e.M);
                }
            },
            {
                key: "getZ",
                value: function value() {
                    return this.z;
                }
            },
            {
                key: "getOrdinate",
                value: function value(t) {
                    switch(t){
                        case e.X:
                            return this.x;
                        case e.Y:
                            return this.y;
                        case e.Z:
                            return this.getZ();
                    }
                    throw new m("Invalid ordinate index: " + t);
                }
            },
            {
                key: "equals3D",
                value: function value(t) {
                    return this.x === t.x && this.y === t.y && (this.getZ() === t.getZ() || A.isNaN(this.getZ()) && A.isNaN(t.getZ()));
                }
            },
            {
                key: "equals",
                value: function value(t) {
                    return _instanceof(t, e) && this.equals2D(t);
                }
            },
            {
                key: "equalInZ",
                value: function value(t, e) {
                    return b.equalsWithTolerance(this.getZ(), t.getZ(), e);
                }
            },
            {
                key: "setX",
                value: function value(t) {
                    this.x = t;
                }
            },
            {
                key: "compareTo",
                value: function value(t) {
                    var _$e = t;
                    return this.x < _$e.x ? -1 : this.x > _$e.x ? 1 : this.y < _$e.y ? -1 : this.y > _$e.y ? 1 : 0;
                }
            },
            {
                key: "getX",
                value: function value() {
                    return this.x;
                }
            },
            {
                key: "setZ",
                value: function value(t) {
                    this.z = t;
                }
            },
            {
                key: "clone",
                value: function value() {
                    try {
                        return null;
                    } catch (t) {
                        if (_instanceof(t, CloneNotSupportedException)) return G.shouldNeverReachHere("this shouldn't happen because this class is Cloneable"), null;
                        throw t;
                    }
                }
            },
            {
                key: "copy",
                value: function value() {
                    return new e(this);
                }
            },
            {
                key: "toString",
                value: function value() {
                    return "(" + this.x + ", " + this.y + ", " + this.getZ() + ")";
                }
            },
            {
                key: "distance3D",
                value: function value(t) {
                    var _$e = this.x - t.x, _$n = this.y - t.y, i = this.getZ() - t.getZ();
                    return Math.sqrt(_$e * _$e + _$n * _$n + i * i);
                }
            },
            {
                key: "getY",
                value: function value() {
                    return this.y;
                }
            },
            {
                key: "setY",
                value: function value(t) {
                    this.y = t;
                }
            },
            {
                key: "distance",
                value: function value(t) {
                    var _$e = this.x - t.x, _$n = this.y - t.y;
                    return Math.sqrt(_$e * _$e + _$n * _$n);
                }
            },
            {
                key: "hashCode",
                value: function value() {
                    var t = 17;
                    return t = 37 * (t = 37 * t + e.hashCode(this.x)) + e.hashCode(this.y);
                }
            },
            {
                key: "setCoordinate",
                value: function value(t) {
                    this.x = t.x, this.y = t.y, this.z = t.getZ();
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        x,
                        I,
                        E
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this.x = null, this.y = null, this.z = null, 0 === arguments.length) e.constructor_.call(this, 0, 0);
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        e.constructor_.call(this, t.x, t.y, t.getZ());
                    } else if (2 === arguments.length) {
                        var _$n = arguments[0], i = arguments[1];
                        e.constructor_.call(this, _$n, i, e.NULL_ORDINATE);
                    } else if (3 === arguments.length) {
                        var r = arguments[0], s = arguments[1], a = arguments[2];
                        this.x = r, this.y = s, this.z = a;
                    }
                }
            },
            {
                key: "hashCode",
                value: function value(t) {
                    return Y[0] = t, z[0] ^ z[1];
                }
            }
        ]), e;
    }(), B = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "compare",
                value: function value(t, n) {
                    var i = e.compare(t.x, n.x);
                    if (0 !== i) return i;
                    var r = e.compare(t.y, n.y);
                    return 0 !== r ? r : this._dimensionsToTest <= 2 ? 0 : e.compare(t.getZ(), n.getZ());
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        P
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._dimensionsToTest = 2, 0 === arguments.length) e.constructor_.call(this, 2);
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        if (2 !== t && 3 !== t) throw new m("only 2 or 3 dimensions may be specified");
                        this._dimensionsToTest = t;
                    }
                }
            },
            {
                key: "compare",
                value: function value(t, e) {
                    return t < e ? -1 : t > e ? 1 : A.isNaN(t) ? A.isNaN(e) ? 0 : -1 : A.isNaN(e) ? 1 : 0;
                }
            }
        ]), e;
    }();
    X.DimensionalComparator = B, X.NULL_ORDINATE = A.NaN, X.X = 0, X.Y = 1, X.Z = 2, X.M = 3;
    var U = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getArea",
                value: function value() {
                    return this.getWidth() * this.getHeight();
                }
            },
            {
                key: "equals",
                value: function value(t) {
                    if (!_instanceof(t, e)) return !1;
                    var _$n = t;
                    return this.isNull() ? _$n.isNull() : this._maxx === _$n.getMaxX() && this._maxy === _$n.getMaxY() && this._minx === _$n.getMinX() && this._miny === _$n.getMinY();
                }
            },
            {
                key: "intersection",
                value: function value(t) {
                    if (this.isNull() || t.isNull() || !this.intersects(t)) return new e;
                    var _$n = this._minx > t._minx ? this._minx : t._minx, i = this._miny > t._miny ? this._miny : t._miny;
                    return new e(_$n, this._maxx < t._maxx ? this._maxx : t._maxx, i, this._maxy < t._maxy ? this._maxy : t._maxy);
                }
            },
            {
                key: "isNull",
                value: function value() {
                    return this._maxx < this._minx;
                }
            },
            {
                key: "getMaxX",
                value: function value() {
                    return this._maxx;
                }
            },
            {
                key: "covers",
                value: function value() {
                    if (1 === arguments.length) {
                        if (_instanceof(arguments[0], X)) {
                            var t = arguments[0];
                            return this.covers(t.x, t.y);
                        }
                        if (_instanceof(arguments[0], e)) {
                            var _$n = arguments[0];
                            return !this.isNull() && !_$n.isNull() && _$n.getMinX() >= this._minx && _$n.getMaxX() <= this._maxx && _$n.getMinY() >= this._miny && _$n.getMaxY() <= this._maxy;
                        }
                    } else if (2 === arguments.length) {
                        var i = arguments[0], r = arguments[1];
                        return !this.isNull() && i >= this._minx && i <= this._maxx && r >= this._miny && r <= this._maxy;
                    }
                }
            },
            {
                key: "intersects",
                value: function value() {
                    if (1 === arguments.length) {
                        if (_instanceof(arguments[0], e)) {
                            var t = arguments[0];
                            return !this.isNull() && !t.isNull() && !(t._minx > this._maxx || t._maxx < this._minx || t._miny > this._maxy || t._maxy < this._miny);
                        }
                        if (_instanceof(arguments[0], X)) {
                            var _$n = arguments[0];
                            return this.intersects(_$n.x, _$n.y);
                        }
                    } else if (2 === arguments.length) {
                        if (_instanceof(arguments[0], X) && _instanceof(arguments[1], X)) {
                            var i = arguments[0], r = arguments[1];
                            if (this.isNull()) return !1;
                            var s = i.x < r.x ? i.x : r.x;
                            if (s > this._maxx) return !1;
                            var a = i.x > r.x ? i.x : r.x;
                            if (a < this._minx) return !1;
                            var o = i.y < r.y ? i.y : r.y;
                            if (o > this._maxy) return !1;
                            var _$u = i.y > r.y ? i.y : r.y;
                            return !(_$u < this._miny);
                        }
                        if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                            var l = arguments[0], h = arguments[1];
                            return !this.isNull() && !(l > this._maxx || l < this._minx || h > this._maxy || h < this._miny);
                        }
                    }
                }
            },
            {
                key: "getMinY",
                value: function value() {
                    return this._miny;
                }
            },
            {
                key: "getDiameter",
                value: function value() {
                    if (this.isNull()) return 0;
                    var t = this.getWidth(), _$e = this.getHeight();
                    return Math.sqrt(t * t + _$e * _$e);
                }
            },
            {
                key: "getMinX",
                value: function value() {
                    return this._minx;
                }
            },
            {
                key: "expandToInclude",
                value: function value() {
                    if (1 === arguments.length) {
                        if (_instanceof(arguments[0], X)) {
                            var t = arguments[0];
                            this.expandToInclude(t.x, t.y);
                        } else if (_instanceof(arguments[0], e)) {
                            var _$n = arguments[0];
                            if (_$n.isNull()) return null;
                            this.isNull() ? (this._minx = _$n.getMinX(), this._maxx = _$n.getMaxX(), this._miny = _$n.getMinY(), this._maxy = _$n.getMaxY()) : (_$n._minx < this._minx && (this._minx = _$n._minx), _$n._maxx > this._maxx && (this._maxx = _$n._maxx), _$n._miny < this._miny && (this._miny = _$n._miny), _$n._maxy > this._maxy && (this._maxy = _$n._maxy));
                        }
                    } else if (2 === arguments.length) {
                        var i = arguments[0], r = arguments[1];
                        this.isNull() ? (this._minx = i, this._maxx = i, this._miny = r, this._maxy = r) : (i < this._minx && (this._minx = i), i > this._maxx && (this._maxx = i), r < this._miny && (this._miny = r), r > this._maxy && (this._maxy = r));
                    }
                }
            },
            {
                key: "minExtent",
                value: function value() {
                    if (this.isNull()) return 0;
                    var t = this.getWidth(), _$e = this.getHeight();
                    return t < _$e ? t : _$e;
                }
            },
            {
                key: "getWidth",
                value: function value() {
                    return this.isNull() ? 0 : this._maxx - this._minx;
                }
            },
            {
                key: "compareTo",
                value: function value(t) {
                    var _$e = t;
                    return this.isNull() ? _$e.isNull() ? 0 : -1 : _$e.isNull() ? 1 : this._minx < _$e._minx ? -1 : this._minx > _$e._minx ? 1 : this._miny < _$e._miny ? -1 : this._miny > _$e._miny ? 1 : this._maxx < _$e._maxx ? -1 : this._maxx > _$e._maxx ? 1 : this._maxy < _$e._maxy ? -1 : this._maxy > _$e._maxy ? 1 : 0;
                }
            },
            {
                key: "translate",
                value: function value(t, e) {
                    if (this.isNull()) return null;
                    this.init(this.getMinX() + t, this.getMaxX() + t, this.getMinY() + e, this.getMaxY() + e);
                }
            },
            {
                key: "copy",
                value: function value() {
                    return new e(this);
                }
            },
            {
                key: "toString",
                value: function value() {
                    return "Env[" + this._minx + " : " + this._maxx + ", " + this._miny + " : " + this._maxy + "]";
                }
            },
            {
                key: "setToNull",
                value: function value() {
                    this._minx = 0, this._maxx = -1, this._miny = 0, this._maxy = -1;
                }
            },
            {
                key: "disjoint",
                value: function value(t) {
                    return !(!this.isNull() && !t.isNull()) || t._minx > this._maxx || t._maxx < this._minx || t._miny > this._maxy || t._maxy < this._miny;
                }
            },
            {
                key: "getHeight",
                value: function value() {
                    return this.isNull() ? 0 : this._maxy - this._miny;
                }
            },
            {
                key: "maxExtent",
                value: function value() {
                    if (this.isNull()) return 0;
                    var t = this.getWidth(), _$e = this.getHeight();
                    return t > _$e ? t : _$e;
                }
            },
            {
                key: "expandBy",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        this.expandBy(t, t);
                    } else if (2 === arguments.length) {
                        var _$e = arguments[0], _$n = arguments[1];
                        if (this.isNull()) return null;
                        this._minx -= _$e, this._maxx += _$e, this._miny -= _$n, this._maxy += _$n, (this._minx > this._maxx || this._miny > this._maxy) && this.setToNull();
                    }
                }
            },
            {
                key: "contains",
                value: function value() {
                    if (1 === arguments.length) {
                        if (_instanceof(arguments[0], e)) {
                            var t = arguments[0];
                            return this.covers(t);
                        }
                        if (_instanceof(arguments[0], X)) {
                            var _$n = arguments[0];
                            return this.covers(_$n);
                        }
                    } else if (2 === arguments.length) {
                        var i = arguments[0], r = arguments[1];
                        return this.covers(i, r);
                    }
                }
            },
            {
                key: "centre",
                value: function value() {
                    return this.isNull() ? null : new X((this.getMinX() + this.getMaxX()) / 2, (this.getMinY() + this.getMaxY()) / 2);
                }
            },
            {
                key: "init",
                value: function value() {
                    if (0 === arguments.length) this.setToNull();
                    else if (1 === arguments.length) {
                        if (_instanceof(arguments[0], X)) {
                            var t = arguments[0];
                            this.init(t.x, t.x, t.y, t.y);
                        } else if (_instanceof(arguments[0], e)) {
                            var _$n = arguments[0];
                            this._minx = _$n._minx, this._maxx = _$n._maxx, this._miny = _$n._miny, this._maxy = _$n._maxy;
                        }
                    } else if (2 === arguments.length) {
                        var i = arguments[0], r = arguments[1];
                        this.init(i.x, r.x, i.y, r.y);
                    } else if (4 === arguments.length) {
                        var s = arguments[0], a = arguments[1], o = arguments[2], _$u = arguments[3];
                        s < a ? (this._minx = s, this._maxx = a) : (this._minx = a, this._maxx = s), o < _$u ? (this._miny = o, this._maxy = _$u) : (this._miny = _$u, this._maxy = o);
                    }
                }
            },
            {
                key: "getMaxY",
                value: function value() {
                    return this._maxy;
                }
            },
            {
                key: "distance",
                value: function value(t) {
                    if (this.intersects(t)) return 0;
                    var _$e = 0;
                    this._maxx < t._minx ? _$e = t._minx - this._maxx : this._minx > t._maxx && (_$e = this._minx - t._maxx);
                    var _$n = 0;
                    return this._maxy < t._miny ? _$n = t._miny - this._maxy : this._miny > t._maxy && (_$n = this._miny - t._maxy), 0 === _$e ? _$n : 0 === _$n ? _$e : Math.sqrt(_$e * _$e + _$n * _$n);
                }
            },
            {
                key: "hashCode",
                value: function value() {
                    var t = 17;
                    return t = 37 * (t = 37 * (t = 37 * (t = 37 * t + X.hashCode(this._minx)) + X.hashCode(this._maxx)) + X.hashCode(this._miny)) + X.hashCode(this._maxy);
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        x,
                        E
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._minx = null, this._maxx = null, this._miny = null, this._maxy = null, 0 === arguments.length) this.init();
                    else if (1 === arguments.length) {
                        if (_instanceof(arguments[0], X)) {
                            var t = arguments[0];
                            this.init(t.x, t.x, t.y, t.y);
                        } else if (_instanceof(arguments[0], e)) {
                            var _$n = arguments[0];
                            this.init(_$n);
                        }
                    } else if (2 === arguments.length) {
                        var i = arguments[0], r = arguments[1];
                        this.init(i.x, r.x, i.y, r.y);
                    } else if (4 === arguments.length) {
                        var s = arguments[0], a = arguments[1], o = arguments[2], _$u = arguments[3];
                        this.init(s, a, o, _$u);
                    }
                }
            },
            {
                key: "intersects",
                value: function value() {
                    if (3 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1], _$n = arguments[2];
                        return _$n.x >= (t.x < _$e.x ? t.x : _$e.x) && _$n.x <= (t.x > _$e.x ? t.x : _$e.x) && _$n.y >= (t.y < _$e.y ? t.y : _$e.y) && _$n.y <= (t.y > _$e.y ? t.y : _$e.y);
                    }
                    if (4 === arguments.length) {
                        var i = arguments[0], r = arguments[1], s = arguments[2], a = arguments[3], o = Math.min(s.x, a.x), _$u = Math.max(s.x, a.x), l = Math.min(i.x, r.x), h = Math.max(i.x, r.x);
                        return !(l > _$u) && !(h < o) && (o = Math.min(s.y, a.y), _$u = Math.max(s.y, a.y), l = Math.min(i.y, r.y), h = Math.max(i.y, r.y), !(l > _$u) && !(h < o));
                    }
                }
            }
        ]), e;
    }(), V = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "isGeometryCollection",
                value: function value() {
                    return this.getTypeCode() === e.TYPECODE_GEOMETRYCOLLECTION;
                }
            },
            {
                key: "getFactory",
                value: function value() {
                    return this._factory;
                }
            },
            {
                key: "getGeometryN",
                value: function value(t) {
                    return this;
                }
            },
            {
                key: "getArea",
                value: function value() {
                    return 0;
                }
            },
            {
                key: "isRectangle",
                value: function value() {
                    return !1;
                }
            },
            {
                key: "equalsExact",
                value: function value(t) {
                    return this === t || this.equalsExact(t, 0);
                }
            },
            {
                key: "geometryChanged",
                value: function value() {
                    this.apply(e.geometryChangedFilter);
                }
            },
            {
                key: "geometryChangedAction",
                value: function value() {
                    this._envelope = null;
                }
            },
            {
                key: "equalsNorm",
                value: function value(t) {
                    return null !== t && this.norm().equalsExact(t.norm());
                }
            },
            {
                key: "getLength",
                value: function value() {
                    return 0;
                }
            },
            {
                key: "getNumGeometries",
                value: function value() {
                    return 1;
                }
            },
            {
                key: "compareTo",
                value: function value() {
                    var t;
                    if (1 === arguments.length) {
                        var _$e = arguments[0];
                        return t = _$e, this.getTypeCode() !== t.getTypeCode() ? this.getTypeCode() - t.getTypeCode() : this.isEmpty() && t.isEmpty() ? 0 : this.isEmpty() ? -1 : t.isEmpty() ? 1 : this.compareToSameClass(_$e);
                    }
                    if (2 === arguments.length) {
                        var _$n = arguments[0], i = arguments[1];
                        return t = _$n, this.getTypeCode() !== t.getTypeCode() ? this.getTypeCode() - t.getTypeCode() : this.isEmpty() && t.isEmpty() ? 0 : this.isEmpty() ? -1 : t.isEmpty() ? 1 : this.compareToSameClass(_$n, i);
                    }
                }
            },
            {
                key: "getUserData",
                value: function value() {
                    return this._userData;
                }
            },
            {
                key: "getSRID",
                value: function value() {
                    return this._SRID;
                }
            },
            {
                key: "getEnvelope",
                value: function value() {
                    return this.getFactory().toGeometry(this.getEnvelopeInternal());
                }
            },
            {
                key: "checkNotGeometryCollection",
                value: function value(t) {
                    if (t.getTypeCode() === e.TYPECODE_GEOMETRYCOLLECTION) throw new m("This method does not support GeometryCollection arguments");
                }
            },
            {
                key: "equal",
                value: function value(t, e, n) {
                    return 0 === n ? t.equals(e) : t.distance(e) <= n;
                }
            },
            {
                key: "norm",
                value: function value() {
                    var t = this.copy();
                    return t.normalize(), t;
                }
            },
            {
                key: "reverse",
                value: function value() {
                    var t = this.reverseInternal();
                    return null != this.envelope && (t.envelope = this.envelope.copy()), t.setSRID(this.getSRID()), t;
                }
            },
            {
                key: "copy",
                value: function value() {
                    var t = this.copyInternal();
                    return t.envelope = null == this._envelope ? null : this._envelope.copy(), t._SRID = this._SRID, t._userData = this._userData, t;
                }
            },
            {
                key: "getPrecisionModel",
                value: function value() {
                    return this._factory.getPrecisionModel();
                }
            },
            {
                key: "getEnvelopeInternal",
                value: function value() {
                    return null === this._envelope && (this._envelope = this.computeEnvelopeInternal()), new U(this._envelope);
                }
            },
            {
                key: "setSRID",
                value: function value(t) {
                    this._SRID = t;
                }
            },
            {
                key: "setUserData",
                value: function value(t) {
                    this._userData = t;
                }
            },
            {
                key: "compare",
                value: function value(t, e) {
                    for(var _$n = t.iterator(), i = e.iterator(); _$n.hasNext() && i.hasNext();){
                        var r = _$n.next(), s = i.next(), a = r.compareTo(s);
                        if (0 !== a) return a;
                    }
                    return _$n.hasNext() ? 1 : i.hasNext() ? -1 : 0;
                }
            },
            {
                key: "hashCode",
                value: function value() {
                    return this.getEnvelopeInternal().hashCode();
                }
            },
            {
                key: "isEquivalentClass",
                value: function value(t) {
                    return this.getClass() === t.getClass();
                }
            },
            {
                key: "isGeometryCollectionOrDerived",
                value: function value() {
                    return this.getTypeCode() === e.TYPECODE_GEOMETRYCOLLECTION || this.getTypeCode() === e.TYPECODE_MULTIPOINT || this.getTypeCode() === e.TYPECODE_MULTILINESTRING || this.getTypeCode() === e.TYPECODE_MULTIPOLYGON;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        I,
                        x,
                        E
                    ];
                }
            },
            {
                key: "getClass",
                value: function value() {
                    return e;
                }
            }
        ], [
            {
                key: "hasNonEmptyElements",
                value: function value(t) {
                    for(var _$e = 0; _$e < t.length; _$e++)if (!t[_$e].isEmpty()) return !0;
                    return !1;
                }
            },
            {
                key: "hasNullElements",
                value: function value(t) {
                    for(var _$e = 0; _$e < t.length; _$e++)if (null === t[_$e]) return !0;
                    return !1;
                }
            }
        ]), e;
    }();
    V.constructor_ = function(t) {
        t && (this._envelope = null, this._userData = null, this._factory = t, this._SRID = t.getSRID());
    }, V.TYPECODE_POINT = 0, V.TYPECODE_MULTIPOINT = 1, V.TYPECODE_LINESTRING = 2, V.TYPECODE_LINEARRING = 3, V.TYPECODE_MULTILINESTRING = 4, V.TYPECODE_POLYGON = 5, V.TYPECODE_MULTIPOLYGON = 6, V.TYPECODE_GEOMETRYCOLLECTION = 7, V.TYPENAME_POINT = "Point", V.TYPENAME_MULTIPOINT = "MultiPoint", V.TYPENAME_LINESTRING = "LineString", V.TYPENAME_LINEARRING = "LinearRing", V.TYPENAME_MULTILINESTRING = "MultiLineString", V.TYPENAME_POLYGON = "Polygon", V.TYPENAME_MULTIPOLYGON = "MultiPolygon", V.TYPENAME_GEOMETRYCOLLECTION = "GeometryCollection", V.geometryChangedFilter = {
        get interfaces_ () {
            return [
                k
            ];
        },
        filter: function filter(t) {
            t.geometryChangedAction();
        }
    };
    var H = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "toLocationSymbol",
                value: function value(t) {
                    switch(t){
                        case e.EXTERIOR:
                            return "e";
                        case e.BOUNDARY:
                            return "b";
                        case e.INTERIOR:
                            return "i";
                        case e.NONE:
                            return "-";
                    }
                    throw new m("Unknown location value: " + t);
                }
            }
        ]), e;
    }();
    H.INTERIOR = 0, H.BOUNDARY = 1, H.EXTERIOR = 2, H.NONE = -1;
    var Z = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "add",
                value: function value() {}
            },
            {
                key: "addAll",
                value: function value() {}
            },
            {
                key: "isEmpty",
                value: function value() {}
            },
            {
                key: "iterator",
                value: function value() {}
            },
            {
                key: "size",
                value: function value() {}
            },
            {
                key: "toArray",
                value: function value() {}
            },
            {
                key: "remove",
                value: function value() {}
            }
        ]), e;
    }(), j = function(e) {
        i(r, e);
        var n = c(r);
        function r(e) {
            var _$i;
            return t(this, r), (_$i = n.call(this, e)).name = Object.keys({
                NoSuchElementException: r
            })[0], _$i;
        }
        return r;
    }(p), W = function(e) {
        i(r, e);
        var n = c(r);
        function r(e) {
            var _$i;
            return t(this, r), (_$i = n.call(this, e)).name = Object.keys({
                UnsupportedOperationException: r
            })[0], _$i;
        }
        return r;
    }(p), K = function(e) {
        i(s, e);
        var r = c(s);
        function s() {
            return t(this, s), r.apply(this, arguments);
        }
        return n(s, [
            {
                key: "contains",
                value: function value() {}
            }
        ]), s;
    }(Z), J = function(e, r) {
        i(a, e);
        var s = c(a);
        function a(e) {
            var _$n;
            return t(this, a), (_$n = s.call(this)).map = new Map, _instanceof(e, Z) && _$n.addAll(e), _$n;
        }
        return n(a, [
            {
                key: "contains",
                value: function value(t) {
                    var _$e = t.hashCode ? t.hashCode() : t;
                    return !!this.map.has(_$e);
                }
            },
            {
                key: "add",
                value: function value(t) {
                    var _$e = t.hashCode ? t.hashCode() : t;
                    return !this.map.has(_$e) && !!this.map.set(_$e, t);
                }
            },
            {
                key: "addAll",
                value: function value(t) {
                    var _$e, _$n = d(t);
                    try {
                        for(_$n.s(); !(_$e = _$n.n()).done;){
                            var _$i = _$e.value;
                            this.add(_$i);
                        }
                    } catch (t) {
                        _$n.e(t);
                    } finally{
                        _$n.f();
                    }
                    return !0;
                }
            },
            {
                key: "remove",
                value: function value() {
                    throw new W;
                }
            },
            {
                key: "size",
                value: function value() {
                    return this.map.size;
                }
            },
            {
                key: "isEmpty",
                value: function value() {
                    return 0 === this.map.size;
                }
            },
            {
                key: "toArray",
                value: function value() {
                    return Array.from(this.map.values());
                }
            },
            {
                key: "iterator",
                value: function value() {
                    return new Q(this.map);
                }
            },
            {
                key: r,
                value: function value() {
                    return this.map;
                }
            }
        ]), a;
    }(K, Symbol.iterator), Q = function() {
        function e(n) {
            t(this, e), this.iterator = n.values();
            var i = this.iterator.next(), r = i.done, s = i.value;
            this.done = r, this.value = s;
        }
        return n(e, [
            {
                key: "next",
                value: function value() {
                    if (this.done) throw new j;
                    var t = this.value, _$e = this.iterator.next(), _$n = _$e.done, i = _$e.value;
                    return this.done = _$n, this.value = i, t;
                }
            },
            {
                key: "hasNext",
                value: function value() {
                    return !this.done;
                }
            },
            {
                key: "remove",
                value: function value() {
                    throw new W;
                }
            }
        ]), e;
    }(), $ = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "opposite",
                value: function value(t) {
                    return t === e.LEFT ? e.RIGHT : t === e.RIGHT ? e.LEFT : t;
                }
            }
        ]), e;
    }();
    $.ON = 0, $.LEFT = 1, $.RIGHT = 2;
    var tt = function(e) {
        i(r, e);
        var n = c(r);
        function r(e) {
            var _$i;
            return t(this, r), (_$i = n.call(this, e)).name = Object.keys({
                EmptyStackException: r
            })[0], _$i;
        }
        return r;
    }(p), et = function(e) {
        i(r, e);
        var n = c(r);
        function r(e) {
            var _$i;
            return t(this, r), (_$i = n.call(this, e)).name = Object.keys({
                IndexOutOfBoundsException: r
            })[0], _$i;
        }
        return r;
    }(p), nt = function(e) {
        i(s, e);
        var r = c(s);
        function s() {
            return t(this, s), r.apply(this, arguments);
        }
        return n(s, [
            {
                key: "get",
                value: function value() {}
            },
            {
                key: "set",
                value: function value() {}
            },
            {
                key: "isEmpty",
                value: function value() {}
            }
        ]), s;
    }(Z), it = function(e) {
        i(s, e);
        var r = c(s);
        function s() {
            var _$e;
            return t(this, s), (_$e = r.call(this)).array = [], _$e;
        }
        return n(s, [
            {
                key: "add",
                value: function value(t) {
                    return this.array.push(t), !0;
                }
            },
            {
                key: "get",
                value: function value(t) {
                    if (t < 0 || t >= this.size()) throw new et;
                    return this.array[t];
                }
            },
            {
                key: "push",
                value: function value(t) {
                    return this.array.push(t), t;
                }
            },
            {
                key: "pop",
                value: function value() {
                    if (0 === this.array.length) throw new tt;
                    return this.array.pop();
                }
            },
            {
                key: "peek",
                value: function value() {
                    if (0 === this.array.length) throw new tt;
                    return this.array[this.array.length - 1];
                }
            },
            {
                key: "empty",
                value: function value() {
                    return 0 === this.array.length;
                }
            },
            {
                key: "isEmpty",
                value: function value() {
                    return this.empty();
                }
            },
            {
                key: "search",
                value: function value(t) {
                    return this.array.indexOf(t);
                }
            },
            {
                key: "size",
                value: function value() {
                    return this.array.length;
                }
            },
            {
                key: "toArray",
                value: function value() {
                    return this.array.slice();
                }
            }
        ]), s;
    }(nt);
    function rt(t, e) {
        return t.interfaces_ && t.interfaces_.indexOf(e) > -1;
    }
    var st = function() {
        function e(n) {
            t(this, e), this.str = n;
        }
        return n(e, [
            {
                key: "append",
                value: function value(t) {
                    this.str += t;
                }
            },
            {
                key: "setCharAt",
                value: function value(t, e) {
                    this.str = this.str.substr(0, t) + e + this.str.substr(t + 1);
                }
            },
            {
                key: "toString",
                value: function value() {
                    return this.str;
                }
            }
        ]), e;
    }(), at = function() {
        function e(n) {
            t(this, e), this.value = n;
        }
        return n(e, [
            {
                key: "intValue",
                value: function value() {
                    return this.value;
                }
            },
            {
                key: "compareTo",
                value: function value(t) {
                    return this.value < t ? -1 : this.value > t ? 1 : 0;
                }
            }
        ], [
            {
                key: "compare",
                value: function value(t, e) {
                    return t < e ? -1 : t > e ? 1 : 0;
                }
            },
            {
                key: "isNan",
                value: function value(t) {
                    return Number.isNaN(t);
                }
            },
            {
                key: "valueOf",
                value: function value(t) {
                    return new e(t);
                }
            }
        ]), e;
    }(), ot = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "isWhitespace",
                value: function value(t) {
                    return t <= 32 && t >= 0 || 127 === t;
                }
            },
            {
                key: "toUpperCase",
                value: function value(t) {
                    return t.toUpperCase();
                }
            }
        ]), e;
    }(), ut = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "le",
                value: function value(t) {
                    return this._hi < t._hi || this._hi === t._hi && this._lo <= t._lo;
                }
            },
            {
                key: "extractSignificantDigits",
                value: function value(t, n) {
                    var i = this.abs(), r = e.magnitude(i._hi), s = e.TEN.pow(r);
                    (i = i.divide(s)).gt(e.TEN) ? (i = i.divide(e.TEN), r += 1) : i.lt(e.ONE) && (i = i.multiply(e.TEN), r -= 1);
                    for(var a = r + 1, o = new st, _$u = e.MAX_PRINT_DIGITS - 1, l = 0; l <= _$u; l++){
                        t && l === a && o.append(".");
                        var h = Math.trunc(i._hi);
                        if (h < 0) break;
                        var c = !1, f = 0;
                        h > 9 ? (c = !0, f = "9") : f = "0" + h, o.append(f), i = i.subtract(e.valueOf(h)).multiply(e.TEN), c && i.selfAdd(e.TEN);
                        var v = !0, g = e.magnitude(i._hi);
                        if (g < 0 && Math.abs(g) >= _$u - l && (v = !1), !v) break;
                    }
                    return n[0] = r, o.toString();
                }
            },
            {
                key: "sqr",
                value: function value() {
                    return this.multiply(this);
                }
            },
            {
                key: "doubleValue",
                value: function value() {
                    return this._hi + this._lo;
                }
            },
            {
                key: "subtract",
                value: function value() {
                    if (_instanceof(arguments[0], e)) {
                        var t = arguments[0];
                        return this.add(t.negate());
                    }
                    if ("number" == typeof arguments[0]) {
                        var _$n = arguments[0];
                        return this.add(-_$n);
                    }
                }
            },
            {
                key: "equals",
                value: function value() {
                    if (1 === arguments.length && _instanceof(arguments[0], e)) {
                        var t = arguments[0];
                        return this._hi === t._hi && this._lo === t._lo;
                    }
                }
            },
            {
                key: "isZero",
                value: function value() {
                    return 0 === this._hi && 0 === this._lo;
                }
            },
            {
                key: "selfSubtract",
                value: function value() {
                    if (_instanceof(arguments[0], e)) {
                        var t = arguments[0];
                        return this.isNaN() ? this : this.selfAdd(-t._hi, -t._lo);
                    }
                    if ("number" == typeof arguments[0]) {
                        var _$n = arguments[0];
                        return this.isNaN() ? this : this.selfAdd(-_$n, 0);
                    }
                }
            },
            {
                key: "getSpecialNumberString",
                value: function value() {
                    return this.isZero() ? "0.0" : this.isNaN() ? "NaN " : null;
                }
            },
            {
                key: "min",
                value: function value(t) {
                    return this.le(t) ? this : t;
                }
            },
            {
                key: "selfDivide",
                value: function value() {
                    if (1 === arguments.length) {
                        if (_instanceof(arguments[0], e)) {
                            var t = arguments[0];
                            return this.selfDivide(t._hi, t._lo);
                        }
                        if ("number" == typeof arguments[0]) {
                            var _$n = arguments[0];
                            return this.selfDivide(_$n, 0);
                        }
                    } else if (2 === arguments.length) {
                        var i = arguments[0], r = arguments[1], s = null, a = null, o = null, _$u = null, l = null, h = null, c = null, f = null;
                        return l = this._hi / i, f = (s = (h = e.SPLIT * l) - (s = h - l)) * (o = (f = e.SPLIT * i) - (o = f - i)) - (c = l * i) + s * (_$u = i - o) + (a = l - s) * o + a * _$u, f = l + (h = (this._hi - c - f + this._lo - l * r) / i), this._hi = f, this._lo = l - f + h, this;
                    }
                }
            },
            {
                key: "dump",
                value: function value() {
                    return "DD<" + this._hi + ", " + this._lo + ">";
                }
            },
            {
                key: "divide",
                value: function value() {
                    if (_instanceof(arguments[0], e)) {
                        var t = arguments[0], _$n = null, i = null, r = null, s = null, a = null, o = null, _$u = null, l = null;
                        i = (a = this._hi / t._hi) - (_$n = (o = e.SPLIT * a) - (_$n = o - a)), l = _$n * (r = (l = e.SPLIT * t._hi) - (r = l - t._hi)) - (_$u = a * t._hi) + _$n * (s = t._hi - r) + i * r + i * s;
                        var h = l = a + (o = (this._hi - _$u - l + this._lo - a * t._lo) / t._hi), c = a - l + o;
                        return new e(h, c);
                    }
                    if ("number" == typeof arguments[0]) {
                        var f = arguments[0];
                        return A.isNaN(f) ? e.createNaN() : e.copy(this).selfDivide(f, 0);
                    }
                }
            },
            {
                key: "ge",
                value: function value(t) {
                    return this._hi > t._hi || this._hi === t._hi && this._lo >= t._lo;
                }
            },
            {
                key: "pow",
                value: function value(t) {
                    if (0 === t) return e.valueOf(1);
                    var _$n = new e(this), i = e.valueOf(1), r = Math.abs(t);
                    if (r > 1) for(; r > 0;)r % 2 == 1 && i.selfMultiply(_$n), (r /= 2) > 0 && (_$n = _$n.sqr());
                    else i = _$n;
                    return t < 0 ? i.reciprocal() : i;
                }
            },
            {
                key: "ceil",
                value: function value() {
                    if (this.isNaN()) return e.NaN;
                    var t = Math.ceil(this._hi), _$n = 0;
                    return t === this._hi && (_$n = Math.ceil(this._lo)), new e(t, _$n);
                }
            },
            {
                key: "compareTo",
                value: function value(t) {
                    var _$e = t;
                    return this._hi < _$e._hi ? -1 : this._hi > _$e._hi ? 1 : this._lo < _$e._lo ? -1 : this._lo > _$e._lo ? 1 : 0;
                }
            },
            {
                key: "rint",
                value: function value() {
                    return this.isNaN() ? this : this.add(.5).floor();
                }
            },
            {
                key: "setValue",
                value: function value() {
                    if (_instanceof(arguments[0], e)) {
                        var t = arguments[0];
                        return this.init(t), this;
                    }
                    if ("number" == typeof arguments[0]) {
                        var _$n = arguments[0];
                        return this.init(_$n), this;
                    }
                }
            },
            {
                key: "max",
                value: function value(t) {
                    return this.ge(t) ? this : t;
                }
            },
            {
                key: "sqrt",
                value: function value() {
                    if (this.isZero()) return e.valueOf(0);
                    if (this.isNegative()) return e.NaN;
                    var t = 1 / Math.sqrt(this._hi), _$n = this._hi * t, i = e.valueOf(_$n), r = this.subtract(i.sqr())._hi * (.5 * t);
                    return i.add(r);
                }
            },
            {
                key: "selfAdd",
                value: function value() {
                    if (1 === arguments.length) {
                        if (_instanceof(arguments[0], e)) {
                            var t = arguments[0];
                            return this.selfAdd(t._hi, t._lo);
                        }
                        if ("number" == typeof arguments[0]) {
                            var _$n = arguments[0], i = null, r = null, s = null, a = null, o = null, _$u = null;
                            return a = (s = this._hi + _$n) - (o = s - this._hi), r = (_$u = (a = _$n - o + (this._hi - a)) + this._lo) + (s - (i = s + _$u)), this._hi = i + r, this._lo = r + (i - this._hi), this;
                        }
                    } else if (2 === arguments.length) {
                        var l = arguments[0], h = arguments[1], c = null, f = null, v = null, g = null, y = null, d = null, _ = null;
                        g = this._hi + l, f = this._lo + h, y = g - (d = g - this._hi), v = f - (_ = f - this._lo);
                        var p = (c = g + (d = (y = l - d + (this._hi - y)) + f)) + (d = (v = h - _ + (this._lo - v)) + (d + (g - c))), m = d + (c - p);
                        return this._hi = p, this._lo = m, this;
                    }
                }
            },
            {
                key: "selfMultiply",
                value: function value() {
                    if (1 === arguments.length) {
                        if (_instanceof(arguments[0], e)) {
                            var t = arguments[0];
                            return this.selfMultiply(t._hi, t._lo);
                        }
                        if ("number" == typeof arguments[0]) {
                            var _$n = arguments[0];
                            return this.selfMultiply(_$n, 0);
                        }
                    } else if (2 === arguments.length) {
                        var i = arguments[0], r = arguments[1], s = null, a = null, o = null, _$u = null, l = null, h = null;
                        s = (l = e.SPLIT * this._hi) - this._hi, h = e.SPLIT * i, s = l - s, a = this._hi - s, o = h - i;
                        var c = (l = this._hi * i) + (h = s * (o = h - o) - l + s * (_$u = i - o) + a * o + a * _$u + (this._hi * r + this._lo * i)), f = h + (s = l - c);
                        return this._hi = c, this._lo = f, this;
                    }
                }
            },
            {
                key: "selfSqr",
                value: function value() {
                    return this.selfMultiply(this);
                }
            },
            {
                key: "floor",
                value: function value() {
                    if (this.isNaN()) return e.NaN;
                    var t = Math.floor(this._hi), _$n = 0;
                    return t === this._hi && (_$n = Math.floor(this._lo)), new e(t, _$n);
                }
            },
            {
                key: "negate",
                value: function value() {
                    return this.isNaN() ? this : new e(-this._hi, -this._lo);
                }
            },
            {
                key: "clone",
                value: function value() {
                    try {
                        return null;
                    } catch (t) {
                        if (_instanceof(t, CloneNotSupportedException)) return null;
                        throw t;
                    }
                }
            },
            {
                key: "multiply",
                value: function value() {
                    if (_instanceof(arguments[0], e)) {
                        var t = arguments[0];
                        return t.isNaN() ? e.createNaN() : e.copy(this).selfMultiply(t);
                    }
                    if ("number" == typeof arguments[0]) {
                        var _$n = arguments[0];
                        return A.isNaN(_$n) ? e.createNaN() : e.copy(this).selfMultiply(_$n, 0);
                    }
                }
            },
            {
                key: "isNaN",
                value: function value() {
                    return A.isNaN(this._hi);
                }
            },
            {
                key: "intValue",
                value: function value() {
                    return Math.trunc(this._hi);
                }
            },
            {
                key: "toString",
                value: function value() {
                    var t = e.magnitude(this._hi);
                    return t >= -3 && t <= 20 ? this.toStandardNotation() : this.toSciNotation();
                }
            },
            {
                key: "toStandardNotation",
                value: function value() {
                    var t = this.getSpecialNumberString();
                    if (null !== t) return t;
                    var _$n = new Array(1).fill(null), i = this.extractSignificantDigits(!0, _$n), r = _$n[0] + 1, s = i;
                    if ("." === i.charAt(0)) s = "0" + i;
                    else if (r < 0) s = "0." + e.stringOfChar("0", -r) + i;
                    else if (-1 === i.indexOf(".")) {
                        var a = r - i.length;
                        s = i + e.stringOfChar("0", a) + ".0";
                    }
                    return this.isNegative() ? "-" + s : s;
                }
            },
            {
                key: "reciprocal",
                value: function value() {
                    var t, _$n, i, r, s = null, a = null, o = null, _$u = null;
                    t = (i = 1 / this._hi) - (s = (o = e.SPLIT * i) - (s = o - i)), a = (_$u = e.SPLIT * this._hi) - this._hi;
                    var l = i + (o = (1 - (r = i * this._hi) - (_$u = s * (a = _$u - a) - r + s * (_$n = this._hi - a) + t * a + t * _$n) - i * this._lo) / this._hi);
                    return new e(l, i - l + o);
                }
            },
            {
                key: "toSciNotation",
                value: function value() {
                    if (this.isZero()) return e.SCI_NOT_ZERO;
                    var t = this.getSpecialNumberString();
                    if (null !== t) return t;
                    var _$n = new Array(1).fill(null), i = this.extractSignificantDigits(!1, _$n), r = e.SCI_NOT_EXPONENT_CHAR + _$n[0];
                    if ("0" === i.charAt(0)) throw new IllegalStateException("Found leading zero: " + i);
                    var s = "";
                    i.length > 1 && (s = i.substring(1));
                    var a = i.charAt(0) + "." + s;
                    return this.isNegative() ? "-" + a + r : a + r;
                }
            },
            {
                key: "abs",
                value: function value() {
                    return this.isNaN() ? e.NaN : this.isNegative() ? this.negate() : new e(this);
                }
            },
            {
                key: "isPositive",
                value: function value() {
                    return this._hi > 0 || 0 === this._hi && this._lo > 0;
                }
            },
            {
                key: "lt",
                value: function value(t) {
                    return this._hi < t._hi || this._hi === t._hi && this._lo < t._lo;
                }
            },
            {
                key: "add",
                value: function value() {
                    if (_instanceof(arguments[0], e)) {
                        var t = arguments[0];
                        return e.copy(this).selfAdd(t);
                    }
                    if ("number" == typeof arguments[0]) {
                        var _$n = arguments[0];
                        return e.copy(this).selfAdd(_$n);
                    }
                }
            },
            {
                key: "init",
                value: function value() {
                    if (1 === arguments.length) {
                        if ("number" == typeof arguments[0]) {
                            var t = arguments[0];
                            this._hi = t, this._lo = 0;
                        } else if (_instanceof(arguments[0], e)) {
                            var _$n = arguments[0];
                            this._hi = _$n._hi, this._lo = _$n._lo;
                        }
                    } else if (2 === arguments.length) {
                        var i = arguments[0], r = arguments[1];
                        this._hi = i, this._lo = r;
                    }
                }
            },
            {
                key: "gt",
                value: function value(t) {
                    return this._hi > t._hi || this._hi === t._hi && this._lo > t._lo;
                }
            },
            {
                key: "isNegative",
                value: function value() {
                    return this._hi < 0 || 0 === this._hi && this._lo < 0;
                }
            },
            {
                key: "trunc",
                value: function value() {
                    return this.isNaN() ? e.NaN : this.isPositive() ? this.floor() : this.ceil();
                }
            },
            {
                key: "signum",
                value: function value() {
                    return this._hi > 0 ? 1 : this._hi < 0 ? -1 : this._lo > 0 ? 1 : this._lo < 0 ? -1 : 0;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        E,
                        x,
                        I
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._hi = 0, this._lo = 0, 0 === arguments.length) this.init(0);
                    else if (1 === arguments.length) {
                        if ("number" == typeof arguments[0]) {
                            var t = arguments[0];
                            this.init(t);
                        } else if (_instanceof(arguments[0], e)) {
                            var _$n = arguments[0];
                            this.init(_$n);
                        } else if ("string" == typeof arguments[0]) {
                            var i = arguments[0];
                            e.constructor_.call(this, e.parse(i));
                        }
                    } else if (2 === arguments.length) {
                        var r = arguments[0], s = arguments[1];
                        this.init(r, s);
                    }
                }
            },
            {
                key: "determinant",
                value: function value() {
                    if ("number" == typeof arguments[3] && "number" == typeof arguments[2] && "number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                        var t = arguments[0], _$n = arguments[1], i = arguments[2], r = arguments[3];
                        return e.determinant(e.valueOf(t), e.valueOf(_$n), e.valueOf(i), e.valueOf(r));
                    }
                    if (_instanceof(arguments[3], e) && _instanceof(arguments[2], e) && _instanceof(arguments[0], e) && _instanceof(arguments[1], e)) {
                        var s = arguments[0], a = arguments[1], o = arguments[2], _$u = arguments[3], l = s.multiply(_$u).selfSubtract(a.multiply(o));
                        return l;
                    }
                }
            },
            {
                key: "sqr",
                value: function value(t) {
                    return e.valueOf(t).selfMultiply(t);
                }
            },
            {
                key: "valueOf",
                value: function value() {
                    if ("string" == typeof arguments[0]) {
                        var t = arguments[0];
                        return e.parse(t);
                    }
                    if ("number" == typeof arguments[0]) {
                        var _$n = arguments[0];
                        return new e(_$n);
                    }
                }
            },
            {
                key: "sqrt",
                value: function value(t) {
                    return e.valueOf(t).sqrt();
                }
            },
            {
                key: "parse",
                value: function value(t) {
                    for(var _$n = 0, i = t.length; ot.isWhitespace(t.charAt(_$n));)_$n++;
                    var r = !1;
                    if (_$n < i) {
                        var s = t.charAt(_$n);
                        "-" !== s && "+" !== s || (_$n++, "-" === s && (r = !0));
                    }
                    for(var a = new e, o = 0, _$u = 0, l = 0, h = !1; !(_$n >= i);){
                        var c = t.charAt(_$n);
                        if (_$n++, ot.isDigit(c)) {
                            var f = c - "0";
                            a.selfMultiply(e.TEN), a.selfAdd(f), o++;
                        } else {
                            if ("." !== c) {
                                if ("e" === c || "E" === c) {
                                    var v = t.substring(_$n);
                                    try {
                                        l = at.parseInt(v);
                                    } catch (e) {
                                        throw _instanceof(e, NumberFormatException) ? new NumberFormatException("Invalid exponent " + v + " in string " + t) : e;
                                    }
                                    break;
                                }
                                throw new NumberFormatException("Unexpected character '" + c + "' at position " + _$n + " in string " + t);
                            }
                            _$u = o, h = !0;
                        }
                    }
                    var g = a;
                    h || (_$u = o);
                    var y = o - _$u - l;
                    if (0 === y) g = a;
                    else if (y > 0) {
                        var d = e.TEN.pow(y);
                        g = a.divide(d);
                    } else if (y < 0) {
                        var _ = e.TEN.pow(-y);
                        g = a.multiply(_);
                    }
                    return r ? g.negate() : g;
                }
            },
            {
                key: "createNaN",
                value: function value() {
                    return new e(A.NaN, A.NaN);
                }
            },
            {
                key: "copy",
                value: function value(t) {
                    return new e(t);
                }
            },
            {
                key: "magnitude",
                value: function value(t) {
                    var _$e = Math.abs(t), _$n = Math.log(_$e) / Math.log(10), i = Math.trunc(Math.floor(_$n));
                    return 10 * Math.pow(10, i) <= _$e && (i += 1), i;
                }
            },
            {
                key: "stringOfChar",
                value: function value(t, e) {
                    for(var _$n = new st, i = 0; i < e; i++)_$n.append(t);
                    return _$n.toString();
                }
            }
        ]), e;
    }();
    ut.PI = new ut(3.141592653589793, 12246467991473532e-32), ut.TWO_PI = new ut(6.283185307179586, 24492935982947064e-32), ut.PI_2 = new ut(1.5707963267948966, 6123233995736766e-32), ut.E = new ut(2.718281828459045, 14456468917292502e-32), ut.NaN = new ut(A.NaN, A.NaN), ut.EPS = 123259516440783e-46, ut.SPLIT = 134217729, ut.MAX_PRINT_DIGITS = 32, ut.TEN = ut.valueOf(10), ut.ONE = ut.valueOf(1), ut.SCI_NOT_EXPONENT_CHAR = "E", ut.SCI_NOT_ZERO = "0.0E0";
    var lt = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "orientationIndex",
                value: function value(t, n, i) {
                    var r = e.orientationIndexFilter(t, n, i);
                    if (r <= 1) return r;
                    var s = ut.valueOf(n.x).selfAdd(-t.x), a = ut.valueOf(n.y).selfAdd(-t.y), o = ut.valueOf(i.x).selfAdd(-n.x), _$u = ut.valueOf(i.y).selfAdd(-n.y);
                    return s.selfMultiply(_$u).selfSubtract(a.selfMultiply(o)).signum();
                }
            },
            {
                key: "signOfDet2x2",
                value: function value() {
                    if (_instanceof(arguments[3], ut) && _instanceof(arguments[2], ut) && _instanceof(arguments[0], ut) && _instanceof(arguments[1], ut)) {
                        var t = arguments[0], _$e = arguments[1], _$n = arguments[2], i = arguments[3], r = t.multiply(i).selfSubtract(_$e.multiply(_$n));
                        return r.signum();
                    }
                    if ("number" == typeof arguments[3] && "number" == typeof arguments[2] && "number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                        var s = arguments[0], a = arguments[1], o = arguments[2], _$u = arguments[3], l = ut.valueOf(s), h = ut.valueOf(a), c = ut.valueOf(o), f = ut.valueOf(_$u), v = l.multiply(f).selfSubtract(h.multiply(c));
                        return v.signum();
                    }
                }
            },
            {
                key: "intersection",
                value: function value(t, e, n, i) {
                    var r = new ut(t.y).selfSubtract(e.y), s = new ut(e.x).selfSubtract(t.x), a = new ut(t.x).selfMultiply(e.y).selfSubtract(new ut(e.x).selfMultiply(t.y)), o = new ut(n.y).selfSubtract(i.y), _$u = new ut(i.x).selfSubtract(n.x), l = new ut(n.x).selfMultiply(i.y).selfSubtract(new ut(i.x).selfMultiply(n.y)), h = s.multiply(l).selfSubtract(_$u.multiply(a)), c = o.multiply(a).selfSubtract(r.multiply(l)), f = r.multiply(_$u).selfSubtract(o.multiply(s)), v = h.selfDivide(f).doubleValue(), g = c.selfDivide(f).doubleValue();
                    return A.isNaN(v) || A.isInfinite(v) || A.isNaN(g) || A.isInfinite(g) ? null : new X(v, g);
                }
            },
            {
                key: "orientationIndexFilter",
                value: function value(t, n, i) {
                    var r = null, s = (t.x - i.x) * (n.y - i.y), a = (t.y - i.y) * (n.x - i.x), o = s - a;
                    if (s > 0) {
                        if (a <= 0) return e.signum(o);
                        r = s + a;
                    } else {
                        if (!(s < 0)) return e.signum(o);
                        if (a >= 0) return e.signum(o);
                        r = -s - a;
                    }
                    var _$u = e.DP_SAFE_EPSILON * r;
                    return o >= _$u || -o >= _$u ? e.signum(o) : 2;
                }
            },
            {
                key: "signum",
                value: function value(t) {
                    return t > 0 ? 1 : t < 0 ? -1 : 0;
                }
            }
        ]), e;
    }();
    lt.DP_SAFE_EPSILON = 1e-15;
    var ht = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "getM",
                value: function value(t) {
                    if (this.hasM()) {
                        var _$e = this.getDimension() - this.getMeasures();
                        return this.getOrdinate(t, _$e);
                    }
                    return A.NaN;
                }
            },
            {
                key: "setOrdinate",
                value: function value(t, e, n) {}
            },
            {
                key: "getZ",
                value: function value(t) {
                    return this.hasZ() ? this.getOrdinate(t, 2) : A.NaN;
                }
            },
            {
                key: "size",
                value: function value() {}
            },
            {
                key: "getOrdinate",
                value: function value(t, e) {}
            },
            {
                key: "getCoordinate",
                value: function value() {}
            },
            {
                key: "getCoordinateCopy",
                value: function value(t) {}
            },
            {
                key: "createCoordinate",
                value: function value() {}
            },
            {
                key: "getDimension",
                value: function value() {}
            },
            {
                key: "hasM",
                value: function value() {
                    return this.getMeasures() > 0;
                }
            },
            {
                key: "getX",
                value: function value(t) {}
            },
            {
                key: "hasZ",
                value: function value() {
                    return this.getDimension() - this.getMeasures() > 2;
                }
            },
            {
                key: "getMeasures",
                value: function value() {
                    return 0;
                }
            },
            {
                key: "expandEnvelope",
                value: function value(t) {}
            },
            {
                key: "copy",
                value: function value() {}
            },
            {
                key: "getY",
                value: function value(t) {}
            },
            {
                key: "toCoordinateArray",
                value: function value() {}
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        I
                    ];
                }
            }
        ]), e;
    }();
    ht.X = 0, ht.Y = 1, ht.Z = 2, ht.M = 3;
    var ct = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "index",
                value: function value(t, e, n) {
                    return lt.orientationIndex(t, e, n);
                }
            },
            {
                key: "isCCW",
                value: function value() {
                    if (_instanceof(arguments[0], Array)) {
                        var t = arguments[0], _$n = t.length - 1;
                        if (_$n < 3) throw new m("Ring has fewer than 4 points, so orientation cannot be determined");
                        for(var i = t[0], r = 0, s = 1; s <= _$n; s++){
                            var a = t[s];
                            a.y > i.y && (i = a, r = s);
                        }
                        var o = r;
                        do {
                            (o -= 1) < 0 && (o = _$n);
                        }while (t[o].equals2D(i) && o !== r);
                        var _$u = r;
                        do {
                            _$u = (_$u + 1) % _$n;
                        }while (t[_$u].equals2D(i) && _$u !== r);
                        var l = t[o], h = t[_$u];
                        if (l.equals2D(i) || h.equals2D(i) || l.equals2D(h)) return !1;
                        var c = e.index(l, i, h), f = null;
                        return f = 0 === c ? l.x > h.x : c > 0, f;
                    }
                    if (rt(arguments[0], ht)) {
                        var v = arguments[0], g = v.size() - 1;
                        if (g < 3) throw new m("Ring has fewer than 4 points, so orientation cannot be determined");
                        for(var y = v.getCoordinate(0), d = 0, _ = 1; _ <= g; _++){
                            var p = v.getCoordinate(_);
                            p.y > y.y && (y = p, d = _);
                        }
                        var k = null, x = d;
                        do {
                            (x -= 1) < 0 && (x = g), k = v.getCoordinate(x);
                        }while (k.equals2D(y) && x !== d);
                        var I = null, E = d;
                        do {
                            E = (E + 1) % g, I = v.getCoordinate(E);
                        }while (I.equals2D(y) && E !== d);
                        if (k.equals2D(y) || I.equals2D(y) || k.equals2D(I)) return !1;
                        var N = e.index(k, y, I);
                        return 0 === N ? k.x > I.x : N > 0;
                    }
                }
            }
        ]), e;
    }();
    ct.CLOCKWISE = -1, ct.RIGHT = ct.CLOCKWISE, ct.COUNTERCLOCKWISE = 1, ct.LEFT = ct.COUNTERCLOCKWISE, ct.COLLINEAR = 0, ct.STRAIGHT = ct.COLLINEAR;
    var ft = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getCoordinate",
                value: function value() {
                    return this._minCoord;
                }
            },
            {
                key: "getRightmostSide",
                value: function value(t, e) {
                    var _$n = this.getRightmostSideOfSegment(t, e);
                    return _$n < 0 && (_$n = this.getRightmostSideOfSegment(t, e - 1)), _$n < 0 && (this._minCoord = null, this.checkForRightmostCoordinate(t)), _$n;
                }
            },
            {
                key: "findRightmostEdgeAtVertex",
                value: function value() {
                    var t = this._minDe.getEdge().getCoordinates();
                    G.isTrue(this._minIndex > 0 && this._minIndex < t.length, "rightmost point expected to be interior vertex of edge");
                    var _$e = t[this._minIndex - 1], _$n = t[this._minIndex + 1], i = ct.index(this._minCoord, _$n, _$e), r = !1;
                    (_$e.y < this._minCoord.y && _$n.y < this._minCoord.y && i === ct.COUNTERCLOCKWISE || _$e.y > this._minCoord.y && _$n.y > this._minCoord.y && i === ct.CLOCKWISE) && (r = !0), r && (this._minIndex = this._minIndex - 1);
                }
            },
            {
                key: "getRightmostSideOfSegment",
                value: function value(t, e) {
                    var _$n = t.getEdge().getCoordinates();
                    if (e < 0 || e + 1 >= _$n.length) return -1;
                    if (_$n[e].y === _$n[e + 1].y) return -1;
                    var i = $.LEFT;
                    return _$n[e].y < _$n[e + 1].y && (i = $.RIGHT), i;
                }
            },
            {
                key: "getEdge",
                value: function value() {
                    return this._orientedDe;
                }
            },
            {
                key: "checkForRightmostCoordinate",
                value: function value(t) {
                    for(var _$e = t.getEdge().getCoordinates(), _$n = 0; _$n < _$e.length - 1; _$n++)(null === this._minCoord || _$e[_$n].x > this._minCoord.x) && (this._minDe = t, this._minIndex = _$n, this._minCoord = _$e[_$n]);
                }
            },
            {
                key: "findRightmostEdgeAtNode",
                value: function value() {
                    var t = this._minDe.getNode().getEdges();
                    this._minDe = t.getRightmostEdge(), this._minDe.isForward() || (this._minDe = this._minDe.getSym(), this._minIndex = this._minDe.getEdge().getCoordinates().length - 1);
                }
            },
            {
                key: "findEdge",
                value: function value(t) {
                    for(var _$e = t.iterator(); _$e.hasNext();){
                        var _$n = _$e.next();
                        _$n.isForward() && this.checkForRightmostCoordinate(_$n);
                    }
                    G.isTrue(0 !== this._minIndex || this._minCoord.equals(this._minDe.getCoordinate()), "inconsistency in rightmost processing"), 0 === this._minIndex ? this.findRightmostEdgeAtNode() : this.findRightmostEdgeAtVertex(), this._orientedDe = this._minDe, this.getRightmostSide(this._minDe, this._minIndex) === $.LEFT && (this._orientedDe = this._minDe.getSym());
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._minIndex = -1, this._minCoord = null, this._minDe = null, this._orientedDe = null;
                }
            }
        ]), e;
    }(), vt = function(e) {
        i(s, e);
        var r = c(s);
        function s(e, n) {
            var _$i;
            return t(this, s), (_$i = r.call(this, n ? e + " [ " + n + " ]" : e)).pt = n ? new X(n) : void 0, _$i.name = Object.keys({
                TopologyException: s
            })[0], _$i;
        }
        return n(s, [
            {
                key: "getCoordinate",
                value: function value() {
                    return this.pt;
                }
            }
        ]), s;
    }(D), gt = function() {
        function e() {
            t(this, e), this.array = [];
        }
        return n(e, [
            {
                key: "addLast",
                value: function value(t) {
                    this.array.push(t);
                }
            },
            {
                key: "removeFirst",
                value: function value() {
                    return this.array.shift();
                }
            },
            {
                key: "isEmpty",
                value: function value() {
                    return 0 === this.array.length;
                }
            }
        ]), e;
    }(), yt = function(e, r) {
        i(a, e);
        var s = c(a);
        function a(e) {
            var _$n;
            return t(this, a), (_$n = s.call(this)).array = [], _instanceof(e, Z) && _$n.addAll(e), _$n;
        }
        return n(a, [
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        nt,
                        Z
                    ];
                }
            },
            {
                key: "ensureCapacity",
                value: function value() {}
            },
            {
                key: "add",
                value: function value(t) {
                    return 1 === arguments.length ? this.array.push(t) : this.array.splice(arguments[0], 0, arguments[1]), !0;
                }
            },
            {
                key: "clear",
                value: function value() {
                    this.array = [];
                }
            },
            {
                key: "addAll",
                value: function value(t) {
                    var _$e, _$n = d(t);
                    try {
                        for(_$n.s(); !(_$e = _$n.n()).done;){
                            var _$i = _$e.value;
                            this.array.push(_$i);
                        }
                    } catch (t) {
                        _$n.e(t);
                    } finally{
                        _$n.f();
                    }
                }
            },
            {
                key: "set",
                value: function value(t, e) {
                    var _$n = this.array[t];
                    return this.array[t] = e, _$n;
                }
            },
            {
                key: "iterator",
                value: function value() {
                    return new dt(this);
                }
            },
            {
                key: "get",
                value: function value(t) {
                    if (t < 0 || t >= this.size()) throw new et;
                    return this.array[t];
                }
            },
            {
                key: "isEmpty",
                value: function value() {
                    return 0 === this.array.length;
                }
            },
            {
                key: "sort",
                value: function value(t) {
                    t ? this.array.sort(function(e, n) {
                        return t.compare(e, n);
                    }) : this.array.sort();
                }
            },
            {
                key: "size",
                value: function value() {
                    return this.array.length;
                }
            },
            {
                key: "toArray",
                value: function value() {
                    return this.array.slice();
                }
            },
            {
                key: "remove",
                value: function value(t) {
                    for(var _$e = 0, _$n = this.array.length; _$e < _$n; _$e++)if (this.array[_$e] === t) return !!this.array.splice(_$e, 1);
                    return !1;
                }
            },
            {
                key: r,
                value: function value() {
                    return this.array.values();
                }
            }
        ]), a;
    }(nt, Symbol.iterator), dt = function() {
        function e(n) {
            t(this, e), this.arrayList = n, this.position = 0;
        }
        return n(e, [
            {
                key: "next",
                value: function value() {
                    if (this.position === this.arrayList.size()) throw new j;
                    return this.arrayList.get(this.position++);
                }
            },
            {
                key: "hasNext",
                value: function value() {
                    return this.position < this.arrayList.size();
                }
            },
            {
                key: "set",
                value: function value(t) {
                    return this.arrayList.set(this.position - 1, t);
                }
            },
            {
                key: "remove",
                value: function value() {
                    this.arrayList.remove(this.arrayList.get(this.position));
                }
            }
        ]), e;
    }(), _t = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "clearVisitedEdges",
                value: function value() {
                    for(var t = this._dirEdgeList.iterator(); t.hasNext();){
                        t.next().setVisited(!1);
                    }
                }
            },
            {
                key: "getRightmostCoordinate",
                value: function value() {
                    return this._rightMostCoord;
                }
            },
            {
                key: "computeNodeDepth",
                value: function value(t) {
                    for(var _$e = null, _$n = t.getEdges().iterator(); _$n.hasNext();){
                        var i = _$n.next();
                        if (i.isVisited() || i.getSym().isVisited()) {
                            _$e = i;
                            break;
                        }
                    }
                    if (null === _$e) throw new vt("unable to find edge to compute depths at " + t.getCoordinate());
                    t.getEdges().computeDepths(_$e);
                    for(var r = t.getEdges().iterator(); r.hasNext();){
                        var s = r.next();
                        s.setVisited(!0), this.copySymDepths(s);
                    }
                }
            },
            {
                key: "computeDepth",
                value: function value(t) {
                    this.clearVisitedEdges();
                    var _$e = this._finder.getEdge();
                    _$e.getNode(), _$e.getLabel(), _$e.setEdgeDepths($.RIGHT, t), this.copySymDepths(_$e), this.computeDepths(_$e);
                }
            },
            {
                key: "create",
                value: function value(t) {
                    this.addReachable(t), this._finder.findEdge(this._dirEdgeList), this._rightMostCoord = this._finder.getCoordinate();
                }
            },
            {
                key: "findResultEdges",
                value: function value() {
                    for(var t = this._dirEdgeList.iterator(); t.hasNext();){
                        var _$e = t.next();
                        _$e.getDepth($.RIGHT) >= 1 && _$e.getDepth($.LEFT) <= 0 && !_$e.isInteriorAreaEdge() && _$e.setInResult(!0);
                    }
                }
            },
            {
                key: "computeDepths",
                value: function value(t) {
                    var _$e = new J, _$n = new gt, i = t.getNode();
                    for(_$n.addLast(i), _$e.add(i), t.setVisited(!0); !_$n.isEmpty();){
                        var r = _$n.removeFirst();
                        _$e.add(r), this.computeNodeDepth(r);
                        for(var s = r.getEdges().iterator(); s.hasNext();){
                            var a = s.next().getSym();
                            if (!a.isVisited()) {
                                var o = a.getNode();
                                _$e.contains(o) || (_$n.addLast(o), _$e.add(o));
                            }
                        }
                    }
                }
            },
            {
                key: "compareTo",
                value: function value(t) {
                    var _$e = t;
                    return this._rightMostCoord.x < _$e._rightMostCoord.x ? -1 : this._rightMostCoord.x > _$e._rightMostCoord.x ? 1 : 0;
                }
            },
            {
                key: "getEnvelope",
                value: function value() {
                    if (null === this._env) {
                        for(var t = new U, _$e = this._dirEdgeList.iterator(); _$e.hasNext();)for(var _$n = _$e.next().getEdge().getCoordinates(), i = 0; i < _$n.length - 1; i++)t.expandToInclude(_$n[i]);
                        this._env = t;
                    }
                    return this._env;
                }
            },
            {
                key: "addReachable",
                value: function value(t) {
                    var _$e = new it;
                    for(_$e.add(t); !_$e.empty();){
                        var _$n = _$e.pop();
                        this.add(_$n, _$e);
                    }
                }
            },
            {
                key: "copySymDepths",
                value: function value(t) {
                    var _$e = t.getSym();
                    _$e.setDepth($.LEFT, t.getDepth($.RIGHT)), _$e.setDepth($.RIGHT, t.getDepth($.LEFT));
                }
            },
            {
                key: "add",
                value: function value(t, e) {
                    t.setVisited(!0), this._nodes.add(t);
                    for(var _$n = t.getEdges().iterator(); _$n.hasNext();){
                        var i = _$n.next();
                        this._dirEdgeList.add(i);
                        var r = i.getSym().getNode();
                        r.isVisited() || e.push(r);
                    }
                }
            },
            {
                key: "getNodes",
                value: function value() {
                    return this._nodes;
                }
            },
            {
                key: "getDirectedEdges",
                value: function value() {
                    return this._dirEdgeList;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        x
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._finder = null, this._dirEdgeList = new yt, this._nodes = new yt, this._rightMostCoord = null, this._env = null, this._finder = new ft;
                }
            }
        ]), e;
    }(), pt = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "intersection",
                value: function value(t, e, n, i) {
                    var r = t.x < e.x ? t.x : e.x, s = t.y < e.y ? t.y : e.y, a = t.x > e.x ? t.x : e.x, o = t.y > e.y ? t.y : e.y, _$u = n.x < i.x ? n.x : i.x, l = n.y < i.y ? n.y : i.y, h = n.x > i.x ? n.x : i.x, c = n.y > i.y ? n.y : i.y, f = ((r > _$u ? r : _$u) + (a < h ? a : h)) / 2, v = ((s > l ? s : l) + (o < c ? o : c)) / 2, g = t.x - f, y = t.y - v, d = e.x - f, _ = e.y - v, p = n.x - f, m = n.y - v, k = i.x - f, x = i.y - v, I = y - _, E = d - g, N = g * _ - d * y, T = m - x, S = k - p, L = p * x - k * m, C = I * S - T * E, R = (E * L - S * N) / C, w = (T * N - I * L) / C;
                    return A.isNaN(R) || A.isInfinite(R) || A.isNaN(w) || A.isInfinite(w) ? null : new X(R + f, w + v);
                }
            }
        ]), e;
    }(), mt = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "arraycopy",
                value: function value(t, e, n, i, r) {
                    for(var s = 0, a = e; a < e + r; a++)n[i + s] = t[a], s++;
                }
            },
            {
                key: "getProperty",
                value: function value(t) {
                    return ({
                        "line.separator": "\n"
                    })[t];
                }
            }
        ]), e;
    }(), kt = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "log10",
                value: function value(t) {
                    var _$n = Math.log(t);
                    return A.isInfinite(_$n) || A.isNaN(_$n) ? _$n : _$n / e.LOG_10;
                }
            },
            {
                key: "min",
                value: function value(t, e, n, i) {
                    var r = t;
                    return e < r && (r = e), n < r && (r = n), i < r && (r = i), r;
                }
            },
            {
                key: "clamp",
                value: function value() {
                    if ("number" == typeof arguments[2] && "number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                        var t = arguments[0], _$e = arguments[1], _$n = arguments[2];
                        return t < _$e ? _$e : t > _$n ? _$n : t;
                    }
                    if (Number.isInteger(arguments[2]) && Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
                        var i = arguments[0], r = arguments[1], s = arguments[2];
                        return i < r ? r : i > s ? s : i;
                    }
                }
            },
            {
                key: "wrap",
                value: function value(t, e) {
                    return t < 0 ? e - -t % e : t % e;
                }
            },
            {
                key: "max",
                value: function value() {
                    if (3 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1], _$n = arguments[2], i = t;
                        return _$e > i && (i = _$e), _$n > i && (i = _$n), i;
                    }
                    if (4 === arguments.length) {
                        var r = arguments[0], s = arguments[1], a = arguments[2], o = arguments[3], _$u = r;
                        return s > _$u && (_$u = s), a > _$u && (_$u = a), o > _$u && (_$u = o), _$u;
                    }
                }
            },
            {
                key: "average",
                value: function value(t, e) {
                    return (t + e) / 2;
                }
            }
        ]), e;
    }();
    kt.LOG_10 = Math.log(10);
    var xt = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "segmentToSegment",
                value: function value(t, n, i, r) {
                    if (t.equals(n)) return e.pointToSegment(t, i, r);
                    if (i.equals(r)) return e.pointToSegment(r, t, n);
                    var s = !1;
                    if (U.intersects(t, n, i, r)) {
                        var a = (n.x - t.x) * (r.y - i.y) - (n.y - t.y) * (r.x - i.x);
                        if (0 === a) s = !0;
                        else {
                            var o = (t.y - i.y) * (r.x - i.x) - (t.x - i.x) * (r.y - i.y), _$u = ((t.y - i.y) * (n.x - t.x) - (t.x - i.x) * (n.y - t.y)) / a, l = o / a;
                            (l < 0 || l > 1 || _$u < 0 || _$u > 1) && (s = !0);
                        }
                    } else s = !0;
                    return s ? kt.min(e.pointToSegment(t, i, r), e.pointToSegment(n, i, r), e.pointToSegment(i, t, n), e.pointToSegment(r, t, n)) : 0;
                }
            },
            {
                key: "pointToSegment",
                value: function value(t, e, n) {
                    if (e.x === n.x && e.y === n.y) return t.distance(e);
                    var i = (n.x - e.x) * (n.x - e.x) + (n.y - e.y) * (n.y - e.y), r = ((t.x - e.x) * (n.x - e.x) + (t.y - e.y) * (n.y - e.y)) / i;
                    if (r <= 0) return t.distance(e);
                    if (r >= 1) return t.distance(n);
                    var s = ((e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y)) / i;
                    return Math.abs(s) * Math.sqrt(i);
                }
            },
            {
                key: "pointToLinePerpendicular",
                value: function value(t, e, n) {
                    var i = (n.x - e.x) * (n.x - e.x) + (n.y - e.y) * (n.y - e.y), r = ((e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y)) / i;
                    return Math.abs(r) * Math.sqrt(i);
                }
            },
            {
                key: "pointToSegmentString",
                value: function value(t, n) {
                    if (0 === n.length) throw new m("Line array must contain at least one vertex");
                    for(var i = t.distance(n[0]), r = 0; r < n.length - 1; r++){
                        var s = e.pointToSegment(t, n[r], n[r + 1]);
                        s < i && (i = s);
                    }
                    return i;
                }
            }
        ]), e;
    }(), It = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "create",
                value: function value() {
                    if (1 === arguments.length) _instanceof(arguments[0], Array) || rt(arguments[0], ht);
                    else if (2 === arguments.length) ;
                    else if (3 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1];
                        return this.create(t, _$e);
                    }
                }
            }
        ]), e;
    }(), Et = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "filter",
                value: function value(t) {}
            }
        ]), e;
    }(), Nt = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "ofLine",
                value: function value(t) {
                    var _$e = t.size();
                    if (_$e <= 1) return 0;
                    var _$n = 0, i = new X;
                    t.getCoordinate(0, i);
                    for(var r = i.x, s = i.y, a = 1; a < _$e; a++){
                        t.getCoordinate(a, i);
                        var o = i.x, _$u = i.y, l = o - r, h = _$u - s;
                        _$n += Math.sqrt(l * l + h * h), r = o, s = _$u;
                    }
                    return _$n;
                }
            }
        ]), e;
    }(), Tt = function e() {
        t(this, e);
    }, St = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "copyCoord",
                value: function value(t, e, n, i) {
                    for(var r = Math.min(t.getDimension(), n.getDimension()), s = 0; s < r; s++)n.setOrdinate(i, s, t.getOrdinate(e, s));
                }
            },
            {
                key: "isRing",
                value: function value(t) {
                    var _$e = t.size();
                    return 0 === _$e || !(_$e <= 3) && t.getOrdinate(0, ht.X) === t.getOrdinate(_$e - 1, ht.X) && t.getOrdinate(0, ht.Y) === t.getOrdinate(_$e - 1, ht.Y);
                }
            },
            {
                key: "scroll",
                value: function value() {
                    if (2 === arguments.length) {
                        if (rt(arguments[0], ht) && Number.isInteger(arguments[1])) {
                            var t = arguments[0], _$n = arguments[1];
                            e.scroll(t, _$n, e.isRing(t));
                        } else if (rt(arguments[0], ht) && _instanceof(arguments[1], X)) {
                            var i = arguments[0], r = arguments[1], s = e.indexOf(r, i);
                            if (s <= 0) return null;
                            e.scroll(i, s);
                        }
                    } else if (3 === arguments.length) {
                        var a = arguments[0], o = arguments[1], _$u = arguments[2], l = o;
                        if (l <= 0) return null;
                        for(var h = a.copy(), c = _$u ? a.size() - 1 : a.size(), f = 0; f < c; f++)for(var v = 0; v < a.getDimension(); v++)a.setOrdinate(f, v, h.getOrdinate((o + f) % c, v));
                        if (_$u) for(var g = 0; g < a.getDimension(); g++)a.setOrdinate(c, g, a.getOrdinate(0, g));
                    }
                }
            },
            {
                key: "isEqual",
                value: function value(t, e) {
                    var _$n = t.size();
                    if (_$n !== e.size()) return !1;
                    for(var i = Math.min(t.getDimension(), e.getDimension()), r = 0; r < _$n; r++)for(var s = 0; s < i; s++){
                        var a = t.getOrdinate(r, s), o = e.getOrdinate(r, s);
                        if (t.getOrdinate(r, s) !== e.getOrdinate(r, s) && (!A.isNaN(a) || !A.isNaN(o))) return !1;
                    }
                    return !0;
                }
            },
            {
                key: "minCoordinateIndex",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        return e.minCoordinateIndex(t, 0, t.size() - 1);
                    }
                    if (3 === arguments.length) {
                        for(var _$n = arguments[0], i = arguments[1], r = arguments[2], s = -1, a = null, o = i; o <= r; o++){
                            var _$u = _$n.getCoordinate(o);
                            (null === a || a.compareTo(_$u) > 0) && (a = _$u, s = o);
                        }
                        return s;
                    }
                }
            },
            {
                key: "extend",
                value: function value(t, n, i) {
                    var r = t.create(i, n.getDimension()), s = n.size();
                    if (e.copy(n, 0, r, 0, s), s > 0) for(var a = s; a < i; a++)e.copy(n, s - 1, r, a, 1);
                    return r;
                }
            },
            {
                key: "reverse",
                value: function value(t) {
                    for(var _$n = t.size() - 1, i = Math.trunc(_$n / 2), r = 0; r <= i; r++)e.swap(t, r, _$n - r);
                }
            },
            {
                key: "swap",
                value: function value(t, e, n) {
                    if (e === n) return null;
                    for(var i = 0; i < t.getDimension(); i++){
                        var r = t.getOrdinate(e, i);
                        t.setOrdinate(e, i, t.getOrdinate(n, i)), t.setOrdinate(n, i, r);
                    }
                }
            },
            {
                key: "copy",
                value: function value(t, n, i, r, s) {
                    for(var a = 0; a < s; a++)e.copyCoord(t, n + a, i, r + a);
                }
            },
            {
                key: "ensureValidRing",
                value: function value(t, n) {
                    var i = n.size();
                    return 0 === i ? n : i <= 3 ? e.createClosedRing(t, n, 4) : n.getOrdinate(0, ht.X) === n.getOrdinate(i - 1, ht.X) && n.getOrdinate(0, ht.Y) === n.getOrdinate(i - 1, ht.Y) ? n : e.createClosedRing(t, n, i + 1);
                }
            },
            {
                key: "indexOf",
                value: function value(t, e) {
                    for(var _$n = 0; _$n < e.size(); _$n++)if (t.x === e.getOrdinate(_$n, ht.X) && t.y === e.getOrdinate(_$n, ht.Y)) return _$n;
                    return -1;
                }
            },
            {
                key: "createClosedRing",
                value: function value(t, n, i) {
                    var r = t.create(i, n.getDimension()), s = n.size();
                    e.copy(n, 0, r, 0, s);
                    for(var a = s; a < i; a++)e.copy(n, 0, r, a, 1);
                    return r;
                }
            },
            {
                key: "minCoordinate",
                value: function value(t) {
                    for(var _$e = null, _$n = 0; _$n < t.size(); _$n++){
                        var i = t.getCoordinate(_$n);
                        (null === _$e || _$e.compareTo(i) > 0) && (_$e = i);
                    }
                    return _$e;
                }
            }
        ]), e;
    }(), Lt = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "toDimensionSymbol",
                value: function value(t) {
                    switch(t){
                        case e.FALSE:
                            return e.SYM_FALSE;
                        case e.TRUE:
                            return e.SYM_TRUE;
                        case e.DONTCARE:
                            return e.SYM_DONTCARE;
                        case e.P:
                            return e.SYM_P;
                        case e.L:
                            return e.SYM_L;
                        case e.A:
                            return e.SYM_A;
                    }
                    throw new m("Unknown dimension value: " + t);
                }
            },
            {
                key: "toDimensionValue",
                value: function value(t) {
                    switch(ot.toUpperCase(t)){
                        case e.SYM_FALSE:
                            return e.FALSE;
                        case e.SYM_TRUE:
                            return e.TRUE;
                        case e.SYM_DONTCARE:
                            return e.DONTCARE;
                        case e.SYM_P:
                            return e.P;
                        case e.SYM_L:
                            return e.L;
                        case e.SYM_A:
                            return e.A;
                    }
                    throw new m("Unknown dimension symbol: " + t);
                }
            }
        ]), e;
    }();
    Lt.P = 0, Lt.L = 1, Lt.A = 2, Lt.FALSE = -1, Lt.TRUE = -2, Lt.DONTCARE = -3, Lt.SYM_FALSE = "F", Lt.SYM_TRUE = "T", Lt.SYM_DONTCARE = "*", Lt.SYM_P = "0", Lt.SYM_L = "1", Lt.SYM_A = "2";
    var Ct = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "filter",
                value: function value(t) {}
            }
        ]), e;
    }(), Rt = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "filter",
                value: function value(t, e) {}
            },
            {
                key: "isDone",
                value: function value() {}
            },
            {
                key: "isGeometryChanged",
                value: function value() {}
            }
        ]), e;
    }(), wt = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "computeEnvelopeInternal",
                value: function value() {
                    return this.isEmpty() ? new U : this._points.expandEnvelope(new U);
                }
            },
            {
                key: "isRing",
                value: function value() {
                    return this.isClosed() && this.isSimple();
                }
            },
            {
                key: "getCoordinates",
                value: function value() {
                    return this._points.toCoordinateArray();
                }
            },
            {
                key: "copyInternal",
                value: function value() {
                    return new a(this._points.copy(), this._factory);
                }
            },
            {
                key: "equalsExact",
                value: function value() {
                    if (2 === arguments.length && "number" == typeof arguments[1] && _instanceof(arguments[0], V)) {
                        var t = arguments[0], _$e = arguments[1];
                        if (!this.isEquivalentClass(t)) return !1;
                        var _$n = t;
                        if (this._points.size() !== _$n._points.size()) return !1;
                        for(var _$i = 0; _$i < this._points.size(); _$i++)if (!this.equal(this._points.getCoordinate(_$i), _$n._points.getCoordinate(_$i), _$e)) return !1;
                        return !0;
                    }
                    return f(r(a.prototype), "equalsExact", this).apply(this, arguments);
                }
            },
            {
                key: "normalize",
                value: function value() {
                    for(var t = 0; t < Math.trunc(this._points.size() / 2); t++){
                        var _$e = this._points.size() - 1 - t;
                        if (!this._points.getCoordinate(t).equals(this._points.getCoordinate(_$e))) {
                            if (this._points.getCoordinate(t).compareTo(this._points.getCoordinate(_$e)) > 0) {
                                var _$n = this._points.copy();
                                St.reverse(_$n), this._points = _$n;
                            }
                            return null;
                        }
                    }
                }
            },
            {
                key: "getCoordinate",
                value: function value() {
                    return this.isEmpty() ? null : this._points.getCoordinate(0);
                }
            },
            {
                key: "getBoundaryDimension",
                value: function value() {
                    return this.isClosed() ? Lt.FALSE : 0;
                }
            },
            {
                key: "isClosed",
                value: function value() {
                    return !this.isEmpty() && this.getCoordinateN(0).equals2D(this.getCoordinateN(this.getNumPoints() - 1));
                }
            },
            {
                key: "reverseInternal",
                value: function value() {
                    var t = this._points.copy();
                    return St.reverse(t), this.getFactory().createLineString(t);
                }
            },
            {
                key: "getEndPoint",
                value: function value() {
                    return this.isEmpty() ? null : this.getPointN(this.getNumPoints() - 1);
                }
            },
            {
                key: "getTypeCode",
                value: function value() {
                    return V.TYPECODE_LINESTRING;
                }
            },
            {
                key: "getDimension",
                value: function value() {
                    return 1;
                }
            },
            {
                key: "getLength",
                value: function value() {
                    return Nt.ofLine(this._points);
                }
            },
            {
                key: "getNumPoints",
                value: function value() {
                    return this._points.size();
                }
            },
            {
                key: "compareToSameClass",
                value: function value() {
                    if (1 === arguments.length) {
                        for(var t = arguments[0], _$e = t, _$n = 0, _$i = 0; _$n < this._points.size() && _$i < _$e._points.size();){
                            var r = this._points.getCoordinate(_$n).compareTo(_$e._points.getCoordinate(_$i));
                            if (0 !== r) return r;
                            _$n++, _$i++;
                        }
                        return _$n < this._points.size() ? 1 : _$i < _$e._points.size() ? -1 : 0;
                    }
                    if (2 === arguments.length) {
                        var s = arguments[0], _$a = arguments[1], o = s;
                        return _$a.compare(this._points, o._points);
                    }
                }
            },
            {
                key: "apply",
                value: function value() {
                    if (rt(arguments[0], Et)) for(var t = arguments[0], _$e = 0; _$e < this._points.size(); _$e++)t.filter(this._points.getCoordinate(_$e));
                    else if (rt(arguments[0], Rt)) {
                        var _$n = arguments[0];
                        if (0 === this._points.size()) return null;
                        for(var _$i = 0; _$i < this._points.size() && (_$n.filter(this._points, _$i), !_$n.isDone()); _$i++);
                        _$n.isGeometryChanged() && this.geometryChanged();
                    } else if (rt(arguments[0], Ct)) {
                        var r = arguments[0];
                        r.filter(this);
                    } else if (rt(arguments[0], k)) {
                        var s = arguments[0];
                        s.filter(this);
                    }
                }
            },
            {
                key: "getBoundary",
                value: function value() {
                    throw new W;
                }
            },
            {
                key: "isEquivalentClass",
                value: function value(t) {
                    return _instanceof(t, a);
                }
            },
            {
                key: "getCoordinateN",
                value: function value(t) {
                    return this._points.getCoordinate(t);
                }
            },
            {
                key: "getGeometryType",
                value: function value() {
                    return V.TYPENAME_LINESTRING;
                }
            },
            {
                key: "getCoordinateSequence",
                value: function value() {
                    return this._points;
                }
            },
            {
                key: "isEmpty",
                value: function value() {
                    return 0 === this._points.size();
                }
            },
            {
                key: "init",
                value: function value(t) {
                    if (null === t && (t = this.getFactory().getCoordinateSequenceFactory().create([])), 1 === t.size()) throw new m("Invalid number of points in LineString (found " + t.size() + " - must be 0 or >= 2)");
                    this._points = t;
                }
            },
            {
                key: "isCoordinate",
                value: function value(t) {
                    for(var _$e = 0; _$e < this._points.size(); _$e++)if (this._points.getCoordinate(_$e).equals(t)) return !0;
                    return !1;
                }
            },
            {
                key: "getStartPoint",
                value: function value() {
                    return this.isEmpty() ? null : this.getPointN(0);
                }
            },
            {
                key: "getPointN",
                value: function value(t) {
                    return this.getFactory().createPoint(this._points.getCoordinate(t));
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        Tt
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._points = null, 0 === arguments.length) ;
                    else if (2 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1];
                        V.constructor_.call(this, _$e), this.init(t);
                    }
                }
            }
        ]), a;
    }(V), Ot = function e() {
        t(this, e);
    }, bt = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "computeEnvelopeInternal",
                value: function value() {
                    if (this.isEmpty()) return new U;
                    var t = new U;
                    return t.expandToInclude(this._coordinates.getX(0), this._coordinates.getY(0)), t;
                }
            },
            {
                key: "getCoordinates",
                value: function value() {
                    return this.isEmpty() ? [] : [
                        this.getCoordinate()
                    ];
                }
            },
            {
                key: "copyInternal",
                value: function value() {
                    return new a(this._coordinates.copy(), this._factory);
                }
            },
            {
                key: "equalsExact",
                value: function value() {
                    if (2 === arguments.length && "number" == typeof arguments[1] && _instanceof(arguments[0], V)) {
                        var t = arguments[0], _$e = arguments[1];
                        return !!this.isEquivalentClass(t) && (!(!this.isEmpty() || !t.isEmpty()) || this.isEmpty() === t.isEmpty() && this.equal(t.getCoordinate(), this.getCoordinate(), _$e));
                    }
                    return f(r(a.prototype), "equalsExact", this).apply(this, arguments);
                }
            },
            {
                key: "normalize",
                value: function value() {}
            },
            {
                key: "getCoordinate",
                value: function value() {
                    return 0 !== this._coordinates.size() ? this._coordinates.getCoordinate(0) : null;
                }
            },
            {
                key: "getBoundaryDimension",
                value: function value() {
                    return Lt.FALSE;
                }
            },
            {
                key: "reverseInternal",
                value: function value() {
                    return this.getFactory().createPoint(this._coordinates.copy());
                }
            },
            {
                key: "getTypeCode",
                value: function value() {
                    return V.TYPECODE_POINT;
                }
            },
            {
                key: "getDimension",
                value: function value() {
                    return 0;
                }
            },
            {
                key: "getNumPoints",
                value: function value() {
                    return this.isEmpty() ? 0 : 1;
                }
            },
            {
                key: "getX",
                value: function value() {
                    if (null === this.getCoordinate()) throw new IllegalStateException("getX called on empty Point");
                    return this.getCoordinate().x;
                }
            },
            {
                key: "compareToSameClass",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0], _$e = t;
                        return this.getCoordinate().compareTo(_$e.getCoordinate());
                    }
                    if (2 === arguments.length) {
                        var _$n = arguments[0], _$i = arguments[1], r = _$n;
                        return _$i.compare(this._coordinates, r._coordinates);
                    }
                }
            },
            {
                key: "apply",
                value: function value() {
                    if (rt(arguments[0], Et)) {
                        var t = arguments[0];
                        if (this.isEmpty()) return null;
                        t.filter(this.getCoordinate());
                    } else if (rt(arguments[0], Rt)) {
                        var _$e = arguments[0];
                        if (this.isEmpty()) return null;
                        _$e.filter(this._coordinates, 0), _$e.isGeometryChanged() && this.geometryChanged();
                    } else if (rt(arguments[0], Ct)) {
                        var _$n = arguments[0];
                        _$n.filter(this);
                    } else if (rt(arguments[0], k)) {
                        var _$i = arguments[0];
                        _$i.filter(this);
                    }
                }
            },
            {
                key: "getBoundary",
                value: function value() {
                    return this.getFactory().createGeometryCollection();
                }
            },
            {
                key: "getGeometryType",
                value: function value() {
                    return V.TYPENAME_POINT;
                }
            },
            {
                key: "getCoordinateSequence",
                value: function value() {
                    return this._coordinates;
                }
            },
            {
                key: "getY",
                value: function value() {
                    if (null === this.getCoordinate()) throw new IllegalStateException("getY called on empty Point");
                    return this.getCoordinate().y;
                }
            },
            {
                key: "isEmpty",
                value: function value() {
                    return 0 === this._coordinates.size();
                }
            },
            {
                key: "init",
                value: function value(t) {
                    null === t && (t = this.getFactory().getCoordinateSequenceFactory().create([])), G.isTrue(t.size() <= 1), this._coordinates = t;
                }
            },
            {
                key: "isSimple",
                value: function value() {
                    return !0;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        Ot
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._coordinates = null;
                    var t = arguments[0], _$e = arguments[1];
                    V.constructor_.call(this, _$e), this.init(t);
                }
            }
        ]), a;
    }(V), Mt = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "ofRing",
                value: function value() {
                    if (_instanceof(arguments[0], Array)) {
                        var t = arguments[0];
                        return Math.abs(e.ofRingSigned(t));
                    }
                    if (rt(arguments[0], ht)) {
                        var _$n = arguments[0];
                        return Math.abs(e.ofRingSigned(_$n));
                    }
                }
            },
            {
                key: "ofRingSigned",
                value: function value() {
                    if (_instanceof(arguments[0], Array)) {
                        var t = arguments[0];
                        if (t.length < 3) return 0;
                        for(var _$e = 0, _$n = t[0].x, i = 1; i < t.length - 1; i++){
                            var r = t[i].x - _$n, s = t[i + 1].y, a = t[i - 1].y;
                            _$e += r * (a - s);
                        }
                        return _$e / 2;
                    }
                    if (rt(arguments[0], ht)) {
                        var o = arguments[0], _$u = o.size();
                        if (_$u < 3) return 0;
                        var l = new X, h = new X, c = new X;
                        o.getCoordinate(0, h), o.getCoordinate(1, c);
                        var f = h.x;
                        c.x -= f;
                        for(var v = 0, g = 1; g < _$u - 1; g++)l.y = h.y, h.x = c.x, h.y = c.y, o.getCoordinate(g + 1, c), c.x -= f, v += h.x * (l.y - c.y);
                        return v / 2;
                    }
                }
            }
        ]), e;
    }(), At = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "sort",
                value: function value() {
                    var _$t = arguments, _$e = arguments[0];
                    if (1 === arguments.length) _$e.sort(function(t, e) {
                        return t.compareTo(e);
                    });
                    else if (2 === arguments.length) _$e.sort(function(e, n) {
                        return _$t[1].compare(e, n);
                    });
                    else if (3 === arguments.length) {
                        var _$n = _$e.slice(arguments[1], arguments[2]);
                        _$n.sort();
                        var i = _$e.slice(0, arguments[1]).concat(_$n, _$e.slice(arguments[2], _$e.length));
                        _$e.splice(0, _$e.length);
                        var r, s = d(i);
                        try {
                            for(s.s(); !(r = s.n()).done;){
                                var a = r.value;
                                _$e.push(a);
                            }
                        } catch (t) {
                            s.e(t);
                        } finally{
                            s.f();
                        }
                    } else if (4 === arguments.length) {
                        var o = _$e.slice(arguments[1], arguments[2]);
                        o.sort(function(e, n) {
                            return _$t[3].compare(e, n);
                        });
                        var _$u = _$e.slice(0, arguments[1]).concat(o, _$e.slice(arguments[2], _$e.length));
                        _$e.splice(0, _$e.length);
                        var l, h = d(_$u);
                        try {
                            for(h.s(); !(l = h.n()).done;){
                                var c = l.value;
                                _$e.push(c);
                            }
                        } catch (t) {
                            h.e(t);
                        } finally{
                            h.f();
                        }
                    }
                }
            },
            {
                key: "asList",
                value: function value(t) {
                    var _$e, _$n = new yt, i = d(t);
                    try {
                        for(i.s(); !(_$e = i.n()).done;){
                            var r = _$e.value;
                            _$n.add(r);
                        }
                    } catch (t) {
                        i.e(t);
                    } finally{
                        i.f();
                    }
                    return _$n;
                }
            },
            {
                key: "copyOf",
                value: function value(t, e) {
                    return t.slice(0, e);
                }
            }
        ]), e;
    }(), Pt = function e() {
        t(this, e);
    }, Dt = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "computeEnvelopeInternal",
                value: function value() {
                    return this._shell.getEnvelopeInternal();
                }
            },
            {
                key: "getCoordinates",
                value: function value() {
                    if (this.isEmpty()) return [];
                    for(var t = new Array(this.getNumPoints()).fill(null), _$e = -1, _$n = this._shell.getCoordinates(), _$i = 0; _$i < _$n.length; _$i++)t[++_$e] = _$n[_$i];
                    for(var r = 0; r < this._holes.length; r++)for(var s = this._holes[r].getCoordinates(), _$a = 0; _$a < s.length; _$a++)t[++_$e] = s[_$a];
                    return t;
                }
            },
            {
                key: "getArea",
                value: function value() {
                    var t = 0;
                    t += Mt.ofRing(this._shell.getCoordinateSequence());
                    for(var _$e = 0; _$e < this._holes.length; _$e++)t -= Mt.ofRing(this._holes[_$e].getCoordinateSequence());
                    return t;
                }
            },
            {
                key: "copyInternal",
                value: function value() {
                    for(var t = this._shell.copy(), _$e = new Array(this._holes.length).fill(null), _$n = 0; _$n < this._holes.length; _$n++)_$e[_$n] = this._holes[_$n].copy();
                    return new a(t, _$e, this._factory);
                }
            },
            {
                key: "isRectangle",
                value: function value() {
                    if (0 !== this.getNumInteriorRing()) return !1;
                    if (null === this._shell) return !1;
                    if (5 !== this._shell.getNumPoints()) return !1;
                    for(var t = this._shell.getCoordinateSequence(), _$e = this.getEnvelopeInternal(), _$n = 0; _$n < 5; _$n++){
                        var _$i = t.getX(_$n);
                        if (_$i !== _$e.getMinX() && _$i !== _$e.getMaxX()) return !1;
                        var r = t.getY(_$n);
                        if (r !== _$e.getMinY() && r !== _$e.getMaxY()) return !1;
                    }
                    for(var s = t.getX(0), _$a = t.getY(0), o = 1; o <= 4; o++){
                        var _$u = t.getX(o), l = t.getY(o);
                        if (_$u !== s === (l !== _$a)) return !1;
                        s = _$u, _$a = l;
                    }
                    return !0;
                }
            },
            {
                key: "equalsExact",
                value: function value() {
                    if (2 === arguments.length && "number" == typeof arguments[1] && _instanceof(arguments[0], V)) {
                        var t = arguments[0], _$e = arguments[1];
                        if (!this.isEquivalentClass(t)) return !1;
                        var _$n = t, _$i = this._shell, s = _$n._shell;
                        if (!_$i.equalsExact(s, _$e)) return !1;
                        if (this._holes.length !== _$n._holes.length) return !1;
                        for(var o = 0; o < this._holes.length; o++)if (!this._holes[o].equalsExact(_$n._holes[o], _$e)) return !1;
                        return !0;
                    }
                    return f(r(a.prototype), "equalsExact", this).apply(this, arguments);
                }
            },
            {
                key: "normalize",
                value: function value() {
                    if (0 === arguments.length) {
                        this._shell = this.normalized(this._shell, !0);
                        for(var t = 0; t < this._holes.length; t++)this._holes[t] = this.normalized(this._holes[t], !1);
                        At.sort(this._holes);
                    } else if (2 === arguments.length) {
                        var _$e = arguments[0], _$n = arguments[1];
                        if (_$e.isEmpty()) return null;
                        var _$i = _$e.getCoordinateSequence(), r = St.minCoordinateIndex(_$i, 0, _$i.size() - 2);
                        St.scroll(_$i, r, !0), ct.isCCW(_$i) === _$n && St.reverse(_$i);
                    }
                }
            },
            {
                key: "getCoordinate",
                value: function value() {
                    return this._shell.getCoordinate();
                }
            },
            {
                key: "getNumInteriorRing",
                value: function value() {
                    return this._holes.length;
                }
            },
            {
                key: "getBoundaryDimension",
                value: function value() {
                    return 1;
                }
            },
            {
                key: "reverseInternal",
                value: function value() {
                    for(var t = this.getExteriorRing().reverse(), _$e = new Array(this.getNumInteriorRing()).fill(null), _$n = 0; _$n < _$e.length; _$n++)_$e[_$n] = this.getInteriorRingN(_$n).reverse();
                    return this.getFactory().createPolygon(t, _$e);
                }
            },
            {
                key: "getTypeCode",
                value: function value() {
                    return V.TYPECODE_POLYGON;
                }
            },
            {
                key: "getDimension",
                value: function value() {
                    return 2;
                }
            },
            {
                key: "getLength",
                value: function value() {
                    var t = 0;
                    t += this._shell.getLength();
                    for(var _$e = 0; _$e < this._holes.length; _$e++)t += this._holes[_$e].getLength();
                    return t;
                }
            },
            {
                key: "getNumPoints",
                value: function value() {
                    for(var t = this._shell.getNumPoints(), _$e = 0; _$e < this._holes.length; _$e++)t += this._holes[_$e].getNumPoints();
                    return t;
                }
            },
            {
                key: "convexHull",
                value: function value() {
                    return this.getExteriorRing().convexHull();
                }
            },
            {
                key: "normalized",
                value: function value(t, e) {
                    var _$n = t.copy();
                    return this.normalize(_$n, e), _$n;
                }
            },
            {
                key: "compareToSameClass",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0], _$e = this._shell, _$n = t._shell;
                        return _$e.compareToSameClass(_$n);
                    }
                    if (2 === arguments.length) {
                        var _$i = arguments[0], r = arguments[1], s = _$i, _$a = this._shell, o = s._shell, _$u = _$a.compareToSameClass(o, r);
                        if (0 !== _$u) return _$u;
                        for(var l = this.getNumInteriorRing(), h = s.getNumInteriorRing(), _$c = 0; _$c < l && _$c < h;){
                            var f = this.getInteriorRingN(_$c), v = s.getInteriorRingN(_$c), g = f.compareToSameClass(v, r);
                            if (0 !== g) return g;
                            _$c++;
                        }
                        return _$c < l ? 1 : _$c < h ? -1 : 0;
                    }
                }
            },
            {
                key: "apply",
                value: function value() {
                    if (rt(arguments[0], Et)) {
                        var t = arguments[0];
                        this._shell.apply(t);
                        for(var _$e = 0; _$e < this._holes.length; _$e++)this._holes[_$e].apply(t);
                    } else if (rt(arguments[0], Rt)) {
                        var _$n = arguments[0];
                        if (this._shell.apply(_$n), !_$n.isDone()) for(var _$i = 0; _$i < this._holes.length && (this._holes[_$i].apply(_$n), !_$n.isDone()); _$i++);
                        _$n.isGeometryChanged() && this.geometryChanged();
                    } else if (rt(arguments[0], Ct)) {
                        var r = arguments[0];
                        r.filter(this);
                    } else if (rt(arguments[0], k)) {
                        var s = arguments[0];
                        s.filter(this), this._shell.apply(s);
                        for(var _$a = 0; _$a < this._holes.length; _$a++)this._holes[_$a].apply(s);
                    }
                }
            },
            {
                key: "getBoundary",
                value: function value() {
                    if (this.isEmpty()) return this.getFactory().createMultiLineString();
                    var t = new Array(this._holes.length + 1).fill(null);
                    t[0] = this._shell;
                    for(var _$e = 0; _$e < this._holes.length; _$e++)t[_$e + 1] = this._holes[_$e];
                    return t.length <= 1 ? this.getFactory().createLinearRing(t[0].getCoordinateSequence()) : this.getFactory().createMultiLineString(t);
                }
            },
            {
                key: "getGeometryType",
                value: function value() {
                    return V.TYPENAME_POLYGON;
                }
            },
            {
                key: "getExteriorRing",
                value: function value() {
                    return this._shell;
                }
            },
            {
                key: "isEmpty",
                value: function value() {
                    return this._shell.isEmpty();
                }
            },
            {
                key: "getInteriorRingN",
                value: function value(t) {
                    return this._holes[t];
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        Pt
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._shell = null, this._holes = null;
                    var t = arguments[0], _$e = arguments[1], _$n = arguments[2];
                    if (V.constructor_.call(this, _$n), null === t && (t = this.getFactory().createLinearRing()), null === _$e && (_$e = []), V.hasNullElements(_$e)) throw new m("holes must not contain null elements");
                    if (t.isEmpty() && V.hasNonEmptyElements(_$e)) throw new m("shell is empty but holes are not");
                    this._shell = t, this._holes = _$e;
                }
            }
        ]), a;
    }(V), Ft = function(e) {
        i(r, e);
        var n = c(r);
        function r() {
            return t(this, r), n.apply(this, arguments);
        }
        return r;
    }(K), Gt = function(e) {
        i(s, e);
        var r = c(s);
        function s(e) {
            var _$n;
            return t(this, s), (_$n = r.call(this)).array = [], _instanceof(e, Z) && _$n.addAll(e), _$n;
        }
        return n(s, [
            {
                key: "contains",
                value: function value(t) {
                    var _$e, _$n = d(this.array);
                    try {
                        for(_$n.s(); !(_$e = _$n.n()).done;){
                            if (0 === _$e.value.compareTo(t)) return !0;
                        }
                    } catch (t) {
                        _$n.e(t);
                    } finally{
                        _$n.f();
                    }
                    return !1;
                }
            },
            {
                key: "add",
                value: function value(t) {
                    if (this.contains(t)) return !1;
                    for(var _$e = 0, _$n = this.array.length; _$e < _$n; _$e++){
                        if (1 === this.array[_$e].compareTo(t)) return !!this.array.splice(_$e, 0, t);
                    }
                    return this.array.push(t), !0;
                }
            },
            {
                key: "addAll",
                value: function value(t) {
                    var _$e, _$n = d(t);
                    try {
                        for(_$n.s(); !(_$e = _$n.n()).done;){
                            var _$i = _$e.value;
                            this.add(_$i);
                        }
                    } catch (t) {
                        _$n.e(t);
                    } finally{
                        _$n.f();
                    }
                    return !0;
                }
            },
            {
                key: "remove",
                value: function value() {
                    throw new W;
                }
            },
            {
                key: "size",
                value: function value() {
                    return this.array.length;
                }
            },
            {
                key: "isEmpty",
                value: function value() {
                    return 0 === this.array.length;
                }
            },
            {
                key: "toArray",
                value: function value() {
                    return this.array.slice();
                }
            },
            {
                key: "iterator",
                value: function value() {
                    return new qt(this.array);
                }
            }
        ]), s;
    }(Ft), qt = function() {
        function e(n) {
            t(this, e), this.array = n, this.position = 0;
        }
        return n(e, [
            {
                key: "next",
                value: function value() {
                    if (this.position === this.array.length) throw new j;
                    return this.array[this.position++];
                }
            },
            {
                key: "hasNext",
                value: function value() {
                    return this.position < this.array.length;
                }
            },
            {
                key: "remove",
                value: function value() {
                    throw new W;
                }
            }
        ]), e;
    }(), Yt = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "computeEnvelopeInternal",
                value: function value() {
                    for(var t = new U, _$e = 0; _$e < this._geometries.length; _$e++)t.expandToInclude(this._geometries[_$e].getEnvelopeInternal());
                    return t;
                }
            },
            {
                key: "getGeometryN",
                value: function value(t) {
                    return this._geometries[t];
                }
            },
            {
                key: "getCoordinates",
                value: function value() {
                    for(var t = new Array(this.getNumPoints()).fill(null), _$e = -1, _$n = 0; _$n < this._geometries.length; _$n++)for(var _$i = this._geometries[_$n].getCoordinates(), r = 0; r < _$i.length; r++)t[++_$e] = _$i[r];
                    return t;
                }
            },
            {
                key: "getArea",
                value: function value() {
                    for(var t = 0, _$e = 0; _$e < this._geometries.length; _$e++)t += this._geometries[_$e].getArea();
                    return t;
                }
            },
            {
                key: "copyInternal",
                value: function value() {
                    for(var t = new Array(this._geometries.length).fill(null), _$e = 0; _$e < t.length; _$e++)t[_$e] = this._geometries[_$e].copy();
                    return new a(t, this._factory);
                }
            },
            {
                key: "equalsExact",
                value: function value() {
                    if (2 === arguments.length && "number" == typeof arguments[1] && _instanceof(arguments[0], V)) {
                        var t = arguments[0], _$e = arguments[1];
                        if (!this.isEquivalentClass(t)) return !1;
                        var _$n = t;
                        if (this._geometries.length !== _$n._geometries.length) return !1;
                        for(var _$i = 0; _$i < this._geometries.length; _$i++)if (!this._geometries[_$i].equalsExact(_$n._geometries[_$i], _$e)) return !1;
                        return !0;
                    }
                    return f(r(a.prototype), "equalsExact", this).apply(this, arguments);
                }
            },
            {
                key: "normalize",
                value: function value() {
                    for(var t = 0; t < this._geometries.length; t++)this._geometries[t].normalize();
                    At.sort(this._geometries);
                }
            },
            {
                key: "getCoordinate",
                value: function value() {
                    return this.isEmpty() ? null : this._geometries[0].getCoordinate();
                }
            },
            {
                key: "getBoundaryDimension",
                value: function value() {
                    for(var t = Lt.FALSE, _$e = 0; _$e < this._geometries.length; _$e++)t = Math.max(t, this._geometries[_$e].getBoundaryDimension());
                    return t;
                }
            },
            {
                key: "reverseInternal",
                value: function value() {
                    for(var t = this._geometries.length, _$e = new yt(t), _$n = 0; _$n < t; _$n++)_$e.add(this._geometries[_$n].reverse());
                    return this.getFactory().buildGeometry(_$e);
                }
            },
            {
                key: "getTypeCode",
                value: function value() {
                    return V.TYPECODE_GEOMETRYCOLLECTION;
                }
            },
            {
                key: "getDimension",
                value: function value() {
                    for(var t = Lt.FALSE, _$e = 0; _$e < this._geometries.length; _$e++)t = Math.max(t, this._geometries[_$e].getDimension());
                    return t;
                }
            },
            {
                key: "getLength",
                value: function value() {
                    for(var t = 0, _$e = 0; _$e < this._geometries.length; _$e++)t += this._geometries[_$e].getLength();
                    return t;
                }
            },
            {
                key: "getNumPoints",
                value: function value() {
                    for(var t = 0, _$e = 0; _$e < this._geometries.length; _$e++)t += this._geometries[_$e].getNumPoints();
                    return t;
                }
            },
            {
                key: "getNumGeometries",
                value: function value() {
                    return this._geometries.length;
                }
            },
            {
                key: "compareToSameClass",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0], _$e = new Gt(At.asList(this._geometries)), _$n = new Gt(At.asList(t._geometries));
                        return this.compare(_$e, _$n);
                    }
                    if (2 === arguments.length) {
                        for(var _$i = arguments[0], r = arguments[1], s = _$i, _$a = this.getNumGeometries(), o = s.getNumGeometries(), _$u = 0; _$u < _$a && _$u < o;){
                            var l = this.getGeometryN(_$u), h = s.getGeometryN(_$u), _$c = l.compareToSameClass(h, r);
                            if (0 !== _$c) return _$c;
                            _$u++;
                        }
                        return _$u < _$a ? 1 : _$u < o ? -1 : 0;
                    }
                }
            },
            {
                key: "apply",
                value: function value() {
                    if (rt(arguments[0], Et)) for(var t = arguments[0], _$e = 0; _$e < this._geometries.length; _$e++)this._geometries[_$e].apply(t);
                    else if (rt(arguments[0], Rt)) {
                        var _$n = arguments[0];
                        if (0 === this._geometries.length) return null;
                        for(var _$i = 0; _$i < this._geometries.length && (this._geometries[_$i].apply(_$n), !_$n.isDone()); _$i++);
                        _$n.isGeometryChanged() && this.geometryChanged();
                    } else if (rt(arguments[0], Ct)) {
                        var r = arguments[0];
                        r.filter(this);
                        for(var s = 0; s < this._geometries.length; s++)this._geometries[s].apply(r);
                    } else if (rt(arguments[0], k)) {
                        var _$a = arguments[0];
                        _$a.filter(this);
                        for(var o = 0; o < this._geometries.length; o++)this._geometries[o].apply(_$a);
                    }
                }
            },
            {
                key: "getBoundary",
                value: function value() {
                    return V.checkNotGeometryCollection(this), G.shouldNeverReachHere(), null;
                }
            },
            {
                key: "getGeometryType",
                value: function value() {
                    return V.TYPENAME_GEOMETRYCOLLECTION;
                }
            },
            {
                key: "isEmpty",
                value: function value() {
                    for(var t = 0; t < this._geometries.length; t++)if (!this._geometries[t].isEmpty()) return !1;
                    return !0;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._geometries = null, 0 === arguments.length) ;
                    else if (2 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1];
                        if (V.constructor_.call(this, _$e), null === t && (t = []), V.hasNullElements(t)) throw new m("geometries must not contain null elements");
                        this._geometries = t;
                    }
                }
            }
        ]), a;
    }(V), zt = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "copyInternal",
                value: function value() {
                    for(var t = new Array(this._geometries.length).fill(null), _$e = 0; _$e < t.length; _$e++)t[_$e] = this._geometries[_$e].copy();
                    return new a(t, this._factory);
                }
            },
            {
                key: "isValid",
                value: function value() {
                    return !0;
                }
            },
            {
                key: "equalsExact",
                value: function value() {
                    if (2 === arguments.length && "number" == typeof arguments[1] && _instanceof(arguments[0], V)) {
                        var t = arguments[0], _$e = arguments[1];
                        return !!this.isEquivalentClass(t) && f(r(a.prototype), "equalsExact", this).call(this, t, _$e);
                    }
                    return f(r(a.prototype), "equalsExact", this).apply(this, arguments);
                }
            },
            {
                key: "getCoordinate",
                value: function value() {
                    if (1 === arguments.length && Number.isInteger(arguments[0])) {
                        var t = arguments[0];
                        return this._geometries[t].getCoordinate();
                    }
                    return f(r(a.prototype), "getCoordinate", this).apply(this, arguments);
                }
            },
            {
                key: "getBoundaryDimension",
                value: function value() {
                    return Lt.FALSE;
                }
            },
            {
                key: "getTypeCode",
                value: function value() {
                    return V.TYPECODE_MULTIPOINT;
                }
            },
            {
                key: "getDimension",
                value: function value() {
                    return 0;
                }
            },
            {
                key: "getBoundary",
                value: function value() {
                    return this.getFactory().createGeometryCollection();
                }
            },
            {
                key: "getGeometryType",
                value: function value() {
                    return V.TYPENAME_MULTIPOINT;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        Ot
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    var t = arguments[0], _$e = arguments[1];
                    Yt.constructor_.call(this, t, _$e);
                }
            }
        ]), a;
    }(Yt), Xt = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "copyInternal",
                value: function value() {
                    return new a(this._points.copy(), this._factory);
                }
            },
            {
                key: "getBoundaryDimension",
                value: function value() {
                    return Lt.FALSE;
                }
            },
            {
                key: "isClosed",
                value: function value() {
                    return !!this.isEmpty() || f(r(a.prototype), "isClosed", this).call(this);
                }
            },
            {
                key: "reverseInternal",
                value: function value() {
                    var t = this._points.copy();
                    return St.reverse(t), this.getFactory().createLinearRing(t);
                }
            },
            {
                key: "getTypeCode",
                value: function value() {
                    return V.TYPECODE_LINEARRING;
                }
            },
            {
                key: "validateConstruction",
                value: function value() {
                    if (!this.isEmpty() && !f(r(a.prototype), "isClosed", this).call(this)) throw new m("Points of LinearRing do not form a closed linestring");
                    if (this.getCoordinateSequence().size() >= 1 && this.getCoordinateSequence().size() < a.MINIMUM_VALID_SIZE) throw new m("Invalid number of points in LinearRing (found " + this.getCoordinateSequence().size() + " - must be 0 or >= 4)");
                }
            },
            {
                key: "getGeometryType",
                value: function value() {
                    return V.TYPENAME_LINEARRING;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    var t = arguments[0], _$e = arguments[1];
                    wt.constructor_.call(this, t, _$e), this.validateConstruction();
                }
            }
        ]), a;
    }(wt);
    Xt.MINIMUM_VALID_SIZE = 4;
    var Bt = function(e) {
        i(s, e);
        var r = c(s);
        function s() {
            var _$e;
            return t(this, s), _$e = r.call(this), s.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(s, [
            {
                key: "setOrdinate",
                value: function value(t, e) {
                    switch(t){
                        case s.X:
                            this.x = e;
                            break;
                        case s.Y:
                            this.y = e;
                            break;
                        default:
                            throw new m("Invalid ordinate index: " + t);
                    }
                }
            },
            {
                key: "getZ",
                value: function value() {
                    return X.NULL_ORDINATE;
                }
            },
            {
                key: "getOrdinate",
                value: function value(t) {
                    switch(t){
                        case s.X:
                            return this.x;
                        case s.Y:
                            return this.y;
                    }
                    throw new m("Invalid ordinate index: " + t);
                }
            },
            {
                key: "setZ",
                value: function value(t) {
                    throw new m("CoordinateXY dimension 2 does not support z-ordinate");
                }
            },
            {
                key: "copy",
                value: function value() {
                    return new s(this);
                }
            },
            {
                key: "toString",
                value: function value() {
                    return "(" + this.x + ", " + this.y + ")";
                }
            },
            {
                key: "setCoordinate",
                value: function value(t) {
                    this.x = t.x, this.y = t.y, this.z = t.getZ();
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (0 === arguments.length) X.constructor_.call(this);
                    else if (1 === arguments.length) {
                        if (_instanceof(arguments[0], s)) {
                            var t = arguments[0];
                            X.constructor_.call(this, t.x, t.y);
                        } else if (_instanceof(arguments[0], X)) {
                            var _$e = arguments[0];
                            X.constructor_.call(this, _$e.x, _$e.y);
                        }
                    } else if (2 === arguments.length) {
                        var _$n = arguments[0], _$i = arguments[1];
                        X.constructor_.call(this, _$n, _$i, X.NULL_ORDINATE);
                    }
                }
            }
        ]), s;
    }(X);
    Bt.X = 0, Bt.Y = 1, Bt.Z = -1, Bt.M = -1;
    var Ut = function(e) {
        i(s, e);
        var r = c(s);
        function s() {
            var _$e;
            return t(this, s), _$e = r.call(this), s.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(s, [
            {
                key: "getM",
                value: function value() {
                    return this._m;
                }
            },
            {
                key: "setOrdinate",
                value: function value(t, e) {
                    switch(t){
                        case s.X:
                            this.x = e;
                            break;
                        case s.Y:
                            this.y = e;
                            break;
                        case s.M:
                            this._m = e;
                            break;
                        default:
                            throw new m("Invalid ordinate index: " + t);
                    }
                }
            },
            {
                key: "setM",
                value: function value(t) {
                    this._m = t;
                }
            },
            {
                key: "getZ",
                value: function value() {
                    return X.NULL_ORDINATE;
                }
            },
            {
                key: "getOrdinate",
                value: function value(t) {
                    switch(t){
                        case s.X:
                            return this.x;
                        case s.Y:
                            return this.y;
                        case s.M:
                            return this._m;
                    }
                    throw new m("Invalid ordinate index: " + t);
                }
            },
            {
                key: "setZ",
                value: function value(t) {
                    throw new m("CoordinateXY dimension 2 does not support z-ordinate");
                }
            },
            {
                key: "copy",
                value: function value() {
                    return new s(this);
                }
            },
            {
                key: "toString",
                value: function value() {
                    return "(" + this.x + ", " + this.y + " m=" + this.getM() + ")";
                }
            },
            {
                key: "setCoordinate",
                value: function value(t) {
                    this.x = t.x, this.y = t.y, this.z = t.getZ(), this._m = t.getM();
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._m = null, 0 === arguments.length) X.constructor_.call(this), this._m = 0;
                    else if (1 === arguments.length) {
                        if (_instanceof(arguments[0], s)) {
                            var t = arguments[0];
                            X.constructor_.call(this, t.x, t.y), this._m = t._m;
                        } else if (_instanceof(arguments[0], X)) {
                            var _$e = arguments[0];
                            X.constructor_.call(this, _$e.x, _$e.y), this._m = this.getM();
                        }
                    } else if (3 === arguments.length) {
                        var _$n = arguments[0], _$i = arguments[1], r = arguments[2];
                        X.constructor_.call(this, _$n, _$i, X.NULL_ORDINATE), this._m = r;
                    }
                }
            }
        ]), s;
    }(X);
    Ut.X = 0, Ut.Y = 1, Ut.Z = -1, Ut.M = 2;
    var Vt = function(e) {
        i(s, e);
        var r = c(s);
        function s() {
            var _$e;
            return t(this, s), _$e = r.call(this), s.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(s, [
            {
                key: "getM",
                value: function value() {
                    return this._m;
                }
            },
            {
                key: "setOrdinate",
                value: function value(t, e) {
                    switch(t){
                        case X.X:
                            this.x = e;
                            break;
                        case X.Y:
                            this.y = e;
                            break;
                        case X.Z:
                            this.z = e;
                            break;
                        case X.M:
                            this._m = e;
                            break;
                        default:
                            throw new m("Invalid ordinate index: " + t);
                    }
                }
            },
            {
                key: "setM",
                value: function value(t) {
                    this._m = t;
                }
            },
            {
                key: "getOrdinate",
                value: function value(t) {
                    switch(t){
                        case X.X:
                            return this.x;
                        case X.Y:
                            return this.y;
                        case X.Z:
                            return this.getZ();
                        case X.M:
                            return this.getM();
                    }
                    throw new m("Invalid ordinate index: " + t);
                }
            },
            {
                key: "copy",
                value: function value() {
                    return new s(this);
                }
            },
            {
                key: "toString",
                value: function value() {
                    return "(" + this.x + ", " + this.y + ", " + this.getZ() + " m=" + this.getM() + ")";
                }
            },
            {
                key: "setCoordinate",
                value: function value(t) {
                    this.x = t.x, this.y = t.y, this.z = t.getZ(), this._m = t.getM();
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._m = null, 0 === arguments.length) X.constructor_.call(this), this._m = 0;
                    else if (1 === arguments.length) {
                        if (_instanceof(arguments[0], s)) {
                            var t = arguments[0];
                            X.constructor_.call(this, t), this._m = t._m;
                        } else if (_instanceof(arguments[0], X)) {
                            var _$e = arguments[0];
                            X.constructor_.call(this, _$e), this._m = this.getM();
                        }
                    } else if (4 === arguments.length) {
                        var _$n = arguments[0], _$i = arguments[1], r = arguments[2], a = arguments[3];
                        X.constructor_.call(this, _$n, _$i, r), this._m = a;
                    }
                }
            }
        ]), s;
    }(X), Ht = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "measures",
                value: function value(t) {
                    return _instanceof(t, Bt) ? 0 : _instanceof(t, Ut) || _instanceof(t, Vt) ? 1 : 0;
                }
            },
            {
                key: "dimension",
                value: function value(t) {
                    return _instanceof(t, Bt) ? 2 : _instanceof(t, Ut) ? 3 : _instanceof(t, Vt) ? 4 : 3;
                }
            },
            {
                key: "create",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        return e.create(t, 0);
                    }
                    if (2 === arguments.length) {
                        var _$n = arguments[0], i = arguments[1];
                        return 2 === _$n ? new Bt : 3 === _$n && 0 === i ? new X : 3 === _$n && 1 === i ? new Ut : 4 === _$n && 1 === i ? new Vt : new X;
                    }
                }
            }
        ]), e;
    }(), Zt = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "getCoordinate",
                value: function value(t) {
                    return this.get(t);
                }
            },
            {
                key: "addAll",
                value: function value() {
                    if (2 === arguments.length && "boolean" == typeof arguments[1] && rt(arguments[0], Z)) {
                        for(var t = arguments[0], _$e = arguments[1], _$n = !1, _$i = t.iterator(); _$i.hasNext();)this.add(_$i.next(), _$e), _$n = !0;
                        return _$n;
                    }
                    return f(r(a.prototype), "addAll", this).apply(this, arguments);
                }
            },
            {
                key: "clone",
                value: function value() {
                    for(var t = f(r(a.prototype), "clone", this).call(this), _$e = 0; _$e < this.size(); _$e++)t.add(_$e, this.get(_$e).clone());
                    return t;
                }
            },
            {
                key: "toCoordinateArray",
                value: function value() {
                    if (0 === arguments.length) return this.toArray(a.coordArrayType);
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        if (t) return this.toArray(a.coordArrayType);
                        for(var _$e = this.size(), _$n = new Array(_$e).fill(null), _$i = 0; _$i < _$e; _$i++)_$n[_$i] = this.get(_$e - _$i - 1);
                        return _$n;
                    }
                }
            },
            {
                key: "add",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        return f(r(a.prototype), "add", this).call(this, t);
                    }
                    if (2 === arguments.length) {
                        if (_instanceof(arguments[0], Array) && "boolean" == typeof arguments[1]) {
                            var _$e = arguments[0], _$n = arguments[1];
                            return this.add(_$e, _$n, !0), !0;
                        }
                        if (_instanceof(arguments[0], X) && "boolean" == typeof arguments[1]) {
                            var _$i = arguments[0], s = arguments[1];
                            if (!s && this.size() >= 1) {
                                var o = this.get(this.size() - 1);
                                if (o.equals2D(_$i)) return null;
                            }
                            f(r(a.prototype), "add", this).call(this, _$i);
                        } else if (_instanceof(arguments[0], Object) && "boolean" == typeof arguments[1]) {
                            var _$u = arguments[0], l = arguments[1];
                            return this.add(_$u, l), !0;
                        }
                    } else if (3 === arguments.length) {
                        if ("boolean" == typeof arguments[2] && _instanceof(arguments[0], Array) && "boolean" == typeof arguments[1]) {
                            var h = arguments[0], _$c = arguments[1], v = arguments[2];
                            if (v) for(var g = 0; g < h.length; g++)this.add(h[g], _$c);
                            else for(var y = h.length - 1; y >= 0; y--)this.add(h[y], _$c);
                            return !0;
                        }
                        if ("boolean" == typeof arguments[2] && Number.isInteger(arguments[0]) && _instanceof(arguments[1], X)) {
                            var d = arguments[0], _ = arguments[1], p = arguments[2];
                            if (!p) {
                                var m = this.size();
                                if (m > 0) {
                                    if (d > 0) {
                                        var k = this.get(d - 1);
                                        if (k.equals2D(_)) return null;
                                    }
                                    if (d < m) {
                                        var x = this.get(d);
                                        if (x.equals2D(_)) return null;
                                    }
                                }
                            }
                            f(r(a.prototype), "add", this).call(this, d, _);
                        }
                    } else if (4 === arguments.length) {
                        var I = arguments[0], E = arguments[1], N = arguments[2], T = arguments[3], S = 1;
                        N > T && (S = -1);
                        for(var L = N; L !== T; L += S)this.add(I[L], E);
                        return !0;
                    }
                }
            },
            {
                key: "closeRing",
                value: function value() {
                    if (this.size() > 0) {
                        var t = this.get(0).copy();
                        this.add(t, !1);
                    }
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (0 === arguments.length) ;
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        this.ensureCapacity(t.length), this.add(t, !0);
                    } else if (2 === arguments.length) {
                        var _$e = arguments[0], _$n = arguments[1];
                        this.ensureCapacity(_$e.length), this.add(_$e, _$n);
                    }
                }
            }
        ]), a;
    }(yt);
    Zt.coordArrayType = new Array(0).fill(null);
    var jt = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "isRing",
                value: function value(t) {
                    return !(t.length < 4) && !!t[0].equals2D(t[t.length - 1]);
                }
            },
            {
                key: "ptNotInList",
                value: function value(t, n) {
                    for(var i = 0; i < t.length; i++){
                        var r = t[i];
                        if (e.indexOf(r, n) < 0) return r;
                    }
                    return null;
                }
            },
            {
                key: "scroll",
                value: function value(t, n) {
                    var i = e.indexOf(n, t);
                    if (i < 0) return null;
                    var r = new Array(t.length).fill(null);
                    mt.arraycopy(t, i, r, 0, t.length - i), mt.arraycopy(t, 0, r, t.length - i, i), mt.arraycopy(r, 0, t, 0, t.length);
                }
            },
            {
                key: "equals",
                value: function value() {
                    if (2 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1];
                        if (t === _$e) return !0;
                        if (null === t || null === _$e) return !1;
                        if (t.length !== _$e.length) return !1;
                        for(var _$n = 0; _$n < t.length; _$n++)if (!t[_$n].equals(_$e[_$n])) return !1;
                        return !0;
                    }
                    if (3 === arguments.length) {
                        var i = arguments[0], r = arguments[1], s = arguments[2];
                        if (i === r) return !0;
                        if (null === i || null === r) return !1;
                        if (i.length !== r.length) return !1;
                        for(var a = 0; a < i.length; a++)if (0 !== s.compare(i[a], r[a])) return !1;
                        return !0;
                    }
                }
            },
            {
                key: "intersection",
                value: function value(t, e) {
                    for(var _$n = new Zt, i = 0; i < t.length; i++)e.intersects(t[i]) && _$n.add(t[i], !0);
                    return _$n.toCoordinateArray();
                }
            },
            {
                key: "measures",
                value: function value(t) {
                    if (null === t || 0 === t.length) return 0;
                    var _$e, _$n = 0, i = d(t);
                    try {
                        for(i.s(); !(_$e = i.n()).done;){
                            var r = _$e.value;
                            _$n = Math.max(_$n, Ht.measures(r));
                        }
                    } catch (t) {
                        i.e(t);
                    } finally{
                        i.f();
                    }
                    return _$n;
                }
            },
            {
                key: "hasRepeatedPoints",
                value: function value(t) {
                    for(var _$e = 1; _$e < t.length; _$e++)if (t[_$e - 1].equals(t[_$e])) return !0;
                    return !1;
                }
            },
            {
                key: "removeRepeatedPoints",
                value: function value(t) {
                    return e.hasRepeatedPoints(t) ? new Zt(t, !1).toCoordinateArray() : t;
                }
            },
            {
                key: "reverse",
                value: function value(t) {
                    for(var _$e = t.length - 1, _$n = Math.trunc(_$e / 2), i = 0; i <= _$n; i++){
                        var r = t[i];
                        t[i] = t[_$e - i], t[_$e - i] = r;
                    }
                }
            },
            {
                key: "removeNull",
                value: function value(t) {
                    for(var _$e = 0, _$n = 0; _$n < t.length; _$n++)null !== t[_$n] && _$e++;
                    var i = new Array(_$e).fill(null);
                    if (0 === _$e) return i;
                    for(var r = 0, s = 0; s < t.length; s++)null !== t[s] && (i[r++] = t[s]);
                    return i;
                }
            },
            {
                key: "copyDeep",
                value: function value() {
                    if (1 === arguments.length) {
                        for(var t = arguments[0], _$e = new Array(t.length).fill(null), _$n = 0; _$n < t.length; _$n++)_$e[_$n] = t[_$n].copy();
                        return _$e;
                    }
                    if (5 === arguments.length) for(var i = arguments[0], r = arguments[1], s = arguments[2], a = arguments[3], o = arguments[4], _$u = 0; _$u < o; _$u++)s[a + _$u] = i[r + _$u].copy();
                }
            },
            {
                key: "isEqualReversed",
                value: function value(t, e) {
                    for(var _$n = 0; _$n < t.length; _$n++){
                        var i = t[_$n], r = e[t.length - _$n - 1];
                        if (0 !== i.compareTo(r)) return !1;
                    }
                    return !0;
                }
            },
            {
                key: "envelope",
                value: function value(t) {
                    for(var _$e = new U, _$n = 0; _$n < t.length; _$n++)_$e.expandToInclude(t[_$n]);
                    return _$e;
                }
            },
            {
                key: "toCoordinateArray",
                value: function value(t) {
                    return t.toArray(e.coordArrayType);
                }
            },
            {
                key: "dimension",
                value: function value(t) {
                    if (null === t || 0 === t.length) return 3;
                    var _$e, _$n = 0, i = d(t);
                    try {
                        for(i.s(); !(_$e = i.n()).done;){
                            var r = _$e.value;
                            _$n = Math.max(_$n, Ht.dimension(r));
                        }
                    } catch (t) {
                        i.e(t);
                    } finally{
                        i.f();
                    }
                    return _$n;
                }
            },
            {
                key: "atLeastNCoordinatesOrNothing",
                value: function value(t, e) {
                    return e.length >= t ? e : [];
                }
            },
            {
                key: "indexOf",
                value: function value(t, e) {
                    for(var _$n = 0; _$n < e.length; _$n++)if (t.equals(e[_$n])) return _$n;
                    return -1;
                }
            },
            {
                key: "increasingDirection",
                value: function value(t) {
                    for(var _$e = 0; _$e < Math.trunc(t.length / 2); _$e++){
                        var _$n = t.length - 1 - _$e, i = t[_$e].compareTo(t[_$n]);
                        if (0 !== i) return i;
                    }
                    return 1;
                }
            },
            {
                key: "compare",
                value: function value(t, e) {
                    for(var _$n = 0; _$n < t.length && _$n < e.length;){
                        var i = t[_$n].compareTo(e[_$n]);
                        if (0 !== i) return i;
                        _$n++;
                    }
                    return _$n < e.length ? -1 : _$n < t.length ? 1 : 0;
                }
            },
            {
                key: "minCoordinate",
                value: function value(t) {
                    for(var _$e = null, _$n = 0; _$n < t.length; _$n++)(null === _$e || _$e.compareTo(t[_$n]) > 0) && (_$e = t[_$n]);
                    return _$e;
                }
            },
            {
                key: "extract",
                value: function value(t, e, n) {
                    e = kt.clamp(e, 0, t.length);
                    var i = (n = kt.clamp(n, -1, t.length)) - e + 1;
                    n < 0 && (i = 0), e >= t.length && (i = 0), n < e && (i = 0);
                    var r = new Array(i).fill(null);
                    if (0 === i) return r;
                    for(var s = 0, a = e; a <= n; a++)r[s++] = t[a];
                    return r;
                }
            }
        ]), e;
    }(), Wt = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "compare",
                value: function value(t, e) {
                    var _$n = t, i = e;
                    return jt.compare(_$n, i);
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        P
                    ];
                }
            }
        ]), e;
    }(), Kt = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "compare",
                value: function value(t, e) {
                    var _$n = t, i = e;
                    if (_$n.length < i.length) return -1;
                    if (_$n.length > i.length) return 1;
                    if (0 === _$n.length) return 0;
                    var r = jt.compare(_$n, i);
                    return jt.isEqualReversed(_$n, i) ? 0 : r;
                }
            },
            {
                key: "OLDcompare",
                value: function value(t, e) {
                    var _$n = t, i = e;
                    if (_$n.length < i.length) return -1;
                    if (_$n.length > i.length) return 1;
                    if (0 === _$n.length) return 0;
                    for(var r = jt.increasingDirection(_$n), s = jt.increasingDirection(i), a = r > 0 ? 0 : _$n.length - 1, o = s > 0 ? 0 : _$n.length - 1, _$u = 0; _$u < _$n.length; _$u++){
                        var l = _$n[a].compareTo(i[o]);
                        if (0 !== l) return l;
                        a += r, o += s;
                    }
                    return 0;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        P
                    ];
                }
            }
        ]), e;
    }();
    jt.ForwardComparator = Wt, jt.BidirectionalComparator = Kt, jt.coordArrayType = new Array(0).fill(null);
    var Jt = function() {
        function e(n) {
            t(this, e), this.str = n;
        }
        return n(e, [
            {
                key: "append",
                value: function value(t) {
                    this.str += t;
                }
            },
            {
                key: "setCharAt",
                value: function value(t, e) {
                    this.str = this.str.substr(0, t) + e + this.str.substr(t + 1);
                }
            },
            {
                key: "toString",
                value: function value() {
                    return this.str;
                }
            }
        ]), e;
    }(), Qt = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getM",
                value: function value(t) {
                    return this.hasM() ? this._coordinates[t].getM() : A.NaN;
                }
            },
            {
                key: "setOrdinate",
                value: function value(t, e, n) {
                    switch(e){
                        case ht.X:
                            this._coordinates[t].x = n;
                            break;
                        case ht.Y:
                            this._coordinates[t].y = n;
                            break;
                        default:
                            this._coordinates[t].setOrdinate(e, n);
                    }
                }
            },
            {
                key: "getZ",
                value: function value(t) {
                    return this.hasZ() ? this._coordinates[t].getZ() : A.NaN;
                }
            },
            {
                key: "size",
                value: function value() {
                    return this._coordinates.length;
                }
            },
            {
                key: "getOrdinate",
                value: function value(t, e) {
                    switch(e){
                        case ht.X:
                            return this._coordinates[t].x;
                        case ht.Y:
                            return this._coordinates[t].y;
                        default:
                            return this._coordinates[t].getOrdinate(e);
                    }
                }
            },
            {
                key: "getCoordinate",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        return this._coordinates[t];
                    }
                    if (2 === arguments.length) {
                        var _$e = arguments[0], _$n = arguments[1];
                        _$n.setCoordinate(this._coordinates[_$e]);
                    }
                }
            },
            {
                key: "getCoordinateCopy",
                value: function value(t) {
                    var _$e = this.createCoordinate();
                    return _$e.setCoordinate(this._coordinates[t]), _$e;
                }
            },
            {
                key: "createCoordinate",
                value: function value() {
                    return Ht.create(this.getDimension(), this.getMeasures());
                }
            },
            {
                key: "getDimension",
                value: function value() {
                    return this._dimension;
                }
            },
            {
                key: "getX",
                value: function value(t) {
                    return this._coordinates[t].x;
                }
            },
            {
                key: "getMeasures",
                value: function value() {
                    return this._measures;
                }
            },
            {
                key: "expandEnvelope",
                value: function value(t) {
                    for(var _$e = 0; _$e < this._coordinates.length; _$e++)t.expandToInclude(this._coordinates[_$e]);
                    return t;
                }
            },
            {
                key: "copy",
                value: function value() {
                    for(var t = new Array(this.size()).fill(null), _$n = 0; _$n < this._coordinates.length; _$n++){
                        var i = this.createCoordinate();
                        i.setCoordinate(this._coordinates[_$n]), t[_$n] = i;
                    }
                    return new e(t, this._dimension, this._measures);
                }
            },
            {
                key: "toString",
                value: function value() {
                    if (this._coordinates.length > 0) {
                        var t = new Jt(17 * this._coordinates.length);
                        t.append("("), t.append(this._coordinates[0]);
                        for(var _$e = 1; _$e < this._coordinates.length; _$e++)t.append(", "), t.append(this._coordinates[_$e]);
                        return t.append(")"), t.toString();
                    }
                    return "()";
                }
            },
            {
                key: "getY",
                value: function value(t) {
                    return this._coordinates[t].y;
                }
            },
            {
                key: "toCoordinateArray",
                value: function value() {
                    return this._coordinates;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        ht,
                        E
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._dimension = 3, this._measures = 0, this._coordinates = null, 1 === arguments.length) {
                        if (_instanceof(arguments[0], Array)) {
                            var t = arguments[0];
                            e.constructor_.call(this, t, jt.dimension(t), jt.measures(t));
                        } else if (Number.isInteger(arguments[0])) {
                            var _$n = arguments[0];
                            this._coordinates = new Array(_$n).fill(null);
                            for(var i = 0; i < _$n; i++)this._coordinates[i] = new X;
                        } else if (rt(arguments[0], ht)) {
                            var r = arguments[0];
                            if (null === r) return this._coordinates = new Array(0).fill(null), null;
                            this._dimension = r.getDimension(), this._measures = r.getMeasures(), this._coordinates = new Array(r.size()).fill(null);
                            for(var s = 0; s < this._coordinates.length; s++)this._coordinates[s] = r.getCoordinateCopy(s);
                        }
                    } else if (2 === arguments.length) {
                        if (_instanceof(arguments[0], Array) && Number.isInteger(arguments[1])) {
                            var a = arguments[0], o = arguments[1];
                            e.constructor_.call(this, a, o, jt.measures(a));
                        } else if (Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
                            var _$u = arguments[0], l = arguments[1];
                            this._coordinates = new Array(_$u).fill(null), this._dimension = l;
                            for(var h = 0; h < _$u; h++)this._coordinates[h] = Ht.create(l);
                        }
                    } else if (3 === arguments.length) {
                        if (Number.isInteger(arguments[2]) && _instanceof(arguments[0], Array) && Number.isInteger(arguments[1])) {
                            var c = arguments[0], f = arguments[1], v = arguments[2];
                            this._dimension = f, this._measures = v, this._coordinates = null === c ? new Array(0).fill(null) : c;
                        } else if (Number.isInteger(arguments[2]) && Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
                            var g = arguments[0], y = arguments[1], d = arguments[2];
                            this._coordinates = new Array(g).fill(null), this._dimension = y, this._measures = d;
                            for(var _ = 0; _ < g; _++)this._coordinates[_] = this.createCoordinate();
                        }
                    }
                }
            }
        ]), e;
    }(), $t = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "readResolve",
                value: function value() {
                    return e.instance();
                }
            },
            {
                key: "create",
                value: function value() {
                    if (1 === arguments.length) {
                        if (_instanceof(arguments[0], Array)) {
                            var t = arguments[0];
                            return new Qt(t);
                        }
                        if (rt(arguments[0], ht)) {
                            var _$e = arguments[0];
                            return new Qt(_$e);
                        }
                    } else {
                        if (2 === arguments.length) {
                            var _$n = arguments[0], i = arguments[1];
                            return i > 3 && (i = 3), i < 2 && (i = 2), new Qt(_$n, i);
                        }
                        if (3 === arguments.length) {
                            var r = arguments[0], s = arguments[1], a = arguments[2], o = s - a;
                            return a > 1 && (a = 1), o > 3 && (o = 3), o < 2 && (o = 2), new Qt(r, o + a, a);
                        }
                    }
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        It,
                        E
                    ];
                }
            }
        ], [
            {
                key: "instance",
                value: function value() {
                    return e.instanceObject;
                }
            }
        ]), e;
    }();
    $t.instanceObject = new $t;
    var te = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "copyInternal",
                value: function value() {
                    for(var t = new Array(this._geometries.length).fill(null), _$e = 0; _$e < t.length; _$e++)t[_$e] = this._geometries[_$e].copy();
                    return new a(t, this._factory);
                }
            },
            {
                key: "equalsExact",
                value: function value() {
                    if (2 === arguments.length && "number" == typeof arguments[1] && _instanceof(arguments[0], V)) {
                        var t = arguments[0], _$e = arguments[1];
                        return !!this.isEquivalentClass(t) && f(r(a.prototype), "equalsExact", this).call(this, t, _$e);
                    }
                    return f(r(a.prototype), "equalsExact", this).apply(this, arguments);
                }
            },
            {
                key: "getBoundaryDimension",
                value: function value() {
                    return 1;
                }
            },
            {
                key: "getTypeCode",
                value: function value() {
                    return V.TYPECODE_MULTIPOLYGON;
                }
            },
            {
                key: "getDimension",
                value: function value() {
                    return 2;
                }
            },
            {
                key: "getBoundary",
                value: function value() {
                    if (this.isEmpty()) return this.getFactory().createMultiLineString();
                    for(var t = new yt, _$e = 0; _$e < this._geometries.length; _$e++)for(var _$n = this._geometries[_$e].getBoundary(), _$i = 0; _$i < _$n.getNumGeometries(); _$i++)t.add(_$n.getGeometryN(_$i));
                    var r = new Array(t.size()).fill(null);
                    return this.getFactory().createMultiLineString(t.toArray(r));
                }
            },
            {
                key: "getGeometryType",
                value: function value() {
                    return V.TYPENAME_MULTIPOLYGON;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        Pt
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    var t = arguments[0], _$e = arguments[1];
                    Yt.constructor_.call(this, t, _$e);
                }
            }
        ]), a;
    }(Yt), ee = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "get",
                value: function value() {}
            },
            {
                key: "put",
                value: function value() {}
            },
            {
                key: "size",
                value: function value() {}
            },
            {
                key: "values",
                value: function value() {}
            },
            {
                key: "entrySet",
                value: function value() {}
            }
        ]), e;
    }(), ne = function(e) {
        i(s, e);
        var r = c(s);
        function s() {
            var _$e;
            return t(this, s), (_$e = r.call(this)).map = new Map, _$e;
        }
        return n(s, [
            {
                key: "get",
                value: function value(t) {
                    return this.map.get(t) || null;
                }
            },
            {
                key: "put",
                value: function value(t, e) {
                    return this.map.set(t, e), e;
                }
            },
            {
                key: "values",
                value: function value() {
                    for(var t = new yt, _$e = this.map.values(), _$n = _$e.next(); !_$n.done;)t.add(_$n.value), _$n = _$e.next();
                    return t;
                }
            },
            {
                key: "entrySet",
                value: function value() {
                    var t = new J;
                    return this.map.entries().forEach(function(e) {
                        return t.add(e);
                    }), t;
                }
            },
            {
                key: "size",
                value: function value() {
                    return this.map.size();
                }
            }
        ]), s;
    }(ee), ie = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "equals",
                value: function value(t) {
                    if (!_instanceof(t, e)) return !1;
                    var _$n = t;
                    return this._modelType === _$n._modelType && this._scale === _$n._scale;
                }
            },
            {
                key: "compareTo",
                value: function value(t) {
                    var _$e = t, _$n = this.getMaximumSignificantDigits(), i = _$e.getMaximumSignificantDigits();
                    return at.compare(_$n, i);
                }
            },
            {
                key: "getScale",
                value: function value() {
                    return this._scale;
                }
            },
            {
                key: "isFloating",
                value: function value() {
                    return this._modelType === e.FLOATING || this._modelType === e.FLOATING_SINGLE;
                }
            },
            {
                key: "getType",
                value: function value() {
                    return this._modelType;
                }
            },
            {
                key: "toString",
                value: function value() {
                    var t = "UNKNOWN";
                    return this._modelType === e.FLOATING ? t = "Floating" : this._modelType === e.FLOATING_SINGLE ? t = "Floating-Single" : this._modelType === e.FIXED && (t = "Fixed (Scale=" + this.getScale() + ")"), t;
                }
            },
            {
                key: "makePrecise",
                value: function value() {
                    if ("number" == typeof arguments[0]) {
                        var t = arguments[0];
                        if (A.isNaN(t)) return t;
                        if (this._modelType === e.FLOATING_SINGLE) {
                            return t;
                        }
                        return this._modelType === e.FIXED ? Math.round(t * this._scale) / this._scale : t;
                    }
                    if (_instanceof(arguments[0], X)) {
                        var _$n = arguments[0];
                        if (this._modelType === e.FLOATING) return null;
                        _$n.x = this.makePrecise(_$n.x), _$n.y = this.makePrecise(_$n.y);
                    }
                }
            },
            {
                key: "getMaximumSignificantDigits",
                value: function value() {
                    var t = 16;
                    return this._modelType === e.FLOATING ? t = 16 : this._modelType === e.FLOATING_SINGLE ? t = 6 : this._modelType === e.FIXED && (t = 1 + Math.trunc(Math.ceil(Math.log(this.getScale()) / Math.log(10)))), t;
                }
            },
            {
                key: "setScale",
                value: function value(t) {
                    this._scale = Math.abs(t);
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        E,
                        x
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._modelType = null, this._scale = null, 0 === arguments.length) this._modelType = e.FLOATING;
                    else if (1 === arguments.length) {
                        if (_instanceof(arguments[0], re)) {
                            var t = arguments[0];
                            this._modelType = t, t === e.FIXED && this.setScale(1);
                        } else if ("number" == typeof arguments[0]) {
                            var _$n = arguments[0];
                            this._modelType = e.FIXED, this.setScale(_$n);
                        } else if (_instanceof(arguments[0], e)) {
                            var i = arguments[0];
                            this._modelType = i._modelType, this._scale = i._scale;
                        }
                    }
                }
            },
            {
                key: "mostPrecise",
                value: function value(t, e) {
                    return t.compareTo(e) >= 0 ? t : e;
                }
            }
        ]), e;
    }(), re = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "readResolve",
                value: function value() {
                    return e.nameToTypeMap.get(this._name);
                }
            },
            {
                key: "toString",
                value: function value() {
                    return this._name;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        E
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._name = null;
                    var t = arguments[0];
                    this._name = t, e.nameToTypeMap.put(t, this);
                }
            }
        ]), e;
    }();
    re.nameToTypeMap = new ne, ie.Type = re, ie.FIXED = new re("FIXED"), ie.FLOATING = new re("FLOATING"), ie.FLOATING_SINGLE = new re("FLOATING SINGLE"), ie.maximumPreciseValue = 9007199254740992;
    var se = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "copyInternal",
                value: function value() {
                    for(var t = new Array(this._geometries.length).fill(null), _$e = 0; _$e < t.length; _$e++)t[_$e] = this._geometries[_$e].copy();
                    return new a(t, this._factory);
                }
            },
            {
                key: "equalsExact",
                value: function value() {
                    if (2 === arguments.length && "number" == typeof arguments[1] && _instanceof(arguments[0], V)) {
                        var t = arguments[0], _$e = arguments[1];
                        return !!this.isEquivalentClass(t) && f(r(a.prototype), "equalsExact", this).call(this, t, _$e);
                    }
                    return f(r(a.prototype), "equalsExact", this).apply(this, arguments);
                }
            },
            {
                key: "getBoundaryDimension",
                value: function value() {
                    return this.isClosed() ? Lt.FALSE : 0;
                }
            },
            {
                key: "isClosed",
                value: function value() {
                    if (this.isEmpty()) return !1;
                    for(var t = 0; t < this._geometries.length; t++)if (!this._geometries[t].isClosed()) return !1;
                    return !0;
                }
            },
            {
                key: "getTypeCode",
                value: function value() {
                    return V.TYPECODE_MULTILINESTRING;
                }
            },
            {
                key: "getDimension",
                value: function value() {
                    return 1;
                }
            },
            {
                key: "getBoundary",
                value: function value() {
                    throw new W;
                }
            },
            {
                key: "getGeometryType",
                value: function value() {
                    return V.TYPENAME_MULTILINESTRING;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        Tt
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    var t = arguments[0], _$e = arguments[1];
                    Yt.constructor_.call(this, t, _$e);
                }
            }
        ]), a;
    }(Yt), ae = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "createEmpty",
                value: function value(t) {
                    switch(t){
                        case -1:
                            return this.createGeometryCollection();
                        case 0:
                            return this.createPoint();
                        case 1:
                            return this.createLineString();
                        case 2:
                            return this.createPolygon();
                        default:
                            throw new m("Invalid dimension: " + t);
                    }
                }
            },
            {
                key: "toGeometry",
                value: function value(t) {
                    return t.isNull() ? this.createPoint() : t.getMinX() === t.getMaxX() && t.getMinY() === t.getMaxY() ? this.createPoint(new X(t.getMinX(), t.getMinY())) : t.getMinX() === t.getMaxX() || t.getMinY() === t.getMaxY() ? this.createLineString([
                        new X(t.getMinX(), t.getMinY()),
                        new X(t.getMaxX(), t.getMaxY())
                    ]) : this.createPolygon(this.createLinearRing([
                        new X(t.getMinX(), t.getMinY()),
                        new X(t.getMinX(), t.getMaxY()),
                        new X(t.getMaxX(), t.getMaxY()),
                        new X(t.getMaxX(), t.getMinY()),
                        new X(t.getMinX(), t.getMinY())
                    ]), null);
                }
            },
            {
                key: "createLineString",
                value: function value() {
                    if (0 === arguments.length) return this.createLineString(this.getCoordinateSequenceFactory().create([]));
                    if (1 === arguments.length) {
                        if (_instanceof(arguments[0], Array)) {
                            var t = arguments[0];
                            return this.createLineString(null !== t ? this.getCoordinateSequenceFactory().create(t) : null);
                        }
                        if (rt(arguments[0], ht)) {
                            var _$e = arguments[0];
                            return new wt(_$e, this);
                        }
                    }
                }
            },
            {
                key: "createMultiLineString",
                value: function value() {
                    if (0 === arguments.length) return new se(null, this);
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        return new se(t, this);
                    }
                }
            },
            {
                key: "buildGeometry",
                value: function value(t) {
                    for(var _$n = null, i = !1, r = !1, s = t.iterator(); s.hasNext();){
                        var a = s.next(), o = a.getTypeCode();
                        null === _$n && (_$n = o), o !== _$n && (i = !0), _instanceof(a, Yt) && (r = !0);
                    }
                    if (null === _$n) return this.createGeometryCollection();
                    if (i || r) return this.createGeometryCollection(e.toGeometryArray(t));
                    var _$u = t.iterator().next();
                    if (t.size() > 1) {
                        if (_instanceof(_$u, Dt)) return this.createMultiPolygon(e.toPolygonArray(t));
                        if (_instanceof(_$u, wt)) return this.createMultiLineString(e.toLineStringArray(t));
                        if (_instanceof(_$u, bt)) return this.createMultiPoint(e.toPointArray(t));
                        G.shouldNeverReachHere("Unhandled geometry type: " + _$u.getGeometryType());
                    }
                    return _$u;
                }
            },
            {
                key: "createMultiPointFromCoords",
                value: function value(t) {
                    return this.createMultiPoint(null !== t ? this.getCoordinateSequenceFactory().create(t) : null);
                }
            },
            {
                key: "createPoint",
                value: function value() {
                    if (0 === arguments.length) return this.createPoint(this.getCoordinateSequenceFactory().create([]));
                    if (1 === arguments.length) {
                        if (_instanceof(arguments[0], X)) {
                            var t = arguments[0];
                            return this.createPoint(null !== t ? this.getCoordinateSequenceFactory().create([
                                t
                            ]) : null);
                        }
                        if (rt(arguments[0], ht)) {
                            var _$e = arguments[0];
                            return new bt(_$e, this);
                        }
                    }
                }
            },
            {
                key: "getCoordinateSequenceFactory",
                value: function value() {
                    return this._coordinateSequenceFactory;
                }
            },
            {
                key: "createPolygon",
                value: function value() {
                    if (0 === arguments.length) return this.createPolygon(null, null);
                    if (1 === arguments.length) {
                        if (rt(arguments[0], ht)) {
                            var t = arguments[0];
                            return this.createPolygon(this.createLinearRing(t));
                        }
                        if (_instanceof(arguments[0], Array)) {
                            var _$e = arguments[0];
                            return this.createPolygon(this.createLinearRing(_$e));
                        }
                        if (_instanceof(arguments[0], Xt)) {
                            var _$n = arguments[0];
                            return this.createPolygon(_$n, null);
                        }
                    } else if (2 === arguments.length) {
                        var i = arguments[0], r = arguments[1];
                        return new Dt(i, r, this);
                    }
                }
            },
            {
                key: "getSRID",
                value: function value() {
                    return this._SRID;
                }
            },
            {
                key: "createGeometryCollection",
                value: function value() {
                    if (0 === arguments.length) return new Yt(null, this);
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        return new Yt(t, this);
                    }
                }
            },
            {
                key: "getPrecisionModel",
                value: function value() {
                    return this._precisionModel;
                }
            },
            {
                key: "createLinearRing",
                value: function value() {
                    if (0 === arguments.length) return this.createLinearRing(this.getCoordinateSequenceFactory().create([]));
                    if (1 === arguments.length) {
                        if (_instanceof(arguments[0], Array)) {
                            var t = arguments[0];
                            return this.createLinearRing(null !== t ? this.getCoordinateSequenceFactory().create(t) : null);
                        }
                        if (rt(arguments[0], ht)) {
                            var _$e = arguments[0];
                            return new Xt(_$e, this);
                        }
                    }
                }
            },
            {
                key: "createMultiPolygon",
                value: function value() {
                    if (0 === arguments.length) return new te(null, this);
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        return new te(t, this);
                    }
                }
            },
            {
                key: "createMultiPoint",
                value: function value() {
                    if (0 === arguments.length) return new zt(null, this);
                    if (1 === arguments.length) {
                        if (_instanceof(arguments[0], Array)) {
                            var t = arguments[0];
                            return new zt(t, this);
                        }
                        if (rt(arguments[0], ht)) {
                            var _$e = arguments[0];
                            if (null === _$e) return this.createMultiPoint(new Array(0).fill(null));
                            for(var _$n = new Array(_$e.size()).fill(null), i = 0; i < _$e.size(); i++){
                                var r = this.getCoordinateSequenceFactory().create(1, _$e.getDimension(), _$e.getMeasures());
                                St.copy(_$e, i, r, 0, 1), _$n[i] = this.createPoint(r);
                            }
                            return this.createMultiPoint(_$n);
                        }
                    }
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        E
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._precisionModel = null, this._coordinateSequenceFactory = null, this._SRID = null, 0 === arguments.length) e.constructor_.call(this, new ie, 0);
                    else if (1 === arguments.length) {
                        if (rt(arguments[0], It)) {
                            var t = arguments[0];
                            e.constructor_.call(this, new ie, 0, t);
                        } else if (_instanceof(arguments[0], ie)) {
                            var _$n = arguments[0];
                            e.constructor_.call(this, _$n, 0, e.getDefaultCoordinateSequenceFactory());
                        }
                    } else if (2 === arguments.length) {
                        var i = arguments[0], r = arguments[1];
                        e.constructor_.call(this, i, r, e.getDefaultCoordinateSequenceFactory());
                    } else if (3 === arguments.length) {
                        var s = arguments[0], a = arguments[1], o = arguments[2];
                        this._precisionModel = s, this._coordinateSequenceFactory = o, this._SRID = a;
                    }
                }
            },
            {
                key: "toMultiPolygonArray",
                value: function value(t) {
                    var _$e = new Array(t.size()).fill(null);
                    return t.toArray(_$e);
                }
            },
            {
                key: "toGeometryArray",
                value: function value(t) {
                    if (null === t) return null;
                    var _$e = new Array(t.size()).fill(null);
                    return t.toArray(_$e);
                }
            },
            {
                key: "getDefaultCoordinateSequenceFactory",
                value: function value() {
                    return $t.instance();
                }
            },
            {
                key: "toMultiLineStringArray",
                value: function value(t) {
                    var _$e = new Array(t.size()).fill(null);
                    return t.toArray(_$e);
                }
            },
            {
                key: "toLineStringArray",
                value: function value(t) {
                    var _$e = new Array(t.size()).fill(null);
                    return t.toArray(_$e);
                }
            },
            {
                key: "toMultiPointArray",
                value: function value(t) {
                    var _$e = new Array(t.size()).fill(null);
                    return t.toArray(_$e);
                }
            },
            {
                key: "toLinearRingArray",
                value: function value(t) {
                    var _$e = new Array(t.size()).fill(null);
                    return t.toArray(_$e);
                }
            },
            {
                key: "toPointArray",
                value: function value(t) {
                    var _$e = new Array(t.size()).fill(null);
                    return t.toArray(_$e);
                }
            },
            {
                key: "toPolygonArray",
                value: function value(t) {
                    var _$e = new Array(t.size()).fill(null);
                    return t.toArray(_$e);
                }
            },
            {
                key: "createPointFromInternalCoord",
                value: function value(t, e) {
                    return e.getPrecisionModel().makePrecise(t), e.getFactory().createPoint(t);
                }
            }
        ]), e;
    }(), oe = "XY", ue = "XYZ", le = "XYM", he = "XYZM", ce = {
        POINT: "Point",
        LINE_STRING: "LineString",
        LINEAR_RING: "LinearRing",
        POLYGON: "Polygon",
        MULTI_POINT: "MultiPoint",
        MULTI_LINE_STRING: "MultiLineString",
        MULTI_POLYGON: "MultiPolygon",
        GEOMETRY_COLLECTION: "GeometryCollection",
        CIRCLE: "Circle"
    }, fe = "EMPTY", ve = 1, ge = 2, ye = 3, de = 4, _e = 5, pe = 6, me = {};
    for(var ke in ce)me[ke] = ce[ke].toUpperCase();
    var xe = function() {
        function e(n) {
            t(this, e), this.wkt = n, this.index_ = -1;
        }
        return n(e, [
            {
                key: "isAlpha_",
                value: function value(t) {
                    return t >= "a" && t <= "z" || t >= "A" && t <= "Z";
                }
            },
            {
                key: "isNumeric_",
                value: function value(t, e) {
                    return t >= "0" && t <= "9" || "." == t && !(void 0 !== e && e);
                }
            },
            {
                key: "isWhiteSpace_",
                value: function value(t) {
                    return " " == t || "\t" == t || "\r" == t || "\n" == t;
                }
            },
            {
                key: "nextChar_",
                value: function value() {
                    return this.wkt.charAt(++this.index_);
                }
            },
            {
                key: "nextToken",
                value: function value() {
                    var t, _$e = this.nextChar_(), _$n = this.index_, i = _$e;
                    if ("(" == _$e) t = ge;
                    else if ("," == _$e) t = _e;
                    else if (")" == _$e) t = ye;
                    else if (this.isNumeric_(_$e) || "-" == _$e) t = de, i = this.readNumber_();
                    else if (this.isAlpha_(_$e)) t = ve, i = this.readText_();
                    else {
                        if (this.isWhiteSpace_(_$e)) return this.nextToken();
                        if ("" !== _$e) throw new Error("Unexpected character: " + _$e);
                        t = pe;
                    }
                    return {
                        position: _$n,
                        value: i,
                        type: t
                    };
                }
            },
            {
                key: "readNumber_",
                value: function value() {
                    var t, _$e = this.index_, _$n = !1, i = !1;
                    do {
                        "." == t ? _$n = !0 : "e" != t && "E" != t || (i = !0), t = this.nextChar_();
                    }while (this.isNumeric_(t, _$n) || !i && ("e" == t || "E" == t) || i && ("-" == t || "+" == t));
                    return parseFloat(this.wkt.substring(_$e, this.index_--));
                }
            },
            {
                key: "readText_",
                value: function value() {
                    var t, _$e = this.index_;
                    do {
                        t = this.nextChar_();
                    }while (this.isAlpha_(t));
                    return this.wkt.substring(_$e, this.index_--).toUpperCase();
                }
            }
        ]), e;
    }(), Ie = function() {
        function e(n, i) {
            t(this, e), this.lexer_ = n, this.token_, this.layout_ = oe, this.factory = i;
        }
        return n(e, [
            {
                key: "consume_",
                value: function value() {
                    this.token_ = this.lexer_.nextToken();
                }
            },
            {
                key: "isTokenType",
                value: function value(t) {
                    return this.token_.type == t;
                }
            },
            {
                key: "match",
                value: function value(t) {
                    var _$e = this.isTokenType(t);
                    return _$e && this.consume_(), _$e;
                }
            },
            {
                key: "parse",
                value: function value() {
                    return this.consume_(), this.parseGeometry_();
                }
            },
            {
                key: "parseGeometryLayout_",
                value: function value() {
                    var t = oe, _$e = this.token_;
                    if (this.isTokenType(ve)) {
                        var _$n = _$e.value;
                        "Z" === _$n ? t = ue : "M" === _$n ? t = le : "ZM" === _$n && (t = he), t !== oe && this.consume_();
                    }
                    return t;
                }
            },
            {
                key: "parseGeometryCollectionText_",
                value: function value() {
                    if (this.match(ge)) {
                        var t = [];
                        do {
                            t.push(this.parseGeometry_());
                        }while (this.match(_e));
                        if (this.match(ye)) return t;
                    } else if (this.isEmptyGeometry_()) return [];
                    throw new Error(this.formatErrorMessage_());
                }
            },
            {
                key: "parsePointText_",
                value: function value() {
                    if (this.match(ge)) {
                        var t = this.parsePoint_();
                        if (this.match(ye)) return t;
                    } else if (this.isEmptyGeometry_()) return null;
                    throw new Error(this.formatErrorMessage_());
                }
            },
            {
                key: "parseLineStringText_",
                value: function value() {
                    if (this.match(ge)) {
                        var t = this.parsePointList_();
                        if (this.match(ye)) return t;
                    } else if (this.isEmptyGeometry_()) return [];
                    throw new Error(this.formatErrorMessage_());
                }
            },
            {
                key: "parsePolygonText_",
                value: function value() {
                    if (this.match(ge)) {
                        var t = this.parseLineStringTextList_();
                        if (this.match(ye)) return t;
                    } else if (this.isEmptyGeometry_()) return [];
                    throw new Error(this.formatErrorMessage_());
                }
            },
            {
                key: "parseMultiPointText_",
                value: function value() {
                    var t;
                    if (this.match(ge)) {
                        if (t = this.token_.type == ge ? this.parsePointTextList_() : this.parsePointList_(), this.match(ye)) return t;
                    } else if (this.isEmptyGeometry_()) return [];
                    throw new Error(this.formatErrorMessage_());
                }
            },
            {
                key: "parseMultiLineStringText_",
                value: function value() {
                    if (this.match(ge)) {
                        var t = this.parseLineStringTextList_();
                        if (this.match(ye)) return t;
                    } else if (this.isEmptyGeometry_()) return [];
                    throw new Error(this.formatErrorMessage_());
                }
            },
            {
                key: "parseMultiPolygonText_",
                value: function value() {
                    if (this.match(ge)) {
                        var t = this.parsePolygonTextList_();
                        if (this.match(ye)) return t;
                    } else if (this.isEmptyGeometry_()) return [];
                    throw new Error(this.formatErrorMessage_());
                }
            },
            {
                key: "parsePoint_",
                value: function value() {
                    for(var t = [], _$e = this.layout_.length, _$n = 0; _$n < _$e; ++_$n){
                        var i = this.token_;
                        if (!this.match(de)) break;
                        t.push(i.value);
                    }
                    if (t.length == _$e) return t;
                    throw new Error(this.formatErrorMessage_());
                }
            },
            {
                key: "parsePointList_",
                value: function value() {
                    for(var t = [
                        this.parsePoint_()
                    ]; this.match(_e);)t.push(this.parsePoint_());
                    return t;
                }
            },
            {
                key: "parsePointTextList_",
                value: function value() {
                    for(var t = [
                        this.parsePointText_()
                    ]; this.match(_e);)t.push(this.parsePointText_());
                    return t;
                }
            },
            {
                key: "parseLineStringTextList_",
                value: function value() {
                    for(var t = [
                        this.parseLineStringText_()
                    ]; this.match(_e);)t.push(this.parseLineStringText_());
                    return t;
                }
            },
            {
                key: "parsePolygonTextList_",
                value: function value() {
                    for(var t = [
                        this.parsePolygonText_()
                    ]; this.match(_e);)t.push(this.parsePolygonText_());
                    return t;
                }
            },
            {
                key: "isEmptyGeometry_",
                value: function value() {
                    var t = this.isTokenType(ve) && this.token_.value == fe;
                    return t && this.consume_(), t;
                }
            },
            {
                key: "formatErrorMessage_",
                value: function value() {
                    return "Unexpected `" + this.token_.value + "` at position " + this.token_.position + " in `" + this.lexer_.wkt + "`";
                }
            },
            {
                key: "parseGeometry_",
                value: function value() {
                    var t = this.factory, _$e = function e(t) {
                        return o(X, v(t));
                    }, _$n = function n(n) {
                        var i = n.map(function(n) {
                            return t.createLinearRing(n.map(_$e));
                        });
                        return i.length > 1 ? t.createPolygon(i[0], i.slice(1)) : t.createPolygon(i[0]);
                    }, i = this.token_;
                    if (this.match(ve)) {
                        var r = i.value;
                        if (this.layout_ = this.parseGeometryLayout_(), "GEOMETRYCOLLECTION" == r) {
                            var s = this.parseGeometryCollectionText_();
                            return t.createGeometryCollection(s);
                        }
                        switch(r){
                            case "POINT":
                                var a = this.parsePointText_();
                                return a ? t.createPoint(o(X, v(a))) : t.createPoint();
                            case "LINESTRING":
                                var _$u = this.parseLineStringText_().map(_$e);
                                return t.createLineString(_$u);
                            case "LINEARRING":
                                var l = this.parseLineStringText_().map(_$e);
                                return t.createLinearRing(l);
                            case "POLYGON":
                                var h = this.parsePolygonText_();
                                return h && 0 !== h.length ? _$n(h) : t.createPolygon();
                            case "MULTIPOINT":
                                var c = this.parseMultiPointText_();
                                if (!c || 0 === c.length) return t.createMultiPoint();
                                var f = c.map(_$e).map(function(e) {
                                    return t.createPoint(e);
                                });
                                return t.createMultiPoint(f);
                            case "MULTILINESTRING":
                                var g = this.parseMultiLineStringText_().map(function(n) {
                                    return t.createLineString(n.map(_$e));
                                });
                                return t.createMultiLineString(g);
                            case "MULTIPOLYGON":
                                var y = this.parseMultiPolygonText_();
                                if (!y || 0 === y.length) return t.createMultiPolygon();
                                var d = y.map(_$n);
                                return t.createMultiPolygon(d);
                            default:
                                throw new Error("Invalid geometry type: " + r);
                        }
                    }
                    throw new Error(this.formatErrorMessage_());
                }
            }
        ]), e;
    }();
    function Ee(t) {
        if (t.isEmpty()) return "";
        var e = t.getCoordinate(), n = [
            e.x,
            e.y
        ];
        return void 0 === e.z || Number.isNaN(e.z) || n.push(e.z), void 0 === e.m || Number.isNaN(e.m) || n.push(e.m), n.join(" ");
    }
    function Ne(t) {
        for(var e = t.getCoordinates().map(function(t) {
            var e = [
                t.x,
                t.y
            ];
            return void 0 === t.z || Number.isNaN(t.z) || e.push(t.z), void 0 === t.m || Number.isNaN(t.m) || e.push(t.m), e;
        }), n = [], i = 0, r = e.length; i < r; ++i)n.push(e[i].join(" "));
        return n.join(", ");
    }
    function Te(t) {
        var e = [];
        e.push("(" + Ne(t.getExteriorRing()) + ")");
        for(var n = 0, i = t.getNumInteriorRing(); n < i; ++n)e.push("(" + Ne(t.getInteriorRingN(n)) + ")");
        return e.join(", ");
    }
    var Se = {
        Point: Ee,
        LineString: Ne,
        LinearRing: Ne,
        Polygon: Te,
        MultiPoint: function MultiPoint(t) {
            for(var e = [], n = 0, i = t.getNumGeometries(); n < i; ++n)e.push("(" + Ee(t.getGeometryN(n)) + ")");
            return e.join(", ");
        },
        MultiLineString: function MultiLineString(t) {
            for(var e = [], n = 0, i = t.getNumGeometries(); n < i; ++n)e.push("(" + Ne(t.getGeometryN(n)) + ")");
            return e.join(", ");
        },
        MultiPolygon: function MultiPolygon(t) {
            for(var e = [], n = 0, i = t.getNumGeometries(); n < i; ++n)e.push("(" + Te(t.getGeometryN(n)) + ")");
            return e.join(", ");
        },
        GeometryCollection: function GeometryCollection(t) {
            for(var e = [], n = 0, i = t.getNumGeometries(); n < i; ++n)e.push(Le(t.getGeometryN(n)));
            return e.join(", ");
        }
    };
    function Le(t) {
        var e = t.getGeometryType(), n = Se[e];
        e = e.toUpperCase();
        var i = function(t) {
            var e = "";
            if (t.isEmpty()) return e;
            var n = t.getCoordinate();
            return void 0 === n.z || Number.isNaN(n.z) || (e += "Z"), void 0 === n.m || Number.isNaN(n.m) || (e += "M"), e;
        }(t);
        return i.length > 0 && (e += " " + i), t.isEmpty() ? e + " " + fe : e + " (" + n(t) + ")";
    }
    var Ce = function() {
        function e(n) {
            t(this, e), this.geometryFactory = n || new ae, this.precisionModel = this.geometryFactory.getPrecisionModel();
        }
        return n(e, [
            {
                key: "read",
                value: function value(t) {
                    var _$e = new xe(t);
                    return new Ie(_$e, this.geometryFactory).parse();
                }
            },
            {
                key: "write",
                value: function value(t) {
                    return Le(t);
                }
            }
        ]), e;
    }(), Re = function() {
        function e(n) {
            t(this, e), this.parser = new Ce(n);
        }
        return n(e, [
            {
                key: "write",
                value: function value(t) {
                    return this.parser.write(t);
                }
            }
        ], [
            {
                key: "toLineString",
                value: function value(t, e) {
                    if (2 !== arguments.length) throw new Error("Not implemented");
                    return "LINESTRING ( " + t.x + " " + t.y + ", " + e.x + " " + e.y + " )";
                }
            }
        ]), e;
    }(), we = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getIndexAlongSegment",
                value: function value(t, e) {
                    return this.computeIntLineIndex(), this._intLineIndex[t][e];
                }
            },
            {
                key: "getTopologySummary",
                value: function value() {
                    var t = new Jt;
                    return this.isEndPoint() && t.append(" endpoint"), this._isProper && t.append(" proper"), this.isCollinear() && t.append(" collinear"), t.toString();
                }
            },
            {
                key: "computeIntersection",
                value: function value(t, e, n, i) {
                    this._inputLines[0][0] = t, this._inputLines[0][1] = e, this._inputLines[1][0] = n, this._inputLines[1][1] = i, this._result = this.computeIntersect(t, e, n, i);
                }
            },
            {
                key: "getIntersectionNum",
                value: function value() {
                    return this._result;
                }
            },
            {
                key: "computeIntLineIndex",
                value: function value() {
                    if (0 === arguments.length) null === this._intLineIndex && (this._intLineIndex = Array(2).fill().map(function() {
                        return Array(2);
                    }), this.computeIntLineIndex(0), this.computeIntLineIndex(1));
                    else if (1 === arguments.length) {
                        var t = arguments[0], _$e = this.getEdgeDistance(t, 0), _$n = this.getEdgeDistance(t, 1);
                        _$e > _$n ? (this._intLineIndex[t][0] = 0, this._intLineIndex[t][1] = 1) : (this._intLineIndex[t][0] = 1, this._intLineIndex[t][1] = 0);
                    }
                }
            },
            {
                key: "isProper",
                value: function value() {
                    return this.hasIntersection() && this._isProper;
                }
            },
            {
                key: "setPrecisionModel",
                value: function value(t) {
                    this._precisionModel = t;
                }
            },
            {
                key: "isInteriorIntersection",
                value: function value() {
                    if (0 === arguments.length) return !!this.isInteriorIntersection(0) || !!this.isInteriorIntersection(1);
                    if (1 === arguments.length) {
                        for(var t = arguments[0], _$e = 0; _$e < this._result; _$e++)if (!this._intPt[_$e].equals2D(this._inputLines[t][0]) && !this._intPt[_$e].equals2D(this._inputLines[t][1])) return !0;
                        return !1;
                    }
                }
            },
            {
                key: "getIntersection",
                value: function value(t) {
                    return this._intPt[t];
                }
            },
            {
                key: "isEndPoint",
                value: function value() {
                    return this.hasIntersection() && !this._isProper;
                }
            },
            {
                key: "hasIntersection",
                value: function value() {
                    return this._result !== e.NO_INTERSECTION;
                }
            },
            {
                key: "getEdgeDistance",
                value: function value(t, n) {
                    return e.computeEdgeDistance(this._intPt[n], this._inputLines[t][0], this._inputLines[t][1]);
                }
            },
            {
                key: "isCollinear",
                value: function value() {
                    return this._result === e.COLLINEAR_INTERSECTION;
                }
            },
            {
                key: "toString",
                value: function value() {
                    return Re.toLineString(this._inputLines[0][0], this._inputLines[0][1]) + " - " + Re.toLineString(this._inputLines[1][0], this._inputLines[1][1]) + this.getTopologySummary();
                }
            },
            {
                key: "getEndpoint",
                value: function value(t, e) {
                    return this._inputLines[t][e];
                }
            },
            {
                key: "isIntersection",
                value: function value(t) {
                    for(var _$e = 0; _$e < this._result; _$e++)if (this._intPt[_$e].equals2D(t)) return !0;
                    return !1;
                }
            },
            {
                key: "getIntersectionAlongSegment",
                value: function value(t, e) {
                    return this.computeIntLineIndex(), this._intPt[this._intLineIndex[t][e]];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._result = null, this._inputLines = Array(2).fill().map(function() {
                        return Array(2);
                    }), this._intPt = new Array(2).fill(null), this._intLineIndex = null, this._isProper = null, this._pa = null, this._pb = null, this._precisionModel = null, this._intPt[0] = new X, this._intPt[1] = new X, this._pa = this._intPt[0], this._pb = this._intPt[1], this._result = 0;
                }
            },
            {
                key: "computeEdgeDistance",
                value: function value(t, e, n) {
                    var i = Math.abs(n.x - e.x), r = Math.abs(n.y - e.y), s = -1;
                    if (t.equals(e)) s = 0;
                    else if (t.equals(n)) s = i > r ? i : r;
                    else {
                        var a = Math.abs(t.x - e.x), o = Math.abs(t.y - e.y);
                        0 !== (s = i > r ? a : o) || t.equals(e) || (s = Math.max(a, o));
                    }
                    return G.isTrue(!(0 === s && !t.equals(e)), "Bad distance calculation"), s;
                }
            },
            {
                key: "nonRobustComputeEdgeDistance",
                value: function value(t, e, n) {
                    var i = t.x - e.x, r = t.y - e.y, s = Math.sqrt(i * i + r * r);
                    return G.isTrue(!(0 === s && !t.equals(e)), "Invalid distance calculation"), s;
                }
            }
        ]), e;
    }();
    we.DONT_INTERSECT = 0, we.DO_INTERSECT = 1, we.COLLINEAR = 2, we.NO_INTERSECTION = 0, we.POINT_INTERSECTION = 1, we.COLLINEAR_INTERSECTION = 2;
    var Oe = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            return t(this, a), s.call(this);
        }
        return n(a, [
            {
                key: "isInSegmentEnvelopes",
                value: function value(t) {
                    var _$e = new U(this._inputLines[0][0], this._inputLines[0][1]), _$n = new U(this._inputLines[1][0], this._inputLines[1][1]);
                    return _$e.contains(t) && _$n.contains(t);
                }
            },
            {
                key: "computeIntersection",
                value: function value() {
                    if (3 !== arguments.length) return f(r(a.prototype), "computeIntersection", this).apply(this, arguments);
                    var t = arguments[0], _$e = arguments[1], _$n = arguments[2];
                    if (this._isProper = !1, U.intersects(_$e, _$n, t) && 0 === ct.index(_$e, _$n, t) && 0 === ct.index(_$n, _$e, t)) return this._isProper = !0, (t.equals(_$e) || t.equals(_$n)) && (this._isProper = !1), this._result = we.POINT_INTERSECTION, null;
                    this._result = we.NO_INTERSECTION;
                }
            },
            {
                key: "intersection",
                value: function value(t, e, n, i) {
                    var r = this.intersectionSafe(t, e, n, i);
                    return this.isInSegmentEnvelopes(r) || (r = new X(a.nearestEndpoint(t, e, n, i))), null !== this._precisionModel && this._precisionModel.makePrecise(r), r;
                }
            },
            {
                key: "checkDD",
                value: function value(t, e, n, i, r) {
                    var s = lt.intersection(t, e, n, i), _$a = this.isInSegmentEnvelopes(s);
                    mt.out.println("DD in env = " + _$a + "  --------------------- " + s), r.distance(s) > 1e-4 && mt.out.println("Distance = " + r.distance(s));
                }
            },
            {
                key: "intersectionSafe",
                value: function value(t, e, n, i) {
                    var r = pt.intersection(t, e, n, i);
                    return null === r && (r = a.nearestEndpoint(t, e, n, i)), r;
                }
            },
            {
                key: "computeCollinearIntersection",
                value: function value(t, e, n, i) {
                    var r = U.intersects(t, e, n), s = U.intersects(t, e, i), _$a = U.intersects(n, i, t), o = U.intersects(n, i, e);
                    return r && s ? (this._intPt[0] = n, this._intPt[1] = i, we.COLLINEAR_INTERSECTION) : _$a && o ? (this._intPt[0] = t, this._intPt[1] = e, we.COLLINEAR_INTERSECTION) : r && _$a ? (this._intPt[0] = n, this._intPt[1] = t, !n.equals(t) || s || o ? we.COLLINEAR_INTERSECTION : we.POINT_INTERSECTION) : r && o ? (this._intPt[0] = n, this._intPt[1] = e, !n.equals(e) || s || _$a ? we.COLLINEAR_INTERSECTION : we.POINT_INTERSECTION) : s && _$a ? (this._intPt[0] = i, this._intPt[1] = t, !i.equals(t) || r || o ? we.COLLINEAR_INTERSECTION : we.POINT_INTERSECTION) : s && o ? (this._intPt[0] = i, this._intPt[1] = e, !i.equals(e) || r || _$a ? we.COLLINEAR_INTERSECTION : we.POINT_INTERSECTION) : we.NO_INTERSECTION;
                }
            },
            {
                key: "computeIntersect",
                value: function value(t, e, n, i) {
                    if (this._isProper = !1, !U.intersects(t, e, n, i)) return we.NO_INTERSECTION;
                    var r = ct.index(t, e, n), s = ct.index(t, e, i);
                    if (r > 0 && s > 0 || r < 0 && s < 0) return we.NO_INTERSECTION;
                    var _$a = ct.index(n, i, t), o = ct.index(n, i, e);
                    return _$a > 0 && o > 0 || _$a < 0 && o < 0 ? we.NO_INTERSECTION : 0 === r && 0 === s && 0 === _$a && 0 === o ? this.computeCollinearIntersection(t, e, n, i) : (0 === r || 0 === s || 0 === _$a || 0 === o ? (this._isProper = !1, t.equals2D(n) || t.equals2D(i) ? this._intPt[0] = t : e.equals2D(n) || e.equals2D(i) ? this._intPt[0] = e : 0 === r ? this._intPt[0] = new X(n) : 0 === s ? this._intPt[0] = new X(i) : 0 === _$a ? this._intPt[0] = new X(t) : 0 === o && (this._intPt[0] = new X(e))) : (this._isProper = !0, this._intPt[0] = this.intersection(t, e, n, i)), we.POINT_INTERSECTION);
                }
            }
        ], [
            {
                key: "nearestEndpoint",
                value: function value(t, e, n, i) {
                    var r = t, s = xt.pointToSegment(t, n, i), _$a = xt.pointToSegment(e, n, i);
                    return _$a < s && (s = _$a, r = e), (_$a = xt.pointToSegment(n, t, e)) < s && (s = _$a, r = n), (_$a = xt.pointToSegment(i, t, e)) < s && (s = _$a, r = i), r;
                }
            }
        ]), a;
    }(we), be = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "countSegment",
                value: function value(t, e) {
                    if (t.x < this._p.x && e.x < this._p.x) return null;
                    if (this._p.x === e.x && this._p.y === e.y) return this._isPointOnSegment = !0, null;
                    if (t.y === this._p.y && e.y === this._p.y) {
                        var _$n = t.x, i = e.x;
                        return _$n > i && (_$n = e.x, i = t.x), this._p.x >= _$n && this._p.x <= i && (this._isPointOnSegment = !0), null;
                    }
                    if (t.y > this._p.y && e.y <= this._p.y || e.y > this._p.y && t.y <= this._p.y) {
                        var r = ct.index(t, e, this._p);
                        if (r === ct.COLLINEAR) return this._isPointOnSegment = !0, null;
                        e.y < t.y && (r = -r), r === ct.LEFT && this._crossingCount++;
                    }
                }
            },
            {
                key: "isPointInPolygon",
                value: function value() {
                    return this.getLocation() !== H.EXTERIOR;
                }
            },
            {
                key: "getLocation",
                value: function value() {
                    return this._isPointOnSegment ? H.BOUNDARY : this._crossingCount % 2 == 1 ? H.INTERIOR : H.EXTERIOR;
                }
            },
            {
                key: "isOnSegment",
                value: function value() {
                    return this._isPointOnSegment;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._p = null, this._crossingCount = 0, this._isPointOnSegment = !1;
                    var t = arguments[0];
                    this._p = t;
                }
            },
            {
                key: "locatePointInRing",
                value: function value() {
                    if (_instanceof(arguments[0], X) && rt(arguments[1], ht)) {
                        for(var t = arguments[0], _$n = arguments[1], i = new e(t), r = new X, s = new X, a = 1; a < _$n.size(); a++)if (_$n.getCoordinate(a, r), _$n.getCoordinate(a - 1, s), i.countSegment(r, s), i.isOnSegment()) return i.getLocation();
                        return i.getLocation();
                    }
                    if (_instanceof(arguments[0], X) && _instanceof(arguments[1], Array)) {
                        for(var o = arguments[0], _$u = arguments[1], l = new e(o), h = 1; h < _$u.length; h++){
                            var c = _$u[h], f = _$u[h - 1];
                            if (l.countSegment(c, f), l.isOnSegment()) return l.getLocation();
                        }
                        return l.getLocation();
                    }
                }
            }
        ]), e;
    }(), Me = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "isOnLine",
                value: function value() {
                    if (_instanceof(arguments[0], X) && rt(arguments[1], ht)) {
                        for(var t = arguments[0], _$e = arguments[1], _$n = new Oe, i = new X, r = new X, s = _$e.size(), a = 1; a < s; a++)if (_$e.getCoordinate(a - 1, i), _$e.getCoordinate(a, r), _$n.computeIntersection(t, i, r), _$n.hasIntersection()) return !0;
                        return !1;
                    }
                    if (_instanceof(arguments[0], X) && _instanceof(arguments[1], Array)) {
                        for(var o = arguments[0], _$u = arguments[1], l = new Oe, h = 1; h < _$u.length; h++){
                            var c = _$u[h - 1], f = _$u[h];
                            if (l.computeIntersection(o, c, f), l.hasIntersection()) return !0;
                        }
                        return !1;
                    }
                }
            },
            {
                key: "locateInRing",
                value: function value(t, e) {
                    return be.locatePointInRing(t, e);
                }
            },
            {
                key: "isInRing",
                value: function value(t, n) {
                    return e.locateInRing(t, n) !== H.EXTERIOR;
                }
            }
        ]), e;
    }(), Ae = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "setAllLocations",
                value: function value(t) {
                    for(var _$e = 0; _$e < this.location.length; _$e++)this.location[_$e] = t;
                }
            },
            {
                key: "isNull",
                value: function value() {
                    for(var t = 0; t < this.location.length; t++)if (this.location[t] !== H.NONE) return !1;
                    return !0;
                }
            },
            {
                key: "setAllLocationsIfNull",
                value: function value(t) {
                    for(var _$e = 0; _$e < this.location.length; _$e++)this.location[_$e] === H.NONE && (this.location[_$e] = t);
                }
            },
            {
                key: "isLine",
                value: function value() {
                    return 1 === this.location.length;
                }
            },
            {
                key: "merge",
                value: function value(t) {
                    if (t.location.length > this.location.length) {
                        var _$e = new Array(3).fill(null);
                        _$e[$.ON] = this.location[$.ON], _$e[$.LEFT] = H.NONE, _$e[$.RIGHT] = H.NONE, this.location = _$e;
                    }
                    for(var _$n = 0; _$n < this.location.length; _$n++)this.location[_$n] === H.NONE && _$n < t.location.length && (this.location[_$n] = t.location[_$n]);
                }
            },
            {
                key: "getLocations",
                value: function value() {
                    return this.location;
                }
            },
            {
                key: "flip",
                value: function value() {
                    if (this.location.length <= 1) return null;
                    var t = this.location[$.LEFT];
                    this.location[$.LEFT] = this.location[$.RIGHT], this.location[$.RIGHT] = t;
                }
            },
            {
                key: "toString",
                value: function value() {
                    var t = new st;
                    return this.location.length > 1 && t.append(H.toLocationSymbol(this.location[$.LEFT])), t.append(H.toLocationSymbol(this.location[$.ON])), this.location.length > 1 && t.append(H.toLocationSymbol(this.location[$.RIGHT])), t.toString();
                }
            },
            {
                key: "setLocations",
                value: function value(t, e, n) {
                    this.location[$.ON] = t, this.location[$.LEFT] = e, this.location[$.RIGHT] = n;
                }
            },
            {
                key: "get",
                value: function value(t) {
                    return t < this.location.length ? this.location[t] : H.NONE;
                }
            },
            {
                key: "isArea",
                value: function value() {
                    return this.location.length > 1;
                }
            },
            {
                key: "isAnyNull",
                value: function value() {
                    for(var t = 0; t < this.location.length; t++)if (this.location[t] === H.NONE) return !0;
                    return !1;
                }
            },
            {
                key: "setLocation",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        this.setLocation($.ON, t);
                    } else if (2 === arguments.length) {
                        var _$e = arguments[0], _$n = arguments[1];
                        this.location[_$e] = _$n;
                    }
                }
            },
            {
                key: "init",
                value: function value(t) {
                    this.location = new Array(t).fill(null), this.setAllLocations(H.NONE);
                }
            },
            {
                key: "isEqualOnSide",
                value: function value(t, e) {
                    return this.location[e] === t.location[e];
                }
            },
            {
                key: "allPositionsEqual",
                value: function value(t) {
                    for(var _$e = 0; _$e < this.location.length; _$e++)if (this.location[_$e] !== t) return !1;
                    return !0;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this.location = null, 1 === arguments.length) {
                        if (_instanceof(arguments[0], Array)) {
                            var t = arguments[0];
                            this.init(t.length);
                        } else if (Number.isInteger(arguments[0])) {
                            var _$n = arguments[0];
                            this.init(1), this.location[$.ON] = _$n;
                        } else if (_instanceof(arguments[0], e)) {
                            var i = arguments[0];
                            if (this.init(i.location.length), null !== i) for(var r = 0; r < this.location.length; r++)this.location[r] = i.location[r];
                        }
                    } else if (3 === arguments.length) {
                        var s = arguments[0], a = arguments[1], o = arguments[2];
                        this.init(3), this.location[$.ON] = s, this.location[$.LEFT] = a, this.location[$.RIGHT] = o;
                    }
                }
            }
        ]), e;
    }(), Pe = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getGeometryCount",
                value: function value() {
                    var t = 0;
                    return this.elt[0].isNull() || t++, this.elt[1].isNull() || t++, t;
                }
            },
            {
                key: "setAllLocations",
                value: function value(t, e) {
                    this.elt[t].setAllLocations(e);
                }
            },
            {
                key: "isNull",
                value: function value(t) {
                    return this.elt[t].isNull();
                }
            },
            {
                key: "setAllLocationsIfNull",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        this.setAllLocationsIfNull(0, t), this.setAllLocationsIfNull(1, t);
                    } else if (2 === arguments.length) {
                        var _$e = arguments[0], _$n = arguments[1];
                        this.elt[_$e].setAllLocationsIfNull(_$n);
                    }
                }
            },
            {
                key: "isLine",
                value: function value(t) {
                    return this.elt[t].isLine();
                }
            },
            {
                key: "merge",
                value: function value(t) {
                    for(var _$e = 0; _$e < 2; _$e++)null === this.elt[_$e] && null !== t.elt[_$e] ? this.elt[_$e] = new Ae(t.elt[_$e]) : this.elt[_$e].merge(t.elt[_$e]);
                }
            },
            {
                key: "flip",
                value: function value() {
                    this.elt[0].flip(), this.elt[1].flip();
                }
            },
            {
                key: "getLocation",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        return this.elt[t].get($.ON);
                    }
                    if (2 === arguments.length) {
                        var _$e = arguments[0], _$n = arguments[1];
                        return this.elt[_$e].get(_$n);
                    }
                }
            },
            {
                key: "toString",
                value: function value() {
                    var t = new st;
                    return null !== this.elt[0] && (t.append("A:"), t.append(this.elt[0].toString())), null !== this.elt[1] && (t.append(" B:"), t.append(this.elt[1].toString())), t.toString();
                }
            },
            {
                key: "isArea",
                value: function value() {
                    if (0 === arguments.length) return this.elt[0].isArea() || this.elt[1].isArea();
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        return this.elt[t].isArea();
                    }
                }
            },
            {
                key: "isAnyNull",
                value: function value(t) {
                    return this.elt[t].isAnyNull();
                }
            },
            {
                key: "setLocation",
                value: function value() {
                    if (2 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1];
                        this.elt[t].setLocation($.ON, _$e);
                    } else if (3 === arguments.length) {
                        var _$n = arguments[0], i = arguments[1], r = arguments[2];
                        this.elt[_$n].setLocation(i, r);
                    }
                }
            },
            {
                key: "isEqualOnSide",
                value: function value(t, e) {
                    return this.elt[0].isEqualOnSide(t.elt[0], e) && this.elt[1].isEqualOnSide(t.elt[1], e);
                }
            },
            {
                key: "allPositionsEqual",
                value: function value(t, e) {
                    return this.elt[t].allPositionsEqual(e);
                }
            },
            {
                key: "toLine",
                value: function value(t) {
                    this.elt[t].isArea() && (this.elt[t] = new Ae(this.elt[t].location[0]));
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this.elt = new Array(2).fill(null), 1 === arguments.length) {
                        if (Number.isInteger(arguments[0])) {
                            var t = arguments[0];
                            this.elt[0] = new Ae(t), this.elt[1] = new Ae(t);
                        } else if (_instanceof(arguments[0], e)) {
                            var _$n = arguments[0];
                            this.elt[0] = new Ae(_$n.elt[0]), this.elt[1] = new Ae(_$n.elt[1]);
                        }
                    } else if (2 === arguments.length) {
                        var i = arguments[0], r = arguments[1];
                        this.elt[0] = new Ae(H.NONE), this.elt[1] = new Ae(H.NONE), this.elt[i].setLocation(r);
                    } else if (3 === arguments.length) {
                        var s = arguments[0], a = arguments[1], o = arguments[2];
                        this.elt[0] = new Ae(s, a, o), this.elt[1] = new Ae(s, a, o);
                    } else if (4 === arguments.length) {
                        var _$u = arguments[0], l = arguments[1], h = arguments[2], c = arguments[3];
                        this.elt[0] = new Ae(H.NONE, H.NONE, H.NONE), this.elt[1] = new Ae(H.NONE, H.NONE, H.NONE), this.elt[_$u].setLocations(l, h, c);
                    }
                }
            },
            {
                key: "toLineLabel",
                value: function value(t) {
                    for(var _$n = new e(H.NONE), i = 0; i < 2; i++)_$n.setLocation(i, t.getLocation(i));
                    return _$n;
                }
            }
        ]), e;
    }(), De = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "computeRing",
                value: function value() {
                    if (null !== this._ring) return null;
                    for(var t = new Array(this._pts.size()).fill(null), _$e = 0; _$e < this._pts.size(); _$e++)t[_$e] = this._pts.get(_$e);
                    this._ring = this._geometryFactory.createLinearRing(t), this._isHole = ct.isCCW(this._ring.getCoordinates());
                }
            },
            {
                key: "isIsolated",
                value: function value() {
                    return 1 === this._label.getGeometryCount();
                }
            },
            {
                key: "computePoints",
                value: function value(t) {
                    this._startDe = t;
                    var _$e = t, _$n = !0;
                    do {
                        if (null === _$e) throw new vt("Found null DirectedEdge");
                        if (_$e.getEdgeRing() === this) throw new vt("Directed Edge visited twice during ring-building at " + _$e.getCoordinate());
                        this._edges.add(_$e);
                        var i = _$e.getLabel();
                        G.isTrue(i.isArea()), this.mergeLabel(i), this.addPoints(_$e.getEdge(), _$e.isForward(), _$n), _$n = !1, this.setEdgeRing(_$e, this), _$e = this.getNext(_$e);
                    }while (_$e !== this._startDe);
                }
            },
            {
                key: "getLinearRing",
                value: function value() {
                    return this._ring;
                }
            },
            {
                key: "getCoordinate",
                value: function value(t) {
                    return this._pts.get(t);
                }
            },
            {
                key: "computeMaxNodeDegree",
                value: function value() {
                    this._maxNodeDegree = 0;
                    var t = this._startDe;
                    do {
                        var _$e = t.getNode().getEdges().getOutgoingDegree(this);
                        _$e > this._maxNodeDegree && (this._maxNodeDegree = _$e), t = this.getNext(t);
                    }while (t !== this._startDe);
                    this._maxNodeDegree *= 2;
                }
            },
            {
                key: "addPoints",
                value: function value(t, e, n) {
                    var i = t.getCoordinates();
                    if (e) {
                        var r = 1;
                        n && (r = 0);
                        for(var s = r; s < i.length; s++)this._pts.add(i[s]);
                    } else {
                        var a = i.length - 2;
                        n && (a = i.length - 1);
                        for(var o = a; o >= 0; o--)this._pts.add(i[o]);
                    }
                }
            },
            {
                key: "isHole",
                value: function value() {
                    return this._isHole;
                }
            },
            {
                key: "setInResult",
                value: function value() {
                    var t = this._startDe;
                    do {
                        t.getEdge().setInResult(!0), t = t.getNext();
                    }while (t !== this._startDe);
                }
            },
            {
                key: "containsPoint",
                value: function value(t) {
                    var _$e = this.getLinearRing();
                    if (!_$e.getEnvelopeInternal().contains(t)) return !1;
                    if (!Me.isInRing(t, _$e.getCoordinates())) return !1;
                    for(var _$n = this._holes.iterator(); _$n.hasNext();){
                        if (_$n.next().containsPoint(t)) return !1;
                    }
                    return !0;
                }
            },
            {
                key: "addHole",
                value: function value(t) {
                    this._holes.add(t);
                }
            },
            {
                key: "isShell",
                value: function value() {
                    return null === this._shell;
                }
            },
            {
                key: "getLabel",
                value: function value() {
                    return this._label;
                }
            },
            {
                key: "getEdges",
                value: function value() {
                    return this._edges;
                }
            },
            {
                key: "getMaxNodeDegree",
                value: function value() {
                    return this._maxNodeDegree < 0 && this.computeMaxNodeDegree(), this._maxNodeDegree;
                }
            },
            {
                key: "getShell",
                value: function value() {
                    return this._shell;
                }
            },
            {
                key: "mergeLabel",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        this.mergeLabel(t, 0), this.mergeLabel(t, 1);
                    } else if (2 === arguments.length) {
                        var _$e = arguments[0], _$n = arguments[1], i = _$e.getLocation(_$n, $.RIGHT);
                        if (i === H.NONE) return null;
                        if (this._label.getLocation(_$n) === H.NONE) return this._label.setLocation(_$n, i), null;
                    }
                }
            },
            {
                key: "setShell",
                value: function value(t) {
                    this._shell = t, null !== t && t.addHole(this);
                }
            },
            {
                key: "toPolygon",
                value: function value(t) {
                    for(var _$e = new Array(this._holes.size()).fill(null), _$n = 0; _$n < this._holes.size(); _$n++)_$e[_$n] = this._holes.get(_$n).getLinearRing();
                    return t.createPolygon(this.getLinearRing(), _$e);
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._startDe = null, this._maxNodeDegree = -1, this._edges = new yt, this._pts = new yt, this._label = new Pe(H.NONE), this._ring = null, this._isHole = null, this._shell = null, this._holes = new yt, this._geometryFactory = null, 0 === arguments.length) ;
                    else if (2 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1];
                        this._geometryFactory = _$e, this.computePoints(t), this.computeRing();
                    }
                }
            }
        ]), e;
    }(), Fe = function(e) {
        i(s, e);
        var r = c(s);
        function s() {
            var _$e;
            return t(this, s), _$e = r.call(this), s.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(s, [
            {
                key: "setEdgeRing",
                value: function value(t, e) {
                    t.setMinEdgeRing(e);
                }
            },
            {
                key: "getNext",
                value: function value(t) {
                    return t.getNextMin();
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    var t = arguments[0], _$e = arguments[1];
                    De.constructor_.call(this, t, _$e);
                }
            }
        ]), s;
    }(De), Ge = function(e) {
        i(s, e);
        var r = c(s);
        function s() {
            var _$e;
            return t(this, s), _$e = r.call(this), s.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(s, [
            {
                key: "buildMinimalRings",
                value: function value() {
                    var t = new yt, _$e = this._startDe;
                    do {
                        if (null === _$e.getMinEdgeRing()) {
                            var _$n = new Fe(_$e, this._geometryFactory);
                            t.add(_$n);
                        }
                        _$e = _$e.getNext();
                    }while (_$e !== this._startDe);
                    return t;
                }
            },
            {
                key: "setEdgeRing",
                value: function value(t, e) {
                    t.setEdgeRing(e);
                }
            },
            {
                key: "linkDirectedEdgesForMinimalEdgeRings",
                value: function value() {
                    var t = this._startDe;
                    do {
                        t.getNode().getEdges().linkMinimalDirectedEdges(this), t = t.getNext();
                    }while (t !== this._startDe);
                }
            },
            {
                key: "getNext",
                value: function value(t) {
                    return t.getNext();
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    var t = arguments[0], _$e = arguments[1];
                    De.constructor_.call(this, t, _$e);
                }
            }
        ]), s;
    }(De), qe = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "setVisited",
                value: function value(t) {
                    this._isVisited = t;
                }
            },
            {
                key: "setInResult",
                value: function value(t) {
                    this._isInResult = t;
                }
            },
            {
                key: "isCovered",
                value: function value() {
                    return this._isCovered;
                }
            },
            {
                key: "isCoveredSet",
                value: function value() {
                    return this._isCoveredSet;
                }
            },
            {
                key: "setLabel",
                value: function value(t) {
                    this._label = t;
                }
            },
            {
                key: "getLabel",
                value: function value() {
                    return this._label;
                }
            },
            {
                key: "setCovered",
                value: function value(t) {
                    this._isCovered = t, this._isCoveredSet = !0;
                }
            },
            {
                key: "updateIM",
                value: function value(t) {
                    G.isTrue(this._label.getGeometryCount() >= 2, "found partial label"), this.computeIM(t);
                }
            },
            {
                key: "isInResult",
                value: function value() {
                    return this._isInResult;
                }
            },
            {
                key: "isVisited",
                value: function value() {
                    return this._isVisited;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._label = null, this._isInResult = !1, this._isCovered = !1, this._isCoveredSet = !1, this._isVisited = !1, 0 === arguments.length) ;
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        this._label = t;
                    }
                }
            }
        ]), e;
    }(), Ye = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "isIncidentEdgeInResult",
                value: function value() {
                    for(var t = this.getEdges().getEdges().iterator(); t.hasNext();){
                        if (t.next().getEdge().isInResult()) return !0;
                    }
                    return !1;
                }
            },
            {
                key: "isIsolated",
                value: function value() {
                    return 1 === this._label.getGeometryCount();
                }
            },
            {
                key: "getCoordinate",
                value: function value() {
                    return this._coord;
                }
            },
            {
                key: "print",
                value: function value(t) {
                    t.println("node " + this._coord + " lbl: " + this._label);
                }
            },
            {
                key: "computeIM",
                value: function value(t) {}
            },
            {
                key: "computeMergedLocation",
                value: function value(t, e) {
                    var _$n = H.NONE;
                    if (_$n = this._label.getLocation(e), !t.isNull(e)) {
                        var _$i = t.getLocation(e);
                        _$n !== H.BOUNDARY && (_$n = _$i);
                    }
                    return _$n;
                }
            },
            {
                key: "setLabel",
                value: function value() {
                    if (2 !== arguments.length || !Number.isInteger(arguments[1]) || !Number.isInteger(arguments[0])) return f(r(a.prototype), "setLabel", this).apply(this, arguments);
                    var t = arguments[0], _$e = arguments[1];
                    null === this._label ? this._label = new Pe(t, _$e) : this._label.setLocation(t, _$e);
                }
            },
            {
                key: "getEdges",
                value: function value() {
                    return this._edges;
                }
            },
            {
                key: "mergeLabel",
                value: function value() {
                    if (_instanceof(arguments[0], a)) {
                        var t = arguments[0];
                        this.mergeLabel(t._label);
                    } else if (_instanceof(arguments[0], Pe)) for(var _$e = arguments[0], _$n = 0; _$n < 2; _$n++){
                        var _$i = this.computeMergedLocation(_$e, _$n), r = this._label.getLocation(_$n);
                        r === H.NONE && this._label.setLocation(_$n, _$i);
                    }
                }
            },
            {
                key: "add",
                value: function value(t) {
                    this._edges.insert(t), t.setNode(this);
                }
            },
            {
                key: "setLabelBoundary",
                value: function value(t) {
                    if (null === this._label) return null;
                    var _$e = H.NONE;
                    null !== this._label && (_$e = this._label.getLocation(t));
                    var _$n = null;
                    switch(_$e){
                        case H.BOUNDARY:
                            _$n = H.INTERIOR;
                            break;
                        case H.INTERIOR:
                        default:
                            _$n = H.BOUNDARY;
                    }
                    this._label.setLocation(t, _$n);
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._coord = null, this._edges = null;
                    var t = arguments[0], _$e = arguments[1];
                    this._coord = t, this._edges = _$e, this._label = new Pe(0, H.NONE);
                }
            }
        ]), a;
    }(qe), ze = function(e) {
        i(r, e);
        var n = c(r);
        function r() {
            return t(this, r), n.apply(this, arguments);
        }
        return r;
    }(ee);
    function Xe(t) {
        return null == t ? 0 : t.color;
    }
    function Be(t) {
        return null == t ? null : t.parent;
    }
    function Ue(t, e) {
        null !== t && (t.color = e);
    }
    function Ve(t) {
        return null == t ? null : t.left;
    }
    function He(t) {
        return null == t ? null : t.right;
    }
    var Ze = function(e) {
        i(s, e);
        var r = c(s);
        function s() {
            var _$e;
            return t(this, s), (_$e = r.call(this)).root_ = null, _$e.size_ = 0, _$e;
        }
        return n(s, [
            {
                key: "get",
                value: function value(t) {
                    for(var _$e = this.root_; null !== _$e;){
                        var _$n = t.compareTo(_$e.key);
                        if (_$n < 0) _$e = _$e.left;
                        else {
                            if (!(_$n > 0)) return _$e.value;
                            _$e = _$e.right;
                        }
                    }
                    return null;
                }
            },
            {
                key: "put",
                value: function value(t, e) {
                    if (null === this.root_) return this.root_ = {
                        key: t,
                        value: e,
                        left: null,
                        right: null,
                        parent: null,
                        color: 0,
                        getValue: function getValue() {
                            return this.value;
                        },
                        getKey: function getKey() {
                            return this.key;
                        }
                    }, this.size_ = 1, null;
                    var _$n, _$i, r = this.root_;
                    do {
                        if (_$n = r, (_$i = t.compareTo(r.key)) < 0) r = r.left;
                        else {
                            if (!(_$i > 0)) {
                                var _$s = r.value;
                                return r.value = e, _$s;
                            }
                            r = r.right;
                        }
                    }while (null !== r);
                    var a = {
                        key: t,
                        left: null,
                        right: null,
                        value: e,
                        parent: _$n,
                        color: 0,
                        getValue: function getValue() {
                            return this.value;
                        },
                        getKey: function getKey() {
                            return this.key;
                        }
                    };
                    return _$i < 0 ? _$n.left = a : _$n.right = a, this.fixAfterInsertion(a), this.size_++, null;
                }
            },
            {
                key: "fixAfterInsertion",
                value: function value(t) {
                    var _$e;
                    for(t.color = 1; null != t && t !== this.root_ && 1 === t.parent.color;)Be(t) === Ve(Be(Be(t))) ? 1 === Xe(_$e = He(Be(Be(t)))) ? (Ue(Be(t), 0), Ue(_$e, 0), Ue(Be(Be(t)), 1), t = Be(Be(t))) : (t === He(Be(t)) && (t = Be(t), this.rotateLeft(t)), Ue(Be(t), 0), Ue(Be(Be(t)), 1), this.rotateRight(Be(Be(t)))) : 1 === Xe(_$e = Ve(Be(Be(t)))) ? (Ue(Be(t), 0), Ue(_$e, 0), Ue(Be(Be(t)), 1), t = Be(Be(t))) : (t === Ve(Be(t)) && (t = Be(t), this.rotateRight(t)), Ue(Be(t), 0), Ue(Be(Be(t)), 1), this.rotateLeft(Be(Be(t))));
                    this.root_.color = 0;
                }
            },
            {
                key: "values",
                value: function value() {
                    var t = new yt, _$e = this.getFirstEntry();
                    if (null !== _$e) for(t.add(_$e.value); null !== (_$e = s.successor(_$e));)t.add(_$e.value);
                    return t;
                }
            },
            {
                key: "entrySet",
                value: function value() {
                    var t = new J, _$e = this.getFirstEntry();
                    if (null !== _$e) for(t.add(_$e); null !== (_$e = s.successor(_$e));)t.add(_$e);
                    return t;
                }
            },
            {
                key: "rotateLeft",
                value: function value(t) {
                    if (null != t) {
                        var _$e = t.right;
                        t.right = _$e.left, null != _$e.left && (_$e.left.parent = t), _$e.parent = t.parent, null == t.parent ? this.root_ = _$e : t.parent.left === t ? t.parent.left = _$e : t.parent.right = _$e, _$e.left = t, t.parent = _$e;
                    }
                }
            },
            {
                key: "rotateRight",
                value: function value(t) {
                    if (null != t) {
                        var _$e = t.left;
                        t.left = _$e.right, null != _$e.right && (_$e.right.parent = t), _$e.parent = t.parent, null == t.parent ? this.root_ = _$e : t.parent.right === t ? t.parent.right = _$e : t.parent.left = _$e, _$e.right = t, t.parent = _$e;
                    }
                }
            },
            {
                key: "getFirstEntry",
                value: function value() {
                    var t = this.root_;
                    if (null != t) for(; null != t.left;)t = t.left;
                    return t;
                }
            },
            {
                key: "size",
                value: function value() {
                    return this.size_;
                }
            },
            {
                key: "containsKey",
                value: function value(t) {
                    for(var _$e = this.root_; null !== _$e;){
                        var _$n = t.compareTo(_$e.key);
                        if (_$n < 0) _$e = _$e.left;
                        else {
                            if (!(_$n > 0)) return !0;
                            _$e = _$e.right;
                        }
                    }
                    return !1;
                }
            }
        ], [
            {
                key: "successor",
                value: function value(t) {
                    var _$e;
                    if (null === t) return null;
                    if (null !== t.right) {
                        for(_$e = t.right; null !== _$e.left;)_$e = _$e.left;
                        return _$e;
                    }
                    _$e = t.parent;
                    for(var _$n = t; null !== _$e && _$n === _$e.right;)_$n = _$e, _$e = _$e.parent;
                    return _$e;
                }
            }
        ]), s;
    }(ze), je = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "find",
                value: function value(t) {
                    return this.nodeMap.get(t);
                }
            },
            {
                key: "addNode",
                value: function value() {
                    if (_instanceof(arguments[0], X)) {
                        var t = arguments[0], _$e = this.nodeMap.get(t);
                        return null === _$e && (_$e = this.nodeFact.createNode(t), this.nodeMap.put(t, _$e)), _$e;
                    }
                    if (_instanceof(arguments[0], Ye)) {
                        var _$n = arguments[0], i = this.nodeMap.get(_$n.getCoordinate());
                        return null === i ? (this.nodeMap.put(_$n.getCoordinate(), _$n), _$n) : (i.mergeLabel(_$n), i);
                    }
                }
            },
            {
                key: "print",
                value: function value(t) {
                    for(var _$e = this.iterator(); _$e.hasNext();){
                        _$e.next().print(t);
                    }
                }
            },
            {
                key: "iterator",
                value: function value() {
                    return this.nodeMap.values().iterator();
                }
            },
            {
                key: "values",
                value: function value() {
                    return this.nodeMap.values();
                }
            },
            {
                key: "getBoundaryNodes",
                value: function value(t) {
                    for(var _$e = new yt, _$n = this.iterator(); _$n.hasNext();){
                        var i = _$n.next();
                        i.getLabel().getLocation(t) === H.BOUNDARY && _$e.add(i);
                    }
                    return _$e;
                }
            },
            {
                key: "add",
                value: function value(t) {
                    var _$e = t.getCoordinate();
                    this.addNode(_$e).add(t);
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this.nodeMap = new Ze, this.nodeFact = null;
                    var t = arguments[0];
                    this.nodeFact = t;
                }
            }
        ]), e;
    }(), We = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "isNorthern",
                value: function value(t) {
                    return t === e.NE || t === e.NW;
                }
            },
            {
                key: "isOpposite",
                value: function value(t, e) {
                    return t !== e && 2 === (t - e + 4) % 4;
                }
            },
            {
                key: "commonHalfPlane",
                value: function value(t, e) {
                    if (t === e) return t;
                    if (2 === (t - e + 4) % 4) return -1;
                    var _$n = t < e ? t : e;
                    return 0 === _$n && 3 === (t > e ? t : e) ? 3 : _$n;
                }
            },
            {
                key: "isInHalfPlane",
                value: function value(t, n) {
                    return n === e.SE ? t === e.SE || t === e.SW : t === n || t === n + 1;
                }
            },
            {
                key: "quadrant",
                value: function value() {
                    if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                        var t = arguments[0], _$n = arguments[1];
                        if (0 === t && 0 === _$n) throw new m("Cannot compute the quadrant for point ( " + t + ", " + _$n + " )");
                        return t >= 0 ? _$n >= 0 ? e.NE : e.SE : _$n >= 0 ? e.NW : e.SW;
                    }
                    if (_instanceof(arguments[0], X) && _instanceof(arguments[1], X)) {
                        var i = arguments[0], r = arguments[1];
                        if (r.x === i.x && r.y === i.y) throw new m("Cannot compute the quadrant for two identical points " + i);
                        return r.x >= i.x ? r.y >= i.y ? e.NE : e.SE : r.y >= i.y ? e.NW : e.SW;
                    }
                }
            }
        ]), e;
    }();
    We.NE = 0, We.NW = 1, We.SW = 2, We.SE = 3;
    var Ke = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "compareDirection",
                value: function value(t) {
                    return this._dx === t._dx && this._dy === t._dy ? 0 : this._quadrant > t._quadrant ? 1 : this._quadrant < t._quadrant ? -1 : ct.index(t._p0, t._p1, this._p1);
                }
            },
            {
                key: "getDy",
                value: function value() {
                    return this._dy;
                }
            },
            {
                key: "getCoordinate",
                value: function value() {
                    return this._p0;
                }
            },
            {
                key: "setNode",
                value: function value(t) {
                    this._node = t;
                }
            },
            {
                key: "print",
                value: function value(t) {
                    var _$e = Math.atan2(this._dy, this._dx), _$n = this.getClass().getName(), i = _$n.lastIndexOf("."), r = _$n.substring(i + 1);
                    t.print("  " + r + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + _$e + "   " + this._label);
                }
            },
            {
                key: "compareTo",
                value: function value(t) {
                    var _$e = t;
                    return this.compareDirection(_$e);
                }
            },
            {
                key: "getDirectedCoordinate",
                value: function value() {
                    return this._p1;
                }
            },
            {
                key: "getDx",
                value: function value() {
                    return this._dx;
                }
            },
            {
                key: "getLabel",
                value: function value() {
                    return this._label;
                }
            },
            {
                key: "getEdge",
                value: function value() {
                    return this._edge;
                }
            },
            {
                key: "getQuadrant",
                value: function value() {
                    return this._quadrant;
                }
            },
            {
                key: "getNode",
                value: function value() {
                    return this._node;
                }
            },
            {
                key: "toString",
                value: function value() {
                    var t = Math.atan2(this._dy, this._dx), _$e = this.getClass().getName(), _$n = _$e.lastIndexOf(".");
                    return "  " + _$e.substring(_$n + 1) + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + t + "   " + this._label;
                }
            },
            {
                key: "computeLabel",
                value: function value(t) {}
            },
            {
                key: "init",
                value: function value(t, e) {
                    this._p0 = t, this._p1 = e, this._dx = e.x - t.x, this._dy = e.y - t.y, this._quadrant = We.quadrant(this._dx, this._dy), G.isTrue(!(0 === this._dx && 0 === this._dy), "EdgeEnd with identical endpoints found");
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        x
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._edge = null, this._label = null, this._node = null, this._p0 = null, this._p1 = null, this._dx = null, this._dy = null, this._quadrant = null, 1 === arguments.length) {
                        var t = arguments[0];
                        this._edge = t;
                    } else if (3 === arguments.length) {
                        var _$n = arguments[0], i = arguments[1], r = arguments[2];
                        e.constructor_.call(this, _$n, i, r, null);
                    } else if (4 === arguments.length) {
                        var s = arguments[0], a = arguments[1], o = arguments[2], _$u = arguments[3];
                        e.constructor_.call(this, s), this.init(a, o), this._label = _$u;
                    }
                }
            }
        ]), e;
    }(), Je = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "getNextMin",
                value: function value() {
                    return this._nextMin;
                }
            },
            {
                key: "getDepth",
                value: function value(t) {
                    return this._depth[t];
                }
            },
            {
                key: "setVisited",
                value: function value(t) {
                    this._isVisited = t;
                }
            },
            {
                key: "computeDirectedLabel",
                value: function value() {
                    this._label = new Pe(this._edge.getLabel()), this._isForward || this._label.flip();
                }
            },
            {
                key: "getNext",
                value: function value() {
                    return this._next;
                }
            },
            {
                key: "setDepth",
                value: function value(t, e) {
                    if (-999 !== this._depth[t] && this._depth[t] !== e) throw new vt("assigned depths do not match", this.getCoordinate());
                    this._depth[t] = e;
                }
            },
            {
                key: "isInteriorAreaEdge",
                value: function value() {
                    for(var t = !0, _$e = 0; _$e < 2; _$e++)this._label.isArea(_$e) && this._label.getLocation(_$e, $.LEFT) === H.INTERIOR && this._label.getLocation(_$e, $.RIGHT) === H.INTERIOR || (t = !1);
                    return t;
                }
            },
            {
                key: "setNextMin",
                value: function value(t) {
                    this._nextMin = t;
                }
            },
            {
                key: "print",
                value: function value(t) {
                    f(r(a.prototype), "print", this).call(this, t), t.print(" " + this._depth[$.LEFT] + "/" + this._depth[$.RIGHT]), t.print(" (" + this.getDepthDelta() + ")"), this._isInResult && t.print(" inResult");
                }
            },
            {
                key: "setMinEdgeRing",
                value: function value(t) {
                    this._minEdgeRing = t;
                }
            },
            {
                key: "isLineEdge",
                value: function value() {
                    var t = this._label.isLine(0) || this._label.isLine(1), _$e = !this._label.isArea(0) || this._label.allPositionsEqual(0, H.EXTERIOR), _$n = !this._label.isArea(1) || this._label.allPositionsEqual(1, H.EXTERIOR);
                    return t && _$e && _$n;
                }
            },
            {
                key: "setEdgeRing",
                value: function value(t) {
                    this._edgeRing = t;
                }
            },
            {
                key: "getMinEdgeRing",
                value: function value() {
                    return this._minEdgeRing;
                }
            },
            {
                key: "getDepthDelta",
                value: function value() {
                    var t = this._edge.getDepthDelta();
                    return this._isForward || (t = -t), t;
                }
            },
            {
                key: "setInResult",
                value: function value(t) {
                    this._isInResult = t;
                }
            },
            {
                key: "getSym",
                value: function value() {
                    return this._sym;
                }
            },
            {
                key: "isForward",
                value: function value() {
                    return this._isForward;
                }
            },
            {
                key: "getEdge",
                value: function value() {
                    return this._edge;
                }
            },
            {
                key: "printEdge",
                value: function value(t) {
                    this.print(t), t.print(" "), this._isForward ? this._edge.print(t) : this._edge.printReverse(t);
                }
            },
            {
                key: "setSym",
                value: function value(t) {
                    this._sym = t;
                }
            },
            {
                key: "setVisitedEdge",
                value: function value(t) {
                    this.setVisited(t), this._sym.setVisited(t);
                }
            },
            {
                key: "setEdgeDepths",
                value: function value(t, e) {
                    var _$n = this.getEdge().getDepthDelta();
                    this._isForward || (_$n = -_$n);
                    var _$i = 1;
                    t === $.LEFT && (_$i = -1);
                    var r = $.opposite(t), s = e + _$n * _$i;
                    this.setDepth(t, e), this.setDepth(r, s);
                }
            },
            {
                key: "getEdgeRing",
                value: function value() {
                    return this._edgeRing;
                }
            },
            {
                key: "isInResult",
                value: function value() {
                    return this._isInResult;
                }
            },
            {
                key: "setNext",
                value: function value(t) {
                    this._next = t;
                }
            },
            {
                key: "isVisited",
                value: function value() {
                    return this._isVisited;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._isForward = null, this._isInResult = !1, this._isVisited = !1, this._sym = null, this._next = null, this._nextMin = null, this._edgeRing = null, this._minEdgeRing = null, this._depth = [
                        0,
                        -999,
                        -999
                    ];
                    var t = arguments[0], _$e = arguments[1];
                    if (Ke.constructor_.call(this, t), this._isForward = _$e, _$e) this.init(t.getCoordinate(0), t.getCoordinate(1));
                    else {
                        var _$n = t.getNumPoints() - 1;
                        this.init(t.getCoordinate(_$n), t.getCoordinate(_$n - 1));
                    }
                    this.computeDirectedLabel();
                }
            },
            {
                key: "depthFactor",
                value: function value(t, e) {
                    return t === H.EXTERIOR && e === H.INTERIOR ? 1 : t === H.INTERIOR && e === H.EXTERIOR ? -1 : 0;
                }
            }
        ]), a;
    }(Ke), Qe = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "createNode",
                value: function value(t) {
                    return new Ye(t, null);
                }
            }
        ]), e;
    }(), $e = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "printEdges",
                value: function value(t) {
                    t.println("Edges:");
                    for(var _$e = 0; _$e < this._edges.size(); _$e++){
                        t.println("edge " + _$e + ":");
                        var _$n = this._edges.get(_$e);
                        _$n.print(t), _$n.eiList.print(t);
                    }
                }
            },
            {
                key: "find",
                value: function value(t) {
                    return this._nodes.find(t);
                }
            },
            {
                key: "addNode",
                value: function value() {
                    if (_instanceof(arguments[0], Ye)) {
                        var t = arguments[0];
                        return this._nodes.addNode(t);
                    }
                    if (_instanceof(arguments[0], X)) {
                        var _$e = arguments[0];
                        return this._nodes.addNode(_$e);
                    }
                }
            },
            {
                key: "getNodeIterator",
                value: function value() {
                    return this._nodes.iterator();
                }
            },
            {
                key: "linkResultDirectedEdges",
                value: function value() {
                    for(var t = this._nodes.iterator(); t.hasNext();){
                        t.next().getEdges().linkResultDirectedEdges();
                    }
                }
            },
            {
                key: "debugPrintln",
                value: function value(t) {
                    mt.out.println(t);
                }
            },
            {
                key: "isBoundaryNode",
                value: function value(t, e) {
                    var _$n = this._nodes.find(e);
                    if (null === _$n) return !1;
                    var i = _$n.getLabel();
                    return null !== i && i.getLocation(t) === H.BOUNDARY;
                }
            },
            {
                key: "linkAllDirectedEdges",
                value: function value() {
                    for(var t = this._nodes.iterator(); t.hasNext();){
                        t.next().getEdges().linkAllDirectedEdges();
                    }
                }
            },
            {
                key: "matchInSameDirection",
                value: function value(t, e, n, i) {
                    return !!t.equals(n) && ct.index(t, e, i) === ct.COLLINEAR && We.quadrant(t, e) === We.quadrant(n, i);
                }
            },
            {
                key: "getEdgeEnds",
                value: function value() {
                    return this._edgeEndList;
                }
            },
            {
                key: "debugPrint",
                value: function value(t) {
                    mt.out.print(t);
                }
            },
            {
                key: "getEdgeIterator",
                value: function value() {
                    return this._edges.iterator();
                }
            },
            {
                key: "findEdgeInSameDirection",
                value: function value(t, e) {
                    for(var _$n = 0; _$n < this._edges.size(); _$n++){
                        var i = this._edges.get(_$n), r = i.getCoordinates();
                        if (this.matchInSameDirection(t, e, r[0], r[1])) return i;
                        if (this.matchInSameDirection(t, e, r[r.length - 1], r[r.length - 2])) return i;
                    }
                    return null;
                }
            },
            {
                key: "insertEdge",
                value: function value(t) {
                    this._edges.add(t);
                }
            },
            {
                key: "findEdgeEnd",
                value: function value(t) {
                    for(var _$e = this.getEdgeEnds().iterator(); _$e.hasNext();){
                        var _$n = _$e.next();
                        if (_$n.getEdge() === t) return _$n;
                    }
                    return null;
                }
            },
            {
                key: "addEdges",
                value: function value(t) {
                    for(var _$e = t.iterator(); _$e.hasNext();){
                        var _$n = _$e.next();
                        this._edges.add(_$n);
                        var i = new Je(_$n, !0), r = new Je(_$n, !1);
                        i.setSym(r), r.setSym(i), this.add(i), this.add(r);
                    }
                }
            },
            {
                key: "add",
                value: function value(t) {
                    this._nodes.add(t), this._edgeEndList.add(t);
                }
            },
            {
                key: "getNodes",
                value: function value() {
                    return this._nodes.values();
                }
            },
            {
                key: "findEdge",
                value: function value(t, e) {
                    for(var _$n = 0; _$n < this._edges.size(); _$n++){
                        var i = this._edges.get(_$n), r = i.getCoordinates();
                        if (t.equals(r[0]) && e.equals(r[1])) return i;
                    }
                    return null;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._edges = new yt, this._nodes = null, this._edgeEndList = new yt, 0 === arguments.length) this._nodes = new je(new Qe);
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        this._nodes = new je(t);
                    }
                }
            },
            {
                key: "linkResultDirectedEdges",
                value: function value(t) {
                    for(var _$e = t.iterator(); _$e.hasNext();){
                        _$e.next().getEdges().linkResultDirectedEdges();
                    }
                }
            }
        ]), e;
    }(), tn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "sortShellsAndHoles",
                value: function value(t, e, n) {
                    for(var i = t.iterator(); i.hasNext();){
                        var r = i.next();
                        r.isHole() ? n.add(r) : e.add(r);
                    }
                }
            },
            {
                key: "computePolygons",
                value: function value(t) {
                    for(var _$e = new yt, _$n = t.iterator(); _$n.hasNext();){
                        var i = _$n.next().toPolygon(this._geometryFactory);
                        _$e.add(i);
                    }
                    return _$e;
                }
            },
            {
                key: "placeFreeHoles",
                value: function value(t, n) {
                    for(var i = n.iterator(); i.hasNext();){
                        var r = i.next();
                        if (null === r.getShell()) {
                            var s = e.findEdgeRingContaining(r, t);
                            if (null === s) throw new vt("unable to assign hole to a shell", r.getCoordinate(0));
                            r.setShell(s);
                        }
                    }
                }
            },
            {
                key: "buildMinimalEdgeRings",
                value: function value(t, e, n) {
                    for(var i = new yt, r = t.iterator(); r.hasNext();){
                        var s = r.next();
                        if (s.getMaxNodeDegree() > 2) {
                            s.linkDirectedEdgesForMinimalEdgeRings();
                            var a = s.buildMinimalRings(), o = this.findShell(a);
                            null !== o ? (this.placePolygonHoles(o, a), e.add(o)) : n.addAll(a);
                        } else i.add(s);
                    }
                    return i;
                }
            },
            {
                key: "buildMaximalEdgeRings",
                value: function value(t) {
                    for(var _$e = new yt, _$n = t.iterator(); _$n.hasNext();){
                        var i = _$n.next();
                        if (i.isInResult() && i.getLabel().isArea() && null === i.getEdgeRing()) {
                            var r = new Ge(i, this._geometryFactory);
                            _$e.add(r), r.setInResult();
                        }
                    }
                    return _$e;
                }
            },
            {
                key: "placePolygonHoles",
                value: function value(t, e) {
                    for(var _$n = e.iterator(); _$n.hasNext();){
                        var i = _$n.next();
                        i.isHole() && i.setShell(t);
                    }
                }
            },
            {
                key: "getPolygons",
                value: function value() {
                    return this.computePolygons(this._shellList);
                }
            },
            {
                key: "findShell",
                value: function value(t) {
                    for(var _$e = 0, _$n = null, i = t.iterator(); i.hasNext();){
                        var r = i.next();
                        r.isHole() || (_$n = r, _$e++);
                    }
                    return G.isTrue(_$e <= 1, "found two shells in MinimalEdgeRing list"), _$n;
                }
            },
            {
                key: "add",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        this.add(t.getEdgeEnds(), t.getNodes());
                    } else if (2 === arguments.length) {
                        var _$e = arguments[0], _$n = arguments[1];
                        $e.linkResultDirectedEdges(_$n);
                        var i = this.buildMaximalEdgeRings(_$e), r = new yt, s = this.buildMinimalEdgeRings(i, this._shellList, r);
                        this.sortShellsAndHoles(s, this._shellList, r), this.placeFreeHoles(this._shellList, r);
                    }
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._geometryFactory = null, this._shellList = new yt;
                    var t = arguments[0];
                    this._geometryFactory = t;
                }
            },
            {
                key: "findEdgeRingContaining",
                value: function value(t, e) {
                    for(var _$n = t.getLinearRing(), i = _$n.getEnvelopeInternal(), r = _$n.getCoordinateN(0), s = null, a = null, o = e.iterator(); o.hasNext();){
                        var _$u = o.next(), l = _$u.getLinearRing(), h = l.getEnvelopeInternal();
                        if (!h.equals(i) && h.contains(i)) {
                            r = jt.ptNotInList(_$n.getCoordinates(), l.getCoordinates());
                            var c = !1;
                            Me.isInRing(r, l.getCoordinates()) && (c = !0), c && (null === s || a.contains(h)) && (a = (s = _$u).getLinearRing().getEnvelopeInternal());
                        }
                    }
                    return s;
                }
            }
        ]), e;
    }(), en = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "getBounds",
                value: function value() {}
            }
        ]), e;
    }(), nn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getItem",
                value: function value() {
                    return this._item;
                }
            },
            {
                key: "getBounds",
                value: function value() {
                    return this._bounds;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        en,
                        E
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._bounds = null, this._item = null;
                    var t = arguments[0], _$e = arguments[1];
                    this._bounds = t, this._item = _$e;
                }
            }
        ]), e;
    }(), rn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "poll",
                value: function value() {
                    if (this.isEmpty()) return null;
                    var t = this._items.get(1);
                    return this._items.set(1, this._items.get(this._size)), this._size -= 1, this.reorder(1), t;
                }
            },
            {
                key: "size",
                value: function value() {
                    return this._size;
                }
            },
            {
                key: "reorder",
                value: function value(t) {
                    for(var _$e = null, _$n = this._items.get(t); 2 * t <= this._size && ((_$e = 2 * t) !== this._size && this._items.get(_$e + 1).compareTo(this._items.get(_$e)) < 0 && _$e++, this._items.get(_$e).compareTo(_$n) < 0); t = _$e)this._items.set(t, this._items.get(_$e));
                    this._items.set(t, _$n);
                }
            },
            {
                key: "clear",
                value: function value() {
                    this._size = 0, this._items.clear();
                }
            },
            {
                key: "peek",
                value: function value() {
                    return this.isEmpty() ? null : this._items.get(1);
                }
            },
            {
                key: "isEmpty",
                value: function value() {
                    return 0 === this._size;
                }
            },
            {
                key: "add",
                value: function value(t) {
                    this._items.add(null), this._size += 1;
                    var _$e = this._size;
                    for(this._items.set(0, t); t.compareTo(this._items.get(Math.trunc(_$e / 2))) < 0; _$e /= 2)this._items.set(_$e, this._items.get(Math.trunc(_$e / 2)));
                    this._items.set(_$e, t);
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._size = null, this._items = null, this._size = 0, this._items = new yt, this._items.add(null);
                }
            }
        ]), e;
    }(), sn = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "insert",
                value: function value(t, e) {}
            },
            {
                key: "remove",
                value: function value(t, e) {}
            },
            {
                key: "query",
                value: function value() {}
            }
        ]), e;
    }(), an = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getLevel",
                value: function value() {
                    return this._level;
                }
            },
            {
                key: "size",
                value: function value() {
                    return this._childBoundables.size();
                }
            },
            {
                key: "getChildBoundables",
                value: function value() {
                    return this._childBoundables;
                }
            },
            {
                key: "addChildBoundable",
                value: function value(t) {
                    G.isTrue(null === this._bounds), this._childBoundables.add(t);
                }
            },
            {
                key: "isEmpty",
                value: function value() {
                    return this._childBoundables.isEmpty();
                }
            },
            {
                key: "getBounds",
                value: function value() {
                    return null === this._bounds && (this._bounds = this.computeBounds()), this._bounds;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        en,
                        E
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._childBoundables = new yt, this._bounds = null, this._level = null, 0 === arguments.length) ;
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        this._level = t;
                    }
                }
            }
        ]), e;
    }(), on = {
        reverseOrder: function reverseOrder() {
            return {
                compare: function compare(t, e) {
                    return e.compareTo(t);
                }
            };
        },
        min: function min(t) {
            return on.sort(t), t.get(0);
        },
        sort: function sort(t, e) {
            var n = t.toArray();
            e ? At.sort(n, e) : At.sort(n);
            for(var i = t.iterator(), r = 0, s = n.length; r < s; r++)i.next(), i.set(n[r]);
        },
        singletonList: function singletonList(t) {
            var e = new yt;
            return e.add(t), e;
        }
    }, un = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "maxDistance",
                value: function value(t, n, i, r, s, a, o, u) {
                    var l = e.distance(t, n, s, a);
                    return l = Math.max(l, e.distance(t, n, o, u)), l = Math.max(l, e.distance(i, r, s, a)), l = Math.max(l, e.distance(i, r, o, u));
                }
            },
            {
                key: "distance",
                value: function value(t, e, n, i) {
                    var r = n - t, s = i - e;
                    return Math.sqrt(r * r + s * s);
                }
            },
            {
                key: "maximumDistance",
                value: function value(t, n) {
                    var i = Math.min(t.getMinX(), n.getMinX()), r = Math.min(t.getMinY(), n.getMinY()), s = Math.max(t.getMaxX(), n.getMaxX()), a = Math.max(t.getMaxY(), n.getMaxY());
                    return e.distance(i, r, s, a);
                }
            },
            {
                key: "minMaxDistance",
                value: function value(t, n) {
                    var i = t.getMinX(), r = t.getMinY(), s = t.getMaxX(), a = t.getMaxY(), o = n.getMinX(), _$u = n.getMinY(), l = n.getMaxX(), h = n.getMaxY(), c = e.maxDistance(i, r, i, a, o, _$u, o, h);
                    return c = Math.min(c, e.maxDistance(i, r, i, a, o, _$u, l, _$u)), c = Math.min(c, e.maxDistance(i, r, i, a, l, h, o, h)), c = Math.min(c, e.maxDistance(i, r, i, a, l, h, l, _$u)), c = Math.min(c, e.maxDistance(i, r, s, r, o, _$u, o, h)), c = Math.min(c, e.maxDistance(i, r, s, r, o, _$u, l, _$u)), c = Math.min(c, e.maxDistance(i, r, s, r, l, h, o, h)), c = Math.min(c, e.maxDistance(i, r, s, r, l, h, l, _$u)), c = Math.min(c, e.maxDistance(s, a, i, a, o, _$u, o, h)), c = Math.min(c, e.maxDistance(s, a, i, a, o, _$u, l, _$u)), c = Math.min(c, e.maxDistance(s, a, i, a, l, h, o, h)), c = Math.min(c, e.maxDistance(s, a, i, a, l, h, l, _$u)), c = Math.min(c, e.maxDistance(s, a, s, r, o, _$u, o, h)), c = Math.min(c, e.maxDistance(s, a, s, r, o, _$u, l, _$u)), c = Math.min(c, e.maxDistance(s, a, s, r, l, h, o, h)), c = Math.min(c, e.maxDistance(s, a, s, r, l, h, l, _$u));
                }
            }
        ]), e;
    }(), ln = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "maximumDistance",
                value: function value() {
                    return un.maximumDistance(this._boundable1.getBounds(), this._boundable2.getBounds());
                }
            },
            {
                key: "expandToQueue",
                value: function value(t, n) {
                    var i = e.isComposite(this._boundable1), r = e.isComposite(this._boundable2);
                    if (i && r) return e.area(this._boundable1) > e.area(this._boundable2) ? (this.expand(this._boundable1, this._boundable2, !1, t, n), null) : (this.expand(this._boundable2, this._boundable1, !0, t, n), null);
                    if (i) return this.expand(this._boundable1, this._boundable2, !1, t, n), null;
                    if (r) return this.expand(this._boundable2, this._boundable1, !0, t, n), null;
                    throw new m("neither boundable is composite");
                }
            },
            {
                key: "isLeaves",
                value: function value() {
                    return !(e.isComposite(this._boundable1) || e.isComposite(this._boundable2));
                }
            },
            {
                key: "compareTo",
                value: function value(t) {
                    var _$e = t;
                    return this._distance < _$e._distance ? -1 : this._distance > _$e._distance ? 1 : 0;
                }
            },
            {
                key: "expand",
                value: function value(t, n, i, r, s) {
                    for(var a = t.getChildBoundables().iterator(); a.hasNext();){
                        var o = a.next(), _$u = null;
                        (_$u = i ? new e(n, o, this._itemDistance) : new e(o, n, this._itemDistance)).getDistance() < s && r.add(_$u);
                    }
                }
            },
            {
                key: "getBoundable",
                value: function value(t) {
                    return 0 === t ? this._boundable1 : this._boundable2;
                }
            },
            {
                key: "getDistance",
                value: function value() {
                    return this._distance;
                }
            },
            {
                key: "distance",
                value: function value() {
                    return this.isLeaves() ? this._itemDistance.distance(this._boundable1, this._boundable2) : this._boundable1.getBounds().distance(this._boundable2.getBounds());
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        x
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._boundable1 = null, this._boundable2 = null, this._distance = null, this._itemDistance = null;
                    var t = arguments[0], _$e = arguments[1], _$n = arguments[2];
                    this._boundable1 = t, this._boundable2 = _$e, this._itemDistance = _$n, this._distance = this.distance();
                }
            },
            {
                key: "area",
                value: function value(t) {
                    return t.getBounds().getArea();
                }
            },
            {
                key: "isComposite",
                value: function value(t) {
                    return _instanceof(t, an);
                }
            }
        ]), e;
    }(), hn = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "visitItem",
                value: function value(t) {}
            }
        ]), e;
    }(), cn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "queryInternal",
                value: function value() {
                    if (rt(arguments[2], hn) && _instanceof(arguments[0], Object) && _instanceof(arguments[1], an)) for(var t = arguments[0], _$e = arguments[1], _$n = arguments[2], i = _$e.getChildBoundables(), r = 0; r < i.size(); r++){
                        var s = i.get(r);
                        this.getIntersectsOp().intersects(s.getBounds(), t) && (_instanceof(s, an) ? this.queryInternal(t, s, _$n) : _instanceof(s, nn) ? _$n.visitItem(s.getItem()) : G.shouldNeverReachHere());
                    }
                    else if (rt(arguments[2], nt) && _instanceof(arguments[0], Object) && _instanceof(arguments[1], an)) for(var a = arguments[0], o = arguments[1], _$u = arguments[2], l = o.getChildBoundables(), h = 0; h < l.size(); h++){
                        var c = l.get(h);
                        this.getIntersectsOp().intersects(c.getBounds(), a) && (_instanceof(c, an) ? this.queryInternal(a, c, _$u) : _instanceof(c, nn) ? _$u.add(c.getItem()) : G.shouldNeverReachHere());
                    }
                }
            },
            {
                key: "getNodeCapacity",
                value: function value() {
                    return this._nodeCapacity;
                }
            },
            {
                key: "lastNode",
                value: function value(t) {
                    return t.get(t.size() - 1);
                }
            },
            {
                key: "size",
                value: function value() {
                    if (0 === arguments.length) return this.isEmpty() ? 0 : (this.build(), this.size(this._root));
                    if (1 === arguments.length) {
                        for(var t = arguments[0], _$e = 0, _$n = t.getChildBoundables().iterator(); _$n.hasNext();){
                            var i = _$n.next();
                            _instanceof(i, an) ? _$e += this.size(i) : _instanceof(i, nn) && (_$e += 1);
                        }
                        return _$e;
                    }
                }
            },
            {
                key: "removeItem",
                value: function value(t, e) {
                    for(var _$n = null, i = t.getChildBoundables().iterator(); i.hasNext();){
                        var r = i.next();
                        _instanceof(r, nn) && r.getItem() === e && (_$n = r);
                    }
                    return null !== _$n && (t.getChildBoundables().remove(_$n), !0);
                }
            },
            {
                key: "itemsTree",
                value: function value() {
                    if (0 === arguments.length) {
                        this.build();
                        var t = this.itemsTree(this._root);
                        return null === t ? new yt : t;
                    }
                    if (1 === arguments.length) {
                        for(var _$e = arguments[0], _$n = new yt, i = _$e.getChildBoundables().iterator(); i.hasNext();){
                            var r = i.next();
                            if (_instanceof(r, an)) {
                                var s = this.itemsTree(r);
                                null !== s && _$n.add(s);
                            } else _instanceof(r, nn) ? _$n.add(r.getItem()) : G.shouldNeverReachHere();
                        }
                        return _$n.size() <= 0 ? null : _$n;
                    }
                }
            },
            {
                key: "insert",
                value: function value(t, e) {
                    G.isTrue(!this._built, "Cannot insert items into an STR packed R-tree after it has been built."), this._itemBoundables.add(new nn(t, e));
                }
            },
            {
                key: "boundablesAtLevel",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0], _$e = new yt;
                        return this.boundablesAtLevel(t, this._root, _$e), _$e;
                    }
                    if (3 === arguments.length) {
                        var _$n = arguments[0], i = arguments[1], r = arguments[2];
                        if (G.isTrue(_$n > -2), i.getLevel() === _$n) return r.add(i), null;
                        for(var s = i.getChildBoundables().iterator(); s.hasNext();){
                            var a = s.next();
                            _instanceof(a, an) ? this.boundablesAtLevel(_$n, a, r) : (G.isTrue(_instanceof(a, nn)), -1 === _$n && r.add(a));
                        }
                        return null;
                    }
                }
            },
            {
                key: "query",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        this.build();
                        var _$e = new yt;
                        return this.isEmpty() || this.getIntersectsOp().intersects(this._root.getBounds(), t) && this.queryInternal(t, this._root, _$e), _$e;
                    }
                    if (2 === arguments.length) {
                        var _$n = arguments[0], i = arguments[1];
                        if (this.build(), this.isEmpty()) return null;
                        this.getIntersectsOp().intersects(this._root.getBounds(), _$n) && this.queryInternal(_$n, this._root, i);
                    }
                }
            },
            {
                key: "build",
                value: function value() {
                    if (this._built) return null;
                    this._root = this._itemBoundables.isEmpty() ? this.createNode(0) : this.createHigherLevels(this._itemBoundables, -1), this._itemBoundables = null, this._built = !0;
                }
            },
            {
                key: "getRoot",
                value: function value() {
                    return this.build(), this._root;
                }
            },
            {
                key: "remove",
                value: function value() {
                    if (2 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1];
                        return this.build(), !!this.getIntersectsOp().intersects(this._root.getBounds(), t) && this.remove(t, this._root, _$e);
                    }
                    if (3 === arguments.length) {
                        var _$n = arguments[0], i = arguments[1], r = arguments[2], s = this.removeItem(i, r);
                        if (s) return !0;
                        for(var a = null, o = i.getChildBoundables().iterator(); o.hasNext();){
                            var _$u = o.next();
                            if (this.getIntersectsOp().intersects(_$u.getBounds(), _$n) && _instanceof(_$u, an) && (s = this.remove(_$n, _$u, r))) {
                                a = _$u;
                                break;
                            }
                        }
                        return null !== a && a.getChildBoundables().isEmpty() && i.getChildBoundables().remove(a), s;
                    }
                }
            },
            {
                key: "createHigherLevels",
                value: function value(t, e) {
                    G.isTrue(!t.isEmpty());
                    var _$n = this.createParentBoundables(t, e + 1);
                    return 1 === _$n.size() ? _$n.get(0) : this.createHigherLevels(_$n, e + 1);
                }
            },
            {
                key: "depth",
                value: function value() {
                    if (0 === arguments.length) return this.isEmpty() ? 0 : (this.build(), this.depth(this._root));
                    if (1 === arguments.length) {
                        for(var t = arguments[0], _$e = 0, _$n = t.getChildBoundables().iterator(); _$n.hasNext();){
                            var i = _$n.next();
                            if (_instanceof(i, an)) {
                                var r = this.depth(i);
                                r > _$e && (_$e = r);
                            }
                        }
                        return _$e + 1;
                    }
                }
            },
            {
                key: "createParentBoundables",
                value: function value(t, e) {
                    G.isTrue(!t.isEmpty());
                    var _$n = new yt;
                    _$n.add(this.createNode(e));
                    var i = new yt(t);
                    on.sort(i, this.getComparator());
                    for(var r = i.iterator(); r.hasNext();){
                        var s = r.next();
                        this.lastNode(_$n).getChildBoundables().size() === this.getNodeCapacity() && _$n.add(this.createNode(e)), this.lastNode(_$n).addChildBoundable(s);
                    }
                    return _$n;
                }
            },
            {
                key: "isEmpty",
                value: function value() {
                    return this._built ? this._root.isEmpty() : this._itemBoundables.isEmpty();
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        E
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._root = null, this._built = !1, this._itemBoundables = new yt, this._nodeCapacity = null, 0 === arguments.length) e.constructor_.call(this, e.DEFAULT_NODE_CAPACITY);
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        G.isTrue(t > 1, "Node capacity must be greater than 1"), this._nodeCapacity = t;
                    }
                }
            },
            {
                key: "compareDoubles",
                value: function value(t, e) {
                    return t > e ? 1 : t < e ? -1 : 0;
                }
            }
        ]), e;
    }();
    cn.IntersectsOp = function() {}, cn.DEFAULT_NODE_CAPACITY = 10;
    var fn = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "distance",
                value: function value(t, e) {}
            }
        ]), e;
    }(), vn = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "createParentBoundablesFromVerticalSlices",
                value: function value(t, e) {
                    G.isTrue(t.length > 0);
                    for(var _$n = new yt, _$i = 0; _$i < t.length; _$i++)_$n.addAll(this.createParentBoundablesFromVerticalSlice(t[_$i], e));
                    return _$n;
                }
            },
            {
                key: "nearestNeighbourK",
                value: function value() {
                    if (2 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1];
                        return this.nearestNeighbourK(t, A.POSITIVE_INFINITY, _$e);
                    }
                    if (3 === arguments.length) {
                        var _$n = arguments[0], _$i = arguments[1], r = arguments[2], s = _$i, o = new rn;
                        o.add(_$n);
                        for(var _$u = new rn; !o.isEmpty() && s >= 0;){
                            var l = o.poll(), h = l.getDistance();
                            if (h >= s) break;
                            if (l.isLeaves()) if (_$u.size() < r) _$u.add(l);
                            else {
                                var _$c = _$u.peek();
                                _$c.getDistance() > h && (_$u.poll(), _$u.add(l));
                                var f = _$u.peek();
                                s = f.getDistance();
                            }
                            else l.expandToQueue(o, s);
                        }
                        return a.getItems(_$u);
                    }
                }
            },
            {
                key: "createNode",
                value: function value(t) {
                    return new gn(t);
                }
            },
            {
                key: "size",
                value: function value() {
                    return 0 === arguments.length ? f(r(a.prototype), "size", this).call(this) : f(r(a.prototype), "size", this).apply(this, arguments);
                }
            },
            {
                key: "insert",
                value: function value() {
                    if (!(2 === arguments.length && _instanceof(arguments[1], Object) && _instanceof(arguments[0], U))) return f(r(a.prototype), "insert", this).apply(this, arguments);
                    var t = arguments[0], _$e = arguments[1];
                    if (t.isNull()) return null;
                    f(r(a.prototype), "insert", this).call(this, t, _$e);
                }
            },
            {
                key: "getIntersectsOp",
                value: function value() {
                    return a.intersectsOp;
                }
            },
            {
                key: "verticalSlices",
                value: function value(t, e) {
                    for(var _$n = Math.trunc(Math.ceil(t.size() / e)), _$i = new Array(e).fill(null), r = t.iterator(), s = 0; s < e; s++){
                        _$i[s] = new yt;
                        for(var _$a = 0; r.hasNext() && _$a < _$n;){
                            var o = r.next();
                            _$i[s].add(o), _$a++;
                        }
                    }
                    return _$i;
                }
            },
            {
                key: "query",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        return f(r(a.prototype), "query", this).call(this, t);
                    }
                    if (2 === arguments.length) {
                        var _$e = arguments[0], _$n = arguments[1];
                        f(r(a.prototype), "query", this).call(this, _$e, _$n);
                    }
                }
            },
            {
                key: "getComparator",
                value: function value() {
                    return a.yComparator;
                }
            },
            {
                key: "createParentBoundablesFromVerticalSlice",
                value: function value(t, e) {
                    return f(r(a.prototype), "createParentBoundables", this).call(this, t, e);
                }
            },
            {
                key: "remove",
                value: function value() {
                    if (2 === arguments.length && _instanceof(arguments[1], Object) && _instanceof(arguments[0], U)) {
                        var t = arguments[0], _$e = arguments[1];
                        return f(r(a.prototype), "remove", this).call(this, t, _$e);
                    }
                    return f(r(a.prototype), "remove", this).apply(this, arguments);
                }
            },
            {
                key: "depth",
                value: function value() {
                    return 0 === arguments.length ? f(r(a.prototype), "depth", this).call(this) : f(r(a.prototype), "depth", this).apply(this, arguments);
                }
            },
            {
                key: "createParentBoundables",
                value: function value(t, e) {
                    G.isTrue(!t.isEmpty());
                    var _$n = Math.trunc(Math.ceil(t.size() / this.getNodeCapacity())), _$i = new yt(t);
                    on.sort(_$i, a.xComparator);
                    var r = this.verticalSlices(_$i, Math.trunc(Math.ceil(Math.sqrt(_$n))));
                    return this.createParentBoundablesFromVerticalSlices(r, e);
                }
            },
            {
                key: "nearestNeighbour",
                value: function value() {
                    if (1 === arguments.length) {
                        if (rt(arguments[0], fn)) {
                            var t = arguments[0];
                            if (this.isEmpty()) return null;
                            var _$e = new ln(this.getRoot(), this.getRoot(), t);
                            return this.nearestNeighbour(_$e);
                        }
                        if (_instanceof(arguments[0], ln)) {
                            var _$n = arguments[0], _$i = A.POSITIVE_INFINITY, r = null, s = new rn;
                            for(s.add(_$n); !s.isEmpty() && _$i > 0;){
                                var _$a = s.poll(), o = _$a.getDistance();
                                if (o >= _$i) break;
                                _$a.isLeaves() ? (_$i = o, r = _$a) : _$a.expandToQueue(s, _$i);
                            }
                            return null === r ? null : [
                                r.getBoundable(0).getItem(),
                                r.getBoundable(1).getItem()
                            ];
                        }
                    } else {
                        if (2 === arguments.length) {
                            var _$u = arguments[0], l = arguments[1];
                            if (this.isEmpty() || _$u.isEmpty()) return null;
                            var h = new ln(this.getRoot(), _$u.getRoot(), l);
                            return this.nearestNeighbour(h);
                        }
                        if (3 === arguments.length) {
                            var _$c = arguments[0], f = arguments[1], v = arguments[2], g = new nn(_$c, f), y = new ln(this.getRoot(), g, v);
                            return this.nearestNeighbour(y)[0];
                        }
                        if (4 === arguments.length) {
                            var d = arguments[0], _ = arguments[1], p = arguments[2], m = arguments[3], k = new nn(d, _), x = new ln(this.getRoot(), k, p);
                            return this.nearestNeighbourK(x, m);
                        }
                    }
                }
            },
            {
                key: "isWithinDistance",
                value: function value() {
                    if (2 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1], _$n = A.POSITIVE_INFINITY, _$i = new rn;
                        for(_$i.add(t); !_$i.isEmpty();){
                            var r = _$i.poll(), s = r.getDistance();
                            if (s > _$e) return !1;
                            if (r.maximumDistance() <= _$e) return !0;
                            if (r.isLeaves()) {
                                if ((_$n = s) <= _$e) return !0;
                            } else r.expandToQueue(_$i, _$n);
                        }
                        return !1;
                    }
                    if (3 === arguments.length) {
                        var _$a = arguments[0], o = arguments[1], _$u = arguments[2], l = new ln(this.getRoot(), _$a.getRoot(), o);
                        return this.isWithinDistance(l, _$u);
                    }
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        sn,
                        E
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (0 === arguments.length) a.constructor_.call(this, a.DEFAULT_NODE_CAPACITY);
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        cn.constructor_.call(this, t);
                    }
                }
            },
            {
                key: "centreX",
                value: function value(t) {
                    return a.avg(t.getMinX(), t.getMaxX());
                }
            },
            {
                key: "avg",
                value: function value(t, e) {
                    return (t + e) / 2;
                }
            },
            {
                key: "getItems",
                value: function value(t) {
                    for(var _$e = new Array(t.size()).fill(null), _$n = 0; !t.isEmpty();){
                        var _$i = t.poll();
                        _$e[_$n] = _$i.getBoundable(0).getItem(), _$n++;
                    }
                    return _$e;
                }
            },
            {
                key: "centreY",
                value: function value(t) {
                    return a.avg(t.getMinY(), t.getMaxY());
                }
            }
        ]), a;
    }(cn), gn = function(e) {
        i(s, e);
        var r = c(s);
        function s() {
            var _$e;
            return t(this, s), _$e = r.call(this), s.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(s, [
            {
                key: "computeBounds",
                value: function value() {
                    for(var t = null, _$e = this.getChildBoundables().iterator(); _$e.hasNext();){
                        var _$n = _$e.next();
                        null === t ? t = new U(_$n.getBounds()) : t.expandToInclude(_$n.getBounds());
                    }
                    return t;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    var t = arguments[0];
                    an.constructor_.call(this, t);
                }
            }
        ]), s;
    }(an);
    vn.STRtreeNode = gn, vn.xComparator = new (function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        P
                    ];
                }
            },
            {
                key: "compare",
                value: function value(t, e) {
                    return cn.compareDoubles(vn.centreX(t.getBounds()), vn.centreX(e.getBounds()));
                }
            }
        ]), e;
    }()), vn.yComparator = new (function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        P
                    ];
                }
            },
            {
                key: "compare",
                value: function value(t, e) {
                    return cn.compareDoubles(vn.centreY(t.getBounds()), vn.centreY(e.getBounds()));
                }
            }
        ]), e;
    }()), vn.intersectsOp = new (function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        IntersectsOp
                    ];
                }
            },
            {
                key: "intersects",
                value: function value(t, e) {
                    return t.intersects(e);
                }
            }
        ]), e;
    }()), vn.DEFAULT_NODE_CAPACITY = 10;
    var yn = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "relativeSign",
                value: function value(t, e) {
                    return t < e ? -1 : t > e ? 1 : 0;
                }
            },
            {
                key: "compare",
                value: function value(t, n, i) {
                    if (n.equals2D(i)) return 0;
                    var r = e.relativeSign(n.x, i.x), s = e.relativeSign(n.y, i.y);
                    switch(t){
                        case 0:
                            return e.compareValue(r, s);
                        case 1:
                            return e.compareValue(s, r);
                        case 2:
                            return e.compareValue(s, -r);
                        case 3:
                            return e.compareValue(-r, s);
                        case 4:
                            return e.compareValue(-r, -s);
                        case 5:
                            return e.compareValue(-s, -r);
                        case 6:
                            return e.compareValue(-s, r);
                        case 7:
                            return e.compareValue(r, -s);
                    }
                    return G.shouldNeverReachHere("invalid octant value"), 0;
                }
            },
            {
                key: "compareValue",
                value: function value(t, e) {
                    return t < 0 ? -1 : t > 0 ? 1 : e < 0 ? -1 : e > 0 ? 1 : 0;
                }
            }
        ]), e;
    }(), dn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getCoordinate",
                value: function value() {
                    return this.coord;
                }
            },
            {
                key: "print",
                value: function value(t) {
                    t.print(this.coord), t.print(" seg # = " + this.segmentIndex);
                }
            },
            {
                key: "compareTo",
                value: function value(t) {
                    var _$e = t;
                    return this.segmentIndex < _$e.segmentIndex ? -1 : this.segmentIndex > _$e.segmentIndex ? 1 : this.coord.equals2D(_$e.coord) ? 0 : this._isInterior ? _$e._isInterior ? yn.compare(this._segmentOctant, this.coord, _$e.coord) : 1 : -1;
                }
            },
            {
                key: "isEndPoint",
                value: function value(t) {
                    return 0 === this.segmentIndex && !this._isInterior || this.segmentIndex === t;
                }
            },
            {
                key: "toString",
                value: function value() {
                    return this.segmentIndex + ":" + this.coord.toString();
                }
            },
            {
                key: "isInterior",
                value: function value() {
                    return this._isInterior;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        x
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._segString = null, this.coord = null, this.segmentIndex = null, this._segmentOctant = null, this._isInterior = null;
                    var t = arguments[0], _$e = arguments[1], _$n = arguments[2], i = arguments[3];
                    this._segString = t, this.coord = new X(_$e), this.segmentIndex = _$n, this._segmentOctant = i, this._isInterior = !_$e.equals2D(t.getCoordinate(_$n));
                }
            }
        ]), e;
    }(), _n = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "hasNext",
                value: function value() {}
            },
            {
                key: "next",
                value: function value() {}
            },
            {
                key: "remove",
                value: function value() {}
            }
        ]), e;
    }(), pn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getSplitCoordinates",
                value: function value() {
                    var t = new Zt;
                    this.addEndpoints();
                    for(var _$e = this.iterator(), _$n = _$e.next(); _$e.hasNext();){
                        var i = _$e.next();
                        this.addEdgeCoordinates(_$n, i, t), _$n = i;
                    }
                    return t.toCoordinateArray();
                }
            },
            {
                key: "addCollapsedNodes",
                value: function value() {
                    var t = new yt;
                    this.findCollapsesFromInsertedNodes(t), this.findCollapsesFromExistingVertices(t);
                    for(var _$e = t.iterator(); _$e.hasNext();){
                        var _$n = _$e.next().intValue();
                        this.add(this._edge.getCoordinate(_$n), _$n);
                    }
                }
            },
            {
                key: "createSplitEdgePts",
                value: function value(t, e) {
                    var _$n = e.segmentIndex - t.segmentIndex + 2;
                    if (2 === _$n) return [
                        new X(t.coord),
                        new X(e.coord)
                    ];
                    var i = this._edge.getCoordinate(e.segmentIndex), r = e.isInterior() || !e.coord.equals2D(i);
                    r || _$n--;
                    var s = new Array(_$n).fill(null), a = 0;
                    s[a++] = new X(t.coord);
                    for(var o = t.segmentIndex + 1; o <= e.segmentIndex; o++)s[a++] = this._edge.getCoordinate(o);
                    return r && (s[a] = new X(e.coord)), s;
                }
            },
            {
                key: "print",
                value: function value(t) {
                    t.println("Intersections:");
                    for(var _$e = this.iterator(); _$e.hasNext();){
                        _$e.next().print(t);
                    }
                }
            },
            {
                key: "findCollapsesFromExistingVertices",
                value: function value(t) {
                    for(var _$e = 0; _$e < this._edge.size() - 2; _$e++){
                        var _$n = this._edge.getCoordinate(_$e);
                        this._edge.getCoordinate(_$e + 1);
                        var i = this._edge.getCoordinate(_$e + 2);
                        _$n.equals2D(i) && t.add(at.valueOf(_$e + 1));
                    }
                }
            },
            {
                key: "addEdgeCoordinates",
                value: function value(t, e, n) {
                    var i = this.createSplitEdgePts(t, e);
                    n.add(i, !1);
                }
            },
            {
                key: "iterator",
                value: function value() {
                    return this._nodeMap.values().iterator();
                }
            },
            {
                key: "addSplitEdges",
                value: function value(t) {
                    this.addEndpoints(), this.addCollapsedNodes();
                    for(var _$e = this.iterator(), _$n = _$e.next(); _$e.hasNext();){
                        var i = _$e.next(), r = this.createSplitEdge(_$n, i);
                        t.add(r), _$n = i;
                    }
                }
            },
            {
                key: "findCollapseIndex",
                value: function value(t, e, n) {
                    if (!t.coord.equals2D(e.coord)) return !1;
                    var i = e.segmentIndex - t.segmentIndex;
                    return e.isInterior() || i--, 1 === i && (n[0] = t.segmentIndex + 1, !0);
                }
            },
            {
                key: "findCollapsesFromInsertedNodes",
                value: function value(t) {
                    for(var _$e = new Array(1).fill(null), _$n = this.iterator(), i = _$n.next(); _$n.hasNext();){
                        var r = _$n.next();
                        this.findCollapseIndex(i, r, _$e) && t.add(at.valueOf(_$e[0])), i = r;
                    }
                }
            },
            {
                key: "getEdge",
                value: function value() {
                    return this._edge;
                }
            },
            {
                key: "addEndpoints",
                value: function value() {
                    var t = this._edge.size() - 1;
                    this.add(this._edge.getCoordinate(0), 0), this.add(this._edge.getCoordinate(t), t);
                }
            },
            {
                key: "createSplitEdge",
                value: function value(t, e) {
                    var _$n = this.createSplitEdgePts(t, e);
                    return new In(_$n, this._edge.getData());
                }
            },
            {
                key: "add",
                value: function value(t, e) {
                    var _$n = new dn(this._edge, t, e, this._edge.getSegmentOctant(e)), i = this._nodeMap.get(_$n);
                    return null !== i ? (G.isTrue(i.coord.equals2D(t), "Found equal nodes with different coordinates"), i) : (this._nodeMap.put(_$n, _$n), _$n);
                }
            },
            {
                key: "checkSplitEdgesCorrectness",
                value: function value(t) {
                    var _$e = this._edge.getCoordinates(), _$n = t.get(0).getCoordinate(0);
                    if (!_$n.equals2D(_$e[0])) throw new D("bad split edge start point at " + _$n);
                    var i = t.get(t.size() - 1).getCoordinates(), r = i[i.length - 1];
                    if (!r.equals2D(_$e[_$e.length - 1])) throw new D("bad split edge end point at " + r);
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._nodeMap = new Ze, this._edge = null;
                    var t = arguments[0];
                    this._edge = t;
                }
            }
        ]), e;
    }(), mn = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "octant",
                value: function value() {
                    if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                        var t = arguments[0], _$n = arguments[1];
                        if (0 === t && 0 === _$n) throw new m("Cannot compute the octant for point ( " + t + ", " + _$n + " )");
                        var i = Math.abs(t), r = Math.abs(_$n);
                        return t >= 0 ? _$n >= 0 ? i >= r ? 0 : 1 : i >= r ? 7 : 6 : _$n >= 0 ? i >= r ? 3 : 2 : i >= r ? 4 : 5;
                    }
                    if (_instanceof(arguments[0], X) && _instanceof(arguments[1], X)) {
                        var s = arguments[0], a = arguments[1], o = a.x - s.x, _$u = a.y - s.y;
                        if (0 === o && 0 === _$u) throw new m("Cannot compute the octant for two identical points " + s);
                        return e.octant(o, _$u);
                    }
                }
            }
        ]), e;
    }(), kn = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "getCoordinates",
                value: function value() {}
            },
            {
                key: "size",
                value: function value() {}
            },
            {
                key: "getCoordinate",
                value: function value(t) {}
            },
            {
                key: "isClosed",
                value: function value() {}
            },
            {
                key: "setData",
                value: function value(t) {}
            },
            {
                key: "getData",
                value: function value() {}
            }
        ]), e;
    }(), xn = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "addIntersection",
                value: function value(t, e) {}
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        kn
                    ];
                }
            }
        ]), e;
    }(), In = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getCoordinates",
                value: function value() {
                    return this._pts;
                }
            },
            {
                key: "size",
                value: function value() {
                    return this._pts.length;
                }
            },
            {
                key: "getCoordinate",
                value: function value(t) {
                    return this._pts[t];
                }
            },
            {
                key: "isClosed",
                value: function value() {
                    return this._pts[0].equals(this._pts[this._pts.length - 1]);
                }
            },
            {
                key: "getSegmentOctant",
                value: function value(t) {
                    return t === this._pts.length - 1 ? -1 : this.safeOctant(this.getCoordinate(t), this.getCoordinate(t + 1));
                }
            },
            {
                key: "setData",
                value: function value(t) {
                    this._data = t;
                }
            },
            {
                key: "safeOctant",
                value: function value(t, e) {
                    return t.equals2D(e) ? 0 : mn.octant(t, e);
                }
            },
            {
                key: "getData",
                value: function value() {
                    return this._data;
                }
            },
            {
                key: "addIntersection",
                value: function value() {
                    if (2 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1];
                        this.addIntersectionNode(t, _$e);
                    } else if (4 === arguments.length) {
                        var _$n = arguments[0], i = arguments[1], r = arguments[3], s = new X(_$n.getIntersection(r));
                        this.addIntersection(s, i);
                    }
                }
            },
            {
                key: "toString",
                value: function value() {
                    return Re.toLineString(new Qt(this._pts));
                }
            },
            {
                key: "getNodeList",
                value: function value() {
                    return this._nodeList;
                }
            },
            {
                key: "addIntersectionNode",
                value: function value(t, e) {
                    var _$n = e, i = _$n + 1;
                    if (i < this._pts.length) {
                        var r = this._pts[i];
                        t.equals2D(r) && (_$n = i);
                    }
                    return this._nodeList.add(t, _$n);
                }
            },
            {
                key: "addIntersections",
                value: function value(t, e, n) {
                    for(var i = 0; i < t.getIntersectionNum(); i++)this.addIntersection(t, e, n, i);
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        xn
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._nodeList = new pn(this), this._pts = null, this._data = null;
                    var t = arguments[0], _$e = arguments[1];
                    this._pts = t, this._data = _$e;
                }
            },
            {
                key: "getNodedSubstrings",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0], _$n = new yt;
                        return e.getNodedSubstrings(t, _$n), _$n;
                    }
                    if (2 === arguments.length) for(var i = arguments[0], r = arguments[1], s = i.iterator(); s.hasNext();){
                        var a = s.next();
                        a.getNodeList().addSplitEdges(r);
                    }
                }
            }
        ]), e;
    }(), En = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "minX",
                value: function value() {
                    return Math.min(this.p0.x, this.p1.x);
                }
            },
            {
                key: "orientationIndex",
                value: function value() {
                    if (_instanceof(arguments[0], e)) {
                        var t = arguments[0], _$n = ct.index(this.p0, this.p1, t.p0), i = ct.index(this.p0, this.p1, t.p1);
                        return _$n >= 0 && i >= 0 || _$n <= 0 && i <= 0 ? Math.max(_$n, i) : 0;
                    }
                    if (_instanceof(arguments[0], X)) {
                        var r = arguments[0];
                        return ct.index(this.p0, this.p1, r);
                    }
                }
            },
            {
                key: "toGeometry",
                value: function value(t) {
                    return t.createLineString([
                        this.p0,
                        this.p1
                    ]);
                }
            },
            {
                key: "isVertical",
                value: function value() {
                    return this.p0.x === this.p1.x;
                }
            },
            {
                key: "equals",
                value: function value(t) {
                    if (!_instanceof(t, e)) return !1;
                    var _$n = t;
                    return this.p0.equals(_$n.p0) && this.p1.equals(_$n.p1);
                }
            },
            {
                key: "intersection",
                value: function value(t) {
                    var _$e = new Oe;
                    return _$e.computeIntersection(this.p0, this.p1, t.p0, t.p1), _$e.hasIntersection() ? _$e.getIntersection(0) : null;
                }
            },
            {
                key: "project",
                value: function value() {
                    if (_instanceof(arguments[0], X)) {
                        var t = arguments[0];
                        if (t.equals(this.p0) || t.equals(this.p1)) return new X(t);
                        var _$n = this.projectionFactor(t), i = new X;
                        return i.x = this.p0.x + _$n * (this.p1.x - this.p0.x), i.y = this.p0.y + _$n * (this.p1.y - this.p0.y), i;
                    }
                    if (_instanceof(arguments[0], e)) {
                        var r = arguments[0], s = this.projectionFactor(r.p0), a = this.projectionFactor(r.p1);
                        if (s >= 1 && a >= 1) return null;
                        if (s <= 0 && a <= 0) return null;
                        var o = this.project(r.p0);
                        s < 0 && (o = this.p0), s > 1 && (o = this.p1);
                        var _$u = this.project(r.p1);
                        return a < 0 && (_$u = this.p0), a > 1 && (_$u = this.p1), new e(o, _$u);
                    }
                }
            },
            {
                key: "normalize",
                value: function value() {
                    this.p1.compareTo(this.p0) < 0 && this.reverse();
                }
            },
            {
                key: "angle",
                value: function value() {
                    return Math.atan2(this.p1.y - this.p0.y, this.p1.x - this.p0.x);
                }
            },
            {
                key: "getCoordinate",
                value: function value(t) {
                    return 0 === t ? this.p0 : this.p1;
                }
            },
            {
                key: "distancePerpendicular",
                value: function value(t) {
                    return xt.pointToLinePerpendicular(t, this.p0, this.p1);
                }
            },
            {
                key: "minY",
                value: function value() {
                    return Math.min(this.p0.y, this.p1.y);
                }
            },
            {
                key: "midPoint",
                value: function value() {
                    return e.midPoint(this.p0, this.p1);
                }
            },
            {
                key: "projectionFactor",
                value: function value(t) {
                    if (t.equals(this.p0)) return 0;
                    if (t.equals(this.p1)) return 1;
                    var _$e = this.p1.x - this.p0.x, _$n = this.p1.y - this.p0.y, i = _$e * _$e + _$n * _$n;
                    return i <= 0 ? A.NaN : ((t.x - this.p0.x) * _$e + (t.y - this.p0.y) * _$n) / i;
                }
            },
            {
                key: "closestPoints",
                value: function value(t) {
                    var _$e = this.intersection(t);
                    if (null !== _$e) return [
                        _$e,
                        _$e
                    ];
                    var _$n = new Array(2).fill(null), i = A.MAX_VALUE, r = null, s = this.closestPoint(t.p0);
                    i = s.distance(t.p0), _$n[0] = s, _$n[1] = t.p0;
                    var a = this.closestPoint(t.p1);
                    (r = a.distance(t.p1)) < i && (i = r, _$n[0] = a, _$n[1] = t.p1);
                    var o = t.closestPoint(this.p0);
                    (r = o.distance(this.p0)) < i && (i = r, _$n[0] = this.p0, _$n[1] = o);
                    var _$u = t.closestPoint(this.p1);
                    return (r = _$u.distance(this.p1)) < i && (i = r, _$n[0] = this.p1, _$n[1] = _$u), _$n;
                }
            },
            {
                key: "closestPoint",
                value: function value(t) {
                    var _$e = this.projectionFactor(t);
                    return _$e > 0 && _$e < 1 ? this.project(t) : this.p0.distance(t) < this.p1.distance(t) ? this.p0 : this.p1;
                }
            },
            {
                key: "maxX",
                value: function value() {
                    return Math.max(this.p0.x, this.p1.x);
                }
            },
            {
                key: "getLength",
                value: function value() {
                    return this.p0.distance(this.p1);
                }
            },
            {
                key: "compareTo",
                value: function value(t) {
                    var _$e = t, _$n = this.p0.compareTo(_$e.p0);
                    return 0 !== _$n ? _$n : this.p1.compareTo(_$e.p1);
                }
            },
            {
                key: "reverse",
                value: function value() {
                    var t = this.p0;
                    this.p0 = this.p1, this.p1 = t;
                }
            },
            {
                key: "equalsTopo",
                value: function value(t) {
                    return this.p0.equals(t.p0) && this.p1.equals(t.p1) || this.p0.equals(t.p1) && this.p1.equals(t.p0);
                }
            },
            {
                key: "lineIntersection",
                value: function value(t) {
                    return pt.intersection(this.p0, this.p1, t.p0, t.p1);
                }
            },
            {
                key: "maxY",
                value: function value() {
                    return Math.max(this.p0.y, this.p1.y);
                }
            },
            {
                key: "pointAlongOffset",
                value: function value(t, e) {
                    var _$n = this.p0.x + t * (this.p1.x - this.p0.x), i = this.p0.y + t * (this.p1.y - this.p0.y), r = this.p1.x - this.p0.x, s = this.p1.y - this.p0.y, a = Math.sqrt(r * r + s * s), o = 0, _$u = 0;
                    if (0 !== e) {
                        if (a <= 0) throw new IllegalStateException("Cannot compute offset from zero-length line segment");
                        o = e * r / a, _$u = e * s / a;
                    }
                    return new X(_$n - _$u, i + o);
                }
            },
            {
                key: "setCoordinates",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        this.setCoordinates(t.p0, t.p1);
                    } else if (2 === arguments.length) {
                        var _$e = arguments[0], _$n = arguments[1];
                        this.p0.x = _$e.x, this.p0.y = _$e.y, this.p1.x = _$n.x, this.p1.y = _$n.y;
                    }
                }
            },
            {
                key: "segmentFraction",
                value: function value(t) {
                    var _$e = this.projectionFactor(t);
                    return _$e < 0 ? _$e = 0 : (_$e > 1 || A.isNaN(_$e)) && (_$e = 1), _$e;
                }
            },
            {
                key: "toString",
                value: function value() {
                    return "LINESTRING( " + this.p0.x + " " + this.p0.y + ", " + this.p1.x + " " + this.p1.y + ")";
                }
            },
            {
                key: "isHorizontal",
                value: function value() {
                    return this.p0.y === this.p1.y;
                }
            },
            {
                key: "reflect",
                value: function value(t) {
                    var _$e = this.p1.getY() - this.p0.getY(), _$n = this.p0.getX() - this.p1.getX(), i = this.p0.getY() * (this.p1.getX() - this.p0.getX()) - this.p0.getX() * (this.p1.getY() - this.p0.getY()), r = _$e * _$e + _$n * _$n, s = _$e * _$e - _$n * _$n, a = t.getX(), o = t.getY();
                    return new X((-s * a - 2 * _$e * _$n * o - 2 * _$e * i) / r, (s * o - 2 * _$e * _$n * a - 2 * _$n * i) / r);
                }
            },
            {
                key: "distance",
                value: function value() {
                    if (_instanceof(arguments[0], e)) {
                        var t = arguments[0];
                        return xt.segmentToSegment(this.p0, this.p1, t.p0, t.p1);
                    }
                    if (_instanceof(arguments[0], X)) {
                        var _$n = arguments[0];
                        return xt.pointToSegment(_$n, this.p0, this.p1);
                    }
                }
            },
            {
                key: "pointAlong",
                value: function value(t) {
                    var _$e = new X;
                    return _$e.x = this.p0.x + t * (this.p1.x - this.p0.x), _$e.y = this.p0.y + t * (this.p1.y - this.p0.y), _$e;
                }
            },
            {
                key: "hashCode",
                value: function value() {
                    var t = A.doubleToLongBits(this.p0.x);
                    t ^= 31 * A.doubleToLongBits(this.p0.y);
                    var _$e = Math.trunc(t) ^ Math.trunc(t >> 32), _$n = A.doubleToLongBits(this.p1.x);
                    return _$n ^= 31 * A.doubleToLongBits(this.p1.y), _$e ^ (Math.trunc(_$n) ^ Math.trunc(_$n >> 32));
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        x,
                        E
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this.p0 = null, this.p1 = null, 0 === arguments.length) e.constructor_.call(this, new X, new X);
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        e.constructor_.call(this, t.p0, t.p1);
                    } else if (2 === arguments.length) {
                        var _$n = arguments[0], i = arguments[1];
                        this.p0 = _$n, this.p1 = i;
                    } else if (4 === arguments.length) {
                        var r = arguments[0], s = arguments[1], a = arguments[2], o = arguments[3];
                        e.constructor_.call(this, new X(r, s), new X(a, o));
                    }
                }
            },
            {
                key: "midPoint",
                value: function value(t, e) {
                    return new X((t.x + e.x) / 2, (t.y + e.y) / 2);
                }
            }
        ]), e;
    }(), Nn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "overlap",
                value: function value() {
                    if (2 === arguments.length) ;
                    else if (4 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1], _$n = arguments[2], i = arguments[3];
                        t.getLineSegment(_$e, this._overlapSeg1), _$n.getLineSegment(i, this._overlapSeg2), this.overlap(this._overlapSeg1, this._overlapSeg2);
                    }
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._overlapSeg1 = new En, this._overlapSeg2 = new En;
                }
            }
        ]), e;
    }(), Tn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getLineSegment",
                value: function value(t, e) {
                    e.p0 = this._pts[t], e.p1 = this._pts[t + 1];
                }
            },
            {
                key: "computeSelect",
                value: function value(t, e, n, i) {
                    var r = this._pts[e], s = this._pts[n];
                    if (n - e == 1) return i.select(this, e), null;
                    if (!t.intersects(r, s)) return null;
                    var a = Math.trunc((e + n) / 2);
                    e < a && this.computeSelect(t, e, a, i), a < n && this.computeSelect(t, a, n, i);
                }
            },
            {
                key: "getCoordinates",
                value: function value() {
                    for(var t = new Array(this._end - this._start + 1).fill(null), _$e = 0, _$n = this._start; _$n <= this._end; _$n++)t[_$e++] = this._pts[_$n];
                    return t;
                }
            },
            {
                key: "computeOverlaps",
                value: function value() {
                    if (2 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1];
                        this.computeOverlaps(this._start, this._end, t, t._start, t._end, _$e);
                    } else if (6 === arguments.length) {
                        var _$n = arguments[0], i = arguments[1], r = arguments[2], s = arguments[3], a = arguments[4], o = arguments[5];
                        if (i - _$n == 1 && a - s == 1) return o.overlap(this, _$n, r, s), null;
                        if (!this.overlaps(_$n, i, r, s, a)) return null;
                        var _$u = Math.trunc((_$n + i) / 2), l = Math.trunc((s + a) / 2);
                        _$n < _$u && (s < l && this.computeOverlaps(_$n, _$u, r, s, l, o), l < a && this.computeOverlaps(_$n, _$u, r, l, a, o)), _$u < i && (s < l && this.computeOverlaps(_$u, i, r, s, l, o), l < a && this.computeOverlaps(_$u, i, r, l, a, o));
                    }
                }
            },
            {
                key: "setId",
                value: function value(t) {
                    this._id = t;
                }
            },
            {
                key: "select",
                value: function value(t, e) {
                    this.computeSelect(t, this._start, this._end, e);
                }
            },
            {
                key: "getEnvelope",
                value: function value() {
                    if (null === this._env) {
                        var t = this._pts[this._start], _$e = this._pts[this._end];
                        this._env = new U(t, _$e);
                    }
                    return this._env;
                }
            },
            {
                key: "overlaps",
                value: function value(t, e, n, i, r) {
                    return U.intersects(this._pts[t], this._pts[e], n._pts[i], n._pts[r]);
                }
            },
            {
                key: "getEndIndex",
                value: function value() {
                    return this._end;
                }
            },
            {
                key: "getStartIndex",
                value: function value() {
                    return this._start;
                }
            },
            {
                key: "getContext",
                value: function value() {
                    return this._context;
                }
            },
            {
                key: "getId",
                value: function value() {
                    return this._id;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._pts = null, this._start = null, this._end = null, this._env = null, this._context = null, this._id = null;
                    var t = arguments[0], _$e = arguments[1], _$n = arguments[2], i = arguments[3];
                    this._pts = t, this._start = _$e, this._end = _$n, this._context = i;
                }
            }
        ]), e;
    }(), Sn = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "findChainEnd",
                value: function value(t, e) {
                    for(var _$n = e; _$n < t.length - 1 && t[_$n].equals2D(t[_$n + 1]);)_$n++;
                    if (_$n >= t.length - 1) return t.length - 1;
                    for(var i = We.quadrant(t[_$n], t[_$n + 1]), r = e + 1; r < t.length;){
                        if (!t[r - 1].equals2D(t[r])) {
                            if (We.quadrant(t[r - 1], t[r]) !== i) break;
                        }
                        r++;
                    }
                    return r - 1;
                }
            },
            {
                key: "getChains",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        return e.getChains(t, null);
                    }
                    if (2 === arguments.length) {
                        var _$n = arguments[0], i = arguments[1], r = new yt, s = 0;
                        do {
                            var a = e.findChainEnd(_$n, s), o = new Tn(_$n, s, a, i);
                            r.add(o), s = a;
                        }while (s < _$n.length - 1);
                        return r;
                    }
                }
            }
        ]), e;
    }(), Ln = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "computeNodes",
                value: function value(t) {}
            },
            {
                key: "getNodedSubstrings",
                value: function value() {}
            }
        ]), e;
    }(), Cn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "setSegmentIntersector",
                value: function value(t) {
                    this._segInt = t;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        Ln
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._segInt = null, 0 === arguments.length) ;
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        this.setSegmentIntersector(t);
                    }
                }
            }
        ]), e;
    }(), Rn = function(e) {
        i(s, e);
        var r = c(s);
        function s() {
            var _$e;
            return t(this, s), _$e = r.call(this), s.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(s, [
            {
                key: "getMonotoneChains",
                value: function value() {
                    return this._monoChains;
                }
            },
            {
                key: "getNodedSubstrings",
                value: function value() {
                    return In.getNodedSubstrings(this._nodedSegStrings);
                }
            },
            {
                key: "getIndex",
                value: function value() {
                    return this._index;
                }
            },
            {
                key: "add",
                value: function value(t) {
                    for(var _$e = Sn.getChains(t.getCoordinates(), t).iterator(); _$e.hasNext();){
                        var _$n = _$e.next();
                        _$n.setId(this._idCounter++), this._index.insert(_$n.getEnvelope(), _$n), this._monoChains.add(_$n);
                    }
                }
            },
            {
                key: "computeNodes",
                value: function value(t) {
                    this._nodedSegStrings = t;
                    for(var _$e = t.iterator(); _$e.hasNext();)this.add(_$e.next());
                    this.intersectChains();
                }
            },
            {
                key: "intersectChains",
                value: function value() {
                    for(var t = new wn(this._segInt), _$e = this._monoChains.iterator(); _$e.hasNext();)for(var _$n = _$e.next(), _$i = this._index.query(_$n.getEnvelope()).iterator(); _$i.hasNext();){
                        var r = _$i.next();
                        if (r.getId() > _$n.getId() && (_$n.computeOverlaps(r, t), this._nOverlaps++), this._segInt.isDone()) return null;
                    }
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._monoChains = new yt, this._index = new vn, this._idCounter = 0, this._nodedSegStrings = null, this._nOverlaps = 0, 0 === arguments.length) ;
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        Cn.constructor_.call(this, t);
                    }
                }
            }
        ]), s;
    }(Cn), wn = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "overlap",
                value: function value() {
                    if (4 !== arguments.length) return f(r(a.prototype), "overlap", this).apply(this, arguments);
                    var t = arguments[0], _$e = arguments[1], _$n = arguments[2], _$i = arguments[3], s = t.getContext(), o = _$n.getContext();
                    this._si.processIntersections(s, _$e, o, _$i);
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._si = null;
                    var t = arguments[0];
                    this._si = t;
                }
            }
        ]), a;
    }(Nn);
    Rn.SegmentOverlapAction = wn;
    var On = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "isDeletable",
                value: function value(t, e, n, i) {
                    var r = this._inputLine[t], s = this._inputLine[e], a = this._inputLine[n];
                    return !!this.isConcave(r, s, a) && !!this.isShallow(r, s, a, i) && this.isShallowSampled(r, s, t, n, i);
                }
            },
            {
                key: "deleteShallowConcavities",
                value: function value() {
                    for(var t = 1, _$n = this.findNextNonDeletedIndex(t), i = this.findNextNonDeletedIndex(_$n), r = !1; i < this._inputLine.length;){
                        var s = !1;
                        this.isDeletable(t, _$n, i, this._distanceTol) && (this._isDeleted[_$n] = e.DELETE, s = !0, r = !0), t = s ? i : _$n, _$n = this.findNextNonDeletedIndex(t), i = this.findNextNonDeletedIndex(_$n);
                    }
                    return r;
                }
            },
            {
                key: "isShallowConcavity",
                value: function value(t, e, n, i) {
                    return ct.index(t, e, n) === this._angleOrientation && xt.pointToSegment(e, t, n) < i;
                }
            },
            {
                key: "isShallowSampled",
                value: function value(t, n, i, r, s) {
                    var a = Math.trunc((r - i) / e.NUM_PTS_TO_CHECK);
                    a <= 0 && (a = 1);
                    for(var o = i; o < r; o += a)if (!this.isShallow(t, n, this._inputLine[o], s)) return !1;
                    return !0;
                }
            },
            {
                key: "isConcave",
                value: function value(t, e, n) {
                    var i = ct.index(t, e, n) === this._angleOrientation;
                    return i;
                }
            },
            {
                key: "simplify",
                value: function value(t) {
                    this._distanceTol = Math.abs(t), t < 0 && (this._angleOrientation = ct.CLOCKWISE), this._isDeleted = new Array(this._inputLine.length).fill(null);
                    var _$e = !1;
                    do {
                        _$e = this.deleteShallowConcavities();
                    }while (_$e);
                    return this.collapseLine();
                }
            },
            {
                key: "findNextNonDeletedIndex",
                value: function value(t) {
                    for(var _$n = t + 1; _$n < this._inputLine.length && this._isDeleted[_$n] === e.DELETE;)_$n++;
                    return _$n;
                }
            },
            {
                key: "isShallow",
                value: function value(t, e, n, i) {
                    return xt.pointToSegment(e, t, n) < i;
                }
            },
            {
                key: "collapseLine",
                value: function value() {
                    for(var t = new Zt, _$n = 0; _$n < this._inputLine.length; _$n++)this._isDeleted[_$n] !== e.DELETE && t.add(this._inputLine[_$n]);
                    return t.toCoordinateArray();
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._inputLine = null, this._distanceTol = null, this._isDeleted = null, this._angleOrientation = ct.COUNTERCLOCKWISE;
                    var t = arguments[0];
                    this._inputLine = t;
                }
            },
            {
                key: "simplify",
                value: function value(t, n) {
                    return new e(t).simplify(n);
                }
            }
        ]), e;
    }();
    On.INIT = 0, On.DELETE = 1, On.KEEP = 1, On.NUM_PTS_TO_CHECK = 10;
    var bn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getCoordinates",
                value: function value() {
                    return this._ptList.toArray(e.COORDINATE_ARRAY_TYPE);
                }
            },
            {
                key: "setPrecisionModel",
                value: function value(t) {
                    this._precisionModel = t;
                }
            },
            {
                key: "addPt",
                value: function value(t) {
                    var _$e = new X(t);
                    if (this._precisionModel.makePrecise(_$e), this.isRedundant(_$e)) return null;
                    this._ptList.add(_$e);
                }
            },
            {
                key: "reverse",
                value: function value() {}
            },
            {
                key: "addPts",
                value: function value(t, e) {
                    if (e) for(var _$n = 0; _$n < t.length; _$n++)this.addPt(t[_$n]);
                    else for(var i = t.length - 1; i >= 0; i--)this.addPt(t[i]);
                }
            },
            {
                key: "isRedundant",
                value: function value(t) {
                    if (this._ptList.size() < 1) return !1;
                    var _$e = this._ptList.get(this._ptList.size() - 1);
                    return t.distance(_$e) < this._minimimVertexDistance;
                }
            },
            {
                key: "toString",
                value: function value() {
                    return (new ae).createLineString(this.getCoordinates()).toString();
                }
            },
            {
                key: "closeRing",
                value: function value() {
                    if (this._ptList.size() < 1) return null;
                    var t = new X(this._ptList.get(0)), _$e = this._ptList.get(this._ptList.size() - 1);
                    if (t.equals(_$e)) return null;
                    this._ptList.add(t);
                }
            },
            {
                key: "setMinimumVertexDistance",
                value: function value(t) {
                    this._minimimVertexDistance = t;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._ptList = null, this._precisionModel = null, this._minimimVertexDistance = 0, this._ptList = new yt;
                }
            }
        ]), e;
    }();
    bn.COORDINATE_ARRAY_TYPE = new Array(0).fill(null);
    var Mn = function() {
        function e() {
            t(this, e);
        }
        return n(e, null, [
            {
                key: "toDegrees",
                value: function value(t) {
                    return 180 * t / Math.PI;
                }
            },
            {
                key: "normalize",
                value: function value(t) {
                    for(; t > Math.PI;)t -= e.PI_TIMES_2;
                    for(; t <= -Math.PI;)t += e.PI_TIMES_2;
                    return t;
                }
            },
            {
                key: "angle",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        return Math.atan2(t.y, t.x);
                    }
                    if (2 === arguments.length) {
                        var _$e = arguments[0], _$n = arguments[1], i = _$n.x - _$e.x, r = _$n.y - _$e.y;
                        return Math.atan2(r, i);
                    }
                }
            },
            {
                key: "isAcute",
                value: function value(t, e, n) {
                    var i = t.x - e.x, r = t.y - e.y;
                    return i * (n.x - e.x) + r * (n.y - e.y) > 0;
                }
            },
            {
                key: "isObtuse",
                value: function value(t, e, n) {
                    var i = t.x - e.x, r = t.y - e.y;
                    return i * (n.x - e.x) + r * (n.y - e.y) < 0;
                }
            },
            {
                key: "interiorAngle",
                value: function value(t, n, i) {
                    var r = e.angle(n, t), s = e.angle(n, i);
                    return Math.abs(s - r);
                }
            },
            {
                key: "normalizePositive",
                value: function value(t) {
                    if (t < 0) {
                        for(; t < 0;)t += e.PI_TIMES_2;
                        t >= e.PI_TIMES_2 && (t = 0);
                    } else {
                        for(; t >= e.PI_TIMES_2;)t -= e.PI_TIMES_2;
                        t < 0 && (t = 0);
                    }
                    return t;
                }
            },
            {
                key: "angleBetween",
                value: function value(t, n, i) {
                    var r = e.angle(n, t), s = e.angle(n, i);
                    return e.diff(r, s);
                }
            },
            {
                key: "diff",
                value: function value(t, e) {
                    var _$n = null;
                    return (_$n = t < e ? e - t : t - e) > Math.PI && (_$n = 2 * Math.PI - _$n), _$n;
                }
            },
            {
                key: "toRadians",
                value: function value(t) {
                    return t * Math.PI / 180;
                }
            },
            {
                key: "getTurn",
                value: function value(t, n) {
                    var i = Math.sin(n - t);
                    return i > 0 ? e.COUNTERCLOCKWISE : i < 0 ? e.CLOCKWISE : e.NONE;
                }
            },
            {
                key: "angleBetweenOriented",
                value: function value(t, n, i) {
                    var r = e.angle(n, t), s = e.angle(n, i) - r;
                    return s <= -Math.PI ? s + e.PI_TIMES_2 : s > Math.PI ? s - e.PI_TIMES_2 : s;
                }
            }
        ]), e;
    }();
    Mn.PI_TIMES_2 = 2 * Math.PI, Mn.PI_OVER_2 = Math.PI / 2, Mn.PI_OVER_4 = Math.PI / 4, Mn.COUNTERCLOCKWISE = ct.COUNTERCLOCKWISE, Mn.CLOCKWISE = ct.CLOCKWISE, Mn.NONE = ct.COLLINEAR;
    var An = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "addNextSegment",
                value: function value(t, e) {
                    if (this._s0 = this._s1, this._s1 = this._s2, this._s2 = t, this._seg0.setCoordinates(this._s0, this._s1), this.computeOffsetSegment(this._seg0, this._side, this._distance, this._offset0), this._seg1.setCoordinates(this._s1, this._s2), this.computeOffsetSegment(this._seg1, this._side, this._distance, this._offset1), this._s1.equals(this._s2)) return null;
                    var _$n = ct.index(this._s0, this._s1, this._s2), i = _$n === ct.CLOCKWISE && this._side === $.LEFT || _$n === ct.COUNTERCLOCKWISE && this._side === $.RIGHT;
                    0 === _$n ? this.addCollinear(e) : i ? this.addOutsideTurn(_$n, e) : this.addInsideTurn(_$n, e);
                }
            },
            {
                key: "addLineEndCap",
                value: function value(t, e) {
                    var _$n = new En(t, e), i = new En;
                    this.computeOffsetSegment(_$n, $.LEFT, this._distance, i);
                    var r = new En;
                    this.computeOffsetSegment(_$n, $.RIGHT, this._distance, r);
                    var s = e.x - t.x, a = e.y - t.y, o = Math.atan2(a, s);
                    switch(this._bufParams.getEndCapStyle()){
                        case _.CAP_ROUND:
                            this._segList.addPt(i.p1), this.addDirectedFillet(e, o + Math.PI / 2, o - Math.PI / 2, ct.CLOCKWISE, this._distance), this._segList.addPt(r.p1);
                            break;
                        case _.CAP_FLAT:
                            this._segList.addPt(i.p1), this._segList.addPt(r.p1);
                            break;
                        case _.CAP_SQUARE:
                            var _$u = new X;
                            _$u.x = Math.abs(this._distance) * Math.cos(o), _$u.y = Math.abs(this._distance) * Math.sin(o);
                            var l = new X(i.p1.x + _$u.x, i.p1.y + _$u.y), h = new X(r.p1.x + _$u.x, r.p1.y + _$u.y);
                            this._segList.addPt(l), this._segList.addPt(h);
                    }
                }
            },
            {
                key: "getCoordinates",
                value: function value() {
                    return this._segList.getCoordinates();
                }
            },
            {
                key: "addMitreJoin",
                value: function value(t, e, n, i) {
                    var r = pt.intersection(e.p0, e.p1, n.p0, n.p1);
                    if (null !== r && (i <= 0 ? 1 : r.distance(t) / Math.abs(i)) <= this._bufParams.getMitreLimit()) return this._segList.addPt(r), null;
                    this.addLimitedMitreJoin(e, n, i, this._bufParams.getMitreLimit());
                }
            },
            {
                key: "addOutsideTurn",
                value: function value(t, n) {
                    if (this._offset0.p1.distance(this._offset1.p0) < this._distance * e.OFFSET_SEGMENT_SEPARATION_FACTOR) return this._segList.addPt(this._offset0.p1), null;
                    this._bufParams.getJoinStyle() === _.JOIN_MITRE ? this.addMitreJoin(this._s1, this._offset0, this._offset1, this._distance) : this._bufParams.getJoinStyle() === _.JOIN_BEVEL ? this.addBevelJoin(this._offset0, this._offset1) : (n && this._segList.addPt(this._offset0.p1), this.addCornerFillet(this._s1, this._offset0.p1, this._offset1.p0, t, this._distance), this._segList.addPt(this._offset1.p0));
                }
            },
            {
                key: "createSquare",
                value: function value(t) {
                    this._segList.addPt(new X(t.x + this._distance, t.y + this._distance)), this._segList.addPt(new X(t.x + this._distance, t.y - this._distance)), this._segList.addPt(new X(t.x - this._distance, t.y - this._distance)), this._segList.addPt(new X(t.x - this._distance, t.y + this._distance)), this._segList.closeRing();
                }
            },
            {
                key: "addSegments",
                value: function value(t, e) {
                    this._segList.addPts(t, e);
                }
            },
            {
                key: "addFirstSegment",
                value: function value() {
                    this._segList.addPt(this._offset1.p0);
                }
            },
            {
                key: "addCornerFillet",
                value: function value(t, e, n, i, r) {
                    var s = e.x - t.x, a = e.y - t.y, o = Math.atan2(a, s), _$u = n.x - t.x, l = n.y - t.y, h = Math.atan2(l, _$u);
                    i === ct.CLOCKWISE ? o <= h && (o += 2 * Math.PI) : o >= h && (o -= 2 * Math.PI), this._segList.addPt(e), this.addDirectedFillet(t, o, h, i, r), this._segList.addPt(n);
                }
            },
            {
                key: "addLastSegment",
                value: function value() {
                    this._segList.addPt(this._offset1.p1);
                }
            },
            {
                key: "initSideSegments",
                value: function value(t, e, n) {
                    this._s1 = t, this._s2 = e, this._side = n, this._seg1.setCoordinates(t, e), this.computeOffsetSegment(this._seg1, n, this._distance, this._offset1);
                }
            },
            {
                key: "addLimitedMitreJoin",
                value: function value(t, e, n, i) {
                    var r = this._seg0.p1, s = Mn.angle(r, this._seg0.p0), a = Mn.angleBetweenOriented(this._seg0.p0, r, this._seg1.p1) / 2, o = Mn.normalize(s + a), _$u = Mn.normalize(o + Math.PI), l = i * n, h = n - l * Math.abs(Math.sin(a)), c = r.x + l * Math.cos(_$u), f = r.y + l * Math.sin(_$u), v = new X(c, f), g = new En(r, v), y = g.pointAlongOffset(1, h), d = g.pointAlongOffset(1, -h);
                    this._side === $.LEFT ? (this._segList.addPt(y), this._segList.addPt(d)) : (this._segList.addPt(d), this._segList.addPt(y));
                }
            },
            {
                key: "addDirectedFillet",
                value: function value(t, e, n, i, r) {
                    var s = i === ct.CLOCKWISE ? -1 : 1, a = Math.abs(e - n), o = Math.trunc(a / this._filletAngleQuantum + .5);
                    if (o < 1) return null;
                    for(var _$u = a / o, l = new X, h = 0; h < o; h++){
                        var c = e + s * h * _$u;
                        l.x = t.x + r * Math.cos(c), l.y = t.y + r * Math.sin(c), this._segList.addPt(l);
                    }
                }
            },
            {
                key: "computeOffsetSegment",
                value: function value(t, e, n, i) {
                    var r = e === $.LEFT ? 1 : -1, s = t.p1.x - t.p0.x, a = t.p1.y - t.p0.y, o = Math.sqrt(s * s + a * a), _$u = r * n * s / o, l = r * n * a / o;
                    i.p0.x = t.p0.x - l, i.p0.y = t.p0.y + _$u, i.p1.x = t.p1.x - l, i.p1.y = t.p1.y + _$u;
                }
            },
            {
                key: "addInsideTurn",
                value: function value(t, n) {
                    if (this._li.computeIntersection(this._offset0.p0, this._offset0.p1, this._offset1.p0, this._offset1.p1), this._li.hasIntersection()) this._segList.addPt(this._li.getIntersection(0));
                    else if (this._hasNarrowConcaveAngle = !0, this._offset0.p1.distance(this._offset1.p0) < this._distance * e.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR) this._segList.addPt(this._offset0.p1);
                    else {
                        if (this._segList.addPt(this._offset0.p1), this._closingSegLengthFactor > 0) {
                            var i = new X((this._closingSegLengthFactor * this._offset0.p1.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset0.p1.y + this._s1.y) / (this._closingSegLengthFactor + 1));
                            this._segList.addPt(i);
                            var r = new X((this._closingSegLengthFactor * this._offset1.p0.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset1.p0.y + this._s1.y) / (this._closingSegLengthFactor + 1));
                            this._segList.addPt(r);
                        } else this._segList.addPt(this._s1);
                        this._segList.addPt(this._offset1.p0);
                    }
                }
            },
            {
                key: "createCircle",
                value: function value(t) {
                    var _$e = new X(t.x + this._distance, t.y);
                    this._segList.addPt(_$e), this.addDirectedFillet(t, 0, 2 * Math.PI, -1, this._distance), this._segList.closeRing();
                }
            },
            {
                key: "addBevelJoin",
                value: function value(t, e) {
                    this._segList.addPt(t.p1), this._segList.addPt(e.p0);
                }
            },
            {
                key: "init",
                value: function value(t) {
                    this._distance = t, this._maxCurveSegmentError = t * (1 - Math.cos(this._filletAngleQuantum / 2)), this._segList = new bn, this._segList.setPrecisionModel(this._precisionModel), this._segList.setMinimumVertexDistance(t * e.CURVE_VERTEX_SNAP_DISTANCE_FACTOR);
                }
            },
            {
                key: "addCollinear",
                value: function value(t) {
                    this._li.computeIntersection(this._s0, this._s1, this._s1, this._s2), this._li.getIntersectionNum() >= 2 && (this._bufParams.getJoinStyle() === _.JOIN_BEVEL || this._bufParams.getJoinStyle() === _.JOIN_MITRE ? (t && this._segList.addPt(this._offset0.p1), this._segList.addPt(this._offset1.p0)) : this.addCornerFillet(this._s1, this._offset0.p1, this._offset1.p0, ct.CLOCKWISE, this._distance));
                }
            },
            {
                key: "closeRing",
                value: function value() {
                    this._segList.closeRing();
                }
            },
            {
                key: "hasNarrowConcaveAngle",
                value: function value() {
                    return this._hasNarrowConcaveAngle;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._maxCurveSegmentError = 0, this._filletAngleQuantum = null, this._closingSegLengthFactor = 1, this._segList = null, this._distance = 0, this._precisionModel = null, this._bufParams = null, this._li = null, this._s0 = null, this._s1 = null, this._s2 = null, this._seg0 = new En, this._seg1 = new En, this._offset0 = new En, this._offset1 = new En, this._side = 0, this._hasNarrowConcaveAngle = !1;
                    var t = arguments[0], _$n = arguments[1], i = arguments[2];
                    this._precisionModel = t, this._bufParams = _$n, this._li = new Oe, this._filletAngleQuantum = Math.PI / 2 / _$n.getQuadrantSegments(), _$n.getQuadrantSegments() >= 8 && _$n.getJoinStyle() === _.JOIN_ROUND && (this._closingSegLengthFactor = e.MAX_CLOSING_SEG_LEN_FACTOR), this.init(i);
                }
            }
        ]), e;
    }();
    An.OFFSET_SEGMENT_SEPARATION_FACTOR = .001, An.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR = .001, An.CURVE_VERTEX_SNAP_DISTANCE_FACTOR = 1e-6, An.MAX_CLOSING_SEG_LEN_FACTOR = 80;
    var Pn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getOffsetCurve",
                value: function value(t, e) {
                    if (this._distance = e, 0 === e) return null;
                    var _$n = e < 0, i = Math.abs(e), r = this.getSegGen(i);
                    t.length <= 1 ? this.computePointCurve(t[0], r) : this.computeOffsetCurve(t, _$n, r);
                    var s = r.getCoordinates();
                    return _$n && jt.reverse(s), s;
                }
            },
            {
                key: "computeSingleSidedBufferCurve",
                value: function value(t, e, n) {
                    var i = this.simplifyTolerance(this._distance);
                    if (e) {
                        n.addSegments(t, !0);
                        var r = On.simplify(t, -i), s = r.length - 1;
                        n.initSideSegments(r[s], r[s - 1], $.LEFT), n.addFirstSegment();
                        for(var a = s - 2; a >= 0; a--)n.addNextSegment(r[a], !0);
                    } else {
                        n.addSegments(t, !1);
                        var o = On.simplify(t, i), _$u = o.length - 1;
                        n.initSideSegments(o[0], o[1], $.LEFT), n.addFirstSegment();
                        for(var l = 2; l <= _$u; l++)n.addNextSegment(o[l], !0);
                    }
                    n.addLastSegment(), n.closeRing();
                }
            },
            {
                key: "computeRingBufferCurve",
                value: function value(t, e, n) {
                    var i = this.simplifyTolerance(this._distance);
                    e === $.RIGHT && (i = -i);
                    var r = On.simplify(t, i), s = r.length - 1;
                    n.initSideSegments(r[s - 1], r[0], e);
                    for(var a = 1; a <= s; a++){
                        var o = 1 !== a;
                        n.addNextSegment(r[a], o);
                    }
                    n.closeRing();
                }
            },
            {
                key: "computeLineBufferCurve",
                value: function value(t, e) {
                    var _$n = this.simplifyTolerance(this._distance), i = On.simplify(t, _$n), r = i.length - 1;
                    e.initSideSegments(i[0], i[1], $.LEFT);
                    for(var s = 2; s <= r; s++)e.addNextSegment(i[s], !0);
                    e.addLastSegment(), e.addLineEndCap(i[r - 1], i[r]);
                    var a = On.simplify(t, -_$n), o = a.length - 1;
                    e.initSideSegments(a[o], a[o - 1], $.LEFT);
                    for(var _$u = o - 2; _$u >= 0; _$u--)e.addNextSegment(a[_$u], !0);
                    e.addLastSegment(), e.addLineEndCap(a[1], a[0]), e.closeRing();
                }
            },
            {
                key: "computePointCurve",
                value: function value(t, e) {
                    switch(this._bufParams.getEndCapStyle()){
                        case _.CAP_ROUND:
                            e.createCircle(t);
                            break;
                        case _.CAP_SQUARE:
                            e.createSquare(t);
                    }
                }
            },
            {
                key: "getLineCurve",
                value: function value(t, e) {
                    if (this._distance = e, this.isLineOffsetEmpty(e)) return null;
                    var _$n = Math.abs(e), i = this.getSegGen(_$n);
                    if (t.length <= 1) this.computePointCurve(t[0], i);
                    else if (this._bufParams.isSingleSided()) {
                        var r = e < 0;
                        this.computeSingleSidedBufferCurve(t, r, i);
                    } else this.computeLineBufferCurve(t, i);
                    return i.getCoordinates();
                }
            },
            {
                key: "getBufferParameters",
                value: function value() {
                    return this._bufParams;
                }
            },
            {
                key: "simplifyTolerance",
                value: function value(t) {
                    return t * this._bufParams.getSimplifyFactor();
                }
            },
            {
                key: "getRingCurve",
                value: function value(t, n, i) {
                    if (this._distance = i, t.length <= 2) return this.getLineCurve(t, i);
                    if (0 === i) return e.copyCoordinates(t);
                    var r = this.getSegGen(i);
                    return this.computeRingBufferCurve(t, n, r), r.getCoordinates();
                }
            },
            {
                key: "computeOffsetCurve",
                value: function value(t, e, n) {
                    var i = this.simplifyTolerance(this._distance);
                    if (e) {
                        var r = On.simplify(t, -i), s = r.length - 1;
                        n.initSideSegments(r[s], r[s - 1], $.LEFT), n.addFirstSegment();
                        for(var a = s - 2; a >= 0; a--)n.addNextSegment(r[a], !0);
                    } else {
                        var o = On.simplify(t, i), _$u = o.length - 1;
                        n.initSideSegments(o[0], o[1], $.LEFT), n.addFirstSegment();
                        for(var l = 2; l <= _$u; l++)n.addNextSegment(o[l], !0);
                    }
                    n.addLastSegment();
                }
            },
            {
                key: "isLineOffsetEmpty",
                value: function value(t) {
                    return 0 === t || t < 0 && !this._bufParams.isSingleSided();
                }
            },
            {
                key: "getSegGen",
                value: function value(t) {
                    return new An(this._precisionModel, this._bufParams, t);
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._distance = 0, this._precisionModel = null, this._bufParams = null;
                    var t = arguments[0], _$e = arguments[1];
                    this._precisionModel = t, this._bufParams = _$e;
                }
            },
            {
                key: "copyCoordinates",
                value: function value(t) {
                    for(var _$e = new Array(t.length).fill(null), _$n = 0; _$n < _$e.length; _$n++)_$e[_$n] = new X(t[_$n]);
                    return _$e;
                }
            }
        ]), e;
    }(), Dn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "findStabbedSegments",
                value: function value() {
                    if (1 === arguments.length) {
                        for(var t = arguments[0], _$e = new yt, _$n = this._subgraphs.iterator(); _$n.hasNext();){
                            var i = _$n.next(), r = i.getEnvelope();
                            t.y < r.getMinY() || t.y > r.getMaxY() || this.findStabbedSegments(t, i.getDirectedEdges(), _$e);
                        }
                        return _$e;
                    }
                    if (3 === arguments.length) {
                        if (rt(arguments[2], nt) && _instanceof(arguments[0], X) && _instanceof(arguments[1], Je)) for(var s = arguments[0], a = arguments[1], o = arguments[2], _$u = a.getEdge().getCoordinates(), l = 0; l < _$u.length - 1; l++){
                            this._seg.p0 = _$u[l], this._seg.p1 = _$u[l + 1], this._seg.p0.y > this._seg.p1.y && this._seg.reverse();
                            var h = Math.max(this._seg.p0.x, this._seg.p1.x);
                            if (!(h < s.x) && !(this._seg.isHorizontal() || s.y < this._seg.p0.y || s.y > this._seg.p1.y || ct.index(this._seg.p0, this._seg.p1, s) === ct.RIGHT)) {
                                var c = a.getDepth($.LEFT);
                                this._seg.p0.equals(_$u[l]) || (c = a.getDepth($.RIGHT));
                                var f = new Fn(this._seg, c);
                                o.add(f);
                            }
                        }
                        else if (rt(arguments[2], nt) && _instanceof(arguments[0], X) && rt(arguments[1], nt)) for(var v = arguments[0], g = arguments[1], y = arguments[2], d = g.iterator(); d.hasNext();){
                            var _ = d.next();
                            _.isForward() && this.findStabbedSegments(v, _, y);
                        }
                    }
                }
            },
            {
                key: "getDepth",
                value: function value(t) {
                    var _$e = this.findStabbedSegments(t);
                    return 0 === _$e.size() ? 0 : on.min(_$e)._leftDepth;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._subgraphs = null, this._seg = new En;
                    var t = arguments[0];
                    this._subgraphs = t;
                }
            }
        ]), e;
    }(), Fn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "compareTo",
                value: function value(t) {
                    var _$e = t;
                    if (this._upwardSeg.minX() >= _$e._upwardSeg.maxX()) return 1;
                    if (this._upwardSeg.maxX() <= _$e._upwardSeg.minX()) return -1;
                    var _$n = this._upwardSeg.orientationIndex(_$e._upwardSeg);
                    return 0 !== _$n || 0 !== (_$n = -1 * _$e._upwardSeg.orientationIndex(this._upwardSeg)) ? _$n : this._upwardSeg.compareTo(_$e._upwardSeg);
                }
            },
            {
                key: "compareX",
                value: function value(t, e) {
                    var _$n = t.p0.compareTo(e.p0);
                    return 0 !== _$n ? _$n : t.p1.compareTo(e.p1);
                }
            },
            {
                key: "toString",
                value: function value() {
                    return this._upwardSeg.toString();
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        x
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._upwardSeg = null, this._leftDepth = null;
                    var t = arguments[0], _$e = arguments[1];
                    this._upwardSeg = new En(t), this._leftDepth = _$e;
                }
            }
        ]), e;
    }();
    Dn.DepthSegment = Fn;
    var Gn = function(e) {
        i(s, e);
        var r = c(s);
        function s() {
            var _$e;
            return t(this, s), _$e = r.call(this), s.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(s, null, [
            {
                key: "constructor_",
                value: function value() {
                    p.constructor_.call(this, "Projective point not representable on the Cartesian plane.");
                }
            }
        ]), s;
    }(p), qn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getY",
                value: function value() {
                    var t = this.y / this.w;
                    if (A.isNaN(t) || A.isInfinite(t)) throw new Gn;
                    return t;
                }
            },
            {
                key: "getX",
                value: function value() {
                    var t = this.x / this.w;
                    if (A.isNaN(t) || A.isInfinite(t)) throw new Gn;
                    return t;
                }
            },
            {
                key: "getCoordinate",
                value: function value() {
                    var t = new X;
                    return t.x = this.getX(), t.y = this.getY(), t;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this.x = null, this.y = null, this.w = null, 0 === arguments.length) this.x = 0, this.y = 0, this.w = 1;
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        this.x = t.x, this.y = t.y, this.w = 1;
                    } else if (2 === arguments.length) {
                        if ("number" == typeof arguments[0] && "number" == typeof arguments[1]) {
                            var _$n = arguments[0], i = arguments[1];
                            this.x = _$n, this.y = i, this.w = 1;
                        } else if (_instanceof(arguments[0], e) && _instanceof(arguments[1], e)) {
                            var r = arguments[0], s = arguments[1];
                            this.x = r.y * s.w - s.y * r.w, this.y = s.x * r.w - r.x * s.w, this.w = r.x * s.y - s.x * r.y;
                        } else if (_instanceof(arguments[0], X) && _instanceof(arguments[1], X)) {
                            var a = arguments[0], o = arguments[1];
                            this.x = a.y - o.y, this.y = o.x - a.x, this.w = a.x * o.y - o.x * a.y;
                        }
                    } else if (3 === arguments.length) {
                        var _$u = arguments[0], l = arguments[1], h = arguments[2];
                        this.x = _$u, this.y = l, this.w = h;
                    } else if (4 === arguments.length) {
                        var c = arguments[0], f = arguments[1], v = arguments[2], g = arguments[3], y = c.y - f.y, d = f.x - c.x, _ = c.x * f.y - f.x * c.y, p = v.y - g.y, m = g.x - v.x, k = v.x * g.y - g.x * v.y;
                        this.x = d * k - m * _, this.y = p * _ - y * k, this.w = y * m - p * d;
                    }
                }
            }
        ]), e;
    }(), Yn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "area",
                value: function value() {
                    return e.area(this.p0, this.p1, this.p2);
                }
            },
            {
                key: "signedArea",
                value: function value() {
                    return e.signedArea(this.p0, this.p1, this.p2);
                }
            },
            {
                key: "interpolateZ",
                value: function value(t) {
                    if (null === t) throw new m("Supplied point is null.");
                    return e.interpolateZ(t, this.p0, this.p1, this.p2);
                }
            },
            {
                key: "longestSideLength",
                value: function value() {
                    return e.longestSideLength(this.p0, this.p1, this.p2);
                }
            },
            {
                key: "isAcute",
                value: function value() {
                    return e.isAcute(this.p0, this.p1, this.p2);
                }
            },
            {
                key: "circumcentre",
                value: function value() {
                    return e.circumcentre(this.p0, this.p1, this.p2);
                }
            },
            {
                key: "area3D",
                value: function value() {
                    return e.area3D(this.p0, this.p1, this.p2);
                }
            },
            {
                key: "centroid",
                value: function value() {
                    return e.centroid(this.p0, this.p1, this.p2);
                }
            },
            {
                key: "inCentre",
                value: function value() {
                    return e.inCentre(this.p0, this.p1, this.p2);
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this.p0 = null, this.p1 = null, this.p2 = null;
                    var t = arguments[0], _$e = arguments[1], _$n = arguments[2];
                    this.p0 = t, this.p1 = _$e, this.p2 = _$n;
                }
            },
            {
                key: "area",
                value: function value(t, e, n) {
                    return Math.abs(((n.x - t.x) * (e.y - t.y) - (e.x - t.x) * (n.y - t.y)) / 2);
                }
            },
            {
                key: "signedArea",
                value: function value(t, e, n) {
                    return ((n.x - t.x) * (e.y - t.y) - (e.x - t.x) * (n.y - t.y)) / 2;
                }
            },
            {
                key: "det",
                value: function value(t, e, n, i) {
                    return t * i - e * n;
                }
            },
            {
                key: "interpolateZ",
                value: function value(t, e, n, i) {
                    var r = e.x, s = e.y, a = n.x - r, o = i.x - r, _$u = n.y - s, l = i.y - s, h = a * l - o * _$u, c = t.x - r, f = t.y - s, v = (l * c - o * f) / h, g = (-_$u * c + a * f) / h;
                    return e.getZ() + v * (n.getZ() - e.getZ()) + g * (i.getZ() - e.getZ());
                }
            },
            {
                key: "longestSideLength",
                value: function value(t, e, n) {
                    var i = t.distance(e), r = e.distance(n), s = n.distance(t), a = i;
                    return r > a && (a = r), s > a && (a = s), a;
                }
            },
            {
                key: "circumcentreDD",
                value: function value(t, e, n) {
                    var i = ut.valueOf(t.x).subtract(n.x), r = ut.valueOf(t.y).subtract(n.y), s = ut.valueOf(e.x).subtract(n.x), a = ut.valueOf(e.y).subtract(n.y), o = ut.determinant(i, r, s, a).multiply(2), _$u = i.sqr().add(r.sqr()), l = s.sqr().add(a.sqr()), h = ut.determinant(r, _$u, a, l), c = ut.determinant(i, _$u, s, l), f = ut.valueOf(n.x).subtract(h.divide(o)).doubleValue(), v = ut.valueOf(n.y).add(c.divide(o)).doubleValue();
                    return new X(f, v);
                }
            },
            {
                key: "isAcute",
                value: function value(t, e, n) {
                    return !!Mn.isAcute(t, e, n) && !!Mn.isAcute(e, n, t) && !!Mn.isAcute(n, t, e);
                }
            },
            {
                key: "circumcentre",
                value: function value(t, n, i) {
                    var r = i.x, s = i.y, a = t.x - r, o = t.y - s, _$u = n.x - r, l = n.y - s, h = 2 * e.det(a, o, _$u, l), c = e.det(o, a * a + o * o, l, _$u * _$u + l * l), f = e.det(a, a * a + o * o, _$u, _$u * _$u + l * l);
                    return new X(r - c / h, s + f / h);
                }
            },
            {
                key: "perpendicularBisector",
                value: function value(t, e) {
                    var _$n = e.x - t.x, i = e.y - t.y, r = new qn(t.x + _$n / 2, t.y + i / 2, 1), s = new qn(t.x - i + _$n / 2, t.y + _$n + i / 2, 1);
                    return new qn(r, s);
                }
            },
            {
                key: "angleBisector",
                value: function value(t, e, n) {
                    var i = e.distance(t), r = i / (i + e.distance(n)), s = n.x - t.x, a = n.y - t.y;
                    return new X(t.x + r * s, t.y + r * a);
                }
            },
            {
                key: "area3D",
                value: function value(t, e, n) {
                    var i = e.x - t.x, r = e.y - t.y, s = e.getZ() - t.getZ(), a = n.x - t.x, o = n.y - t.y, _$u = n.getZ() - t.getZ(), l = r * _$u - s * o, h = s * a - i * _$u, c = i * o - r * a, f = l * l + h * h + c * c, v = Math.sqrt(f) / 2;
                    return v;
                }
            },
            {
                key: "centroid",
                value: function value(t, e, n) {
                    var i = (t.x + e.x + n.x) / 3, r = (t.y + e.y + n.y) / 3;
                    return new X(i, r);
                }
            },
            {
                key: "inCentre",
                value: function value(t, e, n) {
                    var i = e.distance(n), r = t.distance(n), s = t.distance(e), a = i + r + s, o = (i * t.x + r * e.x + s * n.x) / a, _$u = (i * t.y + r * e.y + s * n.y) / a;
                    return new X(o, _$u);
                }
            }
        ]), e;
    }(), zn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "addRingSide",
                value: function value(t, e, n, i, r) {
                    if (0 === e && t.length < Xt.MINIMUM_VALID_SIZE) return null;
                    var s = i, a = r;
                    t.length >= Xt.MINIMUM_VALID_SIZE && ct.isCCW(t) && (s = r, a = i, n = $.opposite(n));
                    var o = this._curveBuilder.getRingCurve(t, n, e);
                    this.addCurve(o, s, a);
                }
            },
            {
                key: "addRingBothSides",
                value: function value(t, e) {
                    this.addRingSide(t, e, $.LEFT, H.EXTERIOR, H.INTERIOR), this.addRingSide(t, e, $.RIGHT, H.INTERIOR, H.EXTERIOR);
                }
            },
            {
                key: "addPoint",
                value: function value(t) {
                    if (this._distance <= 0) return null;
                    var _$e = t.getCoordinates(), _$n = this._curveBuilder.getLineCurve(_$e, this._distance);
                    this.addCurve(_$n, H.EXTERIOR, H.INTERIOR);
                }
            },
            {
                key: "addPolygon",
                value: function value(t) {
                    var _$e = this._distance, _$n = $.LEFT;
                    this._distance < 0 && (_$e = -this._distance, _$n = $.RIGHT);
                    var i = t.getExteriorRing(), r = jt.removeRepeatedPoints(i.getCoordinates());
                    if (this._distance < 0 && this.isErodedCompletely(i, this._distance)) return null;
                    if (this._distance <= 0 && r.length < 3) return null;
                    this.addRingSide(r, _$e, _$n, H.EXTERIOR, H.INTERIOR);
                    for(var s = 0; s < t.getNumInteriorRing(); s++){
                        var a = t.getInteriorRingN(s), o = jt.removeRepeatedPoints(a.getCoordinates());
                        this._distance > 0 && this.isErodedCompletely(a, -this._distance) || this.addRingSide(o, _$e, $.opposite(_$n), H.INTERIOR, H.EXTERIOR);
                    }
                }
            },
            {
                key: "isTriangleErodedCompletely",
                value: function value(t, e) {
                    var _$n = new Yn(t[0], t[1], t[2]), i = _$n.inCentre();
                    return xt.pointToSegment(i, _$n.p0, _$n.p1) < Math.abs(e);
                }
            },
            {
                key: "addLineString",
                value: function value(t) {
                    if (this._curveBuilder.isLineOffsetEmpty(this._distance)) return null;
                    var _$e = jt.removeRepeatedPoints(t.getCoordinates());
                    if (jt.isRing(_$e) && !this._curveBuilder.getBufferParameters().isSingleSided()) this.addRingBothSides(_$e, this._distance);
                    else {
                        var _$n = this._curveBuilder.getLineCurve(_$e, this._distance);
                        this.addCurve(_$n, H.EXTERIOR, H.INTERIOR);
                    }
                }
            },
            {
                key: "addCurve",
                value: function value(t, e, n) {
                    if (null === t || t.length < 2) return null;
                    var i = new In(t, new Pe(0, H.BOUNDARY, e, n));
                    this._curveList.add(i);
                }
            },
            {
                key: "getCurves",
                value: function value() {
                    return this.add(this._inputGeom), this._curveList;
                }
            },
            {
                key: "add",
                value: function value(t) {
                    if (t.isEmpty()) return null;
                    if (_instanceof(t, Dt)) this.addPolygon(t);
                    else if (_instanceof(t, wt)) this.addLineString(t);
                    else if (_instanceof(t, bt)) this.addPoint(t);
                    else if (_instanceof(t, zt)) this.addCollection(t);
                    else if (_instanceof(t, se)) this.addCollection(t);
                    else if (_instanceof(t, te)) this.addCollection(t);
                    else {
                        if (!_instanceof(t, Yt)) throw new W(t.getGeometryType());
                        this.addCollection(t);
                    }
                }
            },
            {
                key: "isErodedCompletely",
                value: function value(t, e) {
                    var _$n = t.getCoordinates();
                    if (_$n.length < 4) return e < 0;
                    if (4 === _$n.length) return this.isTriangleErodedCompletely(_$n, e);
                    var i = t.getEnvelopeInternal(), r = Math.min(i.getHeight(), i.getWidth());
                    return e < 0 && 2 * Math.abs(e) > r;
                }
            },
            {
                key: "addCollection",
                value: function value(t) {
                    for(var _$e = 0; _$e < t.getNumGeometries(); _$e++){
                        var _$n = t.getGeometryN(_$e);
                        this.add(_$n);
                    }
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._inputGeom = null, this._distance = null, this._curveBuilder = null, this._curveList = new yt;
                    var t = arguments[0], _$e = arguments[1], _$n = arguments[2];
                    this._inputGeom = t, this._distance = _$e, this._curveBuilder = _$n;
                }
            }
        ]), e;
    }(), Xn = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "locate",
                value: function value(t) {}
            }
        ]), e;
    }(), Bn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "next",
                value: function value() {
                    if (this._atStart) return this._atStart = !1, e.isAtomic(this._parent) && this._index++, this._parent;
                    if (null !== this._subcollectionIterator) {
                        if (this._subcollectionIterator.hasNext()) return this._subcollectionIterator.next();
                        this._subcollectionIterator = null;
                    }
                    if (this._index >= this._max) throw new j;
                    var t = this._parent.getGeometryN(this._index++);
                    return _instanceof(t, Yt) ? (this._subcollectionIterator = new e(t), this._subcollectionIterator.next()) : t;
                }
            },
            {
                key: "remove",
                value: function value() {
                    throw new W(this.getClass().getName());
                }
            },
            {
                key: "hasNext",
                value: function value() {
                    if (this._atStart) return !0;
                    if (null !== this._subcollectionIterator) {
                        if (this._subcollectionIterator.hasNext()) return !0;
                        this._subcollectionIterator = null;
                    }
                    return !(this._index >= this._max);
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        _n
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._parent = null, this._atStart = null, this._max = null, this._index = null, this._subcollectionIterator = null;
                    var t = arguments[0];
                    this._parent = t, this._atStart = !0, this._index = 0, this._max = t.getNumGeometries();
                }
            },
            {
                key: "isAtomic",
                value: function value(t) {
                    return !_instanceof(t, Yt);
                }
            }
        ]), e;
    }(), Un = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "locate",
                value: function value(t) {
                    return e.locate(t, this._geom);
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        Xn
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._geom = null;
                    var t = arguments[0];
                    this._geom = t;
                }
            },
            {
                key: "locatePointInPolygon",
                value: function value(t, n) {
                    if (n.isEmpty()) return H.EXTERIOR;
                    var i = n.getExteriorRing(), r = e.locatePointInRing(t, i);
                    if (r !== H.INTERIOR) return r;
                    for(var s = 0; s < n.getNumInteriorRing(); s++){
                        var a = n.getInteriorRingN(s), o = e.locatePointInRing(t, a);
                        if (o === H.BOUNDARY) return H.BOUNDARY;
                        if (o === H.INTERIOR) return H.EXTERIOR;
                    }
                    return H.INTERIOR;
                }
            },
            {
                key: "locatePointInRing",
                value: function value(t, e) {
                    return e.getEnvelopeInternal().intersects(t) ? Me.locateInRing(t, e.getCoordinates()) : H.EXTERIOR;
                }
            },
            {
                key: "containsPointInPolygon",
                value: function value(t, n) {
                    return H.EXTERIOR !== e.locatePointInPolygon(t, n);
                }
            },
            {
                key: "locateInGeometry",
                value: function value(t, n) {
                    if (_instanceof(n, Dt)) return e.locatePointInPolygon(t, n);
                    if (_instanceof(n, Yt)) for(var i = new Bn(n); i.hasNext();){
                        var r = i.next();
                        if (r !== n) {
                            var s = e.locateInGeometry(t, r);
                            if (s !== H.EXTERIOR) return s;
                        }
                    }
                    return H.EXTERIOR;
                }
            },
            {
                key: "isContained",
                value: function value(t, n) {
                    return H.EXTERIOR !== e.locate(t, n);
                }
            },
            {
                key: "locate",
                value: function value(t, n) {
                    return n.isEmpty() ? H.EXTERIOR : n.getEnvelopeInternal().intersects(t) ? e.locateInGeometry(t, n) : H.EXTERIOR;
                }
            }
        ]), e;
    }(), Vn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getNextCW",
                value: function value(t) {
                    this.getEdges();
                    var _$e = this._edgeList.indexOf(t), _$n = _$e - 1;
                    return 0 === _$e && (_$n = this._edgeList.size() - 1), this._edgeList.get(_$n);
                }
            },
            {
                key: "propagateSideLabels",
                value: function value(t) {
                    for(var _$e = H.NONE, _$n = this.iterator(); _$n.hasNext();){
                        var i = _$n.next().getLabel();
                        i.isArea(t) && i.getLocation(t, $.LEFT) !== H.NONE && (_$e = i.getLocation(t, $.LEFT));
                    }
                    if (_$e === H.NONE) return null;
                    for(var r = _$e, s = this.iterator(); s.hasNext();){
                        var a = s.next(), o = a.getLabel();
                        if (o.getLocation(t, $.ON) === H.NONE && o.setLocation(t, $.ON, r), o.isArea(t)) {
                            var _$u = o.getLocation(t, $.LEFT), l = o.getLocation(t, $.RIGHT);
                            if (l !== H.NONE) {
                                if (l !== r) throw new vt("side location conflict", a.getCoordinate());
                                _$u === H.NONE && G.shouldNeverReachHere("found single null side (at " + a.getCoordinate() + ")"), r = _$u;
                            } else G.isTrue(o.getLocation(t, $.LEFT) === H.NONE, "found single null side"), o.setLocation(t, $.RIGHT, r), o.setLocation(t, $.LEFT, r);
                        }
                    }
                }
            },
            {
                key: "getCoordinate",
                value: function value() {
                    var t = this.iterator();
                    return t.hasNext() ? t.next().getCoordinate() : null;
                }
            },
            {
                key: "print",
                value: function value(t) {
                    mt.out.println("EdgeEndStar:   " + this.getCoordinate());
                    for(var _$e = this.iterator(); _$e.hasNext();){
                        _$e.next().print(t);
                    }
                }
            },
            {
                key: "isAreaLabelsConsistent",
                value: function value(t) {
                    return this.computeEdgeEndLabels(t.getBoundaryNodeRule()), this.checkAreaLabelsConsistent(0);
                }
            },
            {
                key: "checkAreaLabelsConsistent",
                value: function value(t) {
                    var _$e = this.getEdges();
                    if (_$e.size() <= 0) return !0;
                    var _$n = _$e.size() - 1, i = _$e.get(_$n).getLabel().getLocation(t, $.LEFT);
                    G.isTrue(i !== H.NONE, "Found unlabelled area edge");
                    for(var r = i, s = this.iterator(); s.hasNext();){
                        var a = s.next().getLabel();
                        G.isTrue(a.isArea(t), "Found non-area edge");
                        var o = a.getLocation(t, $.LEFT), _$u = a.getLocation(t, $.RIGHT);
                        if (o === _$u) return !1;
                        if (_$u !== r) return !1;
                        r = o;
                    }
                    return !0;
                }
            },
            {
                key: "findIndex",
                value: function value(t) {
                    this.iterator();
                    for(var _$e = 0; _$e < this._edgeList.size(); _$e++){
                        if (this._edgeList.get(_$e) === t) return _$e;
                    }
                    return -1;
                }
            },
            {
                key: "iterator",
                value: function value() {
                    return this.getEdges().iterator();
                }
            },
            {
                key: "getEdges",
                value: function value() {
                    return null === this._edgeList && (this._edgeList = new yt(this._edgeMap.values())), this._edgeList;
                }
            },
            {
                key: "getLocation",
                value: function value(t, e, n) {
                    return this._ptInAreaLocation[t] === H.NONE && (this._ptInAreaLocation[t] = Un.locate(e, n[t].getGeometry())), this._ptInAreaLocation[t];
                }
            },
            {
                key: "toString",
                value: function value() {
                    var t = new st;
                    t.append("EdgeEndStar:   " + this.getCoordinate()), t.append("\n");
                    for(var _$e = this.iterator(); _$e.hasNext();){
                        var _$n = _$e.next();
                        t.append(_$n), t.append("\n");
                    }
                    return t.toString();
                }
            },
            {
                key: "computeEdgeEndLabels",
                value: function value(t) {
                    for(var _$e = this.iterator(); _$e.hasNext();){
                        _$e.next().computeLabel(t);
                    }
                }
            },
            {
                key: "computeLabelling",
                value: function value(t) {
                    this.computeEdgeEndLabels(t[0].getBoundaryNodeRule()), this.propagateSideLabels(0), this.propagateSideLabels(1);
                    for(var _$e = [
                        !1,
                        !1
                    ], _$n = this.iterator(); _$n.hasNext();)for(var i = _$n.next().getLabel(), r = 0; r < 2; r++)i.isLine(r) && i.getLocation(r) === H.BOUNDARY && (_$e[r] = !0);
                    for(var s = this.iterator(); s.hasNext();)for(var a = s.next(), o = a.getLabel(), _$u = 0; _$u < 2; _$u++)if (o.isAnyNull(_$u)) {
                        var l = H.NONE;
                        if (_$e[_$u]) l = H.EXTERIOR;
                        else {
                            var h = a.getCoordinate();
                            l = this.getLocation(_$u, h, t);
                        }
                        o.setAllLocationsIfNull(_$u, l);
                    }
                }
            },
            {
                key: "getDegree",
                value: function value() {
                    return this._edgeMap.size();
                }
            },
            {
                key: "insertEdgeEnd",
                value: function value(t, e) {
                    this._edgeMap.put(t, e), this._edgeList = null;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._edgeMap = new Ze, this._edgeList = null, this._ptInAreaLocation = [
                        H.NONE,
                        H.NONE
                    ];
                }
            }
        ]), e;
    }(), Hn = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "linkResultDirectedEdges",
                value: function value() {
                    this.getResultAreaEdges();
                    for(var t = null, _$e = null, _$n = this._SCANNING_FOR_INCOMING, _$i = 0; _$i < this._resultAreaEdgeList.size(); _$i++){
                        var r = this._resultAreaEdgeList.get(_$i), s = r.getSym();
                        if (r.getLabel().isArea()) switch(null === t && r.isInResult() && (t = r), _$n){
                            case this._SCANNING_FOR_INCOMING:
                                if (!s.isInResult()) continue;
                                _$e = s, _$n = this._LINKING_TO_OUTGOING;
                                break;
                            case this._LINKING_TO_OUTGOING:
                                if (!r.isInResult()) continue;
                                _$e.setNext(r), _$n = this._SCANNING_FOR_INCOMING;
                        }
                    }
                    if (_$n === this._LINKING_TO_OUTGOING) {
                        if (null === t) throw new vt("no outgoing dirEdge found", this.getCoordinate());
                        G.isTrue(t.isInResult(), "unable to link last incoming dirEdge"), _$e.setNext(t);
                    }
                }
            },
            {
                key: "insert",
                value: function value(t) {
                    var _$e = t;
                    this.insertEdgeEnd(_$e, _$e);
                }
            },
            {
                key: "getRightmostEdge",
                value: function value() {
                    var t = this.getEdges(), _$e = t.size();
                    if (_$e < 1) return null;
                    var _$n = t.get(0);
                    if (1 === _$e) return _$n;
                    var _$i = t.get(_$e - 1), r = _$n.getQuadrant(), s = _$i.getQuadrant();
                    return We.isNorthern(r) && We.isNorthern(s) ? _$n : We.isNorthern(r) || We.isNorthern(s) ? 0 !== _$n.getDy() ? _$n : 0 !== _$i.getDy() ? _$i : (G.shouldNeverReachHere("found two horizontal edges incident on node"), null) : _$i;
                }
            },
            {
                key: "print",
                value: function value(t) {
                    mt.out.println("DirectedEdgeStar: " + this.getCoordinate());
                    for(var _$e = this.iterator(); _$e.hasNext();){
                        var _$n = _$e.next();
                        t.print("out "), _$n.print(t), t.println(), t.print("in "), _$n.getSym().print(t), t.println();
                    }
                }
            },
            {
                key: "getResultAreaEdges",
                value: function value() {
                    if (null !== this._resultAreaEdgeList) return this._resultAreaEdgeList;
                    this._resultAreaEdgeList = new yt;
                    for(var t = this.iterator(); t.hasNext();){
                        var _$e = t.next();
                        (_$e.isInResult() || _$e.getSym().isInResult()) && this._resultAreaEdgeList.add(_$e);
                    }
                    return this._resultAreaEdgeList;
                }
            },
            {
                key: "updateLabelling",
                value: function value(t) {
                    for(var _$e = this.iterator(); _$e.hasNext();){
                        var _$n = _$e.next().getLabel();
                        _$n.setAllLocationsIfNull(0, t.getLocation(0)), _$n.setAllLocationsIfNull(1, t.getLocation(1));
                    }
                }
            },
            {
                key: "linkAllDirectedEdges",
                value: function value() {
                    this.getEdges();
                    for(var t = null, _$e = null, _$n = this._edgeList.size() - 1; _$n >= 0; _$n--){
                        var _$i = this._edgeList.get(_$n), r = _$i.getSym();
                        null === _$e && (_$e = r), null !== t && r.setNext(t), t = _$i;
                    }
                    _$e.setNext(t);
                }
            },
            {
                key: "computeDepths",
                value: function value() {
                    if (1 === arguments.length) {
                        var t = arguments[0], _$e = this.findIndex(t), _$n = t.getDepth($.LEFT), _$i = t.getDepth($.RIGHT), r = this.computeDepths(_$e + 1, this._edgeList.size(), _$n), s = this.computeDepths(0, _$e, r);
                        if (s !== _$i) throw new vt("depth mismatch at " + t.getCoordinate());
                    } else if (3 === arguments.length) {
                        for(var _$a = arguments[0], o = arguments[1], _$u = arguments[2], l = _$u, h = _$a; h < o; h++){
                            var _$c = this._edgeList.get(h);
                            _$c.setEdgeDepths($.RIGHT, l), l = _$c.getDepth($.LEFT);
                        }
                        return l;
                    }
                }
            },
            {
                key: "mergeSymLabels",
                value: function value() {
                    for(var t = this.iterator(); t.hasNext();){
                        var _$e = t.next();
                        _$e.getLabel().merge(_$e.getSym().getLabel());
                    }
                }
            },
            {
                key: "linkMinimalDirectedEdges",
                value: function value(t) {
                    for(var _$e = null, _$n = null, _$i = this._SCANNING_FOR_INCOMING, r = this._resultAreaEdgeList.size() - 1; r >= 0; r--){
                        var s = this._resultAreaEdgeList.get(r), _$a = s.getSym();
                        switch(null === _$e && s.getEdgeRing() === t && (_$e = s), _$i){
                            case this._SCANNING_FOR_INCOMING:
                                if (_$a.getEdgeRing() !== t) continue;
                                _$n = _$a, _$i = this._LINKING_TO_OUTGOING;
                                break;
                            case this._LINKING_TO_OUTGOING:
                                if (s.getEdgeRing() !== t) continue;
                                _$n.setNextMin(s), _$i = this._SCANNING_FOR_INCOMING;
                        }
                    }
                    _$i === this._LINKING_TO_OUTGOING && (G.isTrue(null !== _$e, "found null for first outgoing dirEdge"), G.isTrue(_$e.getEdgeRing() === t, "unable to link last incoming dirEdge"), _$n.setNextMin(_$e));
                }
            },
            {
                key: "getOutgoingDegree",
                value: function value() {
                    if (0 === arguments.length) {
                        for(var t = 0, _$e = this.iterator(); _$e.hasNext();){
                            var _$n = _$e.next();
                            _$n.isInResult() && t++;
                        }
                        return t;
                    }
                    if (1 === arguments.length) {
                        for(var _$i = arguments[0], r = 0, s = this.iterator(); s.hasNext();){
                            var _$a = s.next();
                            _$a.getEdgeRing() === _$i && r++;
                        }
                        return r;
                    }
                }
            },
            {
                key: "getLabel",
                value: function value() {
                    return this._label;
                }
            },
            {
                key: "findCoveredLineEdges",
                value: function value() {
                    for(var t = H.NONE, _$e = this.iterator(); _$e.hasNext();){
                        var _$n = _$e.next(), _$i = _$n.getSym();
                        if (!_$n.isLineEdge()) {
                            if (_$n.isInResult()) {
                                t = H.INTERIOR;
                                break;
                            }
                            if (_$i.isInResult()) {
                                t = H.EXTERIOR;
                                break;
                            }
                        }
                    }
                    if (t === H.NONE) return null;
                    for(var r = t, s = this.iterator(); s.hasNext();){
                        var _$a = s.next(), o = _$a.getSym();
                        _$a.isLineEdge() ? _$a.getEdge().setCovered(r === H.INTERIOR) : (_$a.isInResult() && (r = H.EXTERIOR), o.isInResult() && (r = H.INTERIOR));
                    }
                }
            },
            {
                key: "computeLabelling",
                value: function value(t) {
                    f(r(a.prototype), "computeLabelling", this).call(this, t), this._label = new Pe(H.NONE);
                    for(var _$e = this.iterator(); _$e.hasNext();)for(var _$n = _$e.next().getEdge().getLabel(), _$i = 0; _$i < 2; _$i++){
                        var s = _$n.getLocation(_$i);
                        s !== H.INTERIOR && s !== H.BOUNDARY || this._label.setLocation(_$i, H.INTERIOR);
                    }
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._resultAreaEdgeList = null, this._label = null, this._SCANNING_FOR_INCOMING = 1, this._LINKING_TO_OUTGOING = 2;
                }
            }
        ]), a;
    }(Vn), Zn = function(e) {
        i(s, e);
        var r = c(s);
        function s() {
            return t(this, s), r.call(this);
        }
        return n(s, [
            {
                key: "createNode",
                value: function value(t) {
                    return new Ye(t, new Hn);
                }
            }
        ]), s;
    }(Qe), jn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "compareTo",
                value: function value(t) {
                    var _$n = t;
                    return e.compareOriented(this._pts, this._orientation, _$n._pts, _$n._orientation);
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        x
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._pts = null, this._orientation = null;
                    var t = arguments[0];
                    this._pts = t, this._orientation = e.orientation(t);
                }
            },
            {
                key: "orientation",
                value: function value(t) {
                    return 1 === jt.increasingDirection(t);
                }
            },
            {
                key: "compareOriented",
                value: function value(t, e, n, i) {
                    for(var r = e ? 1 : -1, s = i ? 1 : -1, a = e ? t.length : -1, o = i ? n.length : -1, _$u = e ? 0 : t.length - 1, l = i ? 0 : n.length - 1;;){
                        var h = t[_$u].compareTo(n[l]);
                        if (0 !== h) return h;
                        var c = (_$u += r) === a, f = (l += s) === o;
                        if (c && !f) return -1;
                        if (!c && f) return 1;
                        if (c && f) return 0;
                    }
                }
            }
        ]), e;
    }(), Wn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "print",
                value: function value(t) {
                    t.print("MULTILINESTRING ( ");
                    for(var _$e = 0; _$e < this._edges.size(); _$e++){
                        var _$n = this._edges.get(_$e);
                        _$e > 0 && t.print(","), t.print("(");
                        for(var i = _$n.getCoordinates(), r = 0; r < i.length; r++)r > 0 && t.print(","), t.print(i[r].x + " " + i[r].y);
                        t.println(")");
                    }
                    t.print(")  ");
                }
            },
            {
                key: "addAll",
                value: function value(t) {
                    for(var _$e = t.iterator(); _$e.hasNext();)this.add(_$e.next());
                }
            },
            {
                key: "findEdgeIndex",
                value: function value(t) {
                    for(var _$e = 0; _$e < this._edges.size(); _$e++)if (this._edges.get(_$e).equals(t)) return _$e;
                    return -1;
                }
            },
            {
                key: "iterator",
                value: function value() {
                    return this._edges.iterator();
                }
            },
            {
                key: "getEdges",
                value: function value() {
                    return this._edges;
                }
            },
            {
                key: "get",
                value: function value(t) {
                    return this._edges.get(t);
                }
            },
            {
                key: "findEqualEdge",
                value: function value(t) {
                    var _$e = new jn(t.getCoordinates());
                    return this._ocaMap.get(_$e);
                }
            },
            {
                key: "add",
                value: function value(t) {
                    this._edges.add(t);
                    var _$e = new jn(t.getCoordinates());
                    this._ocaMap.put(_$e, t);
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._edges = new yt, this._ocaMap = new Ze;
                }
            }
        ]), e;
    }(), Kn = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "processIntersections",
                value: function value(t, e, n, i) {}
            },
            {
                key: "isDone",
                value: function value() {}
            }
        ]), e;
    }(), Jn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "isTrivialIntersection",
                value: function value(t, n, i, r) {
                    if (t === i && 1 === this._li.getIntersectionNum()) {
                        if (e.isAdjacentSegments(n, r)) return !0;
                        if (t.isClosed()) {
                            var s = t.size() - 1;
                            if (0 === n && r === s || 0 === r && n === s) return !0;
                        }
                    }
                    return !1;
                }
            },
            {
                key: "getProperIntersectionPoint",
                value: function value() {
                    return this._properIntersectionPoint;
                }
            },
            {
                key: "hasProperInteriorIntersection",
                value: function value() {
                    return this._hasProperInterior;
                }
            },
            {
                key: "getLineIntersector",
                value: function value() {
                    return this._li;
                }
            },
            {
                key: "hasProperIntersection",
                value: function value() {
                    return this._hasProper;
                }
            },
            {
                key: "processIntersections",
                value: function value(t, e, n, i) {
                    if (t === n && e === i) return null;
                    this.numTests++;
                    var r = t.getCoordinates()[e], s = t.getCoordinates()[e + 1], a = n.getCoordinates()[i], o = n.getCoordinates()[i + 1];
                    this._li.computeIntersection(r, s, a, o), this._li.hasIntersection() && (this.numIntersections++, this._li.isInteriorIntersection() && (this.numInteriorIntersections++, this._hasInterior = !0), this.isTrivialIntersection(t, e, n, i) || (this._hasIntersection = !0, t.addIntersections(this._li, e, 0), n.addIntersections(this._li, i, 1), this._li.isProper() && (this.numProperIntersections++, this._hasProper = !0, this._hasProperInterior = !0)));
                }
            },
            {
                key: "hasIntersection",
                value: function value() {
                    return this._hasIntersection;
                }
            },
            {
                key: "isDone",
                value: function value() {
                    return !1;
                }
            },
            {
                key: "hasInteriorIntersection",
                value: function value() {
                    return this._hasInterior;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        Kn
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._hasIntersection = !1, this._hasProper = !1, this._hasProperInterior = !1, this._hasInterior = !1, this._properIntersectionPoint = null, this._li = null, this._isSelfIntersection = null, this.numIntersections = 0, this.numInteriorIntersections = 0, this.numProperIntersections = 0, this.numTests = 0;
                    var t = arguments[0];
                    this._li = t;
                }
            },
            {
                key: "isAdjacentSegments",
                value: function value(t, e) {
                    return 1 === Math.abs(t - e);
                }
            }
        ]), e;
    }(), Qn = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getSegmentIndex",
                value: function value() {
                    return this.segmentIndex;
                }
            },
            {
                key: "getCoordinate",
                value: function value() {
                    return this.coord;
                }
            },
            {
                key: "print",
                value: function value(t) {
                    t.print(this.coord), t.print(" seg # = " + this.segmentIndex), t.println(" dist = " + this.dist);
                }
            },
            {
                key: "compareTo",
                value: function value(t) {
                    var _$e = t;
                    return this.compare(_$e.segmentIndex, _$e.dist);
                }
            },
            {
                key: "isEndPoint",
                value: function value(t) {
                    return 0 === this.segmentIndex && 0 === this.dist || this.segmentIndex === t;
                }
            },
            {
                key: "toString",
                value: function value() {
                    return this.coord + " seg # = " + this.segmentIndex + " dist = " + this.dist;
                }
            },
            {
                key: "getDistance",
                value: function value() {
                    return this.dist;
                }
            },
            {
                key: "compare",
                value: function value(t, e) {
                    return this.segmentIndex < t ? -1 : this.segmentIndex > t ? 1 : this.dist < e ? -1 : this.dist > e ? 1 : 0;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        x
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this.coord = null, this.segmentIndex = null, this.dist = null;
                    var t = arguments[0], _$e = arguments[1], _$n = arguments[2];
                    this.coord = new X(t), this.segmentIndex = _$e, this.dist = _$n;
                }
            }
        ]), e;
    }(), $n = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "print",
                value: function value(t) {
                    t.println("Intersections:");
                    for(var _$e = this.iterator(); _$e.hasNext();){
                        _$e.next().print(t);
                    }
                }
            },
            {
                key: "iterator",
                value: function value() {
                    return this._nodeMap.values().iterator();
                }
            },
            {
                key: "addSplitEdges",
                value: function value(t) {
                    this.addEndpoints();
                    for(var _$e = this.iterator(), _$n = _$e.next(); _$e.hasNext();){
                        var i = _$e.next(), r = this.createSplitEdge(_$n, i);
                        t.add(r), _$n = i;
                    }
                }
            },
            {
                key: "addEndpoints",
                value: function value() {
                    var t = this.edge.pts.length - 1;
                    this.add(this.edge.pts[0], 0, 0), this.add(this.edge.pts[t], t, 0);
                }
            },
            {
                key: "createSplitEdge",
                value: function value(t, e) {
                    var _$n = e.segmentIndex - t.segmentIndex + 2, i = this.edge.pts[e.segmentIndex], r = e.dist > 0 || !e.coord.equals2D(i);
                    r || _$n--;
                    var s = new Array(_$n).fill(null), a = 0;
                    s[a++] = new X(t.coord);
                    for(var o = t.segmentIndex + 1; o <= e.segmentIndex; o++)s[a++] = this.edge.pts[o];
                    return r && (s[a] = e.coord), new si(s, new Pe(this.edge._label));
                }
            },
            {
                key: "add",
                value: function value(t, e, n) {
                    var i = new Qn(t, e, n), r = this._nodeMap.get(i);
                    return null !== r ? r : (this._nodeMap.put(i, i), i);
                }
            },
            {
                key: "isIntersection",
                value: function value(t) {
                    for(var _$e = this.iterator(); _$e.hasNext();){
                        if (_$e.next().coord.equals(t)) return !0;
                    }
                    return !1;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._nodeMap = new Ze, this.edge = null;
                    var t = arguments[0];
                    this.edge = t;
                }
            }
        ]), e;
    }(), ti = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "isIntersects",
                value: function value() {
                    return !this.isDisjoint();
                }
            },
            {
                key: "isCovers",
                value: function value() {
                    return (e.isTrue(this._matrix[H.INTERIOR][H.INTERIOR]) || e.isTrue(this._matrix[H.INTERIOR][H.BOUNDARY]) || e.isTrue(this._matrix[H.BOUNDARY][H.INTERIOR]) || e.isTrue(this._matrix[H.BOUNDARY][H.BOUNDARY])) && this._matrix[H.EXTERIOR][H.INTERIOR] === Lt.FALSE && this._matrix[H.EXTERIOR][H.BOUNDARY] === Lt.FALSE;
                }
            },
            {
                key: "isCoveredBy",
                value: function value() {
                    return (e.isTrue(this._matrix[H.INTERIOR][H.INTERIOR]) || e.isTrue(this._matrix[H.INTERIOR][H.BOUNDARY]) || e.isTrue(this._matrix[H.BOUNDARY][H.INTERIOR]) || e.isTrue(this._matrix[H.BOUNDARY][H.BOUNDARY])) && this._matrix[H.INTERIOR][H.EXTERIOR] === Lt.FALSE && this._matrix[H.BOUNDARY][H.EXTERIOR] === Lt.FALSE;
                }
            },
            {
                key: "set",
                value: function value() {
                    if (1 === arguments.length) for(var t = arguments[0], _$e = 0; _$e < t.length; _$e++){
                        var _$n = Math.trunc(_$e / 3), i = _$e % 3;
                        this._matrix[_$n][i] = Lt.toDimensionValue(t.charAt(_$e));
                    }
                    else if (3 === arguments.length) {
                        var r = arguments[0], s = arguments[1], a = arguments[2];
                        this._matrix[r][s] = a;
                    }
                }
            },
            {
                key: "isContains",
                value: function value() {
                    return e.isTrue(this._matrix[H.INTERIOR][H.INTERIOR]) && this._matrix[H.EXTERIOR][H.INTERIOR] === Lt.FALSE && this._matrix[H.EXTERIOR][H.BOUNDARY] === Lt.FALSE;
                }
            },
            {
                key: "setAtLeast",
                value: function value() {
                    if (1 === arguments.length) for(var t = arguments[0], _$e = 0; _$e < t.length; _$e++){
                        var _$n = Math.trunc(_$e / 3), i = _$e % 3;
                        this.setAtLeast(_$n, i, Lt.toDimensionValue(t.charAt(_$e)));
                    }
                    else if (3 === arguments.length) {
                        var r = arguments[0], s = arguments[1], a = arguments[2];
                        this._matrix[r][s] < a && (this._matrix[r][s] = a);
                    }
                }
            },
            {
                key: "setAtLeastIfValid",
                value: function value(t, e, n) {
                    t >= 0 && e >= 0 && this.setAtLeast(t, e, n);
                }
            },
            {
                key: "isWithin",
                value: function value() {
                    return e.isTrue(this._matrix[H.INTERIOR][H.INTERIOR]) && this._matrix[H.INTERIOR][H.EXTERIOR] === Lt.FALSE && this._matrix[H.BOUNDARY][H.EXTERIOR] === Lt.FALSE;
                }
            },
            {
                key: "isTouches",
                value: function value(t, n) {
                    return t > n ? this.isTouches(n, t) : (t === Lt.A && n === Lt.A || t === Lt.L && n === Lt.L || t === Lt.L && n === Lt.A || t === Lt.P && n === Lt.A || t === Lt.P && n === Lt.L) && this._matrix[H.INTERIOR][H.INTERIOR] === Lt.FALSE && (e.isTrue(this._matrix[H.INTERIOR][H.BOUNDARY]) || e.isTrue(this._matrix[H.BOUNDARY][H.INTERIOR]) || e.isTrue(this._matrix[H.BOUNDARY][H.BOUNDARY]));
                }
            },
            {
                key: "isOverlaps",
                value: function value(t, n) {
                    return t === Lt.P && n === Lt.P || t === Lt.A && n === Lt.A ? e.isTrue(this._matrix[H.INTERIOR][H.INTERIOR]) && e.isTrue(this._matrix[H.INTERIOR][H.EXTERIOR]) && e.isTrue(this._matrix[H.EXTERIOR][H.INTERIOR]) : t === Lt.L && n === Lt.L && 1 === this._matrix[H.INTERIOR][H.INTERIOR] && e.isTrue(this._matrix[H.INTERIOR][H.EXTERIOR]) && e.isTrue(this._matrix[H.EXTERIOR][H.INTERIOR]);
                }
            },
            {
                key: "isEquals",
                value: function value(t, n) {
                    return t === n && e.isTrue(this._matrix[H.INTERIOR][H.INTERIOR]) && this._matrix[H.INTERIOR][H.EXTERIOR] === Lt.FALSE && this._matrix[H.BOUNDARY][H.EXTERIOR] === Lt.FALSE && this._matrix[H.EXTERIOR][H.INTERIOR] === Lt.FALSE && this._matrix[H.EXTERIOR][H.BOUNDARY] === Lt.FALSE;
                }
            },
            {
                key: "toString",
                value: function value() {
                    for(var t = new Jt("123456789"), _$e = 0; _$e < 3; _$e++)for(var _$n = 0; _$n < 3; _$n++)t.setCharAt(3 * _$e + _$n, Lt.toDimensionSymbol(this._matrix[_$e][_$n]));
                    return t.toString();
                }
            },
            {
                key: "setAll",
                value: function value(t) {
                    for(var _$e = 0; _$e < 3; _$e++)for(var _$n = 0; _$n < 3; _$n++)this._matrix[_$e][_$n] = t;
                }
            },
            {
                key: "get",
                value: function value(t, e) {
                    return this._matrix[t][e];
                }
            },
            {
                key: "transpose",
                value: function value() {
                    var t = this._matrix[1][0];
                    return this._matrix[1][0] = this._matrix[0][1], this._matrix[0][1] = t, t = this._matrix[2][0], this._matrix[2][0] = this._matrix[0][2], this._matrix[0][2] = t, t = this._matrix[2][1], this._matrix[2][1] = this._matrix[1][2], this._matrix[1][2] = t, this;
                }
            },
            {
                key: "matches",
                value: function value(t) {
                    if (9 !== t.length) throw new m("Should be length 9: " + t);
                    for(var _$n = 0; _$n < 3; _$n++)for(var i = 0; i < 3; i++)if (!e.matches(this._matrix[_$n][i], t.charAt(3 * _$n + i))) return !1;
                    return !0;
                }
            },
            {
                key: "add",
                value: function value(t) {
                    for(var _$e = 0; _$e < 3; _$e++)for(var _$n = 0; _$n < 3; _$n++)this.setAtLeast(_$e, _$n, t.get(_$e, _$n));
                }
            },
            {
                key: "isDisjoint",
                value: function value() {
                    return this._matrix[H.INTERIOR][H.INTERIOR] === Lt.FALSE && this._matrix[H.INTERIOR][H.BOUNDARY] === Lt.FALSE && this._matrix[H.BOUNDARY][H.INTERIOR] === Lt.FALSE && this._matrix[H.BOUNDARY][H.BOUNDARY] === Lt.FALSE;
                }
            },
            {
                key: "isCrosses",
                value: function value(t, n) {
                    return t === Lt.P && n === Lt.L || t === Lt.P && n === Lt.A || t === Lt.L && n === Lt.A ? e.isTrue(this._matrix[H.INTERIOR][H.INTERIOR]) && e.isTrue(this._matrix[H.INTERIOR][H.EXTERIOR]) : t === Lt.L && n === Lt.P || t === Lt.A && n === Lt.P || t === Lt.A && n === Lt.L ? e.isTrue(this._matrix[H.INTERIOR][H.INTERIOR]) && e.isTrue(this._matrix[H.EXTERIOR][H.INTERIOR]) : t === Lt.L && n === Lt.L && 0 === this._matrix[H.INTERIOR][H.INTERIOR];
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        I
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._matrix = null, 0 === arguments.length) this._matrix = Array(3).fill().map(function() {
                        return Array(3);
                    }), this.setAll(Lt.FALSE);
                    else if (1 === arguments.length) {
                        if ("string" == typeof arguments[0]) {
                            var t = arguments[0];
                            e.constructor_.call(this), this.set(t);
                        } else if (_instanceof(arguments[0], e)) {
                            var _$n = arguments[0];
                            e.constructor_.call(this), this._matrix[H.INTERIOR][H.INTERIOR] = _$n._matrix[H.INTERIOR][H.INTERIOR], this._matrix[H.INTERIOR][H.BOUNDARY] = _$n._matrix[H.INTERIOR][H.BOUNDARY], this._matrix[H.INTERIOR][H.EXTERIOR] = _$n._matrix[H.INTERIOR][H.EXTERIOR], this._matrix[H.BOUNDARY][H.INTERIOR] = _$n._matrix[H.BOUNDARY][H.INTERIOR], this._matrix[H.BOUNDARY][H.BOUNDARY] = _$n._matrix[H.BOUNDARY][H.BOUNDARY], this._matrix[H.BOUNDARY][H.EXTERIOR] = _$n._matrix[H.BOUNDARY][H.EXTERIOR], this._matrix[H.EXTERIOR][H.INTERIOR] = _$n._matrix[H.EXTERIOR][H.INTERIOR], this._matrix[H.EXTERIOR][H.BOUNDARY] = _$n._matrix[H.EXTERIOR][H.BOUNDARY], this._matrix[H.EXTERIOR][H.EXTERIOR] = _$n._matrix[H.EXTERIOR][H.EXTERIOR];
                        }
                    }
                }
            },
            {
                key: "matches",
                value: function value() {
                    if (Number.isInteger(arguments[0]) && "string" == typeof arguments[1]) {
                        var t = arguments[0], _$n = arguments[1];
                        return _$n === Lt.SYM_DONTCARE || _$n === Lt.SYM_TRUE && (t >= 0 || t === Lt.TRUE) || _$n === Lt.SYM_FALSE && t === Lt.FALSE || _$n === Lt.SYM_P && t === Lt.P || _$n === Lt.SYM_L && t === Lt.L || _$n === Lt.SYM_A && t === Lt.A;
                    }
                    if ("string" == typeof arguments[0] && "string" == typeof arguments[1]) {
                        var i = arguments[0], r = arguments[1], s = new e(i);
                        return s.matches(r);
                    }
                }
            },
            {
                key: "isTrue",
                value: function value(t) {
                    return t >= 0 || t === Lt.TRUE;
                }
            }
        ]), e;
    }(), ei = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "size",
                value: function value() {
                    return this._size;
                }
            },
            {
                key: "addAll",
                value: function value(t) {
                    return null === t || 0 === t.length ? null : (this.ensureCapacity(this._size + t.length), mt.arraycopy(t, 0, this._data, this._size, t.length), void (this._size += t.length));
                }
            },
            {
                key: "ensureCapacity",
                value: function value(t) {
                    if (t <= this._data.length) return null;
                    var _$e = Math.max(t, 2 * this._data.length);
                    this._data = At.copyOf(this._data, _$e);
                }
            },
            {
                key: "toArray",
                value: function value() {
                    var t = new Array(this._size).fill(null);
                    return mt.arraycopy(this._data, 0, t, 0, this._size), t;
                }
            },
            {
                key: "add",
                value: function value(t) {
                    this.ensureCapacity(this._size + 1), this._data[this._size] = t, ++this._size;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._data = null, this._size = 0, 0 === arguments.length) e.constructor_.call(this, 10);
                    else if (1 === arguments.length) {
                        var t = arguments[0];
                        this._data = new Array(t).fill(null);
                    }
                }
            }
        ]), e;
    }(), ni = function() {
        function e() {
            t(this, e);
        }
        return n(e, [
            {
                key: "getChainStartIndices",
                value: function value(t) {
                    var _$e = 0, _$n = new ei(Math.trunc(t.length / 2));
                    _$n.add(_$e);
                    do {
                        var i = this.findChainEnd(t, _$e);
                        _$n.add(i), _$e = i;
                    }while (_$e < t.length - 1);
                    return _$n.toArray();
                }
            },
            {
                key: "findChainEnd",
                value: function value(t, e) {
                    for(var _$n = We.quadrant(t[e], t[e + 1]), i = e + 1; i < t.length;){
                        if (We.quadrant(t[i - 1], t[i]) !== _$n) break;
                        i++;
                    }
                    return i - 1;
                }
            },
            {
                key: "OLDgetChainStartIndices",
                value: function value(t) {
                    var _$n = 0, i = new yt;
                    i.add(_$n);
                    do {
                        var r = this.findChainEnd(t, _$n);
                        i.add(r), _$n = r;
                    }while (_$n < t.length - 1);
                    return e.toIntArray(i);
                }
            }
        ], [
            {
                key: "toIntArray",
                value: function value(t) {
                    for(var _$e = new Array(t.size()).fill(null), _$n = 0; _$n < _$e.length; _$n++)_$e[_$n] = t.get(_$n).intValue();
                    return _$e;
                }
            }
        ]), e;
    }(), ii = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getCoordinates",
                value: function value() {
                    return this.pts;
                }
            },
            {
                key: "getMaxX",
                value: function value(t) {
                    var _$e = this.pts[this.startIndex[t]].x, _$n = this.pts[this.startIndex[t + 1]].x;
                    return _$e > _$n ? _$e : _$n;
                }
            },
            {
                key: "getMinX",
                value: function value(t) {
                    var _$e = this.pts[this.startIndex[t]].x, _$n = this.pts[this.startIndex[t + 1]].x;
                    return _$e < _$n ? _$e : _$n;
                }
            },
            {
                key: "computeIntersectsForChain",
                value: function value() {
                    if (4 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1], _$n = arguments[2], i = arguments[3];
                        this.computeIntersectsForChain(this.startIndex[t], this.startIndex[t + 1], _$e, _$e.startIndex[_$n], _$e.startIndex[_$n + 1], i);
                    } else if (6 === arguments.length) {
                        var r = arguments[0], s = arguments[1], a = arguments[2], o = arguments[3], _$u = arguments[4], l = arguments[5];
                        if (s - r == 1 && _$u - o == 1) return l.addIntersections(this.e, r, a.e, o), null;
                        if (!this.overlaps(r, s, a, o, _$u)) return null;
                        var h = Math.trunc((r + s) / 2), c = Math.trunc((o + _$u) / 2);
                        r < h && (o < c && this.computeIntersectsForChain(r, h, a, o, c, l), c < _$u && this.computeIntersectsForChain(r, h, a, c, _$u, l)), h < s && (o < c && this.computeIntersectsForChain(h, s, a, o, c, l), c < _$u && this.computeIntersectsForChain(h, s, a, c, _$u, l));
                    }
                }
            },
            {
                key: "overlaps",
                value: function value(t, e, n, i, r) {
                    return U.intersects(this.pts[t], this.pts[e], n.pts[i], n.pts[r]);
                }
            },
            {
                key: "getStartIndexes",
                value: function value() {
                    return this.startIndex;
                }
            },
            {
                key: "computeIntersects",
                value: function value(t, e) {
                    for(var _$n = 0; _$n < this.startIndex.length - 1; _$n++)for(var i = 0; i < t.startIndex.length - 1; i++)this.computeIntersectsForChain(_$n, t, i, e);
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this.e = null, this.pts = null, this.startIndex = null;
                    var t = arguments[0];
                    this.e = t, this.pts = t.getCoordinates();
                    var _$e = new ni;
                    this.startIndex = _$e.getChainStartIndices(this.pts);
                }
            }
        ]), e;
    }(), ri = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "getDepth",
                value: function value(t, e) {
                    return this._depth[t][e];
                }
            },
            {
                key: "setDepth",
                value: function value(t, e, n) {
                    this._depth[t][e] = n;
                }
            },
            {
                key: "isNull",
                value: function value() {
                    if (0 === arguments.length) {
                        for(var t = 0; t < 2; t++)for(var _$n = 0; _$n < 3; _$n++)if (this._depth[t][_$n] !== e.NULL_VALUE) return !1;
                        return !0;
                    }
                    if (1 === arguments.length) {
                        var i = arguments[0];
                        return this._depth[i][1] === e.NULL_VALUE;
                    }
                    if (2 === arguments.length) {
                        var r = arguments[0], s = arguments[1];
                        return this._depth[r][s] === e.NULL_VALUE;
                    }
                }
            },
            {
                key: "normalize",
                value: function value() {
                    for(var t = 0; t < 2; t++)if (!this.isNull(t)) {
                        var _$e = this._depth[t][1];
                        this._depth[t][2] < _$e && (_$e = this._depth[t][2]), _$e < 0 && (_$e = 0);
                        for(var _$n = 1; _$n < 3; _$n++){
                            var i = 0;
                            this._depth[t][_$n] > _$e && (i = 1), this._depth[t][_$n] = i;
                        }
                    }
                }
            },
            {
                key: "getDelta",
                value: function value(t) {
                    return this._depth[t][$.RIGHT] - this._depth[t][$.LEFT];
                }
            },
            {
                key: "getLocation",
                value: function value(t, e) {
                    return this._depth[t][e] <= 0 ? H.EXTERIOR : H.INTERIOR;
                }
            },
            {
                key: "toString",
                value: function value() {
                    return "A: " + this._depth[0][1] + "," + this._depth[0][2] + " B: " + this._depth[1][1] + "," + this._depth[1][2];
                }
            },
            {
                key: "add",
                value: function value() {
                    if (1 === arguments.length) for(var t = arguments[0], _$n = 0; _$n < 2; _$n++)for(var i = 1; i < 3; i++){
                        var r = t.getLocation(_$n, i);
                        r !== H.EXTERIOR && r !== H.INTERIOR || (this.isNull(_$n, i) ? this._depth[_$n][i] = e.depthAtLocation(r) : this._depth[_$n][i] += e.depthAtLocation(r));
                    }
                    else if (3 === arguments.length) {
                        var s = arguments[0], a = arguments[1], o = arguments[2];
                        o === H.INTERIOR && this._depth[s][a]++;
                    }
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._depth = Array(2).fill().map(function() {
                        return Array(3);
                    });
                    for(var t = 0; t < 2; t++)for(var _$n = 0; _$n < 3; _$n++)this._depth[t][_$n] = e.NULL_VALUE;
                }
            },
            {
                key: "depthAtLocation",
                value: function value(t) {
                    return t === H.EXTERIOR ? 0 : t === H.INTERIOR ? 1 : e.NULL_VALUE;
                }
            }
        ]), e;
    }();
    ri.NULL_VALUE = -1;
    var si = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "getDepth",
                value: function value() {
                    return this._depth;
                }
            },
            {
                key: "getCollapsedEdge",
                value: function value() {
                    var t = new Array(2).fill(null);
                    return t[0] = this.pts[0], t[1] = this.pts[1], new a(t, Pe.toLineLabel(this._label));
                }
            },
            {
                key: "isIsolated",
                value: function value() {
                    return this._isIsolated;
                }
            },
            {
                key: "getCoordinates",
                value: function value() {
                    return this.pts;
                }
            },
            {
                key: "setIsolated",
                value: function value(t) {
                    this._isIsolated = t;
                }
            },
            {
                key: "setName",
                value: function value(t) {
                    this._name = t;
                }
            },
            {
                key: "equals",
                value: function value(t) {
                    if (!_instanceof(t, a)) return !1;
                    var _$e = t;
                    if (this.pts.length !== _$e.pts.length) return !1;
                    for(var _$n = !0, _$i = !0, r = this.pts.length, s = 0; s < this.pts.length; s++)if (this.pts[s].equals2D(_$e.pts[s]) || (_$n = !1), this.pts[s].equals2D(_$e.pts[--r]) || (_$i = !1), !_$n && !_$i) return !1;
                    return !0;
                }
            },
            {
                key: "getCoordinate",
                value: function value() {
                    if (0 === arguments.length) return this.pts.length > 0 ? this.pts[0] : null;
                    if (1 === arguments.length) {
                        var t = arguments[0];
                        return this.pts[t];
                    }
                }
            },
            {
                key: "print",
                value: function value(t) {
                    t.print("edge " + this._name + ": "), t.print("LINESTRING (");
                    for(var _$e = 0; _$e < this.pts.length; _$e++)_$e > 0 && t.print(","), t.print(this.pts[_$e].x + " " + this.pts[_$e].y);
                    t.print(")  " + this._label + " " + this._depthDelta);
                }
            },
            {
                key: "computeIM",
                value: function value(t) {
                    a.updateIM(this._label, t);
                }
            },
            {
                key: "isCollapsed",
                value: function value() {
                    return !!this._label.isArea() && 3 === this.pts.length && !!this.pts[0].equals(this.pts[2]);
                }
            },
            {
                key: "isClosed",
                value: function value() {
                    return this.pts[0].equals(this.pts[this.pts.length - 1]);
                }
            },
            {
                key: "getMaximumSegmentIndex",
                value: function value() {
                    return this.pts.length - 1;
                }
            },
            {
                key: "getDepthDelta",
                value: function value() {
                    return this._depthDelta;
                }
            },
            {
                key: "getNumPoints",
                value: function value() {
                    return this.pts.length;
                }
            },
            {
                key: "printReverse",
                value: function value(t) {
                    t.print("edge " + this._name + ": ");
                    for(var _$e = this.pts.length - 1; _$e >= 0; _$e--)t.print(this.pts[_$e] + " ");
                    t.println("");
                }
            },
            {
                key: "getMonotoneChainEdge",
                value: function value() {
                    return null === this._mce && (this._mce = new ii(this)), this._mce;
                }
            },
            {
                key: "getEnvelope",
                value: function value() {
                    if (null === this._env) {
                        this._env = new U;
                        for(var t = 0; t < this.pts.length; t++)this._env.expandToInclude(this.pts[t]);
                    }
                    return this._env;
                }
            },
            {
                key: "addIntersection",
                value: function value(t, e, n, i) {
                    var r = new X(t.getIntersection(i)), s = e, _$a = t.getEdgeDistance(n, i), o = s + 1;
                    if (o < this.pts.length) {
                        var _$u = this.pts[o];
                        r.equals2D(_$u) && (s = o, _$a = 0);
                    }
                    this.eiList.add(r, s, _$a);
                }
            },
            {
                key: "toString",
                value: function value() {
                    var t = new Jt;
                    t.append("edge " + this._name + ": "), t.append("LINESTRING (");
                    for(var _$e = 0; _$e < this.pts.length; _$e++)_$e > 0 && t.append(","), t.append(this.pts[_$e].x + " " + this.pts[_$e].y);
                    return t.append(")  " + this._label + " " + this._depthDelta), t.toString();
                }
            },
            {
                key: "isPointwiseEqual",
                value: function value(t) {
                    if (this.pts.length !== t.pts.length) return !1;
                    for(var _$e = 0; _$e < this.pts.length; _$e++)if (!this.pts[_$e].equals2D(t.pts[_$e])) return !1;
                    return !0;
                }
            },
            {
                key: "setDepthDelta",
                value: function value(t) {
                    this._depthDelta = t;
                }
            },
            {
                key: "getEdgeIntersectionList",
                value: function value() {
                    return this.eiList;
                }
            },
            {
                key: "addIntersections",
                value: function value(t, e, n) {
                    for(var _$i = 0; _$i < t.getIntersectionNum(); _$i++)this.addIntersection(t, e, n, _$i);
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this.pts = null, this._env = null, this.eiList = new $n(this), this._name = null, this._mce = null, this._isIsolated = !0, this._depth = new ri, this._depthDelta = 0, 1 === arguments.length) {
                        var t = arguments[0];
                        a.constructor_.call(this, t, null);
                    } else if (2 === arguments.length) {
                        var _$e = arguments[0], _$n = arguments[1];
                        this.pts = _$e, this._label = _$n;
                    }
                }
            },
            {
                key: "updateIM",
                value: function value() {
                    if (!(2 === arguments.length && _instanceof(arguments[1], ti) && _instanceof(arguments[0], Pe))) return f(r(a), "updateIM", this).apply(this, arguments);
                    var t = arguments[0], _$e = arguments[1];
                    _$e.setAtLeastIfValid(t.getLocation(0, $.ON), t.getLocation(1, $.ON), 1), t.isArea() && (_$e.setAtLeastIfValid(t.getLocation(0, $.LEFT), t.getLocation(1, $.LEFT), 2), _$e.setAtLeastIfValid(t.getLocation(0, $.RIGHT), t.getLocation(1, $.RIGHT), 2));
                }
            }
        ]), a;
    }(qe), ai = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "setWorkingPrecisionModel",
                value: function value(t) {
                    this._workingPrecisionModel = t;
                }
            },
            {
                key: "insertUniqueEdge",
                value: function value(t) {
                    var _$n = this._edgeList.findEqualEdge(t);
                    if (null !== _$n) {
                        var i = _$n.getLabel(), r = t.getLabel();
                        _$n.isPointwiseEqual(t) || (r = new Pe(t.getLabel())).flip(), i.merge(r);
                        var s = e.depthDelta(r), a = _$n.getDepthDelta() + s;
                        _$n.setDepthDelta(a);
                    } else this._edgeList.add(t), t.setDepthDelta(e.depthDelta(t.getLabel()));
                }
            },
            {
                key: "buildSubgraphs",
                value: function value(t, e) {
                    for(var _$n = new yt, i = t.iterator(); i.hasNext();){
                        var r = i.next(), s = r.getRightmostCoordinate(), a = new Dn(_$n).getDepth(s);
                        r.computeDepth(a), r.findResultEdges(), _$n.add(r), e.add(r.getDirectedEdges(), r.getNodes());
                    }
                }
            },
            {
                key: "createSubgraphs",
                value: function value(t) {
                    for(var _$e = new yt, _$n = t.getNodes().iterator(); _$n.hasNext();){
                        var i = _$n.next();
                        if (!i.isVisited()) {
                            var r = new _t;
                            r.create(i), _$e.add(r);
                        }
                    }
                    return on.sort(_$e, on.reverseOrder()), _$e;
                }
            },
            {
                key: "createEmptyResultGeometry",
                value: function value() {
                    return this._geomFact.createPolygon();
                }
            },
            {
                key: "getNoder",
                value: function value(t) {
                    if (null !== this._workingNoder) return this._workingNoder;
                    var _$e = new Rn, _$n = new Oe;
                    return _$n.setPrecisionModel(t), _$e.setSegmentIntersector(new Jn(_$n)), _$e;
                }
            },
            {
                key: "buffer",
                value: function value(t, e) {
                    var _$n = this._workingPrecisionModel;
                    null === _$n && (_$n = t.getPrecisionModel()), this._geomFact = t.getFactory();
                    var i = new Pn(_$n, this._bufParams), r = new zn(t, e, i).getCurves();
                    if (r.size() <= 0) return this.createEmptyResultGeometry();
                    this.computeNodedEdges(r, _$n), this._graph = new $e(new Zn), this._graph.addEdges(this._edgeList.getEdges());
                    var s = this.createSubgraphs(this._graph), a = new tn(this._geomFact);
                    this.buildSubgraphs(s, a);
                    var o = a.getPolygons();
                    return o.size() <= 0 ? this.createEmptyResultGeometry() : this._geomFact.buildGeometry(o);
                }
            },
            {
                key: "computeNodedEdges",
                value: function value(t, e) {
                    var _$n = this.getNoder(e);
                    _$n.computeNodes(t);
                    for(var i = _$n.getNodedSubstrings().iterator(); i.hasNext();){
                        var r = i.next(), s = r.getCoordinates();
                        if (2 !== s.length || !s[0].equals2D(s[1])) {
                            var a = r.getData(), o = new si(r.getCoordinates(), new Pe(a));
                            this.insertUniqueEdge(o);
                        }
                    }
                }
            },
            {
                key: "setNoder",
                value: function value(t) {
                    this._workingNoder = t;
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._bufParams = null, this._workingPrecisionModel = null, this._workingNoder = null, this._geomFact = null, this._graph = null, this._edgeList = new Wn;
                    var t = arguments[0];
                    this._bufParams = t;
                }
            },
            {
                key: "depthDelta",
                value: function value(t) {
                    var _$e = t.getLocation(0, $.LEFT), _$n = t.getLocation(0, $.RIGHT);
                    return _$e === H.INTERIOR && _$n === H.EXTERIOR ? 1 : _$e === H.EXTERIOR && _$n === H.INTERIOR ? -1 : 0;
                }
            },
            {
                key: "convertSegStrings",
                value: function value(t) {
                    for(var _$e = new ae, _$n = new yt; t.hasNext();){
                        var i = t.next(), r = _$e.createLineString(i.getCoordinates());
                        _$n.add(r);
                    }
                    return _$e.buildGeometry(_$n);
                }
            }
        ]), e;
    }(), oi = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "rescale",
                value: function value() {
                    if (rt(arguments[0], Z)) for(var t = arguments[0], _$e = t.iterator(); _$e.hasNext();){
                        var _$n = _$e.next();
                        this.rescale(_$n.getCoordinates());
                    }
                    else if (_instanceof(arguments[0], Array)) {
                        for(var i = arguments[0], r = 0; r < i.length; r++)i[r].x = i[r].x / this._scaleFactor + this._offsetX, i[r].y = i[r].y / this._scaleFactor + this._offsetY;
                        2 === i.length && i[0].equals2D(i[1]) && mt.out.println(i);
                    }
                }
            },
            {
                key: "scale",
                value: function value() {
                    if (rt(arguments[0], Z)) {
                        for(var t = arguments[0], _$e = new yt(t.size()), _$n = t.iterator(); _$n.hasNext();){
                            var i = _$n.next();
                            _$e.add(new In(this.scale(i.getCoordinates()), i.getData()));
                        }
                        return _$e;
                    }
                    if (_instanceof(arguments[0], Array)) {
                        for(var r = arguments[0], s = new Array(r.length).fill(null), a = 0; a < r.length; a++)s[a] = new X(Math.round((r[a].x - this._offsetX) * this._scaleFactor), Math.round((r[a].y - this._offsetY) * this._scaleFactor), r[a].getZ());
                        var o = jt.removeRepeatedPoints(s);
                        return o;
                    }
                }
            },
            {
                key: "isIntegerPrecision",
                value: function value() {
                    return 1 === this._scaleFactor;
                }
            },
            {
                key: "getNodedSubstrings",
                value: function value() {
                    var t = this._noder.getNodedSubstrings();
                    return this._isScaled && this.rescale(t), t;
                }
            },
            {
                key: "computeNodes",
                value: function value(t) {
                    var _$e = t;
                    this._isScaled && (_$e = this.scale(t)), this._noder.computeNodes(_$e);
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        Ln
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._noder = null, this._scaleFactor = null, this._offsetX = null, this._offsetY = null, this._isScaled = !1, 2 === arguments.length) {
                        var t = arguments[0], _$n = arguments[1];
                        e.constructor_.call(this, t, _$n, 0, 0);
                    } else if (4 === arguments.length) {
                        var i = arguments[0], r = arguments[1];
                        this._noder = i, this._scaleFactor = r, this._isScaled = !this.isIntegerPrecision();
                    }
                }
            }
        ]), e;
    }(), ui = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "checkEndPtVertexIntersections",
                value: function value() {
                    if (0 === arguments.length) for(var t = this._segStrings.iterator(); t.hasNext();){
                        var _$e = t.next(), _$n = _$e.getCoordinates();
                        this.checkEndPtVertexIntersections(_$n[0], this._segStrings), this.checkEndPtVertexIntersections(_$n[_$n.length - 1], this._segStrings);
                    }
                    else if (2 === arguments.length) {
                        for(var i = arguments[0], r = arguments[1], s = r.iterator(); s.hasNext();)for(var a = s.next(), o = a.getCoordinates(), _$u = 1; _$u < o.length - 1; _$u++)if (o[_$u].equals(i)) throw new D("found endpt/interior pt intersection at index " + _$u + " :pt " + i);
                    }
                }
            },
            {
                key: "checkInteriorIntersections",
                value: function value() {
                    if (0 === arguments.length) for(var t = this._segStrings.iterator(); t.hasNext();)for(var _$e = t.next(), _$n = this._segStrings.iterator(); _$n.hasNext();){
                        var i = _$n.next();
                        this.checkInteriorIntersections(_$e, i);
                    }
                    else if (2 === arguments.length) for(var r = arguments[0], s = arguments[1], a = r.getCoordinates(), o = s.getCoordinates(), _$u = 0; _$u < a.length - 1; _$u++)for(var l = 0; l < o.length - 1; l++)this.checkInteriorIntersections(r, _$u, s, l);
                    else if (4 === arguments.length) {
                        var h = arguments[0], c = arguments[1], f = arguments[2], v = arguments[3];
                        if (h === f && c === v) return null;
                        var g = h.getCoordinates()[c], y = h.getCoordinates()[c + 1], d = f.getCoordinates()[v], _ = f.getCoordinates()[v + 1];
                        if (this._li.computeIntersection(g, y, d, _), this._li.hasIntersection() && (this._li.isProper() || this.hasInteriorIntersection(this._li, g, y) || this.hasInteriorIntersection(this._li, d, _))) throw new D("found non-noded intersection at " + g + "-" + y + " and " + d + "-" + _);
                    }
                }
            },
            {
                key: "checkValid",
                value: function value() {
                    this.checkEndPtVertexIntersections(), this.checkInteriorIntersections(), this.checkCollapses();
                }
            },
            {
                key: "checkCollapses",
                value: function value() {
                    if (0 === arguments.length) for(var t = this._segStrings.iterator(); t.hasNext();){
                        var _$e = t.next();
                        this.checkCollapses(_$e);
                    }
                    else if (1 === arguments.length) for(var _$n = arguments[0], i = _$n.getCoordinates(), r = 0; r < i.length - 2; r++)this.checkCollapse(i[r], i[r + 1], i[r + 2]);
                }
            },
            {
                key: "hasInteriorIntersection",
                value: function value(t, e, n) {
                    for(var i = 0; i < t.getIntersectionNum(); i++){
                        var r = t.getIntersection(i);
                        if (!r.equals(e) && !r.equals(n)) return !0;
                    }
                    return !1;
                }
            },
            {
                key: "checkCollapse",
                value: function value(t, n, i) {
                    if (t.equals(i)) throw new D("found non-noded collapse at " + e.fact.createLineString([
                        t,
                        n,
                        i
                    ]));
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._li = new Oe, this._segStrings = null;
                    var t = arguments[0];
                    this._segStrings = t;
                }
            }
        ]), e;
    }();
    ui.fact = new ae;
    var li = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "intersectsScaled",
                value: function value(t, e) {
                    var _$n = Math.min(t.x, e.x), i = Math.max(t.x, e.x), r = Math.min(t.y, e.y), s = Math.max(t.y, e.y), a = this._maxx < _$n || this._minx > i || this._maxy < r || this._miny > s;
                    if (a) return !1;
                    var o = this.intersectsToleranceSquare(t, e);
                    return G.isTrue(!(a && o), "Found bad envelope test"), o;
                }
            },
            {
                key: "initCorners",
                value: function value(t) {
                    var _$e = .5;
                    this._minx = t.x - _$e, this._maxx = t.x + _$e, this._miny = t.y - _$e, this._maxy = t.y + _$e, this._corner[0] = new X(this._maxx, this._maxy), this._corner[1] = new X(this._minx, this._maxy), this._corner[2] = new X(this._minx, this._miny), this._corner[3] = new X(this._maxx, this._miny);
                }
            },
            {
                key: "intersects",
                value: function value(t, e) {
                    return 1 === this._scaleFactor ? this.intersectsScaled(t, e) : (this.copyScaled(t, this._p0Scaled), this.copyScaled(e, this._p1Scaled), this.intersectsScaled(this._p0Scaled, this._p1Scaled));
                }
            },
            {
                key: "scale",
                value: function value(t) {
                    return Math.round(t * this._scaleFactor);
                }
            },
            {
                key: "getCoordinate",
                value: function value() {
                    return this._originalPt;
                }
            },
            {
                key: "copyScaled",
                value: function value(t, e) {
                    e.x = this.scale(t.x), e.y = this.scale(t.y);
                }
            },
            {
                key: "getSafeEnvelope",
                value: function value() {
                    if (null === this._safeEnv) {
                        var t = e.SAFE_ENV_EXPANSION_FACTOR / this._scaleFactor;
                        this._safeEnv = new U(this._originalPt.x - t, this._originalPt.x + t, this._originalPt.y - t, this._originalPt.y + t);
                    }
                    return this._safeEnv;
                }
            },
            {
                key: "intersectsPixelClosure",
                value: function value(t, e) {
                    return this._li.computeIntersection(t, e, this._corner[0], this._corner[1]), !!this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[1], this._corner[2]), !!this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[2], this._corner[3]), !!this._li.hasIntersection() || (this._li.computeIntersection(t, e, this._corner[3], this._corner[0]), !!this._li.hasIntersection())));
                }
            },
            {
                key: "intersectsToleranceSquare",
                value: function value(t, e) {
                    var _$n = !1, i = !1;
                    return this._li.computeIntersection(t, e, this._corner[0], this._corner[1]), !!this._li.isProper() || (this._li.computeIntersection(t, e, this._corner[1], this._corner[2]), !!this._li.isProper() || (this._li.hasIntersection() && (_$n = !0), this._li.computeIntersection(t, e, this._corner[2], this._corner[3]), !!this._li.isProper() || (this._li.hasIntersection() && (i = !0), this._li.computeIntersection(t, e, this._corner[3], this._corner[0]), !!this._li.isProper() || !(!_$n || !i) || !!t.equals(this._pt) || !!e.equals(this._pt))));
                }
            },
            {
                key: "addSnappedNode",
                value: function value(t, e) {
                    var _$n = t.getCoordinate(e), i = t.getCoordinate(e + 1);
                    return !!this.intersects(_$n, i) && (t.addIntersection(this.getCoordinate(), e), !0);
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._li = null, this._pt = null, this._originalPt = null, this._ptScaled = null, this._p0Scaled = null, this._p1Scaled = null, this._scaleFactor = null, this._minx = null, this._maxx = null, this._miny = null, this._maxy = null, this._corner = new Array(4).fill(null), this._safeEnv = null;
                    var t = arguments[0], _$e = arguments[1], _$n = arguments[2];
                    if (this._originalPt = t, this._pt = t, this._scaleFactor = _$e, this._li = _$n, _$e <= 0) throw new m("Scale factor must be non-zero");
                    1 !== _$e && (this._pt = new X(this.scale(t.x), this.scale(t.y)), this._p0Scaled = new X, this._p1Scaled = new X), this.initCorners(this._pt);
                }
            }
        ]), e;
    }();
    li.SAFE_ENV_EXPANSION_FACTOR = .75;
    var hi = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "select",
                value: function value() {
                    if (1 === arguments.length) ;
                    else if (2 === arguments.length) {
                        var t = arguments[0], _$e = arguments[1];
                        t.getLineSegment(_$e, this.selectedSegment), this.select(this.selectedSegment);
                    }
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this.selectedSegment = new En;
                }
            }
        ]), e;
    }(), ci = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "snap",
                value: function value() {
                    if (1 === arguments.length) {
                        var _$e = arguments[0];
                        return this.snap(_$e, null, -1);
                    }
                    if (3 === arguments.length) {
                        var i = arguments[0], r = arguments[1], s = arguments[2], a = i.getSafeEnvelope(), o = new fi(i, r, s);
                        return this._index.query(a, new (function() {
                            function e() {
                                t(this, e);
                            }
                            return n(e, [
                                {
                                    key: "interfaces_",
                                    get: function get() {
                                        return [
                                            hn
                                        ];
                                    }
                                },
                                {
                                    key: "visitItem",
                                    value: function value(t) {
                                        t.select(a, o);
                                    }
                                }
                            ]), e;
                        }())), o.isNodeAdded();
                    }
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._index = null;
                    var t = arguments[0];
                    this._index = t;
                }
            }
        ]), e;
    }(), fi = function(e) {
        i(a, e);
        var s = c(a);
        function a() {
            var _$e;
            return t(this, a), _$e = s.call(this), a.constructor_.apply(l(_$e), arguments), _$e;
        }
        return n(a, [
            {
                key: "isNodeAdded",
                value: function value() {
                    return this._isNodeAdded;
                }
            },
            {
                key: "select",
                value: function value() {
                    if (!(2 === arguments.length && Number.isInteger(arguments[1]) && _instanceof(arguments[0], Tn))) return f(r(a.prototype), "select", this).apply(this, arguments);
                    var t = arguments[0], _$e = arguments[1], _$n = t.getContext();
                    if (this._parentEdge === _$n && (_$e === this._hotPixelVertexIndex || _$e + 1 === this._hotPixelVertexIndex)) return null;
                    this._isNodeAdded |= this._hotPixel.addSnappedNode(_$n, _$e);
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._hotPixel = null, this._parentEdge = null, this._hotPixelVertexIndex = null, this._isNodeAdded = !1;
                    var t = arguments[0], _$e = arguments[1], _$n = arguments[2];
                    this._hotPixel = t, this._parentEdge = _$e, this._hotPixelVertexIndex = _$n;
                }
            }
        ]), a;
    }(hi);
    ci.HotPixelSnapAction = fi;
    var vi = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "processIntersections",
                value: function value(t, e, n, i) {
                    if (t === n && e === i) return null;
                    var r = t.getCoordinates()[e], s = t.getCoordinates()[e + 1], a = n.getCoordinates()[i], o = n.getCoordinates()[i + 1];
                    if (this._li.computeIntersection(r, s, a, o), this._li.hasIntersection() && this._li.isInteriorIntersection()) {
                        for(var _$u = 0; _$u < this._li.getIntersectionNum(); _$u++)this._interiorIntersections.add(this._li.getIntersection(_$u));
                        t.addIntersections(this._li, e, 0), n.addIntersections(this._li, i, 1);
                    }
                }
            },
            {
                key: "isDone",
                value: function value() {
                    return !1;
                }
            },
            {
                key: "getInteriorIntersections",
                value: function value() {
                    return this._interiorIntersections;
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        Kn
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._li = null, this._interiorIntersections = null;
                    var t = arguments[0];
                    this._li = t, this._interiorIntersections = new yt;
                }
            }
        ]), e;
    }(), gi = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "checkCorrectness",
                value: function value(t) {
                    var _$e = In.getNodedSubstrings(t), _$n = new ui(_$e);
                    try {
                        _$n.checkValid();
                    } catch (t) {
                        if (!_instanceof(t, p)) throw t;
                        t.printStackTrace();
                    }
                }
            },
            {
                key: "getNodedSubstrings",
                value: function value() {
                    return In.getNodedSubstrings(this._nodedSegStrings);
                }
            },
            {
                key: "snapRound",
                value: function value(t, e) {
                    var _$n = this.findInteriorIntersections(t, e);
                    this.computeIntersectionSnaps(_$n), this.computeVertexSnaps(t);
                }
            },
            {
                key: "findInteriorIntersections",
                value: function value(t, e) {
                    var _$n = new vi(e);
                    return this._noder.setSegmentIntersector(_$n), this._noder.computeNodes(t), _$n.getInteriorIntersections();
                }
            },
            {
                key: "computeVertexSnaps",
                value: function value() {
                    if (rt(arguments[0], Z)) for(var t = arguments[0], _$e = t.iterator(); _$e.hasNext();){
                        var _$n = _$e.next();
                        this.computeVertexSnaps(_$n);
                    }
                    else if (_instanceof(arguments[0], In)) for(var i = arguments[0], r = i.getCoordinates(), s = 0; s < r.length; s++){
                        var a = new li(r[s], this._scaleFactor, this._li), o = this._pointSnapper.snap(a, i, s);
                        o && i.addIntersection(r[s], s);
                    }
                }
            },
            {
                key: "computeNodes",
                value: function value(t) {
                    this._nodedSegStrings = t, this._noder = new Rn, this._pointSnapper = new ci(this._noder.getIndex()), this.snapRound(t, this._li);
                }
            },
            {
                key: "computeIntersectionSnaps",
                value: function value(t) {
                    for(var _$e = t.iterator(); _$e.hasNext();){
                        var _$n = _$e.next(), i = new li(_$n, this._scaleFactor, this._li);
                        this._pointSnapper.snap(i);
                    }
                }
            },
            {
                key: "interfaces_",
                get: function get() {
                    return [
                        Ln
                    ];
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    this._pm = null, this._li = null, this._scaleFactor = null, this._noder = null, this._pointSnapper = null, this._nodedSegStrings = null;
                    var t = arguments[0];
                    this._pm = t, this._li = new Oe, this._li.setPrecisionModel(t), this._scaleFactor = t.getScale();
                }
            }
        ]), e;
    }(), yi = function() {
        function e() {
            t(this, e), e.constructor_.apply(this, arguments);
        }
        return n(e, [
            {
                key: "bufferFixedPrecision",
                value: function value(t) {
                    var _$e = new oi(new gi(new ie(1)), t.getScale()), _$n = new ai(this._bufParams);
                    _$n.setWorkingPrecisionModel(t), _$n.setNoder(_$e), this._resultGeometry = _$n.buffer(this._argGeom, this._distance);
                }
            },
            {
                key: "bufferReducedPrecision",
                value: function value() {
                    if (0 === arguments.length) {
                        for(var _$t = e.MAX_PRECISION_DIGITS; _$t >= 0; _$t--){
                            try {
                                this.bufferReducedPrecision(_$t);
                            } catch (t) {
                                if (!_instanceof(t, vt)) throw t;
                                this._saveException = t;
                            }
                            if (null !== this._resultGeometry) return null;
                        }
                        throw this._saveException;
                    }
                    if (1 === arguments.length) {
                        var _$n = arguments[0], i = e.precisionScaleFactor(this._argGeom, this._distance, _$n), r = new ie(i);
                        this.bufferFixedPrecision(r);
                    }
                }
            },
            {
                key: "computeGeometry",
                value: function value() {
                    if (this.bufferOriginalPrecision(), null !== this._resultGeometry) return null;
                    var t = this._argGeom.getFactory().getPrecisionModel();
                    t.getType() === ie.FIXED ? this.bufferFixedPrecision(t) : this.bufferReducedPrecision();
                }
            },
            {
                key: "setQuadrantSegments",
                value: function value(t) {
                    this._bufParams.setQuadrantSegments(t);
                }
            },
            {
                key: "bufferOriginalPrecision",
                value: function value() {
                    try {
                        var _$t = new ai(this._bufParams);
                        this._resultGeometry = _$t.buffer(this._argGeom, this._distance);
                    } catch (t) {
                        if (!_instanceof(t, D)) throw t;
                        this._saveException = t;
                    }
                }
            },
            {
                key: "getResultGeometry",
                value: function value(t) {
                    return this._distance = t, this.computeGeometry(), this._resultGeometry;
                }
            },
            {
                key: "setEndCapStyle",
                value: function value(t) {
                    this._bufParams.setEndCapStyle(t);
                }
            }
        ], [
            {
                key: "constructor_",
                value: function value() {
                    if (this._argGeom = null, this._distance = null, this._bufParams = new _, this._resultGeometry = null, this._saveException = null, 1 === arguments.length) {
                        var t = arguments[0];
                        this._argGeom = t;
                    } else if (2 === arguments.length) {
                        var _$e = arguments[0], _$n = arguments[1];
                        this._argGeom = _$e, this._bufParams = _$n;
                    }
                }
            },
            {
                key: "bufferOp",
                value: function value() {
                    if (2 === arguments.length) {
                        var t = arguments[0], _$n = arguments[1], i = new e(t), r = i.getResultGeometry(_$n);
                        return r;
                    }
                    if (3 === arguments.length) {
                        if (Number.isInteger(arguments[2]) && _instanceof(arguments[0], V) && "number" == typeof arguments[1]) {
                            var s = arguments[0], a = arguments[1], o = arguments[2], _$u = new e(s);
                            _$u.setQuadrantSegments(o);
                            var l = _$u.getResultGeometry(a);
                            return l;
                        }
                        if (_instanceof(arguments[2], _) && _instanceof(arguments[0], V) && "number" == typeof arguments[1]) {
                            var h = arguments[0], c = arguments[1], f = arguments[2], v = new e(h, f), g = v.getResultGeometry(c);
                            return g;
                        }
                    } else if (4 === arguments.length) {
                        var y = arguments[0], d = arguments[1], p = arguments[2], m = arguments[3], k = new e(y);
                        k.setQuadrantSegments(p), k.setEndCapStyle(m);
                        var x = k.getResultGeometry(d);
                        return x;
                    }
                }
            },
            {
                key: "precisionScaleFactor",
                value: function value(t, e, n) {
                    var i = t.getEnvelopeInternal(), r = kt.max(Math.abs(i.getMaxX()), Math.abs(i.getMaxY()), Math.abs(i.getMinX()), Math.abs(i.getMinY())) + 2 * (e > 0 ? e : 0), s = n - Math.trunc(Math.log(r) / Math.log(10) + 1);
                    return Math.pow(10, s);
                }
            }
        ]), e;
    }();
    yi.CAP_ROUND = _.CAP_ROUND, yi.CAP_BUTT = _.CAP_FLAT, yi.CAP_FLAT = _.CAP_FLAT, yi.CAP_SQUARE = _.CAP_SQUARE, yi.MAX_PRECISION_DIGITS = 12;
    var di = [
        "Point",
        "MultiPoint",
        "LineString",
        "MultiLineString",
        "Polygon",
        "MultiPolygon"
    ], _i = function() {
        function e(n) {
            t(this, e), this.geometryFactory = n || new ae;
        }
        return n(e, [
            {
                key: "read",
                value: function value(t) {
                    var _$e, _$n = (_$e = "string" == typeof t ? JSON.parse(t) : t).type;
                    if (!pi[_$n]) throw new Error("Unknown GeoJSON type: " + _$e.type);
                    return -1 !== di.indexOf(_$n) ? pi[_$n].call(this, _$e.coordinates) : "GeometryCollection" === _$n ? pi[_$n].call(this, _$e.geometries) : pi[_$n].call(this, _$e);
                }
            },
            {
                key: "write",
                value: function value(t) {
                    var _$e = t.getGeometryType();
                    if (!mi[_$e]) throw new Error("Geometry is not supported");
                    return mi[_$e].call(this, t);
                }
            }
        ]), e;
    }(), pi = {
        Feature: function Feature(t) {
            var e = {};
            for(var n in t)e[n] = t[n];
            if (t.geometry) {
                var i = t.geometry.type;
                if (!pi[i]) throw new Error("Unknown GeoJSON type: " + t.type);
                e.geometry = this.read(t.geometry);
            }
            return t.bbox && (e.bbox = pi.bbox.call(this, t.bbox)), e;
        },
        FeatureCollection: function FeatureCollection(t) {
            var e = {};
            if (t.features) {
                e.features = [];
                for(var n = 0; n < t.features.length; ++n)e.features.push(this.read(t.features[n]));
            }
            return t.bbox && (e.bbox = this.parse.bbox.call(this, t.bbox)), e;
        },
        coordinates: function coordinates(t) {
            for(var e = [], n = 0; n < t.length; ++n){
                var i = t[n];
                e.push(o(X, v(i)));
            }
            return e;
        },
        bbox: function bbox(t) {
            return this.geometryFactory.createLinearRing([
                new X(t[0], t[1]),
                new X(t[2], t[1]),
                new X(t[2], t[3]),
                new X(t[0], t[3]),
                new X(t[0], t[1])
            ]);
        },
        Point: function Point(t) {
            var e = o(X, v(t));
            return this.geometryFactory.createPoint(e);
        },
        MultiPoint: function MultiPoint(t) {
            for(var e = [], n = 0; n < t.length; ++n)e.push(pi.Point.call(this, t[n]));
            return this.geometryFactory.createMultiPoint(e);
        },
        LineString: function LineString(t) {
            var e = pi.coordinates.call(this, t);
            return this.geometryFactory.createLineString(e);
        },
        MultiLineString: function MultiLineString(t) {
            for(var e = [], n = 0; n < t.length; ++n)e.push(pi.LineString.call(this, t[n]));
            return this.geometryFactory.createMultiLineString(e);
        },
        Polygon: function Polygon(t) {
            for(var e = pi.coordinates.call(this, t[0]), n = this.geometryFactory.createLinearRing(e), i = [], r = 1; r < t.length; ++r){
                var s = t[r], a = pi.coordinates.call(this, s), o = this.geometryFactory.createLinearRing(a);
                i.push(o);
            }
            return this.geometryFactory.createPolygon(n, i);
        },
        MultiPolygon: function MultiPolygon(t) {
            for(var e = [], n = 0; n < t.length; ++n){
                var i = t[n];
                e.push(pi.Polygon.call(this, i));
            }
            return this.geometryFactory.createMultiPolygon(e);
        },
        GeometryCollection: function GeometryCollection(t) {
            for(var e = [], n = 0; n < t.length; ++n){
                var i = t[n];
                e.push(this.read(i));
            }
            return this.geometryFactory.createGeometryCollection(e);
        }
    }, mi = {
        coordinate: function coordinate(t) {
            var e = [
                t.x,
                t.y
            ];
            return t.z && e.push(t.z), t.m && e.push(t.m), e;
        },
        Point: function Point(t) {
            return {
                type: "Point",
                coordinates: mi.coordinate.call(this, t.getCoordinate())
            };
        },
        MultiPoint: function MultiPoint(t) {
            for(var e = [], n = 0; n < t._geometries.length; ++n){
                var i = t._geometries[n], r = mi.Point.call(this, i);
                e.push(r.coordinates);
            }
            return {
                type: "MultiPoint",
                coordinates: e
            };
        },
        LineString: function LineString(t) {
            for(var e = [], n = t.getCoordinates(), i = 0; i < n.length; ++i){
                var r = n[i];
                e.push(mi.coordinate.call(this, r));
            }
            return {
                type: "LineString",
                coordinates: e
            };
        },
        MultiLineString: function MultiLineString(t) {
            for(var e = [], n = 0; n < t._geometries.length; ++n){
                var i = t._geometries[n], r = mi.LineString.call(this, i);
                e.push(r.coordinates);
            }
            return {
                type: "MultiLineString",
                coordinates: e
            };
        },
        Polygon: function Polygon(t) {
            var e = [], n = mi.LineString.call(this, t._shell);
            e.push(n.coordinates);
            for(var i = 0; i < t._holes.length; ++i){
                var r = t._holes[i], s = mi.LineString.call(this, r);
                e.push(s.coordinates);
            }
            return {
                type: "Polygon",
                coordinates: e
            };
        },
        MultiPolygon: function MultiPolygon(t) {
            for(var e = [], n = 0; n < t._geometries.length; ++n){
                var i = t._geometries[n], r = mi.Polygon.call(this, i);
                e.push(r.coordinates);
            }
            return {
                type: "MultiPolygon",
                coordinates: e
            };
        },
        GeometryCollection: function GeometryCollection(t) {
            for(var e = [], n = 0; n < t._geometries.length; ++n){
                var i = t._geometries[n], r = i.getGeometryType();
                e.push(mi[r].call(this, i));
            }
            return {
                type: "GeometryCollection",
                geometries: e
            };
        }
    };
    return {
        BufferOp: yi,
        GeoJSONReader: function() {
            function e(n) {
                t(this, e), this.parser = new _i(n || new ae);
            }
            return n(e, [
                {
                    key: "read",
                    value: function value(t) {
                        return this.parser.read(t);
                    }
                }
            ]), e;
        }(),
        GeoJSONWriter: function() {
            function e() {
                t(this, e), this.parser = new _i(this.geometryFactory);
            }
            return n(e, [
                {
                    key: "write",
                    value: function value(t) {
                        return this.parser.write(t);
                    }
                }
            ]), e;
        }()
    };
}); //# sourceMappingURL=jsts.min.js.map
